import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React$1 from 'react';
import React__default$1, { createContext, useContext, useState, useEffect, useLayoutEffect, useRef, forwardRef, useCallback, useMemo } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray: isArray$1} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction$1(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString$1 = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction$1 = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction$1(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction$1(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction$1(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$1(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray$1(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction$1(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray$2 = (thing) => {
  if (!thing) return null;
  if (isArray$1(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty$1 = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction$1(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction$1(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray$1(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop$1 = () => {};

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction$1(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray$1(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction$1(thing)) && isFunction$1(thing.then) && isFunction$1(thing.catch);

var utils = {
  isArray: isArray$1,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray: toArray$2,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$1,
  hasOwnProp: hasOwnProperty$1, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var InterceptorManager$1 = InterceptorManager;

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


var platform = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults$1 = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults$1.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$1.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$1.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

var defaults$2 = defaults$1;

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);

var AxiosHeaders$1 = AxiosHeaders;

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults$2;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

var cookies = platform.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })();

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

var isURLSameOrigin = platform.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })();

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = AxiosHeaders$1.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      if (platform.isStandardBrowserEnv || platform.isStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else {
        requestHeaders.setContentType('multipart/form-data;', false); // mobile/desktop app frameworks
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders$1.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (platform.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath))
        && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};

utils.forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new AxiosError(
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        utils.hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!utils.isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders$1.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults$2.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders$1.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig$1(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

const VERSION = "1.4.0";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator$3 = {
  assertOptions,
  validators: validators$1
};

const validators = validator$3.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig$1(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator$3.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator$3.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig$1(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios$1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

var CancelToken$1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

var HttpStatusCode$1 = HttpStatusCode;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios$1.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig$1(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults$2);

// Expose Axios class to allow class inheritance
axios.Axios = Axios$1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig$1;

axios.AxiosHeaders = AxiosHeaders$1;

axios.formToJSON = thing => formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = HttpStatusCode$1;

axios.default = axios;

// this module should only have a default export
var axios$1 = axios;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var validator$2 = {};

var util$4 = {};

(function (exports) {

const nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const nameChar = nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const nameRegexp = '[' + nameStartChar + '][' + nameChar + ']*';
const regexName = new RegExp('^' + nameRegexp + '$');

const getAllMatches = function(string, regex) {
  const matches = [];
  let match = regex.exec(string);
  while (match) {
    const allmatches = [];
    allmatches.startIndex = regex.lastIndex - match[0].length;
    const len = match.length;
    for (let index = 0; index < len; index++) {
      allmatches.push(match[index]);
    }
    matches.push(allmatches);
    match = regex.exec(string);
  }
  return matches;
};

const isName = function(string) {
  const match = regexName.exec(string);
  return !(match === null || typeof match === 'undefined');
};

exports.isExist = function(v) {
  return typeof v !== 'undefined';
};

exports.isEmptyObject = function(obj) {
  return Object.keys(obj).length === 0;
};

/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */
exports.merge = function(target, a, arrayMode) {
  if (a) {
    const keys = Object.keys(a); // will return an array of own properties
    const len = keys.length; //don't make it inline
    for (let i = 0; i < len; i++) {
      if (arrayMode === 'strict') {
        target[keys[i]] = [ a[keys[i]] ];
      } else {
        target[keys[i]] = a[keys[i]];
      }
    }
  }
};
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */

exports.getValue = function(v) {
  if (exports.isExist(v)) {
    return v;
  } else {
    return '';
  }
};

// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};

exports.isName = isName;
exports.getAllMatches = getAllMatches;
exports.nameRegexp = nameRegexp;
}(util$4));

const util$3 = util$4;

const defaultOptions$3 = {
  allowBooleanAttributes: false, //A tag can have attributes without any value
  unpairedTags: []
};

//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
validator$2.validate = function (xmlData, options) {
  options = Object.assign({}, defaultOptions$3, options);

  //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
  //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
  //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
  const tags = [];
  let tagFound = false;

  //indicates that the root tag has been closed (aka. depth 0 has been reached)
  let reachedRoot = false;

  if (xmlData[0] === '\ufeff') {
    // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
  }
  
  for (let i = 0; i < xmlData.length; i++) {

    if (xmlData[i] === '<' && xmlData[i+1] === '?') {
      i+=2;
      i = readPI(xmlData,i);
      if (i.err) return i;
    }else if (xmlData[i] === '<') {
      //starting of tag
      //read until you reach to '>' avoiding any '>' in attribute value
      let tagStartPos = i;
      i++;
      
      if (xmlData[i] === '!') {
        i = readCommentAndCDATA(xmlData, i);
        continue;
      } else {
        let closingTag = false;
        if (xmlData[i] === '/') {
          //closing tag
          closingTag = true;
          i++;
        }
        //read tagname
        let tagName = '';
        for (; i < xmlData.length &&
          xmlData[i] !== '>' &&
          xmlData[i] !== ' ' &&
          xmlData[i] !== '\t' &&
          xmlData[i] !== '\n' &&
          xmlData[i] !== '\r'; i++
        ) {
          tagName += xmlData[i];
        }
        tagName = tagName.trim();
        //console.log(tagName);

        if (tagName[tagName.length - 1] === '/') {
          //self closing tag without attributes
          tagName = tagName.substring(0, tagName.length - 1);
          //continue;
          i--;
        }
        if (!validateTagName(tagName)) {
          let msg;
          if (tagName.trim().length === 0) {
            msg = "Invalid space after '<'.";
          } else {
            msg = "Tag '"+tagName+"' is an invalid name.";
          }
          return getErrorObject('InvalidTag', msg, getLineNumberForPosition(xmlData, i));
        }

        const result = readAttributeStr(xmlData, i);
        if (result === false) {
          return getErrorObject('InvalidAttr', "Attributes for '"+tagName+"' have open quote.", getLineNumberForPosition(xmlData, i));
        }
        let attrStr = result.value;
        i = result.index;

        if (attrStr[attrStr.length - 1] === '/') {
          //self closing tag
          const attrStrStart = i - attrStr.length;
          attrStr = attrStr.substring(0, attrStr.length - 1);
          const isValid = validateAttributeString(attrStr, options);
          if (isValid === true) {
            tagFound = true;
            //continue; //text may presents after self closing tag
          } else {
            //the result from the nested function returns the position of the error within the attribute
            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
            //this gives us the absolute index in the entire xml, which we can use to find the line at last
            return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
          }
        } else if (closingTag) {
          if (!result.tagClosed) {
            return getErrorObject('InvalidTag', "Closing tag '"+tagName+"' doesn't have proper closing.", getLineNumberForPosition(xmlData, i));
          } else if (attrStr.trim().length > 0) {
            return getErrorObject('InvalidTag', "Closing tag '"+tagName+"' can't have attributes or invalid starting.", getLineNumberForPosition(xmlData, tagStartPos));
          } else {
            const otg = tags.pop();
            if (tagName !== otg.tagName) {
              let openPos = getLineNumberForPosition(xmlData, otg.tagStartPos);
              return getErrorObject('InvalidTag',
                "Expected closing tag '"+otg.tagName+"' (opened in line "+openPos.line+", col "+openPos.col+") instead of closing tag '"+tagName+"'.",
                getLineNumberForPosition(xmlData, tagStartPos));
            }

            //when there are no more tags, we reached the root level.
            if (tags.length == 0) {
              reachedRoot = true;
            }
          }
        } else {
          const isValid = validateAttributeString(attrStr, options);
          if (isValid !== true) {
            //the result from the nested function returns the position of the error within the attribute
            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
            //this gives us the absolute index in the entire xml, which we can use to find the line at last
            return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
          }

          //if the root level has been reached before ...
          if (reachedRoot === true) {
            return getErrorObject('InvalidXml', 'Multiple possible root nodes found.', getLineNumberForPosition(xmlData, i));
          } else if(options.unpairedTags.indexOf(tagName) !== -1); else {
            tags.push({tagName, tagStartPos});
          }
          tagFound = true;
        }

        //skip tag text value
        //It may include comments and CDATA value
        for (i++; i < xmlData.length; i++) {
          if (xmlData[i] === '<') {
            if (xmlData[i + 1] === '!') {
              //comment or CADATA
              i++;
              i = readCommentAndCDATA(xmlData, i);
              continue;
            } else if (xmlData[i+1] === '?') {
              i = readPI(xmlData, ++i);
              if (i.err) return i;
            } else {
              break;
            }
          } else if (xmlData[i] === '&') {
            const afterAmp = validateAmpersand(xmlData, i);
            if (afterAmp == -1)
              return getErrorObject('InvalidChar', "char '&' is not expected.", getLineNumberForPosition(xmlData, i));
            i = afterAmp;
          }else {
            if (reachedRoot === true && !isWhiteSpace(xmlData[i])) {
              return getErrorObject('InvalidXml', "Extra text at the end", getLineNumberForPosition(xmlData, i));
            }
          }
        } //end of reading tag text value
        if (xmlData[i] === '<') {
          i--;
        }
      }
    } else {
      if ( isWhiteSpace(xmlData[i])) {
        continue;
      }
      return getErrorObject('InvalidChar', "char '"+xmlData[i]+"' is not expected.", getLineNumberForPosition(xmlData, i));
    }
  }

  if (!tagFound) {
    return getErrorObject('InvalidXml', 'Start tag expected.', 1);
  }else if (tags.length == 1) {
      return getErrorObject('InvalidTag', "Unclosed tag '"+tags[0].tagName+"'.", getLineNumberForPosition(xmlData, tags[0].tagStartPos));
  }else if (tags.length > 0) {
      return getErrorObject('InvalidXml', "Invalid '"+
          JSON.stringify(tags.map(t => t.tagName), null, 4).replace(/\r?\n/g, '')+
          "' found.", {line: 1, col: 1});
  }

  return true;
};

function isWhiteSpace(char){
  return char === ' ' || char === '\t' || char === '\n'  || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */
function readPI(xmlData, i) {
  const start = i;
  for (; i < xmlData.length; i++) {
    if (xmlData[i] == '?' || xmlData[i] == ' ') {
      //tagname
      const tagname = xmlData.substr(start, i - start);
      if (i > 5 && tagname === 'xml') {
        return getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', getLineNumberForPosition(xmlData, i));
      } else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
        //check if valid attribut string
        i++;
        break;
      } else {
        continue;
      }
    }
  }
  return i;
}

function readCommentAndCDATA(xmlData, i) {
  if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
    //comment
    for (i += 3; i < xmlData.length; i++) {
      if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
        i += 2;
        break;
      }
    }
  } else if (
    xmlData.length > i + 8 &&
    xmlData[i + 1] === 'D' &&
    xmlData[i + 2] === 'O' &&
    xmlData[i + 3] === 'C' &&
    xmlData[i + 4] === 'T' &&
    xmlData[i + 5] === 'Y' &&
    xmlData[i + 6] === 'P' &&
    xmlData[i + 7] === 'E'
  ) {
    let angleBracketsCount = 1;
    for (i += 8; i < xmlData.length; i++) {
      if (xmlData[i] === '<') {
        angleBracketsCount++;
      } else if (xmlData[i] === '>') {
        angleBracketsCount--;
        if (angleBracketsCount === 0) {
          break;
        }
      }
    }
  } else if (
    xmlData.length > i + 9 &&
    xmlData[i + 1] === '[' &&
    xmlData[i + 2] === 'C' &&
    xmlData[i + 3] === 'D' &&
    xmlData[i + 4] === 'A' &&
    xmlData[i + 5] === 'T' &&
    xmlData[i + 6] === 'A' &&
    xmlData[i + 7] === '['
  ) {
    for (i += 8; i < xmlData.length; i++) {
      if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
        i += 2;
        break;
      }
    }
  }

  return i;
}

const doubleQuote = '"';
const singleQuote = "'";

/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */
function readAttributeStr(xmlData, i) {
  let attrStr = '';
  let startChar = '';
  let tagClosed = false;
  for (; i < xmlData.length; i++) {
    if (xmlData[i] === doubleQuote || xmlData[i] === singleQuote) {
      if (startChar === '') {
        startChar = xmlData[i];
      } else if (startChar !== xmlData[i]) ; else {
        startChar = '';
      }
    } else if (xmlData[i] === '>') {
      if (startChar === '') {
        tagClosed = true;
        break;
      }
    }
    attrStr += xmlData[i];
  }
  if (startChar !== '') {
    return false;
  }

  return {
    value: attrStr,
    index: i,
    tagClosed: tagClosed
  };
}

/**
 * Select all the attributes whether valid or invalid.
 */
const validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');

//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""

function validateAttributeString(attrStr, options) {
  //console.log("start:"+attrStr+":end");

  //if(attrStr.trim().length === 0) return true; //empty string

  const matches = util$3.getAllMatches(attrStr, validAttrStrRegxp);
  const attrNames = {};

  for (let i = 0; i < matches.length; i++) {
    if (matches[i][1].length === 0) {
      //nospace before attribute name: a="sd"b="saf"
      return getErrorObject('InvalidAttr', "Attribute '"+matches[i][2]+"' has no space in starting.", getPositionFromMatch(matches[i]))
    } else if (matches[i][3] !== undefined && matches[i][4] === undefined) {
      return getErrorObject('InvalidAttr', "Attribute '"+matches[i][2]+"' is without value.", getPositionFromMatch(matches[i]));
    } else if (matches[i][3] === undefined && !options.allowBooleanAttributes) {
      //independent attribute: ab
      return getErrorObject('InvalidAttr', "boolean attribute '"+matches[i][2]+"' is not allowed.", getPositionFromMatch(matches[i]));
    }
    /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */
    const attrName = matches[i][2];
    if (!validateAttrName(attrName)) {
      return getErrorObject('InvalidAttr', "Attribute '"+attrName+"' is an invalid name.", getPositionFromMatch(matches[i]));
    }
    if (!attrNames.hasOwnProperty(attrName)) {
      //check for duplicate attribute.
      attrNames[attrName] = 1;
    } else {
      return getErrorObject('InvalidAttr', "Attribute '"+attrName+"' is repeated.", getPositionFromMatch(matches[i]));
    }
  }

  return true;
}

function validateNumberAmpersand(xmlData, i) {
  let re = /\d/;
  if (xmlData[i] === 'x') {
    i++;
    re = /[\da-fA-F]/;
  }
  for (; i < xmlData.length; i++) {
    if (xmlData[i] === ';')
      return i;
    if (!xmlData[i].match(re))
      break;
  }
  return -1;
}

function validateAmpersand(xmlData, i) {
  // https://www.w3.org/TR/xml/#dt-charref
  i++;
  if (xmlData[i] === ';')
    return -1;
  if (xmlData[i] === '#') {
    i++;
    return validateNumberAmpersand(xmlData, i);
  }
  let count = 0;
  for (; i < xmlData.length; i++, count++) {
    if (xmlData[i].match(/\w/) && count < 20)
      continue;
    if (xmlData[i] === ';')
      break;
    return -1;
  }
  return i;
}

function getErrorObject(code, message, lineNumber) {
  return {
    err: {
      code: code,
      msg: message,
      line: lineNumber.line || lineNumber,
      col: lineNumber.col,
    },
  };
}

function validateAttrName(attrName) {
  return util$3.isName(attrName);
}

// const startsWithXML = /^xml/i;

function validateTagName(tagname) {
  return util$3.isName(tagname) /* && !tagname.match(startsWithXML) */;
}

//this function returns the line number for the character at the given index
function getLineNumberForPosition(xmlData, index) {
  const lines = xmlData.substring(0, index).split(/\r?\n/);
  return {
    line: lines.length,

    // column number is last line's length + 1, because column numbering starts at 1:
    col: lines[lines.length - 1].length + 1
  };
}

//this function returns the position of the first character of match within attrStr
function getPositionFromMatch(match) {
  return match.startIndex + match[1].length;
}

var OptionsBuilder = {};

const defaultOptions$2 = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false, // remove NS from tag name or attribute name if true
    allowBooleanAttributes: false, //a tag can have attributes without any value
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true, //Trim string values of tag and attributes
    cdataPropName: false,
    numberParseOptions: {
      hex: true,
      leadingZeros: true,
      eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
      return val;
    },
    attributeValueProcessor: function(attrName, val) {
      return val;
    },
    stopNodes: [], //nested tags will not be parsed even for errors
    alwaysCreateTextNode: false,
    isArray: () => false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs){
      return tagName
    },
    // skipEmptyListItem: false
};
   
const buildOptions$1 = function(options) {
    return Object.assign({}, defaultOptions$2, options);
};

OptionsBuilder.buildOptions = buildOptions$1;
OptionsBuilder.defaultOptions = defaultOptions$2;

class XmlNode{
  constructor(tagname) {
    this.tagname = tagname;
    this.child = []; //nested tags, text, cdata, comments in order
    this[":@"] = {}; //attributes map
  }
  add(key,val){
    // this.child.push( {name : key, val: val, isCdata: isCdata });
    if(key === "__proto__") key = "#__proto__";
    this.child.push( {[key]: val });
  }
  addChild(node) {
    if(node.tagname === "__proto__") node.tagname = "#__proto__";
    if(node[":@"] && Object.keys(node[":@"]).length > 0){
      this.child.push( { [node.tagname]: node.child, [":@"]: node[":@"] });
    }else {
      this.child.push( { [node.tagname]: node.child });
    }
  };
}

var xmlNode$1 = XmlNode;

//TODO: handle comments
function readDocType$1(xmlData, i){
    
    const entities = {};
    if( xmlData[i + 3] === 'O' &&
         xmlData[i + 4] === 'C' &&
         xmlData[i + 5] === 'T' &&
         xmlData[i + 6] === 'Y' &&
         xmlData[i + 7] === 'P' &&
         xmlData[i + 8] === 'E')
    {    
        i = i+9;
        let angleBracketsCount = 1;
        let hasBody = false, comment = false;
        let exp = "";
        for(;i<xmlData.length;i++){
            if (xmlData[i] === '<' && !comment) { //Determine the tag type
                if( hasBody && isEntity(xmlData, i)){
                    i += 7; 
                    [entityName, val,i] = readEntityExp(xmlData,i+1);
                    if(val.indexOf("&") === -1) //Parameter entities are not supported
                        entities[ validateEntityName(entityName) ] = {
                            regx : RegExp( `&${entityName};`,"g"),
                            val: val
                        };
                }
                else if( hasBody && isElement(xmlData, i))  i += 8;//Not supported
                else if( hasBody && isAttlist(xmlData, i))  i += 8;//Not supported
                else if( hasBody && isNotation(xmlData, i)) i += 9;//Not supported
                else if( isComment)                         comment = true;
                else                                        throw new Error("Invalid DOCTYPE");

                angleBracketsCount++;
                exp = "";
            } else if (xmlData[i] === '>') { //Read tag content
                if(comment){
                    if( xmlData[i - 1] === "-" && xmlData[i - 2] === "-"){
                        comment = false;
                        angleBracketsCount--;
                    }
                }else {
                    angleBracketsCount--;
                }
                if (angleBracketsCount === 0) {
                  break;
                }
            }else if( xmlData[i] === '['){
                hasBody = true;
            }else {
                exp += xmlData[i];
            }
        }
        if(angleBracketsCount !== 0){
            throw new Error(`Unclosed DOCTYPE`);
        }
    }else {
        throw new Error(`Invalid Tag instead of DOCTYPE`);
    }
    return {entities, i};
}

function readEntityExp(xmlData,i){
    //External entities are not supported
    //    <!ENTITY ext SYSTEM "http://normal-website.com" >

    //Parameter entities are not supported
    //    <!ENTITY entityname "&anotherElement;">

    //Internal entities are supported
    //    <!ENTITY entityname "replacement text">
    
    //read EntityName
    let entityName = "";
    for (; i < xmlData.length && (xmlData[i] !== "'" && xmlData[i] !== '"' ); i++) {
        // if(xmlData[i] === " ") continue;
        // else 
        entityName += xmlData[i];
    }
    entityName = entityName.trim();
    if(entityName.indexOf(" ") !== -1) throw new Error("External entites are not supported");

    //read Entity Value
    const startChar = xmlData[i++];
    let val = "";
    for (; i < xmlData.length && xmlData[i] !== startChar ; i++) {
        val += xmlData[i];
    }
    return [entityName, val, i];
}

function isComment(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === '-' &&
    xmlData[i+3] === '-') return true
    return false
}
function isEntity(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === 'E' &&
    xmlData[i+3] === 'N' &&
    xmlData[i+4] === 'T' &&
    xmlData[i+5] === 'I' &&
    xmlData[i+6] === 'T' &&
    xmlData[i+7] === 'Y') return true
    return false
}
function isElement(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === 'E' &&
    xmlData[i+3] === 'L' &&
    xmlData[i+4] === 'E' &&
    xmlData[i+5] === 'M' &&
    xmlData[i+6] === 'E' &&
    xmlData[i+7] === 'N' &&
    xmlData[i+8] === 'T') return true
    return false
}

function isAttlist(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === 'A' &&
    xmlData[i+3] === 'T' &&
    xmlData[i+4] === 'T' &&
    xmlData[i+5] === 'L' &&
    xmlData[i+6] === 'I' &&
    xmlData[i+7] === 'S' &&
    xmlData[i+8] === 'T') return true
    return false
}
function isNotation(xmlData, i){
    if(xmlData[i+1] === '!' &&
    xmlData[i+2] === 'N' &&
    xmlData[i+3] === 'O' &&
    xmlData[i+4] === 'T' &&
    xmlData[i+5] === 'A' &&
    xmlData[i+6] === 'T' &&
    xmlData[i+7] === 'I' &&
    xmlData[i+8] === 'O' &&
    xmlData[i+9] === 'N') return true
    return false
}

//an entity name should not contains special characters that may be used in regex
//Eg !?\\\/[]$%{}^&*()<>
const specialChar = "!?\\\/[]$%{}^&*()<>|+";

function validateEntityName(name){
    for (let i = 0; i < specialChar.length; i++) {
        const ch = specialChar[i];
        if(name.indexOf(ch) !== -1) throw new Error(`Invalid character ${ch} in entity name`);
    }
    return name;
}

var DocTypeReader = readDocType$1;

const hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
// const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;


//polyfill
if (!Number.parseInt && window.parseInt) {
    Number.parseInt = window.parseInt;
}
if (!Number.parseFloat && window.parseFloat) {
    Number.parseFloat = window.parseFloat;
}

  
const consider = {
    hex :  true,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
    //skipLike: /regex/
};

function toNumber$1(str, options = {}){
    // const options = Object.assign({}, consider);
    // if(opt.leadingZeros === false){
    //     options.leadingZeros = false;
    // }else if(opt.hex === false){
    //     options.hex = false;
    // }

    options = Object.assign({}, consider, options );
    if(!str || typeof str !== "string" ) return str;
    
    let trimmedStr  = str.trim();
    // if(trimmedStr === "0.0") return 0;
    // else if(trimmedStr === "+0.0") return 0;
    // else if(trimmedStr === "-0.0") return -0;

    if(options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (options.hex && hexRegex.test(trimmedStr)) {
        return Number.parseInt(trimmedStr, 16);
    // } else if (options.parseOct && octRegex.test(str)) {
    //     return Number.parseInt(val, 8);
    // }else if (options.parseBin && binRegex.test(str)) {
    //     return Number.parseInt(val, 2);
    }else {
        //separate negative sign, leading zeros, and rest number
        const match = numRegex.exec(trimmedStr);
        if(match){
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            
            const eNotation = match[4] || match[6];
            if(!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if(!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else {//no leading zeros or leading zeros are allowed
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if(numStr.search(/[eE]/) !== -1){ //given number is long and parsed to eNotation
                    if(options.eNotation) return num;
                    else return str;
                }else if(eNotation){ //given number has enotation
                    if(options.eNotation) return num;
                    else return str;
                }else if(trimmedStr.indexOf(".") !== -1){ //floating number
                    // const decimalPart = match[5].substr(1);
                    // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));

                    
                    // const p = numStr.indexOf(".");
                    // const givenIntPart = numStr.substr(0,p);
                    // const givenDecPart = numStr.substr(p+1);
                    if(numStr === "0" && (numTrimmedByZeros === "") ) return num; //0.0
                    else if(numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if( sign && numStr === "-"+numTrimmedByZeros) return num;
                    else return str;
                }
                
                if(leadingZeros){
                    // if(numTrimmedByZeros === numStr){
                    //     if(options.leadingZeros) return num;
                    //     else return str;
                    // }else return str;
                    if(numTrimmedByZeros === numStr) return num;
                    else if(sign+numTrimmedByZeros === numStr) return num;
                    else return str;
                }

                if(trimmedStr === numStr) return num;
                else if(trimmedStr === sign+numStr) return num;
                // else{
                //     //number with +/- sign
                //     trimmedStr.test(/[-+][0-9]);

                // }
                return str;
            }
            // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
            
        }else { //non-numeric string
            return str;
        }
    }
}

/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */
function trimZeros(numStr){
    if(numStr && numStr.indexOf(".") !== -1){//float
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if(numStr === ".")  numStr = "0";
        else if(numStr[0] === ".")  numStr = "0"+numStr;
        else if(numStr[numStr.length-1] === ".")  numStr = numStr.substr(0,numStr.length-1);
        return numStr;
    }
    return numStr;
}
var strnum = toNumber$1;

///@ts-check

const util$2 = util$4;
const xmlNode = xmlNode$1;
const readDocType = DocTypeReader;
const toNumber = strnum;

'<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
  .replace(/NAME/g, util$2.nameRegexp);

//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");

class OrderedObjParser$1{
  constructor(options){
    this.options = options;
    this.currentNode = null;
    this.tagsNodeStack = [];
    this.docTypeEntities = {};
    this.lastEntities = {
      "apos" : { regex: /&(apos|#39|#x27);/g, val : "'"},
      "gt" : { regex: /&(gt|#62|#x3E);/g, val : ">"},
      "lt" : { regex: /&(lt|#60|#x3C);/g, val : "<"},
      "quot" : { regex: /&(quot|#34|#x22);/g, val : "\""},
    };
    this.ampEntity = { regex: /&(amp|#38|#x26);/g, val : "&"};
    this.htmlEntities = {
      "space": { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      "cent" : { regex: /&(cent|#162);/g, val: "¢" },
      "pound" : { regex: /&(pound|#163);/g, val: "£" },
      "yen" : { regex: /&(yen|#165);/g, val: "¥" },
      "euro" : { regex: /&(euro|#8364);/g, val: "€" },
      "copyright" : { regex: /&(copy|#169);/g, val: "©" },
      "reg" : { regex: /&(reg|#174);/g, val: "®" },
      "inr" : { regex: /&(inr|#8377);/g, val: "₹" },
    };
    this.addExternalEntities = addExternalEntities;
    this.parseXml = parseXml;
    this.parseTextData = parseTextData;
    this.resolveNameSpace = resolveNameSpace;
    this.buildAttributesMap = buildAttributesMap;
    this.isItStopNode = isItStopNode;
    this.replaceEntitiesValue = replaceEntitiesValue$1;
    this.readStopNodeData = readStopNodeData;
    this.saveTextToParentTag = saveTextToParentTag;
    this.addChild = addChild;
  }

}

function addExternalEntities(externalEntities){
  const entKeys = Object.keys(externalEntities);
  for (let i = 0; i < entKeys.length; i++) {
    const ent = entKeys[i];
    this.lastEntities[ent] = {
       regex: new RegExp("&"+ent+";","g"),
       val : externalEntities[ent]
    };
  }
}

/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */
function parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
  if (val !== undefined) {
    if (this.options.trimValues && !dontTrim) {
      val = val.trim();
    }
    if(val.length > 0){
      if(!escapeEntities) val = this.replaceEntitiesValue(val);
      
      const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
      if(newval === null || newval === undefined){
        //don't parse
        return val;
      }else if(typeof newval !== typeof val || newval !== val){
        //overwrite
        return newval;
      }else if(this.options.trimValues){
        return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
      }else {
        const trimmedVal = val.trim();
        if(trimmedVal === val){
          return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
        }else {
          return val;
        }
      }
    }
  }
}

function resolveNameSpace(tagname) {
  if (this.options.removeNSPrefix) {
    const tags = tagname.split(':');
    const prefix = tagname.charAt(0) === '/' ? '/' : '';
    if (tags[0] === 'xmlns') {
      return '';
    }
    if (tags.length === 2) {
      tagname = prefix + tags[1];
    }
  }
  return tagname;
}

//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');

function buildAttributesMap(attrStr, jPath, tagName) {
  if (!this.options.ignoreAttributes && typeof attrStr === 'string') {
    // attrStr = attrStr.replace(/\r?\n/g, ' ');
    //attrStr = attrStr || attrStr.trim();

    const matches = util$2.getAllMatches(attrStr, attrsRegx);
    const len = matches.length; //don't make it inline
    const attrs = {};
    for (let i = 0; i < len; i++) {
      const attrName = this.resolveNameSpace(matches[i][1]);
      let oldVal = matches[i][4];
      let aName = this.options.attributeNamePrefix + attrName;
      if (attrName.length) {
        if (this.options.transformAttributeName) {
          aName = this.options.transformAttributeName(aName);
        }
        if(aName === "__proto__") aName  = "#__proto__";
        if (oldVal !== undefined) {
          if (this.options.trimValues) {
            oldVal = oldVal.trim();
          }
          oldVal = this.replaceEntitiesValue(oldVal);
          const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
          if(newVal === null || newVal === undefined){
            //don't parse
            attrs[aName] = oldVal;
          }else if(typeof newVal !== typeof oldVal || newVal !== oldVal){
            //overwrite
            attrs[aName] = newVal;
          }else {
            //parse
            attrs[aName] = parseValue(
              oldVal,
              this.options.parseAttributeValue,
              this.options.numberParseOptions
            );
          }
        } else if (this.options.allowBooleanAttributes) {
          attrs[aName] = true;
        }
      }
    }
    if (!Object.keys(attrs).length) {
      return;
    }
    if (this.options.attributesGroupName) {
      const attrCollection = {};
      attrCollection[this.options.attributesGroupName] = attrs;
      return attrCollection;
    }
    return attrs
  }
}

const parseXml = function(xmlData) {
  xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
  const xmlObj = new xmlNode('!xml');
  let currentNode = xmlObj;
  let textData = "";
  let jPath = "";
  for(let i=0; i< xmlData.length; i++){//for each char in XML data
    const ch = xmlData[i];
    if(ch === '<'){
      // const nextIndex = i+1;
      // const _2ndChar = xmlData[nextIndex];
      if( xmlData[i+1] === '/') {//Closing Tag
        const closeIndex = findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
        let tagName = xmlData.substring(i+2,closeIndex).trim();

        if(this.options.removeNSPrefix){
          const colonIndex = tagName.indexOf(":");
          if(colonIndex !== -1){
            tagName = tagName.substr(colonIndex+1);
          }
        }

        if(this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }

        if(currentNode){
          textData = this.saveTextToParentTag(textData, currentNode, jPath);
        }

        //check if last tag of nested tag was unpaired tag
        const lastTagName = jPath.substring(jPath.lastIndexOf(".")+1);
        if(tagName && this.options.unpairedTags.indexOf(tagName) !== -1 ){
          throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
        }
        let propIndex = 0;
        if(lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1 ){
          propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.')-1);
          this.tagsNodeStack.pop();
        }else {
          propIndex = jPath.lastIndexOf(".");
        }
        jPath = jPath.substring(0, propIndex);

        currentNode = this.tagsNodeStack.pop();//avoid recursion, set the parent tag scope
        textData = "";
        i = closeIndex;
      } else if( xmlData[i+1] === '?') {

        let tagData = readTagExp(xmlData,i, false, "?>");
        if(!tagData) throw new Error("Pi Tag is not closed.");

        textData = this.saveTextToParentTag(textData, currentNode, jPath);
        if( (this.options.ignoreDeclaration && tagData.tagName === "?xml") || this.options.ignorePiTags);else {
  
          const childNode = new xmlNode(tagData.tagName);
          childNode.add(this.options.textNodeName, "");
          
          if(tagData.tagName !== tagData.tagExp && tagData.attrExpPresent){
            childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
          }
          this.addChild(currentNode, childNode, jPath);

        }


        i = tagData.closeIndex + 1;
      } else if(xmlData.substr(i + 1, 3) === '!--') {
        const endIndex = findClosingIndex(xmlData, "-->", i+4, "Comment is not closed.");
        if(this.options.commentPropName){
          const comment = xmlData.substring(i + 4, endIndex - 2);

          textData = this.saveTextToParentTag(textData, currentNode, jPath);

          currentNode.add(this.options.commentPropName, [ { [this.options.textNodeName] : comment } ]);
        }
        i = endIndex;
      } else if( xmlData.substr(i + 1, 2) === '!D') {
        const result = readDocType(xmlData, i);
        this.docTypeEntities = result.entities;
        i = result.i;
      }else if(xmlData.substr(i + 1, 2) === '![') {
        const closeIndex = findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
        const tagExp = xmlData.substring(i + 9,closeIndex);

        textData = this.saveTextToParentTag(textData, currentNode, jPath);

        //cdata should be set even if it is 0 length string
        if(this.options.cdataPropName){
          // let val = this.parseTextData(tagExp, this.options.cdataPropName, jPath + "." + this.options.cdataPropName, true, false, true);
          // if(!val) val = "";
          currentNode.add(this.options.cdataPropName, [ { [this.options.textNodeName] : tagExp } ]);
        }else {
          let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true);
          if(val == undefined) val = "";
          currentNode.add(this.options.textNodeName, val);
        }
        
        i = closeIndex + 2;
      }else {//Opening tag
        let result = readTagExp(xmlData,i, this.options.removeNSPrefix);
        let tagName= result.tagName;
        let tagExp = result.tagExp;
        let attrExpPresent = result.attrExpPresent;
        let closeIndex = result.closeIndex;

        if (this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }
        
        //save text as child node
        if (currentNode && textData) {
          if(currentNode.tagname !== '!xml'){
            //when nested tag is found
            textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
          }
        }

        //check if last tag was unpaired tag
        const lastTag = currentNode;
        if(lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1 ){
          currentNode = this.tagsNodeStack.pop();
          jPath = jPath.substring(0, jPath.lastIndexOf("."));
        }
        if(tagName !== xmlObj.tagname){
          jPath += jPath ? "." + tagName : tagName;
        }
        if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) { //TODO: namespace
          let tagContent = "";
          //self-closing tag
          if(tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1){
            i = result.closeIndex;
          }
          //unpaired tag
          else if(this.options.unpairedTags.indexOf(tagName) !== -1){
            i = result.closeIndex;
          }
          //normal tag
          else {
            //read until closing tag is found
            const result = this.readStopNodeData(xmlData, tagName, closeIndex + 1);
            if(!result) throw new Error(`Unexpected end of ${tagName}`);
            i = result.i;
            tagContent = result.tagContent;
          }

          const childNode = new xmlNode(tagName);
          if(tagName !== tagExp && attrExpPresent){
            childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
          }
          if(tagContent) {
            tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
          }
          
          jPath = jPath.substr(0, jPath.lastIndexOf("."));
          childNode.add(this.options.textNodeName, tagContent);
          
          this.addChild(currentNode, childNode, jPath);
        }else {
  //selfClosing tag
          if(tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1){
            if(tagName[tagName.length - 1] === "/"){ //remove trailing '/'
              tagName = tagName.substr(0, tagName.length - 1);
              tagExp = tagName;
            }else {
              tagExp = tagExp.substr(0, tagExp.length - 1);
            }
            
            if(this.options.transformTagName) {
              tagName = this.options.transformTagName(tagName);
            }

            const childNode = new xmlNode(tagName);
            if(tagName !== tagExp && attrExpPresent){
              childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
            }
            this.addChild(currentNode, childNode, jPath);
            jPath = jPath.substr(0, jPath.lastIndexOf("."));
          }
    //opening tag
          else {
            const childNode = new xmlNode( tagName);
            this.tagsNodeStack.push(currentNode);
            
            if(tagName !== tagExp && attrExpPresent){
              childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
            }
            this.addChild(currentNode, childNode, jPath);
            currentNode = childNode;
          }
          textData = "";
          i = closeIndex;
        }
      }
    }else {
      textData += xmlData[i];
    }
  }
  return xmlObj.child;
};

function addChild(currentNode, childNode, jPath){
  const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
  if(result === false);else if(typeof result === "string"){
    childNode.tagname = result;
    currentNode.addChild(childNode);
  }else {
    currentNode.addChild(childNode);
  }
}

const replaceEntitiesValue$1 = function(val){

  if(this.options.processEntities){
    for(let entityName in this.docTypeEntities){
      const entity = this.docTypeEntities[entityName];
      val = val.replace( entity.regx, entity.val);
    }
    for(let entityName in this.lastEntities){
      const entity = this.lastEntities[entityName];
      val = val.replace( entity.regex, entity.val);
    }
    if(this.options.htmlEntities){
      for(let entityName in this.htmlEntities){
        const entity = this.htmlEntities[entityName];
        val = val.replace( entity.regex, entity.val);
      }
    }
    val = val.replace( this.ampEntity.regex, this.ampEntity.val);
  }
  return val;
};
function saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
  if (textData) { //store previously collected data as textNode
    if(isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0;
    
    textData = this.parseTextData(textData,
      currentNode.tagname,
      jPath,
      false,
      currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false,
      isLeafNode);

    if (textData !== undefined && textData !== "")
      currentNode.add(this.options.textNodeName, textData);
    textData = "";
  }
  return textData;
}

//TODO: use jPath to simplify the logic
/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */
function isItStopNode(stopNodes, jPath, currentTagName){
  const allNodesExp = "*." + currentTagName;
  for (const stopNodePath in stopNodes) {
    const stopNodeExp = stopNodes[stopNodePath];
    if( allNodesExp === stopNodeExp || jPath === stopNodeExp  ) return true;
  }
  return false;
}

/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */
function tagExpWithClosingIndex(xmlData, i, closingChar = ">"){
  let attrBoundary;
  let tagExp = "";
  for (let index = i; index < xmlData.length; index++) {
    let ch = xmlData[index];
    if (attrBoundary) {
        if (ch === attrBoundary) attrBoundary = "";//reset
    } else if (ch === '"' || ch === "'") {
        attrBoundary = ch;
    } else if (ch === closingChar[0]) {
      if(closingChar[1]){
        if(xmlData[index + 1] === closingChar[1]){
          return {
            data: tagExp,
            index: index
          }
        }
      }else {
        return {
          data: tagExp,
          index: index
        }
      }
    } else if (ch === '\t') {
      ch = " ";
    }
    tagExp += ch;
  }
}

function findClosingIndex(xmlData, str, i, errMsg){
  const closingIndex = xmlData.indexOf(str, i);
  if(closingIndex === -1){
    throw new Error(errMsg)
  }else {
    return closingIndex + str.length - 1;
  }
}

function readTagExp(xmlData,i, removeNSPrefix, closingChar = ">"){
  const result = tagExpWithClosingIndex(xmlData, i+1, closingChar);
  if(!result) return;
  let tagExp = result.data;
  const closeIndex = result.index;
  const separatorIndex = tagExp.search(/\s/);
  let tagName = tagExp;
  let attrExpPresent = true;
  if(separatorIndex !== -1){//separate tag name and attributes expression
    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, '');
    tagExp = tagExp.substr(separatorIndex + 1);
  }

  if(removeNSPrefix){
    const colonIndex = tagName.indexOf(":");
    if(colonIndex !== -1){
      tagName = tagName.substr(colonIndex+1);
      attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
    }
  }

  return {
    tagName: tagName,
    tagExp: tagExp,
    closeIndex: closeIndex,
    attrExpPresent: attrExpPresent,
  }
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */
function readStopNodeData(xmlData, tagName, i){
  const startIndex = i;
  // Starting at 1 since we already have an open tag
  let openTagCount = 1;

  for (; i < xmlData.length; i++) {
    if( xmlData[i] === "<"){ 
      if (xmlData[i+1] === "/") {//close tag
          const closeIndex = findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
          let closeTagName = xmlData.substring(i+2,closeIndex).trim();
          if(closeTagName === tagName){
            openTagCount--;
            if (openTagCount === 0) {
              return {
                tagContent: xmlData.substring(startIndex, i),
                i : closeIndex
              }
            }
          }
          i=closeIndex;
        } else if(xmlData[i+1] === '?') { 
          const closeIndex = findClosingIndex(xmlData, "?>", i+1, "StopNode is not closed.");
          i=closeIndex;
        } else if(xmlData.substr(i + 1, 3) === '!--') { 
          const closeIndex = findClosingIndex(xmlData, "-->", i+3, "StopNode is not closed.");
          i=closeIndex;
        } else if(xmlData.substr(i + 1, 2) === '![') { 
          const closeIndex = findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
          i=closeIndex;
        } else {
          const tagData = readTagExp(xmlData, i, '>');

          if (tagData) {
            const openTagName = tagData && tagData.tagName;
            if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length-1] !== "/") {
              openTagCount++;
            }
            i=tagData.closeIndex;
          }
        }
      }
  }//end for loop
}

function parseValue(val, shouldParse, options) {
  if (shouldParse && typeof val === 'string') {
    //console.log(options)
    const newval = val.trim();
    if(newval === 'true' ) return true;
    else if(newval === 'false' ) return false;
    else return toNumber(val, options);
  } else {
    if (util$2.isExist(val)) {
      return val;
    } else {
      return '';
    }
  }
}


var OrderedObjParser_1 = OrderedObjParser$1;

var node2json = {};

/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */
function prettify$1(node, options){
  return compress( node, options);
}

/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */
function compress(arr, options, jPath){
  let text;
  const compressedObj = {};
  for (let i = 0; i < arr.length; i++) {
    const tagObj = arr[i];
    const property = propName$1(tagObj);
    let newJpath = "";
    if(jPath === undefined) newJpath = property;
    else newJpath = jPath + "." + property;

    if(property === options.textNodeName){
      if(text === undefined) text = tagObj[property];
      else text += "" + tagObj[property];
    }else if(property === undefined){
      continue;
    }else if(tagObj[property]){
      
      let val = compress(tagObj[property], options, newJpath);
      const isLeaf = isLeafTag(val, options);

      if(tagObj[":@"]){
        assignAttributes( val, tagObj[":@"], newJpath, options);
      }else if(Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode){
        val = val[options.textNodeName];
      }else if(Object.keys(val).length === 0){
        if(options.alwaysCreateTextNode) val[options.textNodeName] = "";
        else val = "";
      }

      if(compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
        if(!Array.isArray(compressedObj[property])) {
            compressedObj[property] = [ compressedObj[property] ];
        }
        compressedObj[property].push(val);
      }else {
        //TODO: if a node is not an array, then check if it should be an array
        //also determine if it is a leaf node
        if (options.isArray(property, newJpath, isLeaf )) {
          compressedObj[property] = [val];
        }else {
          compressedObj[property] = val;
        }
      }
    }
    
  }
  // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
  if(typeof text === "string"){
    if(text.length > 0) compressedObj[options.textNodeName] = text;
  }else if(text !== undefined) compressedObj[options.textNodeName] = text;
  return compressedObj;
}

function propName$1(obj){
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if(key !== ":@") return key;
  }
}

function assignAttributes(obj, attrMap, jpath, options){
  if (attrMap) {
    const keys = Object.keys(attrMap);
    const len = keys.length; //don't make it inline
    for (let i = 0; i < len; i++) {
      const atrrName = keys[i];
      if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) {
        obj[atrrName] = [ attrMap[atrrName] ];
      } else {
        obj[atrrName] = attrMap[atrrName];
      }
    }
  }
}

function isLeafTag(obj, options){
  const { textNodeName } = options;
  const propCount = Object.keys(obj).length;
  
  if (propCount === 0) {
    return true;
  }

  if (
    propCount === 1 &&
    (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)
  ) {
    return true;
  }

  return false;
}
node2json.prettify = prettify$1;

const { buildOptions} = OptionsBuilder;
const OrderedObjParser = OrderedObjParser_1;
const { prettify} = node2json;
const validator$1 = validator$2;

class XMLParser$1{
    
    constructor(options){
        this.externalEntities = {};
        this.options = buildOptions(options);
        
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */
    parse(xmlData,validationOption){
        if(typeof xmlData === "string");else if( xmlData.toString){
            xmlData = xmlData.toString();
        }else {
            throw new Error("XML data is accepted in String or Bytes[] form.")
        }
        if( validationOption){
            if(validationOption === true) validationOption = {}; //validate with default options
            
            const result = validator$1.validate(xmlData, validationOption);
            if (result !== true) {
              throw Error( `${result.err.msg}:${result.err.line}:${result.err.col}` )
            }
          }
        const orderedObjParser = new OrderedObjParser(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if(this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return prettify(orderedResult, this.options);
    }

    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */
    addEntity(key, value){
        if(value.indexOf("&") !== -1){
            throw new Error("Entity value can't have '&'")
        }else if(key.indexOf("&") !== -1 || key.indexOf(";") !== -1){
            throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'")
        }else if(value === "&"){
            throw new Error("An entity with value '&' is not permitted");
        }else {
            this.externalEntities[key] = value;
        }
    }
}

var XMLParser_1 = XMLParser$1;

const EOL = "\n";

/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */
function toXml(jArray, options) {
    let indentation = "";
    if (options.format && options.indentBy.length > 0) {
        indentation = EOL;
    }
    return arrToStr(jArray, options, "", indentation);
}

function arrToStr(arr, options, jPath, indentation) {
    let xmlStr = "";
    let isPreviousElementTag = false;

    for (let i = 0; i < arr.length; i++) {
        const tagObj = arr[i];
        const tagName = propName(tagObj);
        let newJPath = "";
        if (jPath.length === 0) newJPath = tagName;
        else newJPath = `${jPath}.${tagName}`;

        if (tagName === options.textNodeName) {
            let tagText = tagObj[tagName];
            if (!isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = replaceEntitiesValue(tagText, options);
            }
            if (isPreviousElementTag) {
                xmlStr += indentation;
            }
            xmlStr += tagText;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.cdataPropName) {
            if (isPreviousElementTag) {
                xmlStr += indentation;
            }
            xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.commentPropName) {
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            isPreviousElementTag = true;
            continue;
        } else if (tagName[0] === "?") {
            const attStr = attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            isPreviousElementTag = true;
            continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") {
            newIdentation += options.indentBy;
        }
        const attStr = attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
            if (options.suppressUnpairedNode) xmlStr += tagStart + ">";
            else xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) {
            xmlStr += tagStart + "/>";
        } else if (tagValue && tagValue.endsWith(">")) {
            xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        } else {
            xmlStr += tagStart + ">";
            if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) {
                xmlStr += indentation + options.indentBy + tagValue + indentation;
            } else {
                xmlStr += tagValue;
            }
            xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
    }

    return xmlStr;
}

function propName(obj) {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (key !== ":@") return key;
    }
}

function attr_to_str(attrMap, options) {
    let attrStr = "";
    if (attrMap && !options.ignoreAttributes) {
        for (let attr in attrMap) {
            let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
            attrVal = replaceEntitiesValue(attrVal, options);
            if (attrVal === true && options.suppressBooleanAttributes) {
                attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
            } else {
                attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
            }
        }
    }
    return attrStr;
}

function isStopNode(jPath, options) {
    jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for (let index in options.stopNodes) {
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
    }
    return false;
}

function replaceEntitiesValue(textValue, options) {
    if (textValue && textValue.length > 0 && options.processEntities) {
        for (let i = 0; i < options.entities.length; i++) {
            const entity = options.entities[i];
            textValue = textValue.replace(entity.regex, entity.val);
        }
    }
    return textValue;
}
var orderedJs2Xml = toXml;

//parse Empty Node as self closing node
const buildFromOrderedJs = orderedJs2Xml;

const defaultOptions$1 = {
  attributeNamePrefix: '@_',
  attributesGroupName: false,
  textNodeName: '#text',
  ignoreAttributes: true,
  cdataPropName: false,
  format: false,
  indentBy: '  ',
  suppressEmptyNode: false,
  suppressUnpairedNode: true,
  suppressBooleanAttributes: true,
  tagValueProcessor: function(key, a) {
    return a;
  },
  attributeValueProcessor: function(attrName, a) {
    return a;
  },
  preserveOrder: false,
  commentPropName: false,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },//it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("\'", "g"), val: "&apos;" },
    { regex: new RegExp("\"", "g"), val: "&quot;" }
  ],
  processEntities: true,
  stopNodes: [],
  // transformTagName: false,
  // transformAttributeName: false,
  oneListGroup: false
};

function Builder(options) {
  this.options = Object.assign({}, defaultOptions$1, options);
  if (this.options.ignoreAttributes || this.options.attributesGroupName) {
    this.isAttribute = function(/*a*/) {
      return false;
    };
  } else {
    this.attrPrefixLen = this.options.attributeNamePrefix.length;
    this.isAttribute = isAttribute;
  }

  this.processTextOrObjNode = processTextOrObjNode;

  if (this.options.format) {
    this.indentate = indentate;
    this.tagEndChar = '>\n';
    this.newLine = '\n';
  } else {
    this.indentate = function() {
      return '';
    };
    this.tagEndChar = '>';
    this.newLine = '';
  }
}

Builder.prototype.build = function(jObj) {
  if(this.options.preserveOrder){
    return buildFromOrderedJs(jObj, this.options);
  }else {
    if(Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1){
      jObj = {
        [this.options.arrayNodeName] : jObj
      };
    }
    return this.j2x(jObj, 0).val;
  }
};

Builder.prototype.j2x = function(jObj, level) {
  let attrStr = '';
  let val = '';
  for (let key in jObj) {
    if (typeof jObj[key] === 'undefined') ; else if (jObj[key] === null) {
      if(key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
      else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
      // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
    } else if (jObj[key] instanceof Date) {
      val += this.buildTextValNode(jObj[key], key, '', level);
    } else if (typeof jObj[key] !== 'object') {
      //premitive type
      const attr = this.isAttribute(key);
      if (attr) {
        attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
      }else {
        //tag value
        if (key === this.options.textNodeName) {
          let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
          val += this.replaceEntitiesValue(newval);
        } else {
          val += this.buildTextValNode(jObj[key], key, '', level);
        }
      }
    } else if (Array.isArray(jObj[key])) {
      //repeated nodes
      const arrLen = jObj[key].length;
      let listTagVal = "";
      for (let j = 0; j < arrLen; j++) {
        const item = jObj[key][j];
        if (typeof item === 'undefined') ; else if (item === null) {
          if(key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
          else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
          // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (typeof item === 'object') {
          if(this.options.oneListGroup ){
            listTagVal += this.j2x(item, level + 1).val;
          }else {
            listTagVal += this.processTextOrObjNode(item, key, level);
          }
        } else {
          listTagVal += this.buildTextValNode(item, key, '', level);
        }
      }
      if(this.options.oneListGroup){
        listTagVal = this.buildObjectNode(listTagVal, key, '', level);
      }
      val += listTagVal;
    } else {
      //nested node
      if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
        const Ks = Object.keys(jObj[key]);
        const L = Ks.length;
        for (let j = 0; j < L; j++) {
          attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        }
      } else {
        val += this.processTextOrObjNode(jObj[key], key, level);
      }
    }
  }
  return {attrStr: attrStr, val: val};
};

Builder.prototype.buildAttrPairStr = function(attrName, val){
  val = this.options.attributeValueProcessor(attrName, '' + val);
  val = this.replaceEntitiesValue(val);
  if (this.options.suppressBooleanAttributes && val === "true") {
    return ' ' + attrName;
  } else return ' ' + attrName + '="' + val + '"';
};

function processTextOrObjNode (object, key, level) {
  const result = this.j2x(object, level + 1);
  if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) {
    return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
  } else {
    return this.buildObjectNode(result.val, key, result.attrStr, level);
  }
}

Builder.prototype.buildObjectNode = function(val, key, attrStr, level) {
  if(val === ""){
    if(key[0] === "?") return  this.indentate(level) + '<' + key + attrStr+ '?' + this.tagEndChar;
    else {
      return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    }
  }else {

    let tagEndExp = '</' + key + this.tagEndChar;
    let piClosingChar = "";
    
    if(key[0] === "?") {
      piClosingChar = "?";
      tagEndExp = "";
    }
  
    if (attrStr && val.indexOf('<') === -1) {
      return ( this.indentate(level) + '<' +  key + attrStr + piClosingChar + '>' + val + tagEndExp );
    } else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) {
      return this.indentate(level) + `<!--${val}-->` + this.newLine;
    }else {
      return (
        this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar +
        val +
        this.indentate(level) + tagEndExp    );
    }
  }
};

Builder.prototype.closeTag = function(key){
  let closeTag = "";
  if(this.options.unpairedTags.indexOf(key) !== -1){ //unpaired
    if(!this.options.suppressUnpairedNode) closeTag = "/";
  }else if(this.options.suppressEmptyNode){ //empty
    closeTag = "/";
  }else {
    closeTag = `></${key}`;
  }
  return closeTag;
};

Builder.prototype.buildTextValNode = function(val, key, attrStr, level) {
  if (this.options.cdataPropName !== false && key === this.options.cdataPropName) {
    return this.indentate(level) + `<![CDATA[${val}]]>` +  this.newLine;
  }else if (this.options.commentPropName !== false && key === this.options.commentPropName) {
    return this.indentate(level) + `<!--${val}-->` +  this.newLine;
  }else if(key[0] === "?") {//PI tag
    return  this.indentate(level) + '<' + key + attrStr+ '?' + this.tagEndChar; 
  }else {
    let textValue = this.options.tagValueProcessor(key, val);
    textValue = this.replaceEntitiesValue(textValue);
  
    if( textValue === ''){
      return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    }else {
      return this.indentate(level) + '<' + key + attrStr + '>' +
         textValue +
        '</' + key + this.tagEndChar;
    }
  }
};

Builder.prototype.replaceEntitiesValue = function(textValue){
  if(textValue && textValue.length > 0 && this.options.processEntities){
    for (let i=0; i<this.options.entities.length; i++) {
      const entity = this.options.entities[i];
      textValue = textValue.replace(entity.regex, entity.val);
    }
  }
  return textValue;
};

function indentate(level) {
  return this.options.indentBy.repeat(level);
}

function isAttribute(name /*, options*/) {
  if (name.startsWith(this.options.attributeNamePrefix)) {
    return name.substr(this.attrPrefixLen);
  } else {
    return false;
  }
}

var json2xml = Builder;

const validator = validator$2;
const XMLParser = XMLParser_1;
const XMLBuilder = json2xml;

var fxp = {
  XMLParser: XMLParser,
  XMLValidator: validator,
  XMLBuilder: XMLBuilder
};

var cardScanPackageVersion = '3.0.9';

var CardState;
(function (CardState) {
    CardState["pending"] = "pending";
    CardState["frontsideProcessing"] = "frontside_processing";
    CardState["frontsideFailed"] = "frontside_failed";
    CardState["backsideProcessing"] = "backside_processing";
    CardState["backsideFailed"] = "backside_failed";
    CardState["completed"] = "completed";
    CardState["error"] = "error";
    CardState["unknown"] = "unknown";
})(CardState || (CardState = {}));
//TODO: this needs to be implemented or deleted.
var CardFields;
(function (CardFields) {
    CardFields["groupNumber"] = "group_number";
    CardFields["payerName"] = "payer_name";
    CardFields["memberNumber"] = "member_number";
    CardFields["memberName"] = "member_name";
    CardFields["dependentNames"] = "dependent_names";
    CardFields["rxBin"] = "rx_bin";
    CardFields["rxPCN"] = "rx_pcn";
    CardFields["rxGroup"] = "rx_group";
})(CardFields || (CardFields = {}));
var Card = /** @class */ (function () {
    function Card(params) {
        this.cardId = params.card_id;
        this.state = params.state;
        this.createdAt = params.created_at;
        this.message = params.message ? params.message : undefined;
        this.images = params.images;
        this.details = params.details
            ? {
                memberNumber: params === null || params === void 0 ? void 0 : params.details.member_number,
                groupNumber: params.details.group_number,
                payerName: params.details.payer_name,
                rxBin: params.details.rx_bin,
                rxPCN: params.details.rx_pcn,
                rxGroup: params.details.rx_group,
                memberName: params.details.member_name,
                dependentNames: params.details.dependent_names,
                planName: params.details.plan_name,
                planId: params.details.plan_id,
                clientName: params.details.client_name,
                startDate: params.details.start_date,
                cardSpecificId: params.details.card_specific_id,
            }
            : undefined;
    }
    return Card;
}());

var XMLErrortoCardScanError = function (xmlErrorObj, code) { return ({
    message: xmlErrorObj.Message._text,
    type: xmlErrorObj.Code._text,
    code: code,
    isCardScanError: true,
}); };
var generateError = function (message, type, code) {
    if (type === void 0) { type = "ApiError"; }
    if (code === void 0) { code = 696; }
    return ({
        message: message,
        type: type,
        code: code,
        isCardScanError: true,
    });
};

var SANDBOX_SERVER = "REACT_APP_CARDSCAN_SERVER" in process.env
    ? process.env.REACT_APP_CARDSCAN_SERVER
    : "https://sandbox.cardscan.ai/v1/";
var SANDBOX_WEBSOCKET_SERVER = "REACT_APP_CARDSCAN_WEBSOCKET_SERVER" in process.env
    ? process.env.REACT_APP_CARDSCAN_WEBSOCKET_SERVER
    : "sandbox-ws.cardscan.ai";
var CardScanApi = /** @class */ (function () {
    function CardScanApi(params) {
        var _this = this;
        this.initializeRequestInterceptor = function () {
            _this.instance.interceptors.request.use(_this.handleRequest);
        };
        this.handleRequest = function (config) {
            if (config && config.headers) {
                config.headers.Authorization = "Bearer ".concat(_this.sessionToken);
                config.headers["x-cardscan-ai-sdk"] = "insurance_cardscan_react  ".concat(cardScanPackageVersion);
            }
            return config;
        };
        this.generateUploadUrl = function (cardId, payload) {
            return _this.instance.post("/cards/".concat(cardId, "/generate-upload-url"), payload);
        };
        this.generateMagicLink = function () {
            return _this.instance.get("/generate-magic-link");
        };
        this.uploadCardImage = function (file) {
            var formData = new FormData();
            return _this.instance
                .get("/generate-upload-url")
                .then(function (response) { return response.data; })
                .then(function (cardUploadRes) {
                var upload_parameters = cardUploadRes.upload_parameters;
                for (var key in upload_parameters) {
                    formData.append(key, upload_parameters[key]);
                }
                formData.append("file", file);
                return {
                    uploadUrl: cardUploadRes.upload_url,
                    cardId: cardUploadRes.card_id,
                };
            })
                .then(function (_a) {
                var uploadUrl = _a.uploadUrl, cardId = _a.cardId;
                // needs to be axios and not this.instance because can't use authorization header.
                return axios$1
                    .post(uploadUrl, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(function () { return cardId; })
                    .catch(function (error) {
                    //errors back from S3 will be in XML.
                    if (error.response && error.response.data) {
                        var parser = new fxp.XMLParser();
                        var errorResponse = parser.parse(error.response.data);
                        var cardError = XMLErrortoCardScanError(errorResponse.Error, error.response.status);
                        console.error("Error uploading file: ", cardError);
                        throw cardError;
                    }
                    else {
                        throw error;
                    }
                });
            });
        };
        this.uploadScanImage = function (file, cardId, captureType, orientation, metadata) {
            var payload = {
                metadata: metadata || {},
                capture_type: captureType,
                orientation: orientation,
            };
            return _this.uploadScan(cardId, file, orientation, captureType)
                .then(function (response) { return response.data; })
                .then(function (data) {
                _this.setScanMetadata(data.scan_id, payload);
                return {
                    scanId: data.scan_id,
                    cardId: data.card_id,
                };
            });
        };
        this.uploadScan = function (cardId, file, orientation, captureType) {
            return _this.instance.post("/cards/".concat(cardId, "/upload"), file, {
                params: {
                    orientation: orientation,
                    capture_type: captureType,
                },
                headers: {
                    "Content-Type": file.type,
                },
            });
        };
        this.setScanMetadata = function (scanId, metadata) {
            return _this.instance.post("/scans/".concat(scanId, "/metadata"), metadata);
        };
        this.listCards = function (params) {
            var config = {
                params: {},
            };
            if (params === null || params === void 0 ? void 0 : params.cursor)
                config.params.cursor = params === null || params === void 0 ? void 0 : params.cursor;
            if (params === null || params === void 0 ? void 0 : params.limit)
                config.params.limit = params === null || params === void 0 ? void 0 : params.limit;
            return _this.instance.get("/cards", config);
        };
        this.getCard = function (cardId) {
            return _this.instance.get("/cards/".concat(cardId));
        };
        this.getCardImage = function (cardId) {
            return _this.instance.get("/cards/".concat(cardId, "/image"));
        };
        this.createCard = function (backsideSupport, requiredFields, optionalFields, eligibility) {
            var payload = {
                frontside: {
                    required_fields: requiredFields ? requiredFields : [],
                    optional_fields: optionalFields ? optionalFields : [],
                },
                backside: {
                    scanning: backsideSupport ? "required" : "disabled",
                },
                eligibility: eligibility,
            };
            return _this.instance.post("/cards", payload);
        };
        this.subscribe = function (cardId, callback) {
            var inProgress = false;
            var isDifferent = true;
            var lastState = "";
            _this.intervalId = setInterval(function () {
                if (!inProgress) {
                    inProgress = true;
                    _this.getCard(cardId)
                        .then(function (res) {
                        if (lastState !== res.data.state) {
                            isDifferent = true;
                        }
                        if (isDifferent) {
                            lastState = res.data.state;
                            callback(new Card(res.data));
                        }
                        inProgress = false;
                        if (["completed", "error"].includes(res.data.state))
                            _this.cancelSubscription();
                    })
                        .catch(function (err) {
                        console.log("err: ", err);
                        inProgress = false;
                        callback(new Card({
                            state: CardState.error,
                            message: err.response.data.message,
                            card_id: cardId,
                        }));
                        _this.cancelSubscription();
                    });
                }
            }, 1000);
        };
        this.cancelSubscription = function () {
            if (_this.intervalId) {
                clearInterval(_this.intervalId);
                _this.intervalId = null;
            }
        };
        if (!params.sessionToken || params.sessionToken.length === 0) {
            throw new Error("sessionToken is required");
        }
        this.sessionToken = params.sessionToken;
        this.instance = axios$1.create({
            baseURL: params.live ? "https://api.cardscan.ai/v1/" : SANDBOX_SERVER,
        });
        this.initializeRequestInterceptor();
        this.intervalId = null;
        //Note: This creates 2 active websockets but only in dev mode. This does NOT occur in production.
        var wsUrl = params.live
            ? "wss://ws.cardscan.ai?token=".concat(this.sessionToken)
            : "wss://".concat(SANDBOX_WEBSOCKET_SERVER, "?token=").concat(this.sessionToken);
        if (window.Cypress) {
            wsUrl = "ws://localhost:4000";
        }
        this.socket = new WebSocket(wsUrl);
    }
    return CardScanApi;
}());

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var propTypes$2 = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e$1=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h$2=b?Symbol.for("react.provider"):60109,k$1=b?Symbol.for("react.context"):60110,l$1=b?Symbol.for("react.async_mode"):60111,m$1=b?Symbol.for("react.concurrent_mode"):60111,n$2=b?Symbol.for("react.forward_ref"):60112,p$2=b?Symbol.for("react.suspense"):60113,q$2=b?
Symbol.for("react.suspense_list"):60120,r$2=b?Symbol.for("react.memo"):60115,t$2=b?Symbol.for("react.lazy"):60116,v$1=b?Symbol.for("react.block"):60121,w$1=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l$1:case m$1:case e$1:case g:case f:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$2:case t$2:case r$2:case h$2:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m$1}reactIs_production_min.AsyncMode=l$1;reactIs_production_min.ConcurrentMode=m$1;reactIs_production_min.ContextConsumer=k$1;reactIs_production_min.ContextProvider=h$2;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n$2;reactIs_production_min.Fragment=e$1;reactIs_production_min.Lazy=t$2;reactIs_production_min.Memo=r$2;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p$2;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l$1};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k$1};reactIs_production_min.isContextProvider=function(a){return z(a)===h$2};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n$2};reactIs_production_min.isFragment=function(a){return z(a)===e$1};reactIs_production_min.isLazy=function(a){return z(a)===t$2};
reactIs_production_min.isMemo=function(a){return z(a)===r$2};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p$2};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g||a===f||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$2||a.$$typeof===r$2||a.$$typeof===h$2||a.$$typeof===k$1||a.$$typeof===n$2||a.$$typeof===w$1||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v$1)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$2 = has$3;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$2(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign$4 = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has$1 = has$3;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign$4({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$2.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$2.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes$2.exports;

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var spinkitSpinners = {
  circle: { className: 'sk-circle', divCount: 12 },
  'cube-grid': { className: 'sk-cube-grid', divCount: 9 },
  wave: { className: 'sk-wave', divCount: 5 },
  'folding-cube': { className: 'sk-folding-cube', divCount: 4 },
  'three-bounce': { className: 'sk-three-bounce', divCount: 3 },
  'double-bounce': { className: 'sk-double-bounce', divCount: 2 },
  'wandering-cubes': { className: 'sk-wandering-cubes', divCount: 2 },
  'chasing-dots': { className: 'sk-chasing-dots', divCount: 2 },
  'rotating-plane': { className: 'sk-rotating-plane', divCount: 1 },
  pulse: { className: 'sk-pulse', divCount: 1 },
  wordpress: { className: 'sk-wordpress', divCount: 1 }
};

var loadersCssSpinners = {
  'ball-grid-beat': { divCount: 9 },
  'ball-grid-pulse': { divCount: 9 },
  'line-spin-fade-loader': { divCount: 8 },
  'ball-spin-fade-loader': { divCount: 8 },
  'ball-pulse-rise': { divCount: 5 },
  'line-scale': { divCount: 5 },
  'line-scale-pulse-out': { divCount: 5 },
  'line-scale-pulse-out-rapid': { divCount: 5 },
  pacman: { divCount: 5 },
  'line-scale-party': { divCount: 4 },
  'ball-triangle-path': { divCount: 3 },
  'ball-scale-multiple': { divCount: 3 },
  'ball-scale-ripple-multiple': { divCount: 3 },
  'ball-pulse-sync': { divCount: 3 },
  'ball-beat': { divCount: 3 },
  'ball-zig-zag': { divCount: 2 },
  'ball-zig-zag-deflect': { divCount: 2 },
  'ball-clip-rotate-pulse': { divCount: 2 },
  'ball-clip-rotate-multiple': { divCount: 2 },
  'ball-clip-rotate': { divCount: 1 },
  'ball-scale-ripple': { divCount: 1 },
  'triangle-skew-spin': { divCount: 1 }
};

var spinners = {
  spinkitSpinners: spinkitSpinners,
  loadersCssSpinners: loadersCssSpinners,
  allSpinners: _extends$7({}, spinkitSpinners, loadersCssSpinners)
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$p = "@-webkit-keyframes scale{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}45%{opacity:.7;-webkit-transform:scale(.1);transform:scale(.1)}80%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.ball-pulse>div:nth-child(0){-webkit-animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.36s infinite;animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.36s infinite}.ball-pulse>div:first-child{-webkit-animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.24s infinite;animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.24s infinite}.ball-pulse>div:nth-child(2){-webkit-animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.12s infinite;animation:scale .75s cubic-bezier(.2,.68,.18,1.08) -.12s infinite}.ball-pulse>div:nth-child(3){-webkit-animation:scale .75s cubic-bezier(.2,.68,.18,1.08) 0s infinite;animation:scale .75s cubic-bezier(.2,.68,.18,1.08) 0s infinite}.ball-pulse>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;display:inline-block;height:15px;margin:2px;width:15px}@-webkit-keyframes ball-pulse-sync{33%{-webkit-transform:translateY(10px);transform:translateY(10px)}66%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes ball-pulse-sync{33%{-webkit-transform:translateY(10px);transform:translateY(10px)}66%{-webkit-transform:translateY(-10px);transform:translateY(-10px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.ball-pulse-sync>div:nth-child(0){-webkit-animation:ball-pulse-sync .6s ease-in-out -.21s infinite;animation:ball-pulse-sync .6s ease-in-out -.21s infinite}.ball-pulse-sync>div:first-child{-webkit-animation:ball-pulse-sync .6s ease-in-out -.14s infinite;animation:ball-pulse-sync .6s ease-in-out -.14s infinite}.ball-pulse-sync>div:nth-child(2){-webkit-animation:ball-pulse-sync .6s ease-in-out -.07s infinite;animation:ball-pulse-sync .6s ease-in-out -.07s infinite}.ball-pulse-sync>div:nth-child(3){-webkit-animation:ball-pulse-sync .6s ease-in-out 0s infinite;animation:ball-pulse-sync .6s ease-in-out 0s infinite}.ball-pulse-sync>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;display:inline-block;height:15px;margin:2px;width:15px}@-webkit-keyframes ball-scale{0%{-webkit-transform:scale(0);transform:scale(0)}to{opacity:0;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-scale{0%{-webkit-transform:scale(0);transform:scale(0)}to{opacity:0;-webkit-transform:scale(1);transform:scale(1)}}.ball-scale>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale 1s ease-in-out 0s infinite;animation:ball-scale 1s ease-in-out 0s infinite;background-color:#fff;border-radius:100%;display:inline-block;height:15px;height:60px;margin:2px;width:15px;width:60px}.ball-scale-random{height:40px;width:37px}.ball-scale-random>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale 1s ease-in-out 0s infinite;animation:ball-scale 1s ease-in-out 0s infinite;background-color:#fff;border-radius:100%;display:inline-block;height:15px;height:30px;margin:2px;position:absolute;width:15px;width:30px}.ball-scale-random>div:first-child{-webkit-animation:ball-scale 1s ease-in-out .2s infinite;animation:ball-scale 1s ease-in-out .2s infinite;margin-left:-7px}.ball-scale-random>div:nth-child(3){-webkit-animation:ball-scale 1s ease-in-out .5s infinite;animation:ball-scale 1s ease-in-out .5s infinite;margin-left:-2px;margin-top:9px}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ball-rotate,.ball-rotate>div{position:relative}.ball-rotate>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;height:15px;margin:2px;width:15px}.ball-rotate>div:first-child{-webkit-animation:rotate 1s cubic-bezier(.7,-.13,.22,.86) 0s infinite;animation:rotate 1s cubic-bezier(.7,-.13,.22,.86) 0s infinite}.ball-rotate>div:after,.ball-rotate>div:before{background-color:#fff;border-radius:100%;content:\"\";height:15px;margin:2px;opacity:.8;position:absolute;width:15px}.ball-rotate>div:before{left:-28px;top:0}.ball-rotate>div:after{left:25px;top:0}.ball-clip-rotate>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:rotate .75s linear 0s infinite;animation:rotate .75s linear 0s infinite;background-color:#fff;background:transparent!important;border:2px solid;border-color:#fff #fff transparent;border-radius:100%;display:inline-block;height:15px;height:25px;margin:2px;width:15px;width:25px}@keyframes scale{30%{-webkit-transform:scale(.3);transform:scale(.3)}to{-webkit-transform:scale(1);transform:scale(1)}}.ball-clip-rotate-pulse{position:relative;-webkit-transform:translateY(-15px);-ms-transform:translateY(-15px);transform:translateY(-15px)}.ball-clip-rotate-pulse>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;border-radius:100%;left:0;position:absolute;top:0}.ball-clip-rotate-pulse>div:first-child{-webkit-animation:scale 1s cubic-bezier(.09,.57,.49,.9) 0s infinite;animation:scale 1s cubic-bezier(.09,.57,.49,.9) 0s infinite;background:#fff;height:16px;left:-7px;top:7px;width:16px}.ball-clip-rotate-pulse>div:last-child{-webkit-animation:rotate 1s cubic-bezier(.09,.57,.49,.9) 0s infinite;animation:rotate 1s cubic-bezier(.09,.57,.49,.9) 0s infinite;-webkit-animation-duration:1s;animation-duration:1s;background:transparent;border:2px solid;border-color:#fff transparent;border-style:solid;border-width:2px;height:30px;left:-16px;position:absolute;top:-2px;width:30px}@keyframes rotate{0%{-webkit-transform:rotate(0deg) scale(1);transform:rotate(0deg) scale(1)}50%{-webkit-transform:rotate(180deg) scale(.6);transform:rotate(180deg) scale(.6)}to{-webkit-transform:rotate(1turn) scale(1);transform:rotate(1turn) scale(1)}}.ball-clip-rotate-multiple{position:relative}.ball-clip-rotate-multiple>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:rotate 1s ease-in-out 0s infinite;animation:rotate 1s ease-in-out 0s infinite;border-color:transparent #fff;border-radius:100%;border-style:solid;border-width:2px;height:35px;left:-20px;position:absolute;top:-20px;width:35px}.ball-clip-rotate-multiple>div:last-child{-webkit-animation-direction:reverse;animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s;border-color:#fff transparent;display:inline-block;height:15px;left:-10px;top:-10px;width:15px}@-webkit-keyframes ball-scale-ripple{0%{opacity:1;-webkit-transform:scale(.1);transform:scale(.1)}70%{opacity:.7;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0}}@keyframes ball-scale-ripple{0%{opacity:1;-webkit-transform:scale(.1);transform:scale(.1)}70%{opacity:.7;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0}}.ball-scale-ripple>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale-ripple 1s cubic-bezier(.21,.53,.56,.8) 0s infinite;animation:ball-scale-ripple 1s cubic-bezier(.21,.53,.56,.8) 0s infinite;border:2px solid #fff;border-radius:100%;height:50px;width:50px}@-webkit-keyframes ball-scale-ripple-multiple{0%{opacity:1;-webkit-transform:scale(.1);transform:scale(.1)}70%{opacity:.7;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0}}@keyframes ball-scale-ripple-multiple{0%{opacity:1;-webkit-transform:scale(.1);transform:scale(.1)}70%{opacity:.7;-webkit-transform:scale(1);transform:scale(1)}to{opacity:0}}.ball-scale-ripple-multiple{position:relative;-webkit-transform:translateY(-25px);-ms-transform:translateY(-25px);transform:translateY(-25px)}.ball-scale-ripple-multiple>div:nth-child(0){-webkit-animation-delay:-.8s;animation-delay:-.8s}.ball-scale-ripple-multiple>div:first-child{-webkit-animation-delay:-.6s;animation-delay:-.6s}.ball-scale-ripple-multiple>div:nth-child(2){-webkit-animation-delay:-.4s;animation-delay:-.4s}.ball-scale-ripple-multiple>div:nth-child(3){-webkit-animation-delay:-.2s;animation-delay:-.2s}.ball-scale-ripple-multiple>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale-ripple-multiple 1.25s cubic-bezier(.21,.53,.56,.8) 0s infinite;animation:ball-scale-ripple-multiple 1.25s cubic-bezier(.21,.53,.56,.8) 0s infinite;border:2px solid #fff;border-radius:100%;height:50px;left:-26px;position:absolute;top:-2px;width:50px}@-webkit-keyframes ball-beat{50%{opacity:.2;-webkit-transform:scale(.75);transform:scale(.75)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-beat{50%{opacity:.2;-webkit-transform:scale(.75);transform:scale(.75)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.ball-beat>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-beat .7s linear 0s infinite;animation:ball-beat .7s linear 0s infinite;background-color:#fff;border-radius:100%;display:inline-block;height:15px;margin:2px;width:15px}.ball-beat>div:nth-child(2n-1){-webkit-animation-delay:-.35s!important;animation-delay:-.35s!important}@-webkit-keyframes ball-scale-multiple{0%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}5%{opacity:1}to{opacity:0;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-scale-multiple{0%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}5%{opacity:1}to{opacity:0;-webkit-transform:scale(1);transform:scale(1)}}.ball-scale-multiple{position:relative;-webkit-transform:translateY(-30px);-ms-transform:translateY(-30px);transform:translateY(-30px)}.ball-scale-multiple>div:nth-child(2){-webkit-animation-delay:-.4s;animation-delay:-.4s}.ball-scale-multiple>div:nth-child(3){-webkit-animation-delay:-.2s;animation-delay:-.2s}.ball-scale-multiple>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:ball-scale-multiple 1s linear 0s infinite;animation:ball-scale-multiple 1s linear 0s infinite;background-color:#fff;border-radius:100%;height:15px;height:60px;left:-30px;margin:0;opacity:0;position:absolute;top:0;width:15px;width:60px}@-webkit-keyframes ball-triangle-path-1{33%{-webkit-transform:translate(25px,-50px);transform:translate(25px,-50px)}66%{-webkit-transform:translate(50px);transform:translate(50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-triangle-path-1{33%{-webkit-transform:translate(25px,-50px);transform:translate(25px,-50px)}66%{-webkit-transform:translate(50px);transform:translate(50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ball-triangle-path-2{33%{-webkit-transform:translate(25px,50px);transform:translate(25px,50px)}66%{-webkit-transform:translate(-25px,50px);transform:translate(-25px,50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-triangle-path-2{33%{-webkit-transform:translate(25px,50px);transform:translate(25px,50px)}66%{-webkit-transform:translate(-25px,50px);transform:translate(-25px,50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ball-triangle-path-3{33%{-webkit-transform:translate(-50px);transform:translate(-50px)}66%{-webkit-transform:translate(-25px,-50px);transform:translate(-25px,-50px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-triangle-path-3{33%{-webkit-transform:translate(-50px);transform:translate(-50px)}66%{-webkit-transform:translate(-25px,-50px);transform:translate(-25px,-50px)}to{-webkit-transform:translate(0);transform:translate(0)}}.ball-triangle-path{position:relative;-webkit-transform:translate(-29.994px,-37.50938px);-ms-transform:translate(-29.994px,-37.50938px);transform:translate(-29.994px,-37.50938px)}.ball-triangle-path>div:first-child{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-triangle-path-1;animation-name:ball-triangle-path-1;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.ball-triangle-path>div:first-child,.ball-triangle-path>div:nth-child(2){-webkit-animation-delay:0;animation-delay:0;-webkit-animation-duration:2s;animation-duration:2s}.ball-triangle-path>div:nth-child(2){-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-triangle-path-2;animation-name:ball-triangle-path-2;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.ball-triangle-path>div:nth-child(3){-webkit-animation-delay:0;animation-delay:0;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-triangle-path-3;animation-name:ball-triangle-path-3;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.ball-triangle-path>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;border:1px solid #fff;border-radius:100%;height:10px;position:absolute;width:10px}.ball-triangle-path>div:first-of-type{top:50px}.ball-triangle-path>div:nth-of-type(2){left:25px}.ball-triangle-path>div:nth-of-type(3){left:50px;top:50px}@-webkit-keyframes ball-pulse-rise-even{0%{-webkit-transform:scale(1.1);transform:scale(1.1)}25%{-webkit-transform:translateY(-30px);transform:translateY(-30px)}50%{-webkit-transform:scale(.4);transform:scale(.4)}75%{-webkit-transform:translateY(30px);transform:translateY(30px)}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-pulse-rise-even{0%{-webkit-transform:scale(1.1);transform:scale(1.1)}25%{-webkit-transform:translateY(-30px);transform:translateY(-30px)}50%{-webkit-transform:scale(.4);transform:scale(.4)}75%{-webkit-transform:translateY(30px);transform:translateY(30px)}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes ball-pulse-rise-odd{0%{-webkit-transform:scale(.4);transform:scale(.4)}25%{-webkit-transform:translateY(30px);transform:translateY(30px)}50%{-webkit-transform:scale(1.1);transform:scale(1.1)}75%{-webkit-transform:translateY(-30px);transform:translateY(-30px)}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform:scale(.75);transform:scale(.75)}}@keyframes ball-pulse-rise-odd{0%{-webkit-transform:scale(.4);transform:scale(.4)}25%{-webkit-transform:translateY(30px);transform:translateY(30px)}50%{-webkit-transform:scale(1.1);transform:scale(1.1)}75%{-webkit-transform:translateY(-30px);transform:translateY(-30px)}to{-webkit-transform:translateY(0);transform:translateY(0);-webkit-transform:scale(.75);transform:scale(.75)}}.ball-pulse-rise>div{-webkit-animation-delay:0;animation-delay:0;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:cubic-bezier(.15,.46,.9,.6);animation-timing-function:cubic-bezier(.15,.46,.9,.6);background-color:#fff;border-radius:100%;display:inline-block;height:15px;margin:2px;width:15px}.ball-pulse-rise>div:nth-child(2n){-webkit-animation-name:ball-pulse-rise-even;animation-name:ball-pulse-rise-even}.ball-pulse-rise>div:nth-child(2n-1){-webkit-animation-name:ball-pulse-rise-odd;animation-name:ball-pulse-rise-odd}@-webkit-keyframes ball-grid-beat{50%{opacity:.7}to{opacity:1}}@keyframes ball-grid-beat{50%{opacity:.7}to{opacity:1}}.ball-grid-beat{width:57px}.ball-grid-beat>div:first-child{-webkit-animation-delay:.44s;animation-delay:.44s;-webkit-animation-duration:1.27s;animation-duration:1.27s}.ball-grid-beat>div:nth-child(2){-webkit-animation-delay:.2s;animation-delay:.2s;-webkit-animation-duration:1.52s;animation-duration:1.52s}.ball-grid-beat>div:nth-child(3){-webkit-animation-delay:.14s;animation-delay:.14s;-webkit-animation-duration:.61s;animation-duration:.61s}.ball-grid-beat>div:nth-child(4){-webkit-animation-delay:.15s;animation-delay:.15s;-webkit-animation-duration:.82s;animation-duration:.82s}.ball-grid-beat>div:nth-child(5){-webkit-animation-delay:-.01s;animation-delay:-.01s;-webkit-animation-duration:1.24s;animation-duration:1.24s}.ball-grid-beat>div:nth-child(6){-webkit-animation-delay:-.07s;animation-delay:-.07s;-webkit-animation-duration:1.35s;animation-duration:1.35s}.ball-grid-beat>div:nth-child(7){-webkit-animation-delay:.29s;animation-delay:.29s;-webkit-animation-duration:1.44s;animation-duration:1.44s}.ball-grid-beat>div:nth-child(8){-webkit-animation-delay:.63s;animation-delay:.63s;-webkit-animation-duration:1.19s;animation-duration:1.19s}.ball-grid-beat>div:nth-child(9){-webkit-animation-delay:-.18s;animation-delay:-.18s;-webkit-animation-duration:1.48s;animation-duration:1.48s}.ball-grid-beat>div{-webkit-animation-delay:0;animation-delay:0;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-grid-beat;animation-name:ball-grid-beat;background-color:#fff;border-radius:100%;display:inline-block;float:left;height:15px;margin:2px;width:15px}@-webkit-keyframes ball-grid-pulse{0%{-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.7;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-grid-pulse{0%{-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.7;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.ball-grid-pulse{width:57px}.ball-grid-pulse>div:first-child{-webkit-animation-delay:.58s;animation-delay:.58s;-webkit-animation-duration:.9s;animation-duration:.9s}.ball-grid-pulse>div:nth-child(2){-webkit-animation-delay:.01s;animation-delay:.01s;-webkit-animation-duration:.94s;animation-duration:.94s}.ball-grid-pulse>div:nth-child(3){-webkit-animation-delay:.25s;animation-delay:.25s;-webkit-animation-duration:1.43s;animation-duration:1.43s}.ball-grid-pulse>div:nth-child(4){-webkit-animation-delay:-.03s;animation-delay:-.03s;-webkit-animation-duration:.74s;animation-duration:.74s}.ball-grid-pulse>div:nth-child(5){-webkit-animation-delay:.21s;animation-delay:.21s;-webkit-animation-duration:.68s;animation-duration:.68s}.ball-grid-pulse>div:nth-child(6){-webkit-animation-delay:.25s;animation-delay:.25s;-webkit-animation-duration:1.17s;animation-duration:1.17s}.ball-grid-pulse>div:nth-child(7){-webkit-animation-delay:.46s;animation-delay:.46s;-webkit-animation-duration:1.41s;animation-duration:1.41s}.ball-grid-pulse>div:nth-child(8){-webkit-animation-delay:.02s;animation-delay:.02s;-webkit-animation-duration:1.56s;animation-duration:1.56s}.ball-grid-pulse>div:nth-child(9){-webkit-animation-delay:.13s;animation-delay:.13s;-webkit-animation-duration:.78s;animation-duration:.78s}.ball-grid-pulse>div{-webkit-animation-delay:0;animation-delay:0;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:ball-grid-pulse;animation-name:ball-grid-pulse;background-color:#fff;border-radius:100%;display:inline-block;float:left;height:15px;margin:2px;width:15px}@-webkit-keyframes ball-spin-fade-loader{50%{opacity:.3;-webkit-transform:scale(.4);transform:scale(.4)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes ball-spin-fade-loader{50%{opacity:.3;-webkit-transform:scale(.4);transform:scale(.4)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.ball-spin-fade-loader{left:-10px;position:relative;top:-10px}.ball-spin-fade-loader>div:first-child{-webkit-animation:ball-spin-fade-loader 1s linear -.96s infinite;animation:ball-spin-fade-loader 1s linear -.96s infinite;left:0;top:25px}.ball-spin-fade-loader>div:nth-child(2){-webkit-animation:ball-spin-fade-loader 1s linear -.84s infinite;animation:ball-spin-fade-loader 1s linear -.84s infinite;left:17.04545px;top:17.04545px}.ball-spin-fade-loader>div:nth-child(3){-webkit-animation:ball-spin-fade-loader 1s linear -.72s infinite;animation:ball-spin-fade-loader 1s linear -.72s infinite;left:25px;top:0}.ball-spin-fade-loader>div:nth-child(4){-webkit-animation:ball-spin-fade-loader 1s linear -.6s infinite;animation:ball-spin-fade-loader 1s linear -.6s infinite;left:17.04545px;top:-17.04545px}.ball-spin-fade-loader>div:nth-child(5){-webkit-animation:ball-spin-fade-loader 1s linear -.48s infinite;animation:ball-spin-fade-loader 1s linear -.48s infinite;left:0;top:-25px}.ball-spin-fade-loader>div:nth-child(6){-webkit-animation:ball-spin-fade-loader 1s linear -.36s infinite;animation:ball-spin-fade-loader 1s linear -.36s infinite;left:-17.04545px;top:-17.04545px}.ball-spin-fade-loader>div:nth-child(7){-webkit-animation:ball-spin-fade-loader 1s linear -.24s infinite;animation:ball-spin-fade-loader 1s linear -.24s infinite;left:-25px;top:0}.ball-spin-fade-loader>div:nth-child(8){-webkit-animation:ball-spin-fade-loader 1s linear -.12s infinite;animation:ball-spin-fade-loader 1s linear -.12s infinite;left:-17.04545px;top:17.04545px}.ball-spin-fade-loader>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;height:15px;margin:2px;position:absolute;width:15px}@-webkit-keyframes ball-spin-loader{75%{opacity:.2}to{opacity:1}}@keyframes ball-spin-loader{75%{opacity:.2}to{opacity:1}}.ball-spin-loader{position:relative}.ball-spin-loader>span:first-child{-webkit-animation:ball-spin-loader 2s linear .9s infinite;animation:ball-spin-loader 2s linear .9s infinite;left:0;top:45px}.ball-spin-loader>span:nth-child(2){-webkit-animation:ball-spin-loader 2s linear 1.8s infinite;animation:ball-spin-loader 2s linear 1.8s infinite;left:30.68182px;top:30.68182px}.ball-spin-loader>span:nth-child(3){-webkit-animation:ball-spin-loader 2s linear 2.7s infinite;animation:ball-spin-loader 2s linear 2.7s infinite;left:45px;top:0}.ball-spin-loader>span:nth-child(4){-webkit-animation:ball-spin-loader 2s linear 3.6s infinite;animation:ball-spin-loader 2s linear 3.6s infinite;left:30.68182px;top:-30.68182px}.ball-spin-loader>span:nth-child(5){-webkit-animation:ball-spin-loader 2s linear 4.5s infinite;animation:ball-spin-loader 2s linear 4.5s infinite;left:0;top:-45px}.ball-spin-loader>span:nth-child(6){-webkit-animation:ball-spin-loader 2s linear 5.4s infinite;animation:ball-spin-loader 2s linear 5.4s infinite;left:-30.68182px;top:-30.68182px}.ball-spin-loader>span:nth-child(7){-webkit-animation:ball-spin-loader 2s linear 6.3s infinite;animation:ball-spin-loader 2s linear 6.3s infinite;left:-45px;top:0}.ball-spin-loader>span:nth-child(8){-webkit-animation:ball-spin-loader 2s linear 7.2s infinite;animation:ball-spin-loader 2s linear 7.2s infinite;left:-30.68182px;top:30.68182px}.ball-spin-loader>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background:green;border-radius:100%;height:15px;position:absolute;width:15px}@-webkit-keyframes ball-zig{33%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}66%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-zig{33%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}66%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ball-zag{33%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}66%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-zag{33%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}66%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}to{-webkit-transform:translate(0);transform:translate(0)}}.ball-zig-zag{position:relative;-webkit-transform:translate(-15px,-15px);-ms-transform:translate(-15px,-15px);transform:translate(-15px,-15px)}.ball-zig-zag>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;height:15px;left:-7px;margin:2px 2px 2px 15px;position:absolute;top:4px;width:15px}.ball-zig-zag>div:first-child{-webkit-animation:ball-zig .7s linear 0s infinite;animation:ball-zig .7s linear 0s infinite}.ball-zig-zag>div:last-child{-webkit-animation:ball-zag .7s linear 0s infinite;animation:ball-zag .7s linear 0s infinite}@-webkit-keyframes ball-zig-deflect{17%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}34%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}50%{-webkit-transform:translate(0);transform:translate(0)}67%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}84%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-zig-deflect{17%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}34%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}50%{-webkit-transform:translate(0);transform:translate(0)}67%{-webkit-transform:translate(15px,-30px);transform:translate(15px,-30px)}84%{-webkit-transform:translate(-15px,-30px);transform:translate(-15px,-30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ball-zag-deflect{17%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}34%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}50%{-webkit-transform:translate(0);transform:translate(0)}67%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}84%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ball-zag-deflect{17%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}34%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}50%{-webkit-transform:translate(0);transform:translate(0)}67%{-webkit-transform:translate(-15px,30px);transform:translate(-15px,30px)}84%{-webkit-transform:translate(15px,30px);transform:translate(15px,30px)}to{-webkit-transform:translate(0);transform:translate(0)}}.ball-zig-zag-deflect{position:relative;-webkit-transform:translate(-15px,-15px);-ms-transform:translate(-15px,-15px);transform:translate(-15px,-15px)}.ball-zig-zag-deflect>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:100%;height:15px;left:-7px;margin:2px 2px 2px 15px;position:absolute;top:4px;width:15px}.ball-zig-zag-deflect>div:first-child{-webkit-animation:ball-zig-deflect 1.5s linear 0s infinite;animation:ball-zig-deflect 1.5s linear 0s infinite}.ball-zig-zag-deflect>div:last-child{-webkit-animation:ball-zag-deflect 1.5s linear 0s infinite;animation:ball-zag-deflect 1.5s linear 0s infinite}@-webkit-keyframes line-scale{0%{-webkit-transform:scaley(1);transform:scaley(1)}50%{-webkit-transform:scaley(.4);transform:scaley(.4)}to{-webkit-transform:scaley(1);transform:scaley(1)}}@keyframes line-scale{0%{-webkit-transform:scaley(1);transform:scaley(1)}50%{-webkit-transform:scaley(.4);transform:scaley(.4)}to{-webkit-transform:scaley(1);transform:scaley(1)}}.line-scale>div:first-child{-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.4s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.4s infinite}.line-scale>div:nth-child(2){-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.3s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.3s infinite}.line-scale>div:nth-child(3){-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.2s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.2s infinite}.line-scale>div:nth-child(4){-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.1s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) -.1s infinite}.line-scale>div:nth-child(5){-webkit-animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) 0s infinite;animation:line-scale 1s cubic-bezier(.2,.68,.18,1.08) 0s infinite}.line-scale>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:2px;display:inline-block;height:35px;margin:2px;width:4px}@-webkit-keyframes line-scale-party{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(.5);transform:scale(.5)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes line-scale-party{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(.5);transform:scale(.5)}to{-webkit-transform:scale(1);transform:scale(1)}}.line-scale-party>div:first-child{-webkit-animation-delay:-.09s;animation-delay:-.09s;-webkit-animation-duration:.83s;animation-duration:.83s}.line-scale-party>div:nth-child(2){-webkit-animation-delay:.33s;animation-delay:.33s;-webkit-animation-duration:.64s;animation-duration:.64s}.line-scale-party>div:nth-child(3){-webkit-animation-delay:.32s;animation-delay:.32s;-webkit-animation-duration:.39s;animation-duration:.39s}.line-scale-party>div:nth-child(4){-webkit-animation-delay:.47s;animation-delay:.47s;-webkit-animation-duration:.52s;animation-duration:.52s}.line-scale-party>div{-webkit-animation-delay:0;animation-delay:0;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:line-scale-party;animation-name:line-scale-party;background-color:#fff;border-radius:2px;display:inline-block;height:35px;margin:2px;width:4px}@-webkit-keyframes line-scale-pulse-out{0%{-webkit-transform:scaley(1);transform:scaley(1)}50%{-webkit-transform:scaley(.4);transform:scaley(.4)}to{-webkit-transform:scaley(1);transform:scaley(1)}}@keyframes line-scale-pulse-out{0%{-webkit-transform:scaley(1);transform:scaley(1)}50%{-webkit-transform:scaley(.4);transform:scaley(.4)}to{-webkit-transform:scaley(1);transform:scaley(1)}}.line-scale-pulse-out>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:line-scale-pulse-out .9s cubic-bezier(.85,.25,.37,.85) -.6s infinite;animation:line-scale-pulse-out .9s cubic-bezier(.85,.25,.37,.85) -.6s infinite;background-color:#fff;border-radius:2px;display:inline-block;height:35px;margin:2px;width:4px}.line-scale-pulse-out>div:nth-child(2),.line-scale-pulse-out>div:nth-child(4){-webkit-animation-delay:-.4s!important;animation-delay:-.4s!important}.line-scale-pulse-out>div:first-child,.line-scale-pulse-out>div:nth-child(5){-webkit-animation-delay:-.2s!important;animation-delay:-.2s!important}@-webkit-keyframes line-scale-pulse-out-rapid{0%{-webkit-transform:scaley(1);transform:scaley(1)}80%{-webkit-transform:scaley(.3);transform:scaley(.3)}90%{-webkit-transform:scaley(1);transform:scaley(1)}}@keyframes line-scale-pulse-out-rapid{0%{-webkit-transform:scaley(1);transform:scaley(1)}80%{-webkit-transform:scaley(.3);transform:scaley(.3)}90%{-webkit-transform:scaley(1);transform:scaley(1)}}.line-scale-pulse-out-rapid>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:line-scale-pulse-out-rapid .9s cubic-bezier(.11,.49,.38,.78) -.5s infinite;animation:line-scale-pulse-out-rapid .9s cubic-bezier(.11,.49,.38,.78) -.5s infinite;background-color:#fff;border-radius:2px;display:inline-block;height:35px;margin:2px;width:4px}.line-scale-pulse-out-rapid>div:nth-child(2),.line-scale-pulse-out-rapid>div:nth-child(4){-webkit-animation-delay:-.25s!important;animation-delay:-.25s!important}.line-scale-pulse-out-rapid>div:first-child,.line-scale-pulse-out-rapid>div:nth-child(5){-webkit-animation-delay:0s!important;animation-delay:0s!important}@-webkit-keyframes line-spin-fade-loader{50%{opacity:.3}to{opacity:1}}@keyframes line-spin-fade-loader{50%{opacity:.3}to{opacity:1}}.line-spin-fade-loader{left:-4px;position:relative;top:-10px}.line-spin-fade-loader>div:first-child{-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.84s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.84s infinite;left:0;top:20px}.line-spin-fade-loader>div:nth-child(2){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.72s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.72s infinite;left:13.63636px;top:13.63636px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.line-spin-fade-loader>div:nth-child(3){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.6s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.6s infinite;left:20px;top:0;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.line-spin-fade-loader>div:nth-child(4){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.48s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.48s infinite;left:13.63636px;top:-13.63636px;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.line-spin-fade-loader>div:nth-child(5){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.36s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.36s infinite;left:0;top:-20px}.line-spin-fade-loader>div:nth-child(6){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.24s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.24s infinite;left:-13.63636px;top:-13.63636px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.line-spin-fade-loader>div:nth-child(7){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out -.12s infinite;animation:line-spin-fade-loader 1.2s ease-in-out -.12s infinite;left:-20px;top:0;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.line-spin-fade-loader>div:nth-child(8){-webkit-animation:line-spin-fade-loader 1.2s ease-in-out 0s infinite;animation:line-spin-fade-loader 1.2s ease-in-out 0s infinite;left:-13.63636px;top:13.63636px;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.line-spin-fade-loader>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:#fff;border-radius:2px;height:35px;height:15px;margin:2px;position:absolute;width:4px;width:5px}@-webkit-keyframes triangle-skew-spin{25%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(0);transform:perspective(100px) rotateX(180deg) rotateY(0)}50%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(180deg);transform:perspective(100px) rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:perspective(100px) rotateX(0) rotateY(180deg);transform:perspective(100px) rotateX(0) rotateY(180deg)}to{-webkit-transform:perspective(100px) rotateX(0) rotateY(0);transform:perspective(100px) rotateX(0) rotateY(0)}}@keyframes triangle-skew-spin{25%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(0);transform:perspective(100px) rotateX(180deg) rotateY(0)}50%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(180deg);transform:perspective(100px) rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:perspective(100px) rotateX(0) rotateY(180deg);transform:perspective(100px) rotateX(0) rotateY(180deg)}to{-webkit-transform:perspective(100px) rotateX(0) rotateY(0);transform:perspective(100px) rotateX(0) rotateY(0)}}.triangle-skew-spin>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:triangle-skew-spin 3s cubic-bezier(.09,.57,.49,.9) 0s infinite;animation:triangle-skew-spin 3s cubic-bezier(.09,.57,.49,.9) 0s infinite;border-bottom:20px solid #fff;border-left:20px solid transparent;border-right:20px solid transparent;height:0;width:0}@-webkit-keyframes square-spin{25%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(0);transform:perspective(100px) rotateX(180deg) rotateY(0)}50%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(180deg);transform:perspective(100px) rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:perspective(100px) rotateX(0) rotateY(180deg);transform:perspective(100px) rotateX(0) rotateY(180deg)}to{-webkit-transform:perspective(100px) rotateX(0) rotateY(0);transform:perspective(100px) rotateX(0) rotateY(0)}}@keyframes square-spin{25%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(0);transform:perspective(100px) rotateX(180deg) rotateY(0)}50%{-webkit-transform:perspective(100px) rotateX(180deg) rotateY(180deg);transform:perspective(100px) rotateX(180deg) rotateY(180deg)}75%{-webkit-transform:perspective(100px) rotateX(0) rotateY(180deg);transform:perspective(100px) rotateX(0) rotateY(180deg)}to{-webkit-transform:perspective(100px) rotateX(0) rotateY(0);transform:perspective(100px) rotateX(0) rotateY(0)}}.square-spin>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:square-spin 3s cubic-bezier(.09,.57,.49,.9) 0s infinite;animation:square-spin 3s cubic-bezier(.09,.57,.49,.9) 0s infinite;background:#fff;border:1px solid red;height:50px;width:50px}@-webkit-keyframes rotate_pacman_half_up{0%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}50%{-webkit-transform:rotate(1turn);transform:rotate(1turn)}to{-webkit-transform:rotate(270deg);transform:rotate(270deg)}}@keyframes rotate_pacman_half_up{0%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}50%{-webkit-transform:rotate(1turn);transform:rotate(1turn)}to{-webkit-transform:rotate(270deg);transform:rotate(270deg)}}@-webkit-keyframes rotate_pacman_half_down{0%{-webkit-transform:rotate(90deg);transform:rotate(90deg)}50%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(90deg);transform:rotate(90deg)}}@keyframes rotate_pacman_half_down{0%{-webkit-transform:rotate(90deg);transform:rotate(90deg)}50%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(90deg);transform:rotate(90deg)}}@-webkit-keyframes pacman-balls{75%{opacity:.7}to{-webkit-transform:translate(-100px,-6.25px);transform:translate(-100px,-6.25px)}}@keyframes pacman-balls{75%{opacity:.7}to{-webkit-transform:translate(-100px,-6.25px);transform:translate(-100px,-6.25px)}}.pacman{position:relative}.pacman>div:nth-child(2){-webkit-animation:pacman-balls 1s linear -.99s infinite;animation:pacman-balls 1s linear -.99s infinite}.pacman>div:nth-child(3){-webkit-animation:pacman-balls 1s linear -.66s infinite;animation:pacman-balls 1s linear -.66s infinite}.pacman>div:nth-child(4){-webkit-animation:pacman-balls 1s linear -.33s infinite;animation:pacman-balls 1s linear -.33s infinite}.pacman>div:nth-child(5){-webkit-animation:pacman-balls 1s linear 0s infinite;animation:pacman-balls 1s linear 0s infinite}.pacman>div:first-of-type{-webkit-animation:rotate_pacman_half_up .5s 0s infinite;animation:rotate_pacman_half_up .5s 0s infinite}.pacman>div:first-of-type,.pacman>div:nth-child(2){border:25px solid #fff;border-radius:25px;border-right-color:transparent;height:0;left:-30px;position:relative;width:0}.pacman>div:nth-child(2){-webkit-animation:rotate_pacman_half_down .5s 0s infinite;animation:rotate_pacman_half_down .5s 0s infinite;margin-top:-50px}.pacman>div:nth-child(3),.pacman>div:nth-child(4),.pacman>div:nth-child(5),.pacman>div:nth-child(6){background-color:#fff;border-radius:100%;height:15px;height:10px;left:70px;margin:2px;position:absolute;top:25px;-webkit-transform:translateY(-6.25px);-ms-transform:translateY(-6.25px);transform:translateY(-6.25px);width:15px;width:10px}@-webkit-keyframes cube-transition{25%{-webkit-transform:translateX(50px) scale(.5) rotate(-90deg);transform:translateX(50px) scale(.5) rotate(-90deg)}50%{-webkit-transform:translate(50px,50px) rotate(-180deg);transform:translate(50px,50px) rotate(-180deg)}75%{-webkit-transform:translateY(50px) scale(.5) rotate(-270deg);transform:translateY(50px) scale(.5) rotate(-270deg)}to{-webkit-transform:rotate(-1turn);transform:rotate(-1turn)}}@keyframes cube-transition{25%{-webkit-transform:translateX(50px) scale(.5) rotate(-90deg);transform:translateX(50px) scale(.5) rotate(-90deg)}50%{-webkit-transform:translate(50px,50px) rotate(-180deg);transform:translate(50px,50px) rotate(-180deg)}75%{-webkit-transform:translateY(50px) scale(.5) rotate(-270deg);transform:translateY(50px) scale(.5) rotate(-270deg)}to{-webkit-transform:rotate(-1turn);transform:rotate(-1turn)}}.cube-transition{position:relative;-webkit-transform:translate(-25px,-25px);-ms-transform:translate(-25px,-25px);transform:translate(-25px,-25px)}.cube-transition>div{-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation:cube-transition 1.6s ease-in-out 0s infinite;animation:cube-transition 1.6s ease-in-out 0s infinite;background-color:#fff;height:10px;left:-5px;position:absolute;top:-5px;width:10px}.cube-transition>div:last-child{-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes spin-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.semi-circle-spin{height:35px;overflow:hidden;position:relative;width:35px}.semi-circle-spin>div{-webkit-animation:spin-rotate .6s linear 0s infinite;animation:spin-rotate .6s linear 0s infinite;background-image:-webkit-linear-gradient(transparent,transparent 70%,#fff 0,#fff);background-image:linear-gradient(transparent,transparent 70%,#fff 0,#fff);border-radius:100%;border-width:0;height:100%;position:absolute;width:100%}@-webkit-keyframes bar-progress{0%{opacity:1;-webkit-transform:scaleY(20%);transform:scaleY(20%)}25%{opacity:.7;-webkit-transform:translateX(6%) scaleY(10%);transform:translateX(6%) scaleY(10%)}50%{opacity:1;-webkit-transform:translateX(20%) scaleY(20%);transform:translateX(20%) scaleY(20%)}75%{opacity:.7;-webkit-transform:translateX(6%) scaleY(10%);transform:translateX(6%) scaleY(10%)}to{opacity:1;-webkit-transform:scaleY(20%);transform:scaleY(20%)}}@keyframes bar-progress{0%{opacity:1;-webkit-transform:scaleY(20%);transform:scaleY(20%)}25%{opacity:.7;-webkit-transform:translateX(6%) scaleY(10%);transform:translateX(6%) scaleY(10%)}50%{opacity:1;-webkit-transform:translateX(20%) scaleY(20%);transform:translateX(20%) scaleY(20%)}75%{opacity:.7;-webkit-transform:translateX(6%) scaleY(10%);transform:translateX(6%) scaleY(10%)}to{opacity:1;-webkit-transform:scaleY(20%);transform:scaleY(20%)}}.bar-progress{height:12px;width:30%}.bar-progress>div{-webkit-animation:bar-progress 3s cubic-bezier(.57,.1,.44,.93) infinite;animation:bar-progress 3s cubic-bezier(.57,.1,.44,.93) infinite;background-color:#fff;border-radius:10px;height:12px;opacity:1;position:relative;width:20%}@-webkit-keyframes bar-swing{0%{left:0}50%{left:70%}to{left:0}}@keyframes bar-swing{0%{left:0}50%{left:70%}to{left:0}}.bar-swing,.bar-swing>div{height:8px;width:30%}.bar-swing>div{-webkit-animation:bar-swing 1.5s infinite;animation:bar-swing 1.5s infinite;background-color:#fff;border-radius:10px;position:relative}@-webkit-keyframes bar-swing-container{0%{left:0;-webkit-transform:translateX(0);transform:translateX(0)}50%{left:70%;-webkit-transform:translateX(-4px);transform:translateX(-4px)}to{left:0;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes bar-swing-container{0%{left:0;-webkit-transform:translateX(0);transform:translateX(0)}50%{left:70%;-webkit-transform:translateX(-4px);transform:translateX(-4px)}to{left:0;-webkit-transform:translateX(0);transform:translateX(0)}}.bar-swing-container{height:8px;position:relative;width:20%}.bar-swing-container div:first-child{background-color:hsla(0,0%,100%,.2);border-radius:10px;height:12px;position:absolute;width:100%}.bar-swing-container div:nth-child(2){-webkit-animation:bar-swing-container 2s cubic-bezier(.91,.35,.12,.6) infinite;animation:bar-swing-container 2s cubic-bezier(.91,.35,.12,.6) infinite;background-color:#fff;border-radius:10px;height:8px;margin:2px 2px 0;position:absolute;width:30%}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$p);

var css_248z$o = ".sk-spinner{color:#333}.sk-spinner>div{background-color:currentColor}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJhc2UuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFlBQ0UsVUFDRixDQUVBLGdCQUNFLDZCQUNGIiwiZmlsZSI6ImJhc2UuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNrLXNwaW5uZXIge1xuICBjb2xvcjogIzMzMztcbn1cblxuLnNrLXNwaW5uZXIgPiBkaXYge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiBjdXJyZW50Q29sb3I7XG59XG4iXX0= */";
styleInject(css_248z$o);

var css_248z$n = ".ball-scale-ripple-multiple>div,.ball-scale-ripple>div,.ball-triangle-path>div{background-color:initial;border-color:currentColor}.ball-clip-rotate>div{background-color:initial;border-left-color:currentColor;border-right-color:currentColor;border-top-color:currentColor}.ball-clip-rotate-pulse>div:first-child{background-color:currentColor}.ball-clip-rotate-pulse>div:last-child{background-color:initial;border-bottom-color:currentColor;border-top-color:currentColor}.ball-clip-rotate-multiple>div:first-child{background-color:initial;border-left-color:currentColor;border-right-color:currentColor}.ball-clip-rotate-multiple>div:last-child{border-top-color:currentColor}.ball-clip-rotate-multiple>div:last-child,.pacman>div:first-child,.pacman>div:nth-child(2),.triangle-skew-spin>div{background-color:initial;border-bottom-color:currentColor}.pacman>div:first-child,.pacman>div:nth-child(2){border-left-color:currentColor;border-top-color:currentColor}.pacman>div:nth-child(3),.pacman>div:nth-child(4),.pacman>div:nth-child(5){background-color:currentColor}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$n);

var css_248z$m = "@-webkit-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@-moz-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@-ms-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}.sk-fade-in{-webkit-animation:sk-fade-in 2s;-moz-animation:sk-fade-in 2s;-o-animation:sk-fade-in 2s;-ms-animation:sk-fade-in 2s;animation:sk-fade-in 2s}.sk-fade-in-half-second{-webkit-animation:sk-fade-in 1s;-moz-animation:sk-fade-in 1s;-o-animation:sk-fade-in 1s;-ms-animation:sk-fade-in 1s;animation:sk-fade-in 1s}.sk-fade-in-quarter-second{-webkit-animation:sk-fade-in .5s;-moz-animation:sk-fade-in .5s;-o-animation:sk-fade-in .5s;-ms-animation:sk-fade-in .5s;animation:sk-fade-in .5s}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$m);

var css_248z$l = ".sk-chasing-dots{-webkit-animation:sk-rotate 2s linear infinite;animation:sk-rotate 2s linear infinite;height:27px;position:relative;width:27px}.sk-chasing-dots>div{-webkit-animation:sk-bounce 2s ease-in-out infinite;animation:sk-bounce 2s ease-in-out infinite;background-color:currentColor;border-radius:100%;display:inline-block;height:60%;position:absolute;top:0;width:60%}.sk-chasing-dots>div:last-child{-webkit-animation-delay:-1s;animation-delay:-1s;bottom:0;top:auto}@-webkit-keyframes sk-rotate{to{-webkit-transform:rotate(1turn)}}@keyframes sk-rotate{to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}@-webkit-keyframes sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$l);

var css_248z$k = ".sk-circle{height:22px;position:relative;width:22px}.sk-circle>div{background-color:initial;height:100%;left:0;position:absolute;top:0;width:100%}.sk-circle>div:before{-webkit-animation:sk-bouncedelay 1.2s ease-in-out infinite;animation:sk-bouncedelay 1.2s ease-in-out infinite;-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:currentColor;border-radius:100%;content:\"\";display:block;height:20%;margin:0 auto;width:20%}.sk-circle>div:nth-child(2){-webkit-transform:rotate(30deg);transform:rotate(30deg)}.sk-circle>div:nth-child(3){-webkit-transform:rotate(60deg);transform:rotate(60deg)}.sk-circle>div:nth-child(4){-webkit-transform:rotate(90deg);transform:rotate(90deg)}.sk-circle>div:nth-child(5){-webkit-transform:rotate(120deg);transform:rotate(120deg)}.sk-circle>div:nth-child(6){-webkit-transform:rotate(150deg);transform:rotate(150deg)}.sk-circle>div:nth-child(7){-webkit-transform:rotate(180deg);transform:rotate(180deg)}.sk-circle>div:nth-child(8){-webkit-transform:rotate(210deg);transform:rotate(210deg)}.sk-circle>div:nth-child(9){-webkit-transform:rotate(240deg);transform:rotate(240deg)}.sk-circle>div:nth-child(10){-webkit-transform:rotate(270deg);transform:rotate(270deg)}.sk-circle>div:nth-child(11){-webkit-transform:rotate(300deg);transform:rotate(300deg)}.sk-circle>div:nth-child(12){-webkit-transform:rotate(330deg);transform:rotate(330deg)}.sk-circle>div:nth-child(2):before{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-circle>div:nth-child(3):before{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-circle>div:nth-child(4):before{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-circle>div:nth-child(5):before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.sk-circle>div:nth-child(6):before{-webkit-animation-delay:-.7s;animation-delay:-.7s}.sk-circle>div:nth-child(7):before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.sk-circle>div:nth-child(8):before{-webkit-animation-delay:-.5s;animation-delay:-.5s}.sk-circle>div:nth-child(9):before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.sk-circle>div:nth-child(10):before{-webkit-animation-delay:-.3s;animation-delay:-.3s}.sk-circle>div:nth-child(11):before{-webkit-animation-delay:-.2s;animation-delay:-.2s}.sk-circle>div:nth-child(12):before{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$k);

var css_248z$j = ".sk-cube-grid{height:27px;width:27px}.sk-cube-grid>div{-webkit-animation:sk-scaleDelay 1.3s ease-in-out infinite;animation:sk-scaleDelay 1.3s ease-in-out infinite;background-color:currentColor;float:left;height:33%;width:33%}.sk-cube-grid>div:first-child{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid>div:nth-child(2){-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid>div:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.sk-cube-grid>div:nth-child(4){-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid>div:nth-child(5){-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid>div:nth-child(6){-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid>div:nth-child(7){-webkit-animation-delay:0s;animation-delay:0s}.sk-cube-grid>div:nth-child(8){-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid>div:nth-child(9){-webkit-animation-delay:.2s;animation-delay:.2s}@-webkit-keyframes sk-scaleDelay{0%,70%,to{-webkit-transform:scaleX(1)}35%{-webkit-transform:scale3D(0,0,1)}}@keyframes sk-scaleDelay{0%,70%,to{-webkit-transform:scaleX(1);transform:scaleX(1)}35%{-webkit-transform:scaleX(1);transform:scale3D(0,0,1)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$j);

var css_248z$i = ".sk-double-bounce{height:27px;position:relative;width:27px}.sk-double-bounce>div{-webkit-animation:sk-bounce 2s ease-in-out infinite;animation:sk-bounce 2s ease-in-out infinite;background-color:currentColor;border-radius:50%;height:100%;left:0;opacity:.6;position:absolute;top:0;width:100%}.sk-double-bounce>div:last-child{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRvdWJsZS1ib3VuY2UuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGtCQUVFLFdBQVksQ0FDWixpQkFBa0IsQ0FGbEIsVUFHRixDQUVBLHNCQVVFLG1EQUFzRCxDQUN0RCwyQ0FBOEMsQ0FQOUMsNkJBQThCLENBRDlCLGlCQUFrQixDQURsQixXQUFZLENBTVosTUFBTyxDQUhQLFVBQVksQ0FDWixpQkFBa0IsQ0FDbEIsS0FBTSxDQU5OLFVBV0YsQ0FFQSxpQ0FDRSwyQkFBOEIsQ0FDOUIsbUJBQ0YsQ0FFQSw2QkFDRSxNQUFXLDBCQUE4QixDQUN6QyxJQUFNLDBCQUE4QixDQUN0QyxDQUVBLHFCQUNFLE1BQ0Usa0JBQXFCLENBQ3JCLDBCQUNGLENBQUUsSUFDQSxrQkFBcUIsQ0FDckIsMEJBQ0YsQ0FDRiIsImZpbGUiOiJkb3VibGUtYm91bmNlLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zay1kb3VibGUtYm91bmNlIHtcbiAgd2lkdGg6IDI3cHg7XG4gIGhlaWdodDogMjdweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuXG4uc2stZG91YmxlLWJvdW5jZSA+IGRpdiB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgYmFja2dyb3VuZC1jb2xvcjogY3VycmVudENvbG9yO1xuICBvcGFjaXR5OiAwLjY7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuXG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzay1ib3VuY2UgMi4wcyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbiAgYW5pbWF0aW9uOiBzay1ib3VuY2UgMi4wcyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbn1cblxuLnNrLWRvdWJsZS1ib3VuY2UgPiBkaXY6bGFzdC1jaGlsZCB7XG4gIC13ZWJraXQtYW5pbWF0aW9uLWRlbGF5OiAtMS4wcztcbiAgYW5pbWF0aW9uLWRlbGF5OiAtMS4wcztcbn1cblxuQC13ZWJraXQta2V5ZnJhbWVzIHNrLWJvdW5jZSB7XG4gIDAlLCAxMDAlIHsgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDAuMCkgfVxuICA1MCUgeyAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMS4wKSB9XG59XG5cbkBrZXlmcmFtZXMgc2stYm91bmNlIHtcbiAgMCUsIDEwMCUge1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgfSA1MCUge1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMS4wKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMS4wKTtcbiAgfVxufVxuIl19 */";
styleInject(css_248z$i);

var css_248z$h = ".sk-folding-cube{height:27px;position:relative;-webkit-transform:rotate(45deg);transform:rotate(45deg);width:27px}.sk-folding-cube>div{background-color:initial;float:left;height:50%;position:relative;-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1);width:50%}.sk-folding-cube>div:before{-webkit-animation:sk-foldCubeAngle 2.4s linear infinite both;animation:sk-foldCubeAngle 2.4s linear infinite both;background-color:currentColor;content:\"\";height:100%;left:0;position:absolute;top:0;-webkit-transform-origin:100% 100%;-ms-transform-origin:100% 100%;transform-origin:100% 100%;width:100%}.sk-folding-cube>div:nth-child(2){-webkit-transform:scale(1.1) rotate(90deg);transform:scale(1.1) rotate(90deg)}.sk-folding-cube>div:nth-child(4){-webkit-transform:scale(1.1) rotate(180deg);transform:scale(1.1) rotate(180deg)}.sk-folding-cube>div:nth-child(3){-webkit-transform:scale(1.1) rotate(270deg);transform:scale(1.1) rotate(270deg)}.sk-folding-cube>div:nth-child(2):before{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-folding-cube>div:nth-child(4):before{-webkit-animation-delay:.6s;animation-delay:.6s}.sk-folding-cube>div:nth-child(3):before{-webkit-animation-delay:.9s;animation-delay:.9s}@-webkit-keyframes sk-foldCubeAngle{0%,10%{opacity:0;-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg)}25%,75%{opacity:1;-webkit-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg)}90%,to{opacity:0;-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg)}}@keyframes sk-foldCubeAngle{0%,10%{opacity:0;-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg)}25%,75%{opacity:1;-webkit-transform:perspective(140px) rotateX(0deg);transform:perspective(140px) rotateX(0deg)}90%,to{opacity:0;-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$h);

var css_248z$g = ".sk-pulse>div{-webkit-animation:sk-scaleout 1s ease-in-out infinite;animation:sk-scaleout 1s ease-in-out infinite;background-color:currentColor;border-radius:100%;height:27px;width:27px}@-webkit-keyframes sk-scaleout{0%{-webkit-transform:scale(0)}to{opacity:0;-webkit-transform:scale(1)}}@keyframes sk-scaleout{0%{transform:scale(0);-webkit-transform:scale(0)}to{opacity:0;transform:scale(1);-webkit-transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInB1bHNlLmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxjQU1FLHFEQUF3RCxDQUN4RCw2Q0FBZ0QsQ0FKaEQsNkJBQThCLENBQzlCLGtCQUFtQixDQUZuQixXQUFZLENBRFosVUFPRixDQUVBLCtCQUNFLEdBQUssMEJBQThCLENBQ25DLEdBRUUsU0FBVSxDQURWLDBCQUVGLENBQ0YsQ0FFQSx1QkFDRSxHQUNFLGtCQUFxQixDQUNyQiwwQkFDRixDQUFFLEdBR0EsU0FBVSxDQUZWLGtCQUFxQixDQUNyQiwwQkFFRixDQUNGIiwiZmlsZSI6InB1bHNlLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zay1wdWxzZSA+IGRpdiB7XG4gIHdpZHRoOiAyN3B4O1xuICBoZWlnaHQ6IDI3cHg7XG4gIGJhY2tncm91bmQtY29sb3I6IGN1cnJlbnRDb2xvcjtcbiAgYm9yZGVyLXJhZGl1czogMTAwJTtcblxuICAtd2Via2l0LWFuaW1hdGlvbjogc2stc2NhbGVvdXQgMS4wcyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbiAgYW5pbWF0aW9uOiBzay1zY2FsZW91dCAxLjBzIGluZmluaXRlIGVhc2UtaW4tb3V0O1xufVxuXG5ALXdlYmtpdC1rZXlmcmFtZXMgc2stc2NhbGVvdXQge1xuICAwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZSgwLjApIH1cbiAgMTAwJSB7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDEuMCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuXG5Aa2V5ZnJhbWVzIHNrLXNjYWxlb3V0IHtcbiAgMCUge1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGUoMC4wKTtcbiAgfSAxMDAlIHtcbiAgICB0cmFuc2Zvcm06IHNjYWxlKDEuMCk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDEuMCk7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuIl19 */";
styleInject(css_248z$g);

var css_248z$f = ".sk-rotating-plane>div{-webkit-animation:sk-rotateplane 1.2s ease-in-out infinite;animation:sk-rotateplane 1.2s ease-in-out infinite;background-color:currentColor;height:27px;width:27px}@-webkit-keyframes sk-rotateplane{0%{-webkit-transform:perspective(120px)}50%{-webkit-transform:perspective(120px) rotateY(180deg)}to{-webkit-transform:perspective(120px) rotateY(180deg) rotateX(180deg)}}@keyframes sk-rotateplane{0%{transform:perspective(120px) rotateX(0deg) rotateY(0deg);-webkit-transform:perspective(120px) rotateX(0deg) rotateY(0deg)}50%{transform:perspective(120px) rotateX(-180.1deg) rotateY(0deg);-webkit-transform:perspective(120px) rotateX(-180.1deg) rotateY(0deg)}to{transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg);-webkit-transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJvdGF0aW5nLXBsYW5lLmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSx1QkFLRSwwREFBMkQsQ0FDM0Qsa0RBQW1ELENBSG5ELDZCQUE4QixDQUQ5QixXQUFZLENBRFosVUFNRixDQUVBLGtDQUNFLEdBQUssb0NBQXNDLENBQzNDLElBQU0sb0RBQXNELENBQzVELEdBQU8sb0VBQXVFLENBQ2hGLENBRUEsMEJBQ0UsR0FDRSx3REFBeUQsQ0FDekQsZ0VBQ0YsQ0FBRSxJQUNBLDZEQUE4RCxDQUM5RCxxRUFDRixDQUFFLEdBQ0EsZ0VBQWlFLENBQ2pFLHdFQUNGLENBQ0YiLCJmaWxlIjoicm90YXRpbmctcGxhbmUuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNrLXJvdGF0aW5nLXBsYW5lID4gZGl2IHtcbiAgd2lkdGg6IDI3cHg7XG4gIGhlaWdodDogMjdweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogY3VycmVudENvbG9yO1xuXG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzay1yb3RhdGVwbGFuZSAxLjJzIGluZmluaXRlIGVhc2UtaW4tb3V0O1xuICBhbmltYXRpb246IHNrLXJvdGF0ZXBsYW5lIDEuMnMgaW5maW5pdGUgZWFzZS1pbi1vdXQ7XG59XG5cbkAtd2Via2l0LWtleWZyYW1lcyBzay1yb3RhdGVwbGFuZSB7XG4gIDAlIHsgLXdlYmtpdC10cmFuc2Zvcm06IHBlcnNwZWN0aXZlKDEyMHB4KSB9XG4gIDUwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBwZXJzcGVjdGl2ZSgxMjBweCkgcm90YXRlWSgxODBkZWcpIH1cbiAgMTAwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBwZXJzcGVjdGl2ZSgxMjBweCkgcm90YXRlWSgxODBkZWcpICByb3RhdGVYKDE4MGRlZykgfVxufVxuXG5Aa2V5ZnJhbWVzIHNrLXJvdGF0ZXBsYW5lIHtcbiAgMCUge1xuICAgIHRyYW5zZm9ybTogcGVyc3BlY3RpdmUoMTIwcHgpIHJvdGF0ZVgoMGRlZykgcm90YXRlWSgwZGVnKTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogcGVyc3BlY3RpdmUoMTIwcHgpIHJvdGF0ZVgoMGRlZykgcm90YXRlWSgwZGVnKTtcbiAgfSA1MCUge1xuICAgIHRyYW5zZm9ybTogcGVyc3BlY3RpdmUoMTIwcHgpIHJvdGF0ZVgoLTE4MC4xZGVnKSByb3RhdGVZKDBkZWcpO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiBwZXJzcGVjdGl2ZSgxMjBweCkgcm90YXRlWCgtMTgwLjFkZWcpIHJvdGF0ZVkoMGRlZyk7XG4gIH0gMTAwJSB7XG4gICAgdHJhbnNmb3JtOiBwZXJzcGVjdGl2ZSgxMjBweCkgcm90YXRlWCgtMTgwZGVnKSByb3RhdGVZKC0xNzkuOWRlZyk7XG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHBlcnNwZWN0aXZlKDEyMHB4KSByb3RhdGVYKC0xODBkZWcpIHJvdGF0ZVkoLTE3OS45ZGVnKTtcbiAgfVxufVxuIl19 */";
styleInject(css_248z$f);

var css_248z$e = ".sk-three-bounce{height:18px}.sk-three-bounce>div{-webkit-animation:sk-bouncedelay 1.4s ease-in-out infinite;animation:sk-bouncedelay 1.4s ease-in-out infinite;-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:currentColor;border-radius:100%;display:inline-block;height:18px;width:18px}.sk-three-bounce>div:first-child{-webkit-animation-delay:-.32s;animation-delay:-.32s}.sk-three-bounce>div:nth-child(2){-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0);-webkit-transform:scale(0)}40%{transform:scale(1);-webkit-transform:scale(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRocmVlLWJvdW5jZS5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsaUJBQ0UsV0FDRixDQUVBLHFCQU9FLDBEQUEyRCxDQUMzRCxrREFBbUQsQ0FFbkQsZ0NBQWlDLENBQ2pDLHdCQUF5QixDQVJ6Qiw2QkFBOEIsQ0FDOUIsa0JBQW1CLENBQ25CLG9CQUFxQixDQUhyQixXQUFZLENBRFosVUFXRixDQUVBLGlDQUNFLDZCQUErQixDQUMvQixxQkFDRixDQUVBLGtDQUNFLDZCQUErQixDQUMvQixxQkFDRixDQUVBLGtDQUNFLFVBQWdCLDBCQUE4QixDQUM5QyxJQUFNLDBCQUE4QixDQUN0QyxDQUVBLDBCQUNFLFVBQ0Usa0JBQXFCLENBQ3JCLDBCQUNGLENBQUUsSUFDQSxrQkFBcUIsQ0FDckIsMEJBQ0YsQ0FDRiIsImZpbGUiOiJ0aHJlZS1ib3VuY2UuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNrLXRocmVlLWJvdW5jZSB7XG4gIGhlaWdodDogMThweDtcbn1cblxuLnNrLXRocmVlLWJvdW5jZSA+IGRpdiB7XG4gIHdpZHRoOiAxOHB4O1xuICBoZWlnaHQ6IDE4cHg7XG4gIGJhY2tncm91bmQtY29sb3I6IGN1cnJlbnRDb2xvcjtcbiAgYm9yZGVyLXJhZGl1czogMTAwJTtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzay1ib3VuY2VkZWxheSAxLjRzIGluZmluaXRlIGVhc2UtaW4tb3V0O1xuICBhbmltYXRpb246IHNrLWJvdW5jZWRlbGF5IDEuNHMgaW5maW5pdGUgZWFzZS1pbi1vdXQ7XG4gIC8qIFByZXZlbnQgZmlyc3QgZnJhbWUgZnJvbSBmbGlja2VyaW5nIHdoZW4gYW5pbWF0aW9uIHN0YXJ0cyAqL1xuICAtd2Via2l0LWFuaW1hdGlvbi1maWxsLW1vZGU6IGJvdGg7XG4gIGFuaW1hdGlvbi1maWxsLW1vZGU6IGJvdGg7XG59XG5cbi5zay10aHJlZS1ib3VuY2UgPiBkaXY6Zmlyc3QtY2hpbGQge1xuICAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuMzJzO1xuICBhbmltYXRpb24tZGVsYXk6IC0wLjMycztcbn1cblxuLnNrLXRocmVlLWJvdW5jZSA+IGRpdjpudGgtY2hpbGQoMikge1xuICAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTAuMTZzO1xuICBhbmltYXRpb24tZGVsYXk6IC0wLjE2cztcbn1cblxuQC13ZWJraXQta2V5ZnJhbWVzIHNrLWJvdW5jZWRlbGF5IHtcbiAgMCUsIDgwJSwgMTAwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZSgwLjApIH1cbiAgNDAlIHsgLXdlYmtpdC10cmFuc2Zvcm06IHNjYWxlKDEuMCkgfVxufVxuXG5Aa2V5ZnJhbWVzIHNrLWJvdW5jZWRlbGF5IHtcbiAgMCUsIDgwJSwgMTAwJSB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgwLjApO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZSgwLjApO1xuICB9IDQwJSB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgxLjApO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZSgxLjApO1xuICB9XG59XG4iXX0= */";
styleInject(css_248z$e);

var css_248z$d = ".sk-wandering-cubes{height:52px;position:relative;width:52px}.sk-wandering-cubes>div{-webkit-animation:sk-cubemove 1.8s ease-in-out infinite;animation:sk-cubemove 1.8s ease-in-out infinite;background-color:currentColor;height:10px;left:0;position:absolute;top:0;width:10px}.sk-wandering-cubes>div:last-child{-webkit-animation-delay:-.9s;animation-delay:-.9s}@-webkit-keyframes sk-cubemove{25%{-webkit-transform:translateX(42px) rotate(-90deg) scale(.5)}50%{-webkit-transform:translateX(42px) translateY(42px) rotate(-180deg)}75%{-webkit-transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5)}to{-webkit-transform:rotate(-1turn)}}@keyframes sk-cubemove{25%{transform:translateX(42px) rotate(-90deg) scale(.5);-webkit-transform:translateX(42px) rotate(-90deg) scale(.5)}50%{transform:translateX(42px) translateY(42px) rotate(-179deg);-webkit-transform:translateX(42px) translateY(42px) rotate(-179deg)}50.1%{transform:translateX(42px) translateY(42px) rotate(-180deg);-webkit-transform:translateX(42px) translateY(42px) rotate(-180deg)}75%{transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5);-webkit-transform:translateX(0) translateY(42px) rotate(-270deg) scale(.5)}to{transform:rotate(-1turn);-webkit-transform:rotate(-1turn)}}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$d);

var css_248z$c = ".sk-wave{height:27px;width:30px}.sk-wave>div{-webkit-animation:sk-stretchdelay 1.2s ease-in-out infinite;animation:sk-stretchdelay 1.2s ease-in-out infinite;background-color:currentColor;display:inline-block;height:100%;width:6px}.sk-wave>div:nth-child(2){-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-wave>div:nth-child(3){-webkit-animation-delay:-1s;animation-delay:-1s}.sk-wave>div:nth-child(4){-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-wave>div:nth-child(5){-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes sk-stretchdelay{0%,40%,to{-webkit-transform:scaleY(.4)}20%{-webkit-transform:scaleY(1)}}@keyframes sk-stretchdelay{0%,40%,to{transform:scaleY(.4);-webkit-transform:scaleY(.4)}20%{transform:scaleY(1);-webkit-transform:scaleY(1)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndhdmUuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFNBRUUsV0FBWSxDQURaLFVBRUYsQ0FFQSxhQU1FLDJEQUE0RCxDQUM1RCxtREFBb0QsQ0FOcEQsNkJBQThCLENBRzlCLG9CQUFxQixDQUZyQixXQUFZLENBQ1osU0FLRixDQUVBLDBCQUNFLDZCQUE4QixDQUM5QixxQkFDRixDQUVBLDBCQUNFLDJCQUE4QixDQUM5QixtQkFDRixDQUVBLDBCQUNFLDRCQUE4QixDQUM5QixvQkFDRixDQUVBLDBCQUNFLDRCQUE4QixDQUM5QixvQkFDRixDQUVBLG1DQUNFLFVBQWdCLDRCQUErQixDQUMvQyxJQUFNLDJCQUErQixDQUN2QyxDQUVBLDJCQUNFLFVBQ0Usb0JBQXNCLENBQ3RCLDRCQUNGLENBQUUsSUFDQSxtQkFBc0IsQ0FDdEIsMkJBQ0YsQ0FDRiIsImZpbGUiOiJ3YXZlLmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zay13YXZlIHtcbiAgd2lkdGg6IDMwcHg7XG4gIGhlaWdodDogMjdweDtcbn1cblxuLnNrLXdhdmUgPiBkaXYge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiBjdXJyZW50Q29sb3I7XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDZweDtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXG4gIC13ZWJraXQtYW5pbWF0aW9uOiBzay1zdHJldGNoZGVsYXkgMS4ycyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbiAgYW5pbWF0aW9uOiBzay1zdHJldGNoZGVsYXkgMS4ycyBpbmZpbml0ZSBlYXNlLWluLW91dDtcbn1cblxuLnNrLXdhdmUgPiBkaXY6bnRoLWNoaWxkKDIpIHtcbiAgLXdlYmtpdC1hbmltYXRpb24tZGVsYXk6IC0xLjFzO1xuICBhbmltYXRpb24tZGVsYXk6IC0xLjFzO1xufVxuXG4uc2std2F2ZSA+IGRpdjpudGgtY2hpbGQoMykge1xuICAtd2Via2l0LWFuaW1hdGlvbi1kZWxheTogLTEuMHM7XG4gIGFuaW1hdGlvbi1kZWxheTogLTEuMHM7XG59XG5cbi5zay13YXZlID4gZGl2Om50aC1jaGlsZCg0KSB7XG4gIC13ZWJraXQtYW5pbWF0aW9uLWRlbGF5OiAtMC45cztcbiAgYW5pbWF0aW9uLWRlbGF5OiAtMC45cztcbn1cblxuLnNrLXdhdmUgPiBkaXY6bnRoLWNoaWxkKDUpIHtcbiAgLXdlYmtpdC1hbmltYXRpb24tZGVsYXk6IC0wLjhzO1xuICBhbmltYXRpb24tZGVsYXk6IC0wLjhzO1xufVxuXG5ALXdlYmtpdC1rZXlmcmFtZXMgc2stc3RyZXRjaGRlbGF5IHtcbiAgMCUsIDQwJSwgMTAwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZVkoMC40KSB9XG4gIDIwJSB7IC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZVkoMS4wKSB9XG59XG5cbkBrZXlmcmFtZXMgc2stc3RyZXRjaGRlbGF5IHtcbiAgMCUsIDQwJSwgMTAwJSB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZVkoMC40KTtcbiAgICAtd2Via2l0LXRyYW5zZm9ybTogc2NhbGVZKDAuNCk7XG4gIH0gMjAlIHtcbiAgICB0cmFuc2Zvcm06IHNjYWxlWSgxLjApO1xuICAgIC13ZWJraXQtdHJhbnNmb3JtOiBzY2FsZVkoMS4wKTtcbiAgfVxufVxuIl19 */";
styleInject(css_248z$c);

var css_248z$b = ".sk-wordpress>div{-webkit-animation:sk-inner-circle 1s linear infinite;animation:sk-inner-circle 1s linear infinite;background-color:currentColor;border-radius:27px;display:inline-block;height:27px;position:relative;width:27px}.sk-wordpress>div:after{background-color:#fff;border-radius:8px;content:\"\";display:block;height:8px;left:5px;position:absolute;top:5px;width:8px}@-webkit-keyframes sk-inner-circle{0%{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(1turn)}}@keyframes sk-inner-circle{0%{transform:rotate(0);-webkit-transform:rotate(0)}to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndvcmRwcmVzcy5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsa0JBUUUsb0RBQXFELENBQ3JELDRDQUE2QyxDQU43Qyw2QkFBOEIsQ0FFOUIsa0JBQW1CLENBRG5CLG9CQUFxQixDQUZyQixXQUFZLENBSVosaUJBQWtCLENBTGxCLFVBU0YsQ0FFQSx3QkFHRSxxQkFBc0IsQ0FJdEIsaUJBQWtCLENBTmxCLFVBQVcsQ0FDWCxhQUFjLENBR2QsVUFBVyxDQUlYLFFBQVMsQ0FIVCxpQkFBa0IsQ0FFbEIsT0FBUSxDQUpSLFNBTUYsQ0FFQSxtQ0FDRSxHQUFLLDJCQUE4QixDQUNuQyxHQUFPLCtCQUFtQyxDQUM1QyxDQUVBLDJCQUNFLEdBQUssbUJBQW9CLENBQUUsMkJBQTZCLENBQ3hELEdBQU8sdUJBQXlCLENBQUUsK0JBQWtDLENBQ3RFIiwiZmlsZSI6IndvcmRwcmVzcy5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc2std29yZHByZXNzID4gZGl2IHtcbiAgd2lkdGg6IDI3cHg7XG4gIGhlaWdodDogMjdweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogY3VycmVudENvbG9yO1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIGJvcmRlci1yYWRpdXM6IDI3cHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICAtd2Via2l0LWFuaW1hdGlvbjogc2staW5uZXItY2lyY2xlIDFzIGxpbmVhciBpbmZpbml0ZTtcbiAgYW5pbWF0aW9uOiBzay1pbm5lci1jaXJjbGUgMXMgbGluZWFyIGluZmluaXRlO1xufVxuXG4uc2std29yZHByZXNzID4gZGl2OjphZnRlciB7XG4gIGNvbnRlbnQ6ICcnO1xuICBkaXNwbGF5OiBibG9jaztcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjtcbiAgd2lkdGg6IDhweDtcbiAgaGVpZ2h0OiA4cHg7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgYm9yZGVyLXJhZGl1czogOHB4O1xuICB0b3A6IDVweDtcbiAgbGVmdDogNXB4O1xufVxuXG5ALXdlYmtpdC1rZXlmcmFtZXMgc2staW5uZXItY2lyY2xlIHtcbiAgMCUgeyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDApOyB9XG4gIDEwMCUgeyAtd2Via2l0LXRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7IH1cbn1cblxuQGtleWZyYW1lcyBzay1pbm5lci1jaXJjbGUge1xuICAwJSB7IHRyYW5zZm9ybTogcm90YXRlKDApOyAtd2Via2l0LXRyYW5zZm9ybTpyb3RhdGUoMCk7IH1cbiAgMTAwJSB7IHRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7IC13ZWJraXQtdHJhbnNmb3JtOnJvdGF0ZSgzNjBkZWcpOyB9XG59XG4iXX0= */";
styleInject(css_248z$b);

var _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes$2 = propTypes$2.exports;

var _propTypes2$2 = _interopRequireDefault$2(_propTypes$2);

var _react$2 = React__default$1;

var _react2$2 = _interopRequireDefault$2(_react$2);

var _classnames = classnames.exports;

var _classnames2 = _interopRequireDefault$2(_classnames);

var _objectAssign = objectAssign;

var _objectAssign2 = _interopRequireDefault$2(_objectAssign);

var _spinners = spinners;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies


if (!process.env.REACT_SPINKIT_NO_STYLES) ;

var noFadeInWarning = "Deprecation Warning (react-spinkit): noFadeIn prop should be replaced with fadeIn='none'";

var Spinner = function (_React$Component) {
  _inherits$1(Spinner, _React$Component);

  function Spinner(props) {
    _classCallCheck$1(this, Spinner);

    if (props.noFadeIn) {
      console.warn(noFadeInWarning); // eslint-disable-line no-console
    }

    var _this = _possibleConstructorReturn$1(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, props));

    _this.displayName = 'SpinKit';
    return _this;
  }

  _createClass$1(Spinner, [{
    key: 'render',
    value: function render() {
      var _cx;

      var spinnerInfo = _spinners.allSpinners[this.props.name] || _spinners.allSpinners['three-bounce'];
      var classes = (0, _classnames2.default)((_cx = {
        'sk-fade-in': this.props.fadeIn === 'full' && !this.props.noFadeIn,
        'sk-fade-in-half-second': this.props.fadeIn === 'half' && !this.props.noFadeIn,
        'sk-fade-in-quarter-second': this.props.fadeIn === 'quarter' && !this.props.noFadeIn,
        'sk-spinner': !this.props.overrideSpinnerClassName
      }, _defineProperty$1(_cx, this.props.overrideSpinnerClassName, !!this.props.overrideSpinnerClassName), _defineProperty$1(_cx, this.props.className, !!this.props.className), _defineProperty$1(_cx, spinnerInfo.className || this.props.name, true), _cx));

      var props = (0, _objectAssign2.default)({}, this.props);
      delete props.name;
      delete props.fadeIn;
      delete props.noFadeIn;
      delete props.overrideSpinnerClassName;
      delete props.className;

      if (this.props.color) {
        props.style = props.style ? _extends$6({}, props.style, { color: this.props.color }) : { color: this.props.color };
      }

      return _react2$2.default.createElement(
        'div',
        _extends$6({}, props, { className: classes }),
        [].concat(_toConsumableArray(Array(spinnerInfo.divCount))).map(function (_, idx) {
          return _react2$2.default.createElement('div', { key: idx });
        })
      );
    }
  }]);

  return Spinner;
}(_react2$2.default.Component);

Spinner.propTypes = {
  name: _propTypes2$2.default.string.isRequired,
  noFadeIn: _propTypes2$2.default.bool,
  fadeIn: _propTypes2$2.default.oneOf(['full', 'half', 'quarter', 'none']),
  overrideSpinnerClassName: _propTypes2$2.default.string,
  className: _propTypes2$2.default.string,
  color: _propTypes2$2.default.string
};

Spinner.defaultProps = {
  name: 'three-bounce',
  noFadeIn: false,
  fadeIn: 'full',
  overrideSpinnerClassName: ''
};

var dist = Spinner;

var css_248z$a = "@font-face{font-family:HK Grotesk Pro;src:url(https://cardscan-assets.s3-accelerate.amazonaws.com/fonts/HK/HKGroteskPro-Regular.otf)}html{--cardscan-video-width:0px;--cardscan-video-height:0px;--cardscan-app-height:100vh;--cardscan-app-width:100vw;--cardscan-buffer-size:0;--cardscan-buffer-max-size:1;--cardscan-video-background-height:0;--cardscan-corner-width:62px;--cardscan-corner-height:62px;--cardscan-auto-switch-active-color:#6fcf97;--cardscan-auto-switch-inactive-color:#bdbdbd;--cardscan-progress-bar-color:#6fcf97;--cardscan-widget-background-color:rgba(29,29,29,.9);--cardscan-message-font-size:18px;--cardscan-message-text-color:#fff;--cardscan-message-background-color:rgba(0,0,0,.45)}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFdBQ0UsMEJBQTZCLENBQzdCLDhGQUNGLENBQ0EsS0FDRSwwQkFBMkIsQ0FDM0IsMkJBQTRCLENBQzVCLDJCQUE0QixDQUM1QiwwQkFBMkIsQ0FDM0Isd0JBQXlCLENBQ3pCLDRCQUE2QixDQUM3QixvQ0FBcUMsQ0FDckMsNEJBQTZCLENBQzdCLDZCQUE4QixDQUM5QiwyQ0FBNEMsQ0FDNUMsNkNBQThDLENBQzlDLHFDQUFzQyxDQUN0QyxvREFBeUQsQ0FDekQsaUNBQWtDLENBQ2xDLGtDQUFvQyxDQUNwQyxtREFDRiIsImZpbGUiOiJzdHlsZXMuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIkBmb250LWZhY2Uge1xuICBmb250LWZhbWlseTogXCJISyBHcm90ZXNrIFByb1wiO1xuICBzcmM6IHVybChodHRwczovL2NhcmRzY2FuLWFzc2V0cy5zMy1hY2NlbGVyYXRlLmFtYXpvbmF3cy5jb20vZm9udHMvSEsvSEtHcm90ZXNrUHJvLVJlZ3VsYXIub3RmKTtcbn1cbmh0bWwge1xuICAtLWNhcmRzY2FuLXZpZGVvLXdpZHRoOiAwcHg7XG4gIC0tY2FyZHNjYW4tdmlkZW8taGVpZ2h0OiAwcHg7XG4gIC0tY2FyZHNjYW4tYXBwLWhlaWdodDogMTAwdmg7XG4gIC0tY2FyZHNjYW4tYXBwLXdpZHRoOiAxMDB2dztcbiAgLS1jYXJkc2Nhbi1idWZmZXItc2l6ZTogMDtcbiAgLS1jYXJkc2Nhbi1idWZmZXItbWF4LXNpemU6IDE7XG4gIC0tY2FyZHNjYW4tdmlkZW8tYmFja2dyb3VuZC1oZWlnaHQ6IDA7XG4gIC0tY2FyZHNjYW4tY29ybmVyLXdpZHRoOiA2MnB4O1xuICAtLWNhcmRzY2FuLWNvcm5lci1oZWlnaHQ6IDYycHg7XG4gIC0tY2FyZHNjYW4tYXV0by1zd2l0Y2gtYWN0aXZlLWNvbG9yOiAjNmZjZjk3O1xuICAtLWNhcmRzY2FuLWF1dG8tc3dpdGNoLWluYWN0aXZlLWNvbG9yOiAjYmRiZGJkO1xuICAtLWNhcmRzY2FuLXByb2dyZXNzLWJhci1jb2xvcjogIzZmY2Y5NztcbiAgLS1jYXJkc2Nhbi13aWRnZXQtYmFja2dyb3VuZC1jb2xvcjogcmdiYSgyOSwgMjksIDI5LCAwLjkpO1xuICAtLWNhcmRzY2FuLW1lc3NhZ2UtZm9udC1zaXplOiAxOHB4O1xuICAtLWNhcmRzY2FuLW1lc3NhZ2UtdGV4dC1jb2xvcjogd2hpdGU7XG4gIC0tY2FyZHNjYW4tbWVzc2FnZS1iYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuNDUpO1xufSJdfQ== */";
styleInject(css_248z$a);

var defaultMessages = {
    manualCaptureTitle: "Use Button Below to Scan Card",
    frontsideCompletedTitle: "Front side scan is complete\nRotate card to scan back",
    autoCaptureTitle: "Hold Card in Frame\nIt Will Scan Automatically",
    processingTitle: "Keep Card Still While Scanning",
    completedTitle: "Card Scanned Successfully",
    errorTitle: "Setup Failure - Please Reload the Page",
    retryTitle: "Scanning Failed - Please Try Again",
    cameraErrorTitle: "Unable to Setup Camera for Capture",
};
var defaultIndicatorOptions = {
    name: "ball-spin-fade-loader",
    fadeIn: "none",
    color: "#FFF",
};

/* eslint-disable @typescript-eslint/no-var-requires */
var tf = require("@tensorflow/tfjs");
var loadGraphModel = require("@tensorflow/tfjs-converter").loadGraphModel;
var CardDetector = /** @class */ (function () {
    function CardDetector() {
        var _this = this;
        //model is fixed to IMG_SIZE x IMG_SIZE
        this.IMG_SIZE = 224;
        this._debug = false;
        this.laplaceFilter = tf
            .tensor2d([
            [0, 1, 0],
            [1, -4, 1],
            [0, 1, 0],
        ])
            .expandDims(-1)
            .expandDims(-1);
        console.debug("CardScan: Detector -- init");
        this._modelState = "loading";
        this.load_model().then(function (model) {
            _this.model = model;
            _this._modelState = "loaded";
            _this.warm_model();
        });
        //TODO: catch error loading model....
    }
    Object.defineProperty(CardDetector.prototype, "debug", {
        set: function (value) {
            this._debug = value;
            if (value) {
                //link to console so that we can output debug messages when in debug mode.
                this.console = window.console;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardDetector.prototype, "modelState", {
        get: function () {
            return this._modelState;
        },
        enumerable: false,
        configurable: true
    });
    CardDetector.prototype.load_model = function () {
        return __awaiter(this, void 0, void 0, function () {
            var model, t0, t1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        t0 = performance.now();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, loadGraphModel("indexeddb://cardscan-class-model")];
                    case 2:
                        model = _b.sent();
                        console.debug("model loading from cache");
                        return [3 /*break*/, 5];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, loadGraphModel("https://cardscan-models.s3-accelerate.amazonaws.com/card-detection-ft-class/model-v2-tfjs/model.json")];
                    case 4:
                        model = _b.sent();
                        console.debug("model loading from S3");
                        return [3 /*break*/, 5];
                    case 5:
                        t1 = performance.now();
                        console.debug("model-load: ".concat(t1 - t0, " ms"));
                        return [2 /*return*/, model];
                }
            });
        });
    };
    CardDetector.prototype.warm_model = function () {
        var _this = this;
        if (this.model == null) {
            console.error("Unable to warm unloaded model");
            return;
        }
        //TOOD: check https, check IP isn't HOME.
        var expression = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
        //trying to stop other devs from wasting time.
        if (expression.test(window.location.hostname) &&
            window.location.hostname != "127.0.0.1") {
            console.log("CardScanView: many browsers do not allow camera access on IP addresses. Please use localhost or a domain.");
        }
        if (window.location.protocol != "https:" &&
            window.location.hostname != "localhost" &&
            window.location.hostname != "127.0.0.1") {
            console.log("CardScanView: many browsers do not allow camera access on insecure connections. Please use localhost or https");
        }
        tf.tidy(function () {
            var t0 = performance.now();
            var results = _this.model.predict(tf.zeros([_this.IMG_SIZE, _this.IMG_SIZE, 3], "float32").expandDims(0));
            results.data().then(function () {
                _this._modelState = "warmed";
                //save model on successful warm
                _this.model.save("indexeddb://cardscan-class-model");
            });
            var t1 = performance.now();
            console.debug("model-warm: ".concat(t1 - t0, " ms"));
            console.debug(_this.tf_mem_log(tf.memory()));
        });
    };
    CardDetector.prototype.tf_mem_log = function (memory) {
        return "TF Memory Usage - t:".concat(memory.numTensors, ", gpu:").concat(memory.numBytesInGPU, ", gpufree:").concat(memory.numBytesInGPUFree, " buf:").concat(memory.numDataBuffers, ", mem:").concat(memory.numBytes);
    };
    CardDetector.prototype.prepare_results = function (modelResult, laplaceResult) {
        var response = {};
        var predictions = tf.sigmoid(modelResult);
        var score = predictions.dataSync()[0];
        response["modelClass"] = score < 0.5 ? "card" : "notcard";
        response["modelScore"] = score;
        response["modelProbability"] = score < 0.5 ? 1 - score : score;
        laplaceResult = laplaceResult.squeeze();
        laplaceResult = laplaceResult.div(tf.scalar(255)); //need to workaround #2475
        response["laplaceVariance"] = tf
            .moments(laplaceResult)
            .variance.dataSync()[0];
        response["laplaceMax"] = laplaceResult.max(1).dataSync()[0];
        //cleanup memory
        laplaceResult.dispose();
        modelResult.dispose();
        predictions.dispose();
        return response;
    };
    CardDetector.prototype.predict_image = function (canvas) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                //on slow systems the model might not be loaded yet.
                if (this.model === undefined) {
                    return [2 /*return*/, null];
                }
                //TODO check canvas matches model image size
                //cleans up all tensors on exit
                return [2 /*return*/, tf.tidy(function () {
                        var _a, _b, _c, _d;
                        var t0 = performance.now();
                        var data = tf.browser.fromPixels(canvas, 3);
                        var grey = data.mean(2);
                        data = tf.cast(data, "float32");
                        //normalize from 0 to 1
                        data = data.div(tf.scalar(255));
                        (_a = _this.console) === null || _a === void 0 ? void 0 : _a.debug("image-prepare: ".concat(performance.now() - t0, " ms"));
                        t0 = performance.now();
                        var result = _this.model.predict(data.expandDims(0));
                        (_b = _this.console) === null || _b === void 0 ? void 0 : _b.debug("model-predict: ".concat(performance.now() - t0, " ms"));
                        grey = grey.expandDims(0).expandDims(-1);
                        t0 = performance.now();
                        var lapResult = grey.conv2d(_this.laplaceFilter, 1, "valid");
                        (_c = _this.console) === null || _c === void 0 ? void 0 : _c.debug("laplacian: ".concat(performance.now() - t0, " ms"));
                        (_d = _this.console) === null || _d === void 0 ? void 0 : _d.debug(_this.tf_mem_log(tf.memory()));
                        return _this.prepare_results(result, lapResult);
                    })];
            });
        });
    };
    return CardDetector;
}());
var DetectorWrapper = /** @class */ (function () {
    function DetectorWrapper() {
    }
    DetectorWrapper.get = function () {
        //Lazy init -- if not pre-initalized.
        if (window.cardDetector === undefined) {
            window.cardDetector = new CardDetector();
        }
        return window.cardDetector;
    };
    DetectorWrapper.init = function () {
        if (window.cardDetector === undefined) {
            window.cardDetector = new CardDetector();
        }
    };
    DetectorWrapper.cleanUp = function () {
        delete window.cardDetector;
    };
    return DetectorWrapper;
}());
var CardScanModel = /** @class */ (function () {
    function CardScanModel() {
    }
    CardScanModel.warm = function () {
        console.debug("CardScan: Detector -- warm model");
        DetectorWrapper.init();
    };
    return CardScanModel;
}());

/* eslint-disable @typescript-eslint/no-empty-function */
var MyGlobalContext = createContext({
    debug: true,
    modelState: {},
    scanDebugState: {},
    threshold: {},
    setThreshold: {},
    laplacianThreshold: {},
    setLaplacianThreshold: {},
    scanFreqency: {},
    setScanFreqency: {},
    bufferSize: {},
    setBufferSize: {},
    bufferRef: {},
    debugCanvasBestRef: {},
    bestScore: {},
    debugCanvasLatestRef: {},
    latestScore: {},
    latestLaplacian: {},
    showCurtain: false,
    onCloseBtn: function () { },
    closeButton: null,
    isMobile: false,
    isMobileOnLandscape: false,
    stateMachineState: {},
    stateMachineSend: function () { },
    stateMachineService: {},
});
var useGlobalContext = function () { return useContext(MyGlobalContext); };

var css_248z$9 = ".scanDebugMenu{background-color:grey;left:0;position:absolute;top:0;z-index:2000}.scanDebugMenu *{font-size:14px}.scanDebugMenu input{background-color:#d3d3d3;width:60px}.scanDebugMenu button{background-color:#656464;border-radius:6px;color:#fff;margin-left:13px;padding:0 3px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRlYnVnLm1vZHVsZXMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxlQUNFLHFCQUFzQixDQUd0QixNQUFTLENBRlQsaUJBQWtCLENBQ2xCLEtBQVEsQ0FFUixZQUNGLENBQ0EsaUJBQ0UsY0FDRixDQUNBLHFCQUVFLHdCQUEyQixDQUQzQixVQUVGLENBQ0Esc0JBQ0Usd0JBQXlCLENBR3pCLGlCQUFrQixDQUZsQixVQUFZLENBQ1osZ0JBQWlCLENBRWpCLGFBQ0YiLCJmaWxlIjoiZGVidWcubW9kdWxlcy5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNjYW5EZWJ1Z01lbnUge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiBncmV5O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMHB4O1xuICBsZWZ0OiAwcHg7XG4gIHotaW5kZXg6IDIwMDA7XG59XG4uc2NhbkRlYnVnTWVudSAqIHtcbiAgZm9udC1zaXplOiAxNHB4O1xufVxuLnNjYW5EZWJ1Z01lbnUgaW5wdXQge1xuICB3aWR0aDogNjBweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogbGlnaHRncmF5O1xufVxuLnNjYW5EZWJ1Z01lbnUgYnV0dG9uIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogIzY1NjQ2NDtcbiAgY29sb3I6IHdoaXRlO1xuICBtYXJnaW4tbGVmdDogMTNweDtcbiAgYm9yZGVyLXJhZGl1czogNnB4O1xuICBwYWRkaW5nOiAwcHggM3B4O1xufSJdfQ== */";
styleInject(css_248z$9);

var DebugMenu = function () {
    var _a = useGlobalContext(), debug = _a.debug, bufferRef = _a.bufferRef, threshold = _a.threshold, setThreshold = _a.setThreshold, modelState = _a.modelState, scanDebugState = _a.scanDebugState, laplacianThreshold = _a.laplacianThreshold, scanFreqency = _a.scanFreqency, debugCanvasBestRef = _a.debugCanvasBestRef, bestScore = _a.bestScore, setBufferSize = _a.setBufferSize, setScanFreqency = _a.setScanFreqency, latestScore = _a.latestScore, latestLaplacian = _a.latestLaplacian, debugCanvasLatestRef = _a.debugCanvasLatestRef, setLaplacianThreshold = _a.setLaplacianThreshold, bufferSize = _a.bufferSize;
    var _b = useState(true), showDebugMenu = _b[0], setShowDebugMenu = _b[1];
    var loadDebugLibraries = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            //Load debug libraries in dynamically at runtine so we don't need them in the package.
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    if (debug == false) {
                        return reject();
                    }
                    // @ts-expect-error: Debug libraries loading dynamically.
                    if (window.JSZip != undefined || window.saveAs != undefined) {
                        //already loaded
                        return resolve();
                    }
                    console.log("JSZip & FileSaver are required for this feature");
                    // @ts-expect-error: FileSaver loading dynamically.
                    if (window.FileSaver == undefined) {
                        var script = document.createElement("script");
                        script.src =
                            "https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.0/FileSaver.min.js";
                        script.id = "filesaver-dynamic-load";
                        document.body.appendChild(script);
                    }
                    // @ts-expect-error: JSZip loading dynamically.
                    if (window.JSZip == undefined) {
                        var script = document.createElement("script");
                        script.src =
                            "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.7.1/jszip.min.js";
                        script.id = "jszip-dynamic-load";
                        document.body.appendChild(script);
                        script.onload = function () {
                            // console.log("JSZip loaded!");
                            return resolve();
                        };
                    }
                })];
        });
    }); };
    var downloadDebugLog = function (event) {
        if (bufferRef.current.length == 0) {
            console.log("No cards to download");
            return;
        }
        loadDebugLibraries().then(function () {
            // @ts-expect-error: Debug libraries loading dynamically.
            var zip = new window.JSZip();
            bufferRef.current.forEach(function (element) {
                var name = element.file.lastModified + ".jpg";
                zip.file(name, element.file);
            });
            var files = bufferRef.current.map(function (element) {
                element["file"] = element.file.lastModified;
                return element;
            });
            var results = new Blob([JSON.stringify(files, null, 2)], {
                type: "application/json",
            });
            zip.file("results.json", results);
            var filename = "download_" + new Date().getTime() + ".zip";
            zip.generateAsync({ type: "blob" }).then(function (content) {
                // @ts-expect-error: Debug libraries loading dynamically.
                window.saveAs(content, filename);
            });
        });
    };
    if (!debug) {
        return jsx("div", {});
    }
    return (jsxs("div", __assign$2({ "data-cy": "scanDebugMenu", className: css_248z$9.scanDebugMenu }, { children: [jsx("button", __assign$2({ onClick: function (e) {
                    setShowDebugMenu(!showDebugMenu);
                } }, { children: showDebugMenu ? "Hide" : "Show" })), jsxs("div", __assign$2({ className: "scan-debug-wrapper", hidden: !showDebugMenu }, { children: [jsxs("div", __assign$2({ "data-cy": "scanDebugModelstate", className: "scan-debug-modelstate" }, { children: ["Model: ", modelState] })), jsxs("div", __assign$2({ "data-cy": "scanDebugScanstate", className: "scan-debug-scanstate" }, { children: ["Scanning: ", scanDebugState] })), jsxs("div", __assign$2({ className: "scan-debug-threshold" }, { children: ["Model Threshold:", " ", jsx("input", { type: "number", value: threshold, onChange: function (event) {
                                    setThreshold(Number(event.target.value));
                                } })] })), jsxs("div", __assign$2({ className: "scan-debug-threshold" }, { children: ["Laplacian Threshold:", " ", jsx("input", { type: "number", value: laplacianThreshold, onChange: function (event) {
                                    setLaplacianThreshold(Number(event.target.value));
                                } })] })), jsxs("div", __assign$2({ className: "scan-debug-frequency" }, { children: ["Scan Frequency:", " ", jsx("input", { type: "number", value: scanFreqency, onChange: function (event) {
                                    setScanFreqency(Number(event.target.value));
                                } })] })), jsxs("div", __assign$2({ className: "scan-debug-results" }, { children: ["Buffer: ", bufferRef.current.length, " /", " ", jsx("input", { type: "number", width: "35px", value: bufferSize, onChange: function (event) {
                                    setBufferSize(Number(event.target.value));
                                } }), jsx("button", __assign$2({ onClick: function (event) {
                                    bufferRef.current = [];
                                } }, { children: "Clear" }))] })), jsxs("div", __assign$2({ className: "scan-debug-best-score" }, { children: ["Best Score: ", (Math.round(bestScore * 1000) / 1000).toFixed(3)] })), jsx("canvas", { ref: debugCanvasBestRef, width: "200", height: "125" }), jsxs("div", __assign$2({ className: "scan-debug-latest-score" }, { children: ["Latest Score: ", (Math.round(latestScore * 1000) / 1000).toFixed(3), " ", jsx("br", {}), "Laplacian: ", (Math.round(latestLaplacian * 1000) / 1000).toFixed(3)] })), jsx("canvas", { ref: debugCanvasLatestRef, width: "200", height: "125" }), jsx("div", __assign$2({ className: "scan-debug-get-debug" }, { children: jsx("button", __assign$2({ onClick: downloadDebugLog }, { children: "Download Buffer" })) }))] }))] })));
};

var img$7 = "data:image/png;base64,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";

var FirefoxVideo = "https://cardscan-assets.s3-accelerate.amazonaws.com/permissions-videos/firefox.mp4";
var SafariVideo = "https://cardscan-assets.s3-accelerate.amazonaws.com/permissions-videos/safari.mp4";
var ChromeVideo = "https://cardscan-assets.s3-accelerate.amazonaws.com/permissions-videos/chrome.mp4";
var CardScanLogoURL = "https://cardscan-assets.s3-accelerate.amazonaws.com/images/cardscan-logo.png";
var getBrowserHelperImage = function (browserName) {
    if (browserName === void 0) { browserName = "Chrome"; }
    return ({
        Firefox: FirefoxVideo,
        Chrome: ChromeVideo,
        Safari: SafariVideo,
        Edge: img$7,
    }[browserName]);
};
function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","), mime = arr[0].match(/:(.*?);/)[1], bstr = window.atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
var calculateGuides = function (videoRefBg, frameDivRef, debug) {
    var _a, _b, _c, _d, _e, _f;
    var scaleX = (((_a = videoRefBg.current) === null || _a === void 0 ? void 0 : _a.videoWidth) || 0) /
        (((_b = videoRefBg.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || 1);
    var scaleY = (((_c = videoRefBg.current) === null || _c === void 0 ? void 0 : _c.videoHeight) || 0) /
        (((_d = videoRefBg.current) === null || _d === void 0 ? void 0 : _d.clientHeight) || 1);
    var frameDivDimensions = (_e = frameDivRef.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect();
    var videoElementDimensions = (_f = videoRefBg.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect();
    var offsetX = ((frameDivDimensions === null || frameDivDimensions === void 0 ? void 0 : frameDivDimensions.x) || 0) - ((videoElementDimensions === null || videoElementDimensions === void 0 ? void 0 : videoElementDimensions.x) || 0);
    var offsetY = ((frameDivDimensions === null || frameDivDimensions === void 0 ? void 0 : frameDivDimensions.y) || 0) - ((videoElementDimensions === null || videoElementDimensions === void 0 ? void 0 : videoElementDimensions.y) || 0);
    var guideX = Math.max(Math.round(offsetX * scaleX), 0);
    var guideY = Math.max(Math.round(offsetY * scaleY), 0);
    var guideWidth = Math.round(frameDivDimensions.width * scaleX);
    var guideHeight = Math.round(frameDivDimensions.height * scaleY);
    if (debug) {
        console.debug("Guide: ".concat(guideX, ", ").concat(guideY, ", ").concat(guideWidth, ", ").concat(guideHeight));
    }
    return [guideX, guideY, guideWidth, guideHeight];
};
var getHeaderTitle = function (status, messageState, isAuto) {
    return ({
        cameraLoading: messageState.autoCaptureTitle,
        autoCapture: messageState.autoCaptureTitle,
        manualCapture: messageState.manualCaptureTitle,
        frontsideProcessing: messageState.processingTitle,
        backsidePending: messageState.frontsideCompletedTitle,
        frontsideCompleted: messageState.frontsideCompletedTitle,
        backsideProcessing: messageState.processingTitle,
        completed: messageState.completedTitle,
        pending: isAuto
            ? messageState.autoCaptureTitle
            : messageState.manualCaptureTitle,
        error: messageState.errorTitle,
        cameraError: messageState.cameraErrorTitle,
        retry: messageState.retryTitle,
    }[status]);
};

var lib$1 = {};

var uaParser_min = {exports: {}};

/* UAParser.js v1.0.33
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */

(function (module, exports) {
(function(window,undefined$1){var LIBVERSION="0.7.33",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=350;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i]);}else {mergedRegexes[i]=regexes[i];}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i];}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined$1},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match);}else {this[q[0]]=q[1];}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined$1;}else {this[q[0]]=match?match.replace(q[1],q[2]):undefined$1;}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined$1;}}else {this[q]=match?match:undefined$1;}}}}i+=2;}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined$1:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined$1:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/yabrowser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i,/\[(linkedin)app\]/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i],[NAME,VERSION],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/\((ip(?:hone|od)[\w ]*);/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+ ([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined$1;}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _ua=ua||(typeof window!==UNDEF_TYPE&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var _rgxmap=extensions?extend(regexes,extensions):regexes;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined$1;_browser[VERSION]=undefined$1;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser.major=majorize(_browser.version);return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined$1;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined$1;_device[MODEL]=undefined$1;_device[TYPE]=undefined$1;rgxMapper.call(_device,_ua,_rgxmap.device);return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined$1;_engine[VERSION]=undefined$1;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined$1;_os[VERSION]=undefined$1;rgxMapper.call(_os,_ua,_rgxmap.os);return _os};this.getResult=function(){return {ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);{if(module.exports){exports=module.exports=UAParser;}exports.UAParser=UAParser;}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop];}};}})(typeof window==="object"?window:commonjsGlobal);
}(uaParser_min, uaParser_min.exports));

Object.defineProperty(lib$1, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = React__default$1;
var React__default = _interopDefault(React);

var UAParser = uaParser_min.exports;

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties$2(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties$2(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties$2(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties$2(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties$2(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties$2(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties$2(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children;
      _ref8.viewClassName;
      _ref8.style;
      var props = _objectWithoutProperties$2(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties$2(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties$2(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties$2(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children;
      _ref12.viewClassName;
      _ref12.style;
      var condition = _ref12.condition,
      props = _objectWithoutProperties$2(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends$5({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

lib$1.AndroidView = AndroidView;
lib$1.BrowserTypes = BrowserTypes;
lib$1.BrowserView = BrowserView;
lib$1.ConsoleView = ConsoleView;
lib$1.CustomView = CustomView;
lib$1.IEView = IEView;
lib$1.IOSView = IOSView;
lib$1.MobileOnlyView = MobileOnlyView;
lib$1.MobileView = MobileView;
lib$1.OsTypes = OsTypes;
lib$1.SmartTVView = SmartTVView;
lib$1.TabletView = TabletView;
lib$1.WearableView = WearableView;
lib$1.WinPhoneView = WinPhoneView;
var browserName_1 = lib$1.browserName = browserName;
lib$1.browserVersion = browserVersion;
lib$1.deviceDetect = deviceDetect;
lib$1.deviceType = deviceType;
lib$1.engineName = engineName;
lib$1.engineVersion = engineVersion;
lib$1.fullBrowserVersion = fullBrowserVersion;
lib$1.getSelectorsByUserAgent = getSelectorsByUserAgent;
lib$1.getUA = getUA;
lib$1.isAndroid = isAndroid;
lib$1.isBrowser = isBrowser;
lib$1.isChrome = isChrome;
lib$1.isChromium = isChromium;
lib$1.isConsole = isConsole;
lib$1.isDesktop = isDesktop;
lib$1.isEdge = isEdge;
lib$1.isEdgeChromium = isEdgeChromium;
lib$1.isElectron = isElectron;
lib$1.isEmbedded = isEmbedded;
lib$1.isFirefox = isFirefox;
lib$1.isIE = isIE;
var isIOS_1 = lib$1.isIOS = isIOS;
lib$1.isIOS13 = isIOS13;
lib$1.isIPad13 = isIPad13;
lib$1.isIPhone13 = isIPhone13;
lib$1.isIPod13 = isIPod13;
lib$1.isLegacyEdge = isLegacyEdge;
lib$1.isMIUI = isMIUI;
lib$1.isMacOs = isMacOs;
var isMobile_1 = lib$1.isMobile = isMobile;
lib$1.isMobileOnly = isMobileOnly;
lib$1.isMobileSafari = isMobileSafari;
lib$1.isOpera = isOpera;
lib$1.isSafari = isSafari;
lib$1.isSamsungBrowser = isSamsungBrowser;
lib$1.isSmartTV = isSmartTV;
lib$1.isTablet = isTablet;
lib$1.isWearable = isWearable;
lib$1.isWinPhone = isWinPhone;
lib$1.isWindows = isWindows;
lib$1.isYandex = isYandex;
lib$1.mobileModel = mobileModel;
lib$1.mobileVendor = mobileVendor;
lib$1.osName = osName;
lib$1.osVersion = osVersion;
lib$1.parseUserAgent = parseUserAgent;
lib$1.setUserAgent = setUserAgent;
lib$1.useDeviceData = useDeviceData;
lib$1.useDeviceSelectors = useDeviceSelectors;
var useMobileOrientation_1 = lib$1.useMobileOrientation = useMobileOrientation;
lib$1.withOrientationChange = withOrientationChange;

var css_248z$8 = ".permissionModal-module_scanErrorModal__l1xjO{align-items:center;background-color:#f9fbfd;border-radius:16px;box-shadow:0 8px 36px 0 rgba(0,0,0,.161);display:flex;flex-direction:column;height:630px;left:50%;padding:20px;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%);width:550px;z-index:999999}.permissionModal-module_scanErrorModal__l1xjO>*{margin-bottom:16px}.permissionModal-module_scanErrorTitle__7oc7e{color:#000;font-size:24px;font-weight:700;text-align:center}.permissionModal-module_scanErrorDescription__EgD59{color:rgba(21,25,32,.5);font-size:18px;font-weight:400;text-align:center}.permissionModal-module_scanErrorButton__-Tl-x{border:none;border-radius:8px;font-size:14px;font-weight:600;height:42px;min-width:230px}.permissionModal-module_scanErrorButtonContainer__cKvdH{display:flex;justify-content:space-around;width:100%}.permissionModal-module_scanErrorButtonSecondary__UrV9T{background:#fff;border:1px solid #566789;color:rgba(21,25,32,.5)}.permissionModal-module_scanErrorButtonPrimary__jBcc9{background-color:#2f80ed;color:#fff}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$7 = {"scanErrorModal":"permissionModal-module_scanErrorModal__l1xjO","scanErrorTitle":"permissionModal-module_scanErrorTitle__7oc7e","scanErrorDescription":"permissionModal-module_scanErrorDescription__EgD59","scanErrorButton":"permissionModal-module_scanErrorButton__-Tl-x","scanErrorButtonContainer":"permissionModal-module_scanErrorButtonContainer__cKvdH","scanErrorButtonSecondary":"permissionModal-module_scanErrorButtonSecondary__UrV9T","scanErrorButtonPrimary":"permissionModal-module_scanErrorButtonPrimary__jBcc9"};
styleInject(css_248z$8);

var CameraPermissionModal = function (_a) {
    var enableModel = _a.enableModel;
    if (!enableModel) {
        return jsx("div", {});
    }
    return (jsxs("div", __assign$2({ className: styles$7.scanErrorModal }, { children: [jsx("h2", __assign$2({ className: styles$7.scanErrorTitle }, { children: "Camera Permission Needed" })), jsx("p", { children: "This application needs access to the camera to scan your medical insurance card. Please allow access to the camera." }), jsxs("video", __assign$2({ controls: true, autoPlay: true, loop: true, muted: true, width: "400" }, { children: [jsx("source", { src: getBrowserHelperImage(browserName_1), type: "video/mp4" }), "Sorry, your browser doesn't support embedded videos."] })), jsx("div", __assign$2({ className: styles$7.scanErrorButtonContainer }, { children: jsx("button", __assign$2({ className: "".concat(styles$7.scanErrorButton, " ").concat(styles$7.scanErrorButtonPrimary), onClick: function () { return window.location.reload(); } }, { children: "Try Again" })) }))] })));
};

let updateQueue = makeQueue();
const raf = fn => schedule(fn, updateQueue);
let writeQueue = makeQueue();

raf.write = fn => schedule(fn, writeQueue);

let onStartQueue = makeQueue();

raf.onStart = fn => schedule(fn, onStartQueue);

let onFrameQueue = makeQueue();

raf.onFrame = fn => schedule(fn, onFrameQueue);

let onFinishQueue = makeQueue();

raf.onFinish = fn => schedule(fn, onFinishQueue);

let timeouts = [];

raf.setTimeout = (handler, ms) => {
  let time = raf.now() + ms;

  let cancel = () => {
    let i = timeouts.findIndex(t => t.cancel == cancel);
    if (~i) timeouts.splice(i, 1);
    pendingCount -= ~i ? 1 : 0;
  };

  let timeout = {
    time,
    handler,
    cancel
  };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start$2();
  return timeout;
};

let findTimeout = time => ~(~timeouts.findIndex(t => t.time > time) || ~timeouts.length);

raf.cancel = fn => {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  onFinishQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
};

raf.sync = fn => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};

raf.throttle = fn => {
  let lastArgs;

  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }

  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }

  throttled.handler = fn;

  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };

  return throttled;
};

let nativeRaf = typeof window != 'undefined' ? window.requestAnimationFrame : () => {};

raf.use = impl => nativeRaf = impl;

raf.now = typeof performance != 'undefined' ? () => performance.now() : Date.now;

raf.batchedUpdates = fn => fn();

raf.catch = console.error;
raf.frameLoop = 'always';

raf.advance = () => {
  if (raf.frameLoop !== 'demand') {
    console.warn('Cannot call the manual advancement of rafz whilst frameLoop is not set as demand');
  } else {
    update$1();
  }
};

let ts = -1;
let pendingCount = 0;
let sync = false;

function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start$2();
  }
}

function start$2() {
  if (ts < 0) {
    ts = 0;

    if (raf.frameLoop !== 'demand') {
      nativeRaf(loop);
    }
  }
}

function stop$2() {
  ts = -1;
}

function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update$1);
  }
}

function update$1() {
  let prevTs = ts;
  ts = raf.now();
  let count = findTimeout(ts);

  if (count) {
    eachSafely(timeouts.splice(0, count), t => t.handler());
    pendingCount -= count;
  }

  if (!pendingCount) {
    stop$2();
    return;
  }

  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}

function makeQueue() {
  let next = new Set();
  let current = next;
  return {
    add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },

    delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },

    flush(arg) {
      if (current.size) {
        next = new Set();
        pendingCount -= current.size;
        eachSafely(current, fn => fn(arg) && next.add(fn));
        pendingCount += next.size;
        current = next;
      }
    }

  };
}

function eachSafely(values, each) {
  values.forEach(value => {
    try {
      each(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}

function noop() {}
const defineHidden = (obj, key, value) => Object.defineProperty(obj, key, {
  value,
  writable: true,
  configurable: true
});
const is = {
  arr: Array.isArray,
  obj: a => !!a && a.constructor.name === 'Object',
  fun: a => typeof a === 'function',
  str: a => typeof a === 'string',
  num: a => typeof a === 'number',
  und: a => a === undefined
};
function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length) return false;

    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    return true;
  }

  return a === b;
}
const each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
  if (is.arr(obj)) {
    for (let i = 0; i < obj.length; i++) {
      fn.call(ctx, obj[i], `${i}`);
    }

    return;
  }

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx, obj[key], key);
    }
  }
}
const toArray$1 = a => is.und(a) ? [] : is.arr(a) ? a : [a];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}
const flushCalls = (queue, ...args) => flush(queue, fn => fn(...args));
const isSSR = () => typeof window === 'undefined' || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);

let createStringInterpolator$1;
let to;
let colors$1 = null;
let skipAnimation = false;
let willAdvance = noop;
const assign$3 = globals => {
  if (globals.to) to = globals.to;
  if (globals.now) raf.now = globals.now;
  if (globals.colors !== undefined) colors$1 = globals.colors;
  if (globals.skipAnimation != null) skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator) createStringInterpolator$1 = globals.createStringInterpolator;
  if (globals.requestAnimationFrame) raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates) raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance) willAdvance = globals.willAdvance;
  if (globals.frameLoop) raf.frameLoop = globals.frameLoop;
};

var globals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get createStringInterpolator () { return createStringInterpolator$1; },
  get to () { return to; },
  get colors () { return colors$1; },
  get skipAnimation () { return skipAnimation; },
  get willAdvance () { return willAdvance; },
  assign: assign$3
});

const startQueue = new Set();
let currentFrame = [];
let prevFrame = [];
let priority = 0;
const frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },

  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },

  advance,

  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);

      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },

  clear() {
    currentFrame = [];
    startQueue.clear();
  }

};

function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}

function startSafely(animation) {
  if (!currentFrame.includes(animation)) startUnsafely(animation);
}

function startUnsafely(animation) {
  currentFrame.splice(findIndex(currentFrame, other => other.priority > animation.priority), 0, animation);
}

function advance(dt) {
  const nextFrame = prevFrame;

  for (let i = 0; i < currentFrame.length; i++) {
    const animation = currentFrame[i];
    priority = animation.priority;

    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);

      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }

  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}

function findIndex(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

const clamp = (min, max, v) => Math.min(Math.max(v, min), max);

const colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call(...parts) {
  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

function normalizeColor(color) {
  let match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  }

  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;

  if (colors$1 && colors$1[color] !== undefined) {
    return colors$1[color];
  }

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 0x000000ff) >>> 0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + 'ff', 16) >>> 0;
  }

  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 0x000000ff) >>> 0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 0xff000000) >>> 24;
  let g = (int32Color & 0x00ff0000) >>> 16;
  let b = (int32Color & 0x0000ff00) >>> 8;
  let a = (int32Color & 0x000000ff) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

const createInterpolator = (range, output, extrapolate) => {
  if (is.fun(range)) {
    return range;
  }

  if (is.arr(range)) {
    return createInterpolator({
      range,
      output: output,
      extrapolate
    });
  }

  if (is.str(range.output[0])) {
    return createStringInterpolator$1(range);
  }

  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  const easing = config.easing || (t => t);

  return input => {
    const range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
};

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;

  return i - 1;
}

const steps = (steps, direction = 'end') => progress => {
  progress = direction === 'end' ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
  const expanded = progress * steps;
  const rounded = direction === 'end' ? Math.floor(expanded) : Math.ceil(expanded);
  return clamp(0, 1, rounded / steps);
};

const c1 = 1.70158;
const c2 = c1 * 1.525;
const c3 = c1 + 1;
const c4 = 2 * Math.PI / 3;
const c5 = 2 * Math.PI / 4.5;

const bounceOut = x => {
  const n1 = 7.5625;
  const d1 = 2.75;

  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
};

const easings = {
  linear: x => x,
  easeInQuad: x => x * x,
  easeOutQuad: x => 1 - (1 - x) * (1 - x),
  easeInOutQuad: x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
  easeInCubic: x => x * x * x,
  easeOutCubic: x => 1 - Math.pow(1 - x, 3),
  easeInOutCubic: x => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
  easeInQuart: x => x * x * x * x,
  easeOutQuart: x => 1 - Math.pow(1 - x, 4),
  easeInOutQuart: x => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
  easeInQuint: x => x * x * x * x * x,
  easeOutQuint: x => 1 - Math.pow(1 - x, 5),
  easeInOutQuint: x => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
  easeInSine: x => 1 - Math.cos(x * Math.PI / 2),
  easeOutSine: x => Math.sin(x * Math.PI / 2),
  easeInOutSine: x => -(Math.cos(Math.PI * x) - 1) / 2,
  easeInExpo: x => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
  easeOutExpo: x => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
  easeInOutExpo: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
  easeInCirc: x => 1 - Math.sqrt(1 - Math.pow(x, 2)),
  easeOutCirc: x => Math.sqrt(1 - Math.pow(x - 1, 2)),
  easeInOutCirc: x => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
  easeInBack: x => c3 * x * x * x - c1 * x * x,
  easeOutBack: x => 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
  easeInOutBack: x => x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
  easeInElastic: x => x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
  easeOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
  easeInOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
  easeInBounce: x => 1 - bounceOut(1 - x),
  easeOutBounce: bounceOut,
  easeInOutBounce: x => x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2,
  steps
};

function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$4.apply(this, arguments);
}

const $get = Symbol.for('FluidValue.get');
const $observers = Symbol.for('FluidValue.observers');

const hasFluidValue = arg => Boolean(arg && arg[$get]);

const getFluidValue = arg => arg && arg[$get] ? arg[$get]() : arg;

const getFluidObservers = target => target[$observers] || null;

function callFluidObserver(observer, event) {
  if (observer.eventObserved) {
    observer.eventObserved(event);
  } else {
    observer(event);
  }
}

function callFluidObservers(target, event) {
  let observers = target[$observers];

  if (observers) {
    observers.forEach(observer => {
      callFluidObserver(observer, event);
    });
  }
}

class FluidValue {
  constructor(get) {
    this[$get] = void 0;
    this[$observers] = void 0;

    if (!get && !(get = this.get)) {
      throw Error('Unknown getter');
    }

    setFluidGetter(this, get);
  }

}

const setFluidGetter = (target, get) => setHidden(target, $get, get);

function addFluidObserver(target, observer) {
  if (target[$get]) {
    let observers = target[$observers];

    if (!observers) {
      setHidden(target, $observers, observers = new Set());
    }

    if (!observers.has(observer)) {
      observers.add(observer);

      if (target.observerAdded) {
        target.observerAdded(observers.size, observer);
      }
    }
  }

  return observer;
}

function removeFluidObserver(target, observer) {
  let observers = target[$observers];

  if (observers && observers.has(observer)) {
    const count = observers.size - 1;

    if (count) {
      observers.delete(observer);
    } else {
      target[$observers] = null;
    }

    if (target.observerRemoved) {
      target.observerRemoved(count, observer);
    }
  }
}

const setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});

const numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
const unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, 'i');
const rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

const variableToRgba = input => {
  const [token, fallback] = parseCSSVariable(input);

  if (!token || isSSR()) {
    return input;
  }

  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);

  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith('--')) {
    const _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);

    if (_value) {
      return _value;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }

  return input;
};

const parseCSSVariable = current => {
  const match = cssVariableRegex.exec(current);
  if (!match) return [,];
  const [, token, fallback] = match;
  return [token, fallback];
};

let namedColorRegex;

const rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;

const createStringInterpolator = config => {
  if (!namedColorRegex) namedColorRegex = colors$1 ? new RegExp(`(${Object.keys(colors$1).join('|')})(?!\\w)`, 'g') : /^\b$/;
  const output = config.output.map(value => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes = output.map(value => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map((_, i) => keyframes.map(values => {
    if (!(i in values)) {
      throw Error('The arity of each "output" value must be equal');
    }

    return values[i];
  }));
  const interpolators = outputRanges.map(output => createInterpolator(_extends$4({}, config, {
    output
  })));
  return input => {
    var _output$find;

    const missingUnit = !unitRegex.test(output[0]) && ((_output$find = output.find(value => unitRegex.test(value))) == null ? void 0 : _output$find.replace(numberRegex, ''));
    let i = 0;
    return output[0].replace(numberRegex, () => `${interpolators[i++](input)}${missingUnit || ''}`).replace(rgbaRegex, rgbaRound);
  };
};

const prefix = 'react-spring: ';
const once = fn => {
  const func = fn;
  let called = false;

  if (typeof func != 'function') {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }

  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};
const warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(`${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(`${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}

function isAnimatedString(value) {
  return is.str(value) && (value[0] == '#' || /\d/.test(value) || !isSSR() && cssVariableRegex.test(value) || value in (colors$1 || {}));
}

const useIsomorphicLayoutEffect$1 = isSSR() ? useEffect : useLayoutEffect;

const useIsMounted = () => {
  const isMounted = useRef(false);
  useIsomorphicLayoutEffect$1(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

function useForceUpdate() {
  const update = useState()[1];
  const isMounted = useIsMounted();
  return () => {
    if (isMounted.current) {
      update(Math.random());
    }
  };
}

function useMemoOne(getResult, inputs) {
  const [initial] = useState(() => ({
    inputs,
    result: getResult()
  }));
  const committed = useRef();
  const prevCache = committed.current;
  let cache = prevCache;

  if (cache) {
    const useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));

    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }

  useEffect(() => {
    committed.current = cache;

    if (prevCache == initial) {
      initial.inputs = initial.result = undefined;
    }
  }, [cache]);
  return cache.result;
}

function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }

  for (let i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }

  return true;
}

const useOnce = effect => useEffect(effect, emptyDeps);
const emptyDeps = [];

function usePrev(value) {
  const prevRef = useRef();
  useEffect(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}

const $node = Symbol.for('Animated:node');
const isAnimated = value => !!value && value[$node] === value;
const getAnimated = owner => owner && owner[$node];
const setAnimated = (owner, node) => defineHidden(owner, $node, node);
const getPayload = owner => owner && owner[$node] && owner[$node].getPayload();
class Animated {
  constructor() {
    this.payload = void 0;
    setAnimated(this, this);
  }

  getPayload() {
    return this.payload || [];
  }

}

class AnimatedValue extends Animated {
  constructor(_value) {
    super();
    this.done = true;
    this.elapsedTime = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.v0 = void 0;
    this.durationProgress = 0;
    this._value = _value;

    if (is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }

  static create(value) {
    return new AnimatedValue(value);
  }

  getPayload() {
    return [this];
  }

  getValue() {
    return this._value;
  }

  setValue(value, step) {
    if (is.num(value)) {
      this.lastPosition = value;

      if (step) {
        value = Math.round(value / step) * step;

        if (this.done) {
          this.lastPosition = value;
        }
      }
    }

    if (this._value === value) {
      return false;
    }

    this._value = value;
    return true;
  }

  reset() {
    const {
      done
    } = this;
    this.done = false;

    if (is.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done) this.lastVelocity = null;
      this.v0 = null;
    }
  }

}

class AnimatedString extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = void 0;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }

  static create(value) {
    return new AnimatedString(value);
  }

  getValue() {
    let value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }

  setValue(value) {
    if (is.str(value)) {
      if (value == this._string) {
        return false;
      }

      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }

    return true;
  }

  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }

    this._value = 0;
    super.reset();
  }

}

const TreeContext = {
  dependencies: null
};

class AnimatedObject extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }

  getValue(animated) {
    const values = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if (hasFluidValue(source)) {
        values[key] = getFluidValue(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }

  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }

  reset() {
    if (this.payload) {
      each(this.payload, node => node.reset());
    }
  }

  _makePayload(source) {
    if (source) {
      const payload = new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }

  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }

    const payload = getPayload(source);

    if (payload) {
      each(payload, node => this.add(node));
    }
  }

}

class AnimatedArray extends AnimatedObject {
  constructor(source) {
    super(source);
  }

  static create(source) {
    return new AnimatedArray(source);
  }

  getValue() {
    return this.source.map(node => node.getValue());
  }

  setValue(source) {
    const payload = this.getPayload();

    if (source.length == payload.length) {
      return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
    }

    super.setValue(source.map(makeAnimated));
    return true;
  }

}

function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}

function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3.apply(this, arguments);
}

const withAnimated = (Component, host) => {
  const hasInstance = !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  return forwardRef((givenProps, givenRef) => {
    const instanceRef = useRef(null);
    const ref = hasInstance && useCallback(value => {
      instanceRef.current = updateRef(givenRef, value);
    }, [givenRef]);
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = useForceUpdate();

    const callback = () => {
      const instance = instanceRef.current;

      if (hasInstance && !instance) {
        return;
      }

      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;

      if (didUpdate === false) {
        forceUpdate();
      }
    };

    const observer = new PropsObserver(callback, deps);
    const observerRef = useRef();
    useIsomorphicLayoutEffect$1(() => {
      observerRef.current = observer;
      each(deps, dep => addFluidObserver(dep, observer));
      return () => {
        if (observerRef.current) {
          each(observerRef.current.deps, dep => removeFluidObserver(dep, observerRef.current));
          raf.cancel(observerRef.current.update);
        }
      };
    });
    useEffect(callback, []);
    useOnce(() => () => {
      const observer = observerRef.current;
      each(observer.deps, dep => removeFluidObserver(dep, observer));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return React$1.createElement(Component, _extends$3({}, usedProps, {
      ref: ref
    }));
  });
};

class PropsObserver {
  constructor(update, deps) {
    this.update = update;
    this.deps = deps;
  }

  eventObserved(event) {
    if (event.type == 'change') {
      raf.write(this.update);
    }
  }

}

function getAnimatedState(props, host) {
  const dependencies = new Set();
  TreeContext.dependencies = dependencies;
  if (props.style) props = _extends$3({}, props, {
    style: host.createAnimatedStyle(props.style)
  });
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}

function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
}

const cacheKey = Symbol.for('AnimatedComponent');
const createHost = (components, {
  applyAnimatedValues: _applyAnimatedValues = () => false,
  createAnimatedStyle: _createAnimatedStyle = style => new AnimatedObject(style),
  getComponentProps: _getComponentProps = props => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues: _applyAnimatedValues,
    createAnimatedStyle: _createAnimatedStyle,
    getComponentProps: _getComponentProps
  };

  const animated = Component => {
    const displayName = getDisplayName(Component) || 'Anonymous';

    if (is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }

    Component.displayName = `Animated(${displayName})`;
    return Component;
  };

  eachProp(components, (Component, key) => {
    if (is.arr(components)) {
      key = getDisplayName(Component);
    }

    animated[key] = animated(Component);
  });
  return {
    animated
  };
};

const getDisplayName = arg => is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$2.apply(this, arguments);
}

function callProp(value, ...args) {
  return is.fun(value) ? value(...args) : value;
}
const matchProp = (value, key) => value === true || !!(key && value && (is.fun(value) ? value(key) : toArray$1(value).includes(key)));
const resolveProp = (prop, key) => is.obj(prop) ? key && prop[key] : prop;
const getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : undefined;

const noopTransform = value => value;

const getDefaultProps = (props, transform = noopTransform) => {
  let keys = DEFAULT_PROPS;

  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }

  const defaults = {};

  for (const key of keys) {
    const value = transform(props[key], key);

    if (!is.und(value)) {
      defaults[key] = value;
    }
  }

  return defaults;
};
const DEFAULT_PROPS = ['config', 'onProps', 'onStart', 'onChange', 'onPause', 'onResume', 'onRest'];
const RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  keys: 1,
  callId: 1,
  parentId: 1
};

function getForwardProps(props) {
  const forward = {};
  let count = 0;
  eachProp(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });

  if (count) {
    return forward;
  }
}

function inferTo(props) {
  const to = getForwardProps(props);

  if (to) {
    const out = {
      to
    };
    eachProp(props, (val, key) => key in to || (out[key] = val));
    return out;
  }

  return _extends$2({}, props);
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (const _ in props) return true;

  return false;
}
function isAsyncTo(to) {
  return is.fun(to) || is.arr(to) && is.obj(to[0]);
}
function detachRefs(ctrl, ref) {
  var _ctrl$ref;

  (_ctrl$ref = ctrl.ref) == null ? void 0 : _ctrl$ref.delete(ctrl);
  ref == null ? void 0 : ref.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    var _ctrl$ref2;

    (_ctrl$ref2 = ctrl.ref) == null ? void 0 : _ctrl$ref2.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

const config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};

const defaults = _extends$2({}, config.default, {
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
});

class AnimationConfig {
  constructor() {
    this.tension = void 0;
    this.friction = void 0;
    this.frequency = void 0;
    this.damping = void 0;
    this.mass = void 0;
    this.velocity = 0;
    this.restVelocity = void 0;
    this.precision = void 0;
    this.progress = void 0;
    this.duration = void 0;
    this.easing = void 0;
    this.clamp = void 0;
    this.bounce = void 0;
    this.decay = void 0;
    this.round = void 0;
    Object.assign(this, defaults);
  }

}
function mergeConfig(config, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = _extends$2({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = _extends$2({}, defaultConfig, newConfig);
  }

  sanitizeConfig(config, newConfig);
  Object.assign(config, newConfig);

  for (const key in defaults) {
    if (config[key] == null) {
      config[key] = defaults[key];
    }
  }

  let {
    mass,
    frequency,
    damping
  } = config;

  if (!is.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config.friction = 4 * Math.PI * damping * mass / frequency;
  }

  return config;
}

function sanitizeConfig(config, props) {
  if (!is.und(props.decay)) {
    config.duration = undefined;
  } else {
    const isTensionConfig = !is.und(props.tension) || !is.und(props.friction);

    if (isTensionConfig || !is.und(props.frequency) || !is.und(props.damping) || !is.und(props.mass)) {
      config.duration = undefined;
      config.decay = undefined;
    }

    if (isTensionConfig) {
      config.frequency = undefined;
    }
  }
}

const emptyArray = [];
class Animation {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.to = void 0;
    this.from = void 0;
    this.config = new AnimationConfig();
    this.immediate = false;
  }

}

function scheduleProps(callId, {
  key,
  props,
  defaultProps,
  state,
  actions
}) {
  return new Promise((resolve, reject) => {
    var _props$cancel;

    let delay;
    let timeout;
    let cancel = matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);

    if (cancel) {
      onStart();
    } else {
      if (!is.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }

      let pause = defaultProps == null ? void 0 : defaultProps.pause;

      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }

      delay = callProp(props.delay || 0, key);

      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }

    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }

    function onResume() {
      if (delay > 0 && !globals.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }

    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }

      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);

      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }

      try {
        actions.start(_extends$2({}, props, {
          callId,
          cancel
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

const getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some(result => result.cancelled) ? getCancelledResult(target.get()) : results.every(result => result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(result => result.finished));
const getNoopResult = value => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
const getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
const getCancelledResult = value => ({
  value,
  cancelled: true,
  finished: false
});

function runAsync(to, props, state, target) {
  const {
    callId,
    parentId,
    onRest
  } = props;
  const {
    asyncTo: prevTo,
    promise: prevPromise
  } = state;

  if (!parentId && to === prevTo && !props.reset) {
    return prevPromise;
  }

  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to;
    const defaultProps = getDefaultProps(props, (value, key) => key === 'onRest' ? undefined : value);
    let preventBail;
    let bail;
    const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));

    const bailIfEnded = bailSignal => {
      const bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);

      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };

    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAnimationSignal();
      return (async () => {
        if (globals.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }

        bailIfEnded(bailSignal);
        const props = is.obj(arg1) ? _extends$2({}, arg1) : _extends$2({}, arg2, {
          to: arg1
        });
        props.parentId = callId;
        eachProp(defaultProps, (value, key) => {
          if (is.und(props[key])) {
            props[key] = value;
          }
        });
        const result = await target.start(props);
        bailIfEnded(bailSignal);

        if (state.paused) {
          await new Promise(resume => {
            state.resumeQueue.add(resume);
          });
        }

        return result;
      })();
    };

    let result;

    if (globals.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }

    try {
      let animating;

      if (is.arr(to)) {
        animating = (async queue => {
          for (const props of queue) {
            await animate(props);
          }
        })(to);
      } else {
        animating = Promise.resolve(to(animate, target.stop.bind(target)));
      }

      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAnimationSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : undefined;
        state.promise = parentId ? prevPromise : undefined;
      }
    }

    if (is.fun(onRest)) {
      raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }

    return result;
  })();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, t => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = undefined;
  if (cancelId) state.cancelId = cancelId;
}
class BailSignal extends Error {
  constructor() {
    super('An async animation has been interrupted. You see this error because you ' + 'forgot to use `await` or `.catch(...)` on its returned promise.');
    this.result = void 0;
  }

}
class SkipAnimationSignal extends Error {
  constructor() {
    super('SkipAnimationSignal');
    this.result = void 0;
  }

}

const isFrameValue = value => value instanceof FrameValue;
let nextId$1 = 1;
class FrameValue extends FluidValue {
  constructor(...args) {
    super(...args);
    this.id = nextId$1++;
    this.key = void 0;
    this._priority = 0;
  }

  get priority() {
    return this._priority;
  }

  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;

      this._onPriorityChange(priority);
    }
  }

  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }

  to(...args) {
    return globals.to(this, args);
  }

  interpolate(...args) {
    deprecateInterpolate();
    return globals.to(this, args);
  }

  toJSON() {
    return this.get();
  }

  observerAdded(count) {
    if (count == 1) this._attach();
  }

  observerRemoved(count) {
    if (count == 0) this._detach();
  }

  _attach() {}

  _detach() {}

  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: 'change',
      parent: this,
      value,
      idle
    });
  }

  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.sort(this);
    }

    callFluidObservers(this, {
      type: 'priority',
      parent: this,
      priority
    });
  }

}

const $P = Symbol.for('SpringPhase');
const HAS_ANIMATED = 1;
const IS_ANIMATING = 2;
const IS_PAUSED = 4;
const hasAnimated = target => (target[$P] & HAS_ANIMATED) > 0;
const isAnimating = target => (target[$P] & IS_ANIMATING) > 0;
const isPaused = target => (target[$P] & IS_PAUSED) > 0;
const setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
const setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;

class SpringValue extends FrameValue {
  constructor(arg1, arg2) {
    super();
    this.key = void 0;
    this.animation = new Animation();
    this.queue = void 0;
    this.defaultProps = {};
    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._pendingCalls = new Set();
    this._lastCallId = 0;
    this._lastToId = 0;
    this._memoizedDuration = 0;

    if (!is.und(arg1) || !is.und(arg2)) {
      const props = is.obj(arg1) ? _extends$2({}, arg1) : _extends$2({}, arg2, {
        from: arg1
      });

      if (is.und(props.default)) {
        props.default = true;
      }

      this.start(props);
    }
  }

  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }

  get goal() {
    return getFluidValue(this.animation.to);
  }

  get velocity() {
    const node = getAnimated(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map(node => node.lastVelocity || 0);
  }

  get hasAnimated() {
    return hasAnimated(this);
  }

  get isAnimating() {
    return isAnimating(this);
  }

  get isPaused() {
    return isPaused(this);
  }

  get isDelayed() {
    return this._state.delayed;
  }

  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let {
      config,
      toValues
    } = anim;
    const payload = getPayload(anim.to);

    if (!payload && hasFluidValue(anim.to)) {
      toValues = toArray$1(getFluidValue(anim.to));
    }

    anim.values.forEach((node, i) => {
      if (node.done) return;
      const to = node.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
      let finished = anim.immediate;
      let position = to;

      if (!finished) {
        position = node.lastPosition;

        if (config.tension <= 0) {
          node.done = true;
          return;
        }

        let elapsed = node.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node.v0 != null ? node.v0 : node.v0 = is.arr(config.velocity) ? config.velocity[i] : config.velocity;
        let velocity;
        const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));

        if (!is.und(config.duration)) {
          let p = 1;

          if (config.duration > 0) {
            if (this._memoizedDuration !== config.duration) {
              this._memoizedDuration = config.duration;

              if (node.durationProgress > 0) {
                node.elapsedTime = config.duration * node.durationProgress;
                elapsed = node.elapsedTime += dt;
              }
            }

            p = (config.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node.durationProgress = p;
          }

          position = from + config.easing(p) * (to - from);
          velocity = (position - node.lastPosition) / dt;
          finished = p == 1;
        } else if (config.decay) {
          const decay = config.decay === true ? 0.998 : config.decay;
          const e = Math.exp(-(1 - decay) * elapsed);
          position = from + v0 / (1 - decay) * (1 - e);
          finished = Math.abs(node.lastPosition - position) <= precision;
          velocity = v0 * e;
        } else {
          velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
          const restVelocity = config.restVelocity || precision / 10;
          const bounceFactor = config.clamp ? 0 : config.bounce;
          const canBounce = !is.und(bounceFactor);
          const isGrowing = from == to ? node.v0 > 0 : from < to;
          let isMoving;
          let isBouncing = false;
          const step = 1;
          const numSteps = Math.ceil(dt / step);

          for (let n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;

            if (!isMoving) {
              finished = Math.abs(to - position) <= precision;

              if (finished) {
                break;
              }
            }

            if (canBounce) {
              isBouncing = position == to || position > to == isGrowing;

              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position = to;
              }
            }

            const springForce = -config.tension * 0.000001 * (position - to);
            const dampingForce = -config.friction * 0.001 * velocity;
            const acceleration = (springForce + dampingForce) / config.mass;
            velocity = velocity + acceleration * step;
            position = position + velocity * step;
          }
        }

        node.lastVelocity = velocity;

        if (Number.isNaN(position)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }

      if (payload && !payload[i].done) {
        finished = false;
      }

      if (finished) {
        node.done = true;
      } else {
        idle = false;
      }

      if (node.setValue(position, config.round)) {
        changed = true;
      }
    });
    const node = getAnimated(this);
    const currVal = node.getValue();

    if (idle) {
      const finalVal = getFluidValue(anim.to);

      if ((currVal !== finalVal || changed) && !config.decay) {
        node.setValue(finalVal);

        this._onChange(finalVal);
      } else if (changed && config.decay) {
        this._onChange(currVal);
      }

      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }

  set(value) {
    raf.batchedUpdates(() => {
      this._stop();

      this._focus(value);

      this._set(value);
    });
    return this;
  }

  pause() {
    this._update({
      pause: true
    });
  }

  resume() {
    this._update({
      pause: false
    });
  }

  finish() {
    if (isAnimating(this)) {
      const {
        to,
        config
      } = this.animation;
      raf.batchedUpdates(() => {
        this._onStart();

        if (!config.decay) {
          this._set(to, false);
        }

        this._stop();
      });
    }

    return this;
  }

  update(props) {
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }

  start(to, arg2) {
    let queue;

    if (!is.und(to)) {
      queue = [is.obj(to) ? to : _extends$2({}, arg2, {
        to
      })];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }

    return Promise.all(queue.map(props => {
      const up = this._update(props);

      return up;
    })).then(results => getCombinedResult(this, results));
  }

  stop(cancel) {
    const {
      to
    } = this.animation;

    this._focus(this.get());

    stopAsync(this._state, cancel && this._lastCallId);
    raf.batchedUpdates(() => this._stop(to, cancel));
    return this;
  }

  reset() {
    this._update({
      reset: true
    });
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._start();
    } else if (event.type == 'priority') {
      this.priority = event.priority + 1;
    }
  }

  _prepareNode(props) {
    const key = this.key || '';
    let {
      to,
      from
    } = props;
    to = is.obj(to) ? to[key] : to;

    if (to == null || isAsyncTo(to)) {
      to = undefined;
    }

    from = is.obj(from) ? from[key] : from;

    if (from == null) {
      from = undefined;
    }

    const range = {
      to,
      from
    };

    if (!hasAnimated(this)) {
      if (props.reverse) [to, from] = [from, to];
      from = getFluidValue(from);

      if (!is.und(from)) {
        this._set(from);
      } else if (!getAnimated(this)) {
        this._set(to);
      }
    }

    return range;
  }

  _update(_ref, isLoop) {
    let props = _extends$2({}, _ref);

    const {
      key,
      defaultProps
    } = this;
    if (props.default) Object.assign(defaultProps, getDefaultProps(props, (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value));
    mergeActiveFn(this, props, 'onProps');
    sendEvent(this, 'onProps', props, this);

    const range = this._prepareNode(props);

    if (Object.isFrozen(this)) {
      throw Error('Cannot animate a `SpringValue` object that is frozen. ' + 'Did you forget to pass your component to `animated(...)` before animating its props?');
    }

    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(this, 'onPause', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);

            if (isAnimating(this)) {
              this._resume();
            }

            flushCalls(state.resumeQueue);
            sendEvent(this, 'onResume', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then(result => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);

        if (nextProps) {
          return this._update(nextProps, true);
        }
      }

      return result;
    });
  }

  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }

    const hasToProp = !is.und(range.to);
    const hasFromProp = !is.und(range.from);

    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }

    const {
      key,
      defaultProps,
      animation: anim
    } = this;
    const {
      to: prevTo,
      from: prevFrom
    } = anim;
    let {
      to = prevTo,
      from = prevFrom
    } = range;

    if (hasFromProp && !hasToProp && (!props.default || is.und(to))) {
      to = from;
    }

    if (props.reverse) [to, from] = [from, to];
    const hasFromChanged = !isEqual(from, prevFrom);

    if (hasFromChanged) {
      anim.from = from;
    }

    from = getFluidValue(from);
    const hasToChanged = !isEqual(to, prevTo);

    if (hasToChanged) {
      this._focus(to);
    }

    const hasAsyncTo = isAsyncTo(props.to);
    const {
      config
    } = anim;
    const {
      decay,
      velocity
    } = config;

    if (hasToProp || hasFromProp) {
      config.velocity = 0;
    }

    if (props.config && !hasAsyncTo) {
      mergeConfig(config, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
    }

    let node = getAnimated(this);

    if (!node || is.und(to)) {
      return resolve(getFinishedResult(this, true));
    }

    const reset = is.und(props.reset) ? hasFromProp && !props.default : !is.und(from) && matchProp(props.reset, key);
    const value = reset ? from : this.get();
    const goal = computeGoal(to);
    const isAnimatable = is.num(goal) || is.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));

    if (hasToChanged) {
      const nodeType = getAnimatedType(to);

      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
      }
    }

    const goalType = node.constructor;
    let started = hasFluidValue(to);
    let finished = false;

    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;

      if (hasToChanged || hasValueChanged) {
        finished = isEqual(computeGoal(value), goal);
        started = !finished;
      }

      if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config.decay, decay) || !isEqual(config.velocity, velocity)) {
        started = true;
      }
    }

    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop(prevTo);
      }
    }

    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = hasFluidValue(to) ? null : goalType == AnimatedString ? [1] : toArray$1(goal);
      }

      if (anim.immediate != immediate) {
        anim.immediate = immediate;

        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }

      if (started) {
        const {
          onRest
        } = anim;
        each(ACTIVE_EVENTS, type => mergeActiveFn(this, props, type));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);

        this._pendingCalls.add(resolve);

        if (anim.changed) raf.batchedUpdates(() => {
          anim.changed = !reset;
          onRest == null ? void 0 : onRest(result, this);

          if (reset) {
            callProp(defaultProps.onRest, result);
          } else {
            anim.onStart == null ? void 0 : anim.onStart(result, this);
          }
        });
      }
    }

    if (reset) {
      this._set(value);
    }

    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
      this._start();
    } else if (isAnimating(this) && !hasToChanged) {
      this._pendingCalls.add(resolve);
    } else {
      resolve(getNoopResult(value));
    }
  }

  _focus(value) {
    const anim = this.animation;

    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }

      anim.to = value;

      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }

  _attach() {
    let priority = 0;
    const {
      to
    } = this.animation;

    if (hasFluidValue(to)) {
      addFluidObserver(to, this);

      if (isFrameValue(to)) {
        priority = to.priority + 1;
      }
    }

    this.priority = priority;
  }

  _detach() {
    const {
      to
    } = this.animation;

    if (hasFluidValue(to)) {
      removeFluidObserver(to, this);
    }
  }

  _set(arg, idle = true) {
    const value = getFluidValue(arg);

    if (!is.und(value)) {
      const oldNode = getAnimated(this);

      if (!oldNode || !isEqual(value, oldNode.getValue())) {
        const nodeType = getAnimatedType(value);

        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }

        if (oldNode) {
          raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }

    return getAnimated(this);
  }

  _onStart() {
    const anim = this.animation;

    if (!anim.changed) {
      anim.changed = true;
      sendEvent(this, 'onStart', getFinishedResult(this, checkFinished(this, anim.to)), this);
    }
  }

  _onChange(value, idle) {
    if (!idle) {
      this._onStart();

      callProp(this.animation.onChange, value, this);
    }

    callProp(this.defaultProps.onChange, value, this);

    super._onChange(value, idle);
  }

  _start() {
    const anim = this.animation;
    getAnimated(this).reset(getFluidValue(anim.to));

    if (!anim.immediate) {
      anim.fromValues = anim.values.map(node => node.lastPosition);
    }

    if (!isAnimating(this)) {
      setActiveBit(this, true);

      if (!isPaused(this)) {
        this._resume();
      }
    }
  }

  _resume() {
    if (globals.skipAnimation) {
      this.finish();
    } else {
      frameLoop.start(this);
    }
  }

  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      each(anim.values, node => {
        node.done = true;
      });

      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = undefined;
      }

      callFluidObservers(this, {
        type: 'idle',
        parent: this
      });
      const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal != null ? goal : anim.to));
      flushCalls(this._pendingCalls, result);

      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, 'onRest', result, this);
      }
    }
  }

}

function checkFinished(target, to) {
  const goal = computeGoal(to);
  const value = computeGoal(target.get());
  return isEqual(value, goal);
}

function createLoopUpdate(props, loop = props.loop, to = props.to) {
  let loopRet = callProp(loop);

  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate(_extends$2({}, props, {
      loop,
      default: false,
      pause: undefined,
      to: !reverse || isAsyncTo(to) ? to : undefined,
      from: reset ? props.from : undefined,
      reset
    }, overrides));
  }
}
function createUpdate(props) {
  const {
    to,
    from
  } = props = inferTo(props);
  const keys = new Set();
  if (is.obj(to)) findDefined(to, keys);
  if (is.obj(from)) findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update = createUpdate(props);

  if (is.und(update.default)) {
    update.default = getDefaultProps(update);
  }

  return update;
}

function findDefined(values, keys) {
  eachProp(values, (value, key) => value != null && keys.add(key));
}

const ACTIVE_EVENTS = ['onStart', 'onRest', 'onChange', 'onPause', 'onResume'];

function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : undefined;
}

function sendEvent(target, type, ...args) {
  var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;

  (_target$animation$typ = (_target$animation = target.animation)[type]) == null ? void 0 : _target$animation$typ.call(_target$animation, ...args);
  (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null ? void 0 : _target$defaultProps$.call(_target$defaultProps, ...args);
}

const BATCHED_EVENTS = ['onStart', 'onChange', 'onRest'];
let nextId = 1;
class Controller {
  constructor(props, flush) {
    this.id = nextId++;
    this.springs = {};
    this.queue = [];
    this.ref = void 0;
    this._flush = void 0;
    this._initialProps = void 0;
    this._lastAsyncId = 0;
    this._active = new Set();
    this._changed = new Set();
    this._started = false;
    this._item = void 0;
    this._state = {
      paused: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._events = {
      onStart: new Map(),
      onChange: new Map(),
      onRest: new Map()
    };
    this._onFrame = this._onFrame.bind(this);

    if (flush) {
      this._flush = flush;
    }

    if (props) {
      this.start(_extends$2({
        default: true
      }, props));
    }
  }

  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every(spring => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }

  get item() {
    return this._item;
  }

  set item(item) {
    this._item = item;
  }

  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }

  set(values) {
    for (const key in values) {
      const value = values[key];

      if (!is.und(value)) {
        this.springs[key].set(value);
      }
    }
  }

  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }

    return this;
  }

  start(props) {
    let {
      queue
    } = this;

    if (props) {
      queue = toArray$1(props).map(createUpdate);
    } else {
      this.queue = [];
    }

    if (this._flush) {
      return this._flush(this, queue);
    }

    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }

  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }

    if (keys) {
      const springs = this.springs;
      each(toArray$1(keys), key => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each(spring => spring.stop(!!arg));
    }

    return this;
  }

  pause(keys) {
    if (is.und(keys)) {
      this.start({
        pause: true
      });
    } else {
      const springs = this.springs;
      each(toArray$1(keys), key => springs[key].pause());
    }

    return this;
  }

  resume(keys) {
    if (is.und(keys)) {
      this.start({
        pause: false
      });
    } else {
      const springs = this.springs;
      each(toArray$1(keys), key => springs[key].resume());
    }

    return this;
  }

  each(iterator) {
    eachProp(this.springs, iterator);
  }

  _onFrame() {
    const {
      onStart,
      onChange,
      onRest
    } = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;

    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush(onStart, ([onStart, result]) => {
        result.value = this.get();
        onStart(result, this, this._item);
      });
    }

    const idle = !active && this._started;
    const values = changed || idle && onRest.size ? this.get() : null;

    if (changed && onChange.size) {
      flush(onChange, ([onChange, result]) => {
        result.value = values;
        onChange(result, this, this._item);
      });
    }

    if (idle) {
      this._started = false;
      flush(onRest, ([onRest, result]) => {
        result.value = values;
        onRest(result, this, this._item);
      });
    }
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._changed.add(event.parent);

      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == 'idle') {
      this._active.delete(event.parent);
    } else return;

    raf.onFrame(this._onFrame);
  }

}
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(props => flushUpdate(ctrl, props))).then(results => getCombinedResult(ctrl, results));
}
async function flushUpdate(ctrl, props, isLoop) {
  const {
    keys,
    to,
    from,
    loop,
    onRest,
    onResolve
  } = props;
  const defaults = is.obj(props.default) && props.default;

  if (loop) {
    props.loop = false;
  }

  if (to === false) props.to = null;
  if (from === false) props.from = null;
  const asyncTo = is.arr(to) || is.fun(to) ? to : undefined;

  if (asyncTo) {
    props.to = undefined;
    props.onRest = undefined;

    if (defaults) {
      defaults.onRest = undefined;
    }
  } else {
    each(BATCHED_EVENTS, key => {
      const handler = props[key];

      if (is.fun(handler)) {
        const queue = ctrl['_events'][key];

        props[key] = ({
          finished,
          cancelled
        }) => {
          const result = queue.get(handler);

          if (result) {
            if (!finished) result.finished = false;
            if (cancelled) result.cancelled = true;
          } else {
            queue.set(handler, {
              value: null,
              finished: finished || false,
              cancelled: cancelled || false
            });
          }
        };

        if (defaults) {
          defaults[key] = props[key];
        }
      }
    });
  }

  const state = ctrl['_state'];

  if (props.pause === !state.paused) {
    state.paused = props.pause;
    flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
    props.pause = true;
  }

  const promises = (keys || Object.keys(ctrl.springs)).map(key => ctrl.springs[key].start(props));
  const cancel = props.cancel === true || getDefaultProp(props, 'cancel') === true;

  if (asyncTo || cancel && state.asyncId) {
    promises.push(scheduleProps(++ctrl['_lastAsyncId'], {
      props,
      state,
      actions: {
        pause: noop,
        resume: noop,

        start(props, resolve) {
          if (cancel) {
            stopAsync(state, ctrl['_lastAsyncId']);
            resolve(getCancelledResult(ctrl));
          } else {
            props.onRest = onRest;
            resolve(runAsync(asyncTo, props, state, ctrl));
          }
        }

      }
    }));
  }

  if (state.paused) {
    await new Promise(resume => {
      state.resumeQueue.add(resume);
    });
  }

  const result = getCombinedResult(ctrl, await Promise.all(promises));

  if (loop && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props, loop, to);

    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }

  if (onResolve) {
    raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }

  return result;
}
function getSprings(ctrl, props) {
  const springs = _extends$2({}, ctrl.springs);

  if (props) {
    each(toArray$1(props), props => {
      if (is.und(props.keys)) {
        props = createUpdate(props);
      }

      if (!is.obj(props.to)) {
        props = _extends$2({}, props, {
          to: undefined
        });
      }

      prepareSprings(springs, props, key => {
        return createSpring(key);
      });
    });
  }

  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}

function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;

  if (observer) {
    addFluidObserver(spring, observer);
  }

  return spring;
}

function prepareSprings(springs, props, create) {
  if (props.keys) {
    each(props.keys, key => {
      const spring = springs[key] || (springs[key] = create(key));
      spring['_prepareNode'](props);
    });
  }
}

function prepareKeys(ctrl, queue) {
  each(queue, props => {
    prepareSprings(ctrl.springs, props, key => {
      return createSpring(key, ctrl);
    });
  });
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$6 = ["children"];
const SpringContext = _ref => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose$1(_ref, _excluded$6);

  const inherited = useContext(ctx);
  const pause = props.pause || !!inherited.pause,
        immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({
    pause,
    immediate
  }), [pause, immediate]);
  const {
    Provider
  } = ctx;
  return React$1.createElement(Provider, {
    value: props
  }, children);
};
const ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;

function makeContext(target, init) {
  Object.assign(target, React$1.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

const SpringRef = () => {
  const current = [];

  const SpringRef = function SpringRef(props) {
    deprecateDirectCall();
    const results = [];
    each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = _getProps(props, ctrl, i);

        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  };

  SpringRef.current = current;

  SpringRef.add = function (ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };

  SpringRef.delete = function (ctrl) {
    const i = current.indexOf(ctrl);
    if (~i) current.splice(i, 1);
  };

  SpringRef.pause = function () {
    each(current, ctrl => ctrl.pause(...arguments));
    return this;
  };

  SpringRef.resume = function () {
    each(current, ctrl => ctrl.resume(...arguments));
    return this;
  };

  SpringRef.set = function (values) {
    each(current, ctrl => ctrl.set(values));
  };

  SpringRef.start = function (props) {
    const results = [];
    each(current, (ctrl, i) => {
      if (is.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = this._getProps(props, ctrl, i);

        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  };

  SpringRef.stop = function () {
    each(current, ctrl => ctrl.stop(...arguments));
    return this;
  };

  SpringRef.update = function (props) {
    each(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  };

  const _getProps = function _getProps(arg, ctrl, index) {
    return is.fun(arg) ? arg(index, ctrl) : arg;
  };

  SpringRef._getProps = _getProps;
  return SpringRef;
};

function useSprings(length, props, deps) {
  const propsFn = is.fun(props) && props;
  if (propsFn && !deps) deps = [];
  const ref = useMemo(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  const layoutId = useRef(0);
  const forceUpdate = useForceUpdate();
  const state = useMemo(() => ({
    ctrls: [],
    queue: [],

    flush(ctrl, updates) {
      const springs = getSprings(ctrl, updates);
      const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some(key => !ctrl.springs[key]);
      return canFlushSync ? flushUpdateQueue(ctrl, updates) : new Promise(resolve => {
        setSprings(ctrl, springs);
        state.queue.push(() => {
          resolve(flushUpdateQueue(ctrl, updates));
        });
        forceUpdate();
      });
    }

  }), []);
  const ctrls = useRef([...state.ctrls]);
  const updates = [];
  const prevLength = usePrev(length) || 0;
  useMemo(() => {
    each(ctrls.current.slice(length, prevLength), ctrl => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);

  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      const update = propsFn ? propsFn(i, ctrl) : props[i];

      if (update) {
        updates[i] = declareUpdate(update);
      }
    }
  }

  const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect$1(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    const {
      queue
    } = state;

    if (queue.length) {
      state.queue = [];
      each(queue, cb => cb());
    }

    each(ctrls.current, (ctrl, i) => {
      ref == null ? void 0 : ref.add(ctrl);

      if (hasContext) {
        ctrl.start({
          default: context
        });
      }

      const update = updates[i];

      if (update) {
        replaceRef(ctrl, update.ref);

        if (ctrl.ref) {
          ctrl.queue.push(update);
        } else {
          ctrl.start(update);
        }
      }
    });
  });
  useOnce(() => () => {
    each(state.ctrls, ctrl => ctrl.stop(true));
  });
  const values = springs.map(x => _extends$2({}, x));
  return ref ? [values, ref] : values;
}

function useSpring(props, deps) {
  const isFn = is.fun(props);
  const [[values], ref] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
  return isFn || arguments.length == 2 ? [values, ref] : values;
}

let TransitionPhase;

(function (TransitionPhase) {
  TransitionPhase["MOUNT"] = "mount";
  TransitionPhase["ENTER"] = "enter";
  TransitionPhase["UPDATE"] = "update";
  TransitionPhase["LEAVE"] = "leave";
})(TransitionPhase || (TransitionPhase = {}));

class Interpolation extends FrameValue {
  constructor(source, args) {
    super();
    this.key = void 0;
    this.idle = true;
    this.calc = void 0;
    this._active = new Set();
    this.source = source;
    this.calc = createInterpolator(...args);

    const value = this._get();

    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }

  advance(_dt) {
    const value = this._get();

    const oldValue = this.get();

    if (!isEqual(value, oldValue)) {
      getAnimated(this).setValue(value);

      this._onChange(value, this.idle);
    }

    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }

  _get() {
    const inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray$1(getFluidValue(this.source));
    return this.calc(...inputs);
  }

  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      each(getPayload(this), node => {
        node.done = false;
      });

      if (globals.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }

  _attach() {
    let priority = 1;
    each(toArray$1(this.source), source => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }

      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }

        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;

    this._start();
  }

  _detach() {
    each(toArray$1(this.source), source => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });

    this._active.clear();

    becomeIdle(this);
  }

  eventObserved(event) {
    if (event.type == 'change') {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);

        this._start();
      }
    } else if (event.type == 'idle') {
      this._active.delete(event.parent);
    } else if (event.type == 'priority') {
      this.priority = toArray$1(this.source).reduce((highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
  }

}

function isIdle(source) {
  return source.idle !== false;
}

function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}

function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    each(getPayload(self), node => {
      node.done = true;
    });
    callFluidObservers(self, {
      type: 'idle',
      parent: self
    });
  }
}

globals.assign({
  createStringInterpolator,
  to: (source, args) => new Interpolation(source, args)
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$2 = ["style", "children", "scrollTop", "scrollLeft", "viewBox"];
const isCustomPropRE = /^--/;

function dangerousStyleValue(name, value) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (typeof value === 'number' && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px';
  return ('' + value).trim();
}

const attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }

  const isFilterElement = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';

  const _ref = props,
        {
    style,
    children,
    scrollTop,
    scrollLeft,
    viewBox
  } = _ref,
        attributes = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  const values = Object.values(attributes);
  const names = Object.keys(attributes).map(name => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase())));

  if (children !== void 0) {
    instance.textContent = children;
  }

  for (let name in style) {
    if (style.hasOwnProperty(name)) {
      const value = dangerousStyleValue(name, style[name]);

      if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }

  names.forEach((name, i) => {
    instance.setAttribute(name, values[i]);
  });

  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }

  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }

  if (viewBox !== void 0) {
    instance.setAttribute('viewBox', viewBox);
  }
}
let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

const _excluded$1 = ["x", "y", "z"];
const domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const pxTransforms = /^(translate)/;
const degTransforms = /^(rotate|skew)/;

const addUnit = (value, unit) => is.num(value) && value !== 0 ? value + unit : value;

const isValueIdentity = (value, id) => is.arr(value) ? value.every(v => isValueIdentity(v, id)) : is.num(value) ? value === id : parseFloat(value) === id;

class AnimatedStyle extends AnimatedObject {
  constructor(_ref) {
    let {
      x,
      y,
      z
    } = _ref,
        style = _objectWithoutPropertiesLoose(_ref, _excluded$1);

    const inputs = [];
    const transforms = [];

    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push(xyz => [`translate3d(${xyz.map(v => addUnit(v, 'px')).join(',')})`, isValueIdentity(xyz, 0)]);
    }

    eachProp(style, (value, key) => {
      if (key === 'transform') {
        inputs.push([value || '']);
        transforms.push(transform => [transform, transform === '']);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is.und(value)) return;
        const unit = pxTransforms.test(key) ? 'px' : degTransforms.test(key) ? 'deg' : '';
        inputs.push(toArray$1(value));
        transforms.push(key === 'rotate3d' ? ([x, y, z, deg]) => [`rotate3d(${x},${y},${z},${addUnit(deg, unit)})`, isValueIdentity(deg, 0)] : input => [`${key}(${input.map(v => addUnit(v, unit)).join(',')})`, isValueIdentity(input, key.startsWith('scale') ? 1 : 0)]);
      }
    });

    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }

    super(style);
  }

}

class FluidTransform extends FluidValue {
  constructor(inputs, transforms) {
    super();
    this._value = null;
    this.inputs = inputs;
    this.transforms = transforms;
  }

  get() {
    return this._value || (this._value = this._get());
  }

  _get() {
    let transform = '';
    let identity = true;
    each(this.inputs, (input, i) => {
      const arg1 = getFluidValue(input[0]);
      const [t, id] = this.transforms[i](is.arr(arg1) ? arg1 : input.map(getFluidValue));
      transform += ' ' + t;
      identity = identity && id;
    });
    return identity ? 'none' : transform;
  }

  observerAdded(count) {
    if (count == 1) each(this.inputs, input => each(input, value => hasFluidValue(value) && addFluidObserver(value, this)));
  }

  observerRemoved(count) {
    if (count == 0) each(this.inputs, input => each(input, value => hasFluidValue(value) && removeFluidObserver(value, this)));
  }

  eventObserved(event) {
    if (event.type == 'change') {
      this._value = null;
    }

    callFluidObservers(this, event);
  }

}

const primitives = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

const _excluded = ["scrollTop", "scrollLeft"];
globals.assign({
  batchedUpdates: unstable_batchedUpdates,
  createStringInterpolator,
  colors
});
const host = createHost(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: style => new AnimatedStyle(style),
  getComponentProps: _ref => {
    let props = _objectWithoutPropertiesLoose(_ref, _excluded);

    return props;
  }
});
const animated = host.animated;

var img$6 = "data:image/png;base64,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";

var img$5 = "data:image/png;base64,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";

var img$4 = "data:image/png;base64,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";

var img$3 = "data:image/png;base64,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";

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALZSURBVHgBlVXrTRtBEN7ds2Mh5OATAim/cnQAFXCkAaACnArAFRjSAHRgUoFJBYYGgqkA+5elIHFO/L7HTr7Z23Nsg21lpPHsa76d+XbGJ8UKIaISzD7UgzahXVYpZVf8j0RR5Mdx3EiSREMphtq1Z6jmPejZWiBE5MGxEUYRQXUYhmwZrDoajS7Hk4k2Oh4TVI8mkxrWvVkMmQ14A6k0bHqC0k02bQB+xaTBK7xG0y3MpWhFyjlyNzZac4DD8bguSB+TJnPKxiyUVGVE6Wuty/Ye4wdBQpTZNq45cF23azzB0yUivNNEj3McSNkaD4enUqnHN/wASKSA2S03O9vblRzzBoKrhUKBhqPRDTbOs5uVEOUQCwXH8cW7EgPMscM4tSD+fBKGTHbAPL4GwStUB0FQE0sE6Tegml8/scpzBFJVidYniFBizjVXjbX+hmKReMWrZYAAuIKCci3gzxcYG8WxL/v9fgBCSpQxQXTUR6SfdndvxQpBZtcI6YLfnOmxy7/ln16PQ5X/uJb3H4vFI7FGuItA0TMctuyCQeWUu3oadsLp+ODvQqwXDz5XeiZltgq91bYTQg1Skm5WAVpaFR3O11EZTfD/lPnDvanwc88TRCZZcQEDlkBwVSzn7wJnPvOr4mEqCR7V+GrdlJ1Ox3Py+UPDn+O0Zh13XPdhEcz27rPpJuLapgq67BgD31HKN4eAfmvrSWd1FS/MWSFng8GgNhgOCaqtomyD/V8vL9cmKMuJh379iYE7F07a06bFYFv4kzjl9sz6eHpMqcvi5qap21zqJ1uoxy8YNHBqK0uHtyiFpXw+f4Ko7yitO2Ft+s+Dh5mCzwbEoeO2OpdE5oQT/PfzPUqSB7jXUhD0euralbnciVssPrwLyNIJAu+DEGfoqzI8PV4DkQfCceqA8kzx4hOA1O8GvV5lb29v7nPwBnAh4kPwxqBPADqX/E1RqgmgH4tAmfwFCACBSzrNB+sAAAAASUVORK5CYII=";

var css_248z$7 = ".scanSwitch-module_cardScanAutoSwitch__6ONVZ{background-color:var(--cardscan-auto-switch-active-color);border-radius:50px;box-sizing:border-box;color:#fff;cursor:pointer;display:flex;flex-flow:row-reverse;font-size:14px;font-weight:600;justify-content:space-evenly;left:50%;line-height:1.5;padding:4px;position:fixed;top:-50px;transform:translateX(-50%);transition:all 1s ease;width:77px;z-index:9}.scanSwitch-module_cardScanAutoSwitchMobile__Bo8Za{top:10px}.scanSwitch-module_cardScanAutoSwitchMobileLandscape__GYVhq{top:16px}.scanSwitch-module_cardScanSwitchOff__x9Hne{background:var(--cardscan-auto-switch-inactive-color);flex-flow:row}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjYW5Td2l0Y2gubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNkNBR0UseURBQTBELENBQzFELGtCQUFtQixDQUhuQixxQkFBc0IsQ0FJdEIsVUFBVyxDQVlYLGNBQWUsQ0FKZixZQUFhLENBQ2IscUJBQXNCLENBUHRCLGNBQWUsQ0FEZixlQUFnQixDQVNoQiw0QkFBNkIsQ0FKN0IsUUFBUyxDQUhULGVBQWdCLENBUWhCLFdBQVksQ0FQWixjQUFlLENBQ2YsU0FBVSxDQUVWLDBCQUEyQixDQU0zQixzQkFBdUIsQ0FoQnZCLFVBQVcsQ0FpQlgsU0FDRixDQUVBLG1EQUNFLFFBQ0YsQ0FFQSw0REFDRSxRQUNGLENBRUEsNENBQ0UscURBQXNELENBQ3RELGFBQ0YiLCJmaWxlIjoic2NhblN3aXRjaC5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jYXJkU2NhbkF1dG9Td2l0Y2gge1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB3aWR0aDogNzdweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tY2FyZHNjYW4tYXV0by1zd2l0Y2gtYWN0aXZlLWNvbG9yKTtcbiAgYm9yZGVyLXJhZGl1czogNTBweDtcbiAgY29sb3I6ICNmZmY7XG4gIGZvbnQtd2VpZ2h0OiA2MDA7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgbGluZS1oZWlnaHQ6IDEuNTtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB0b3A6IC01MHB4O1xuICBsZWZ0OiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgtNTAlKTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1mbG93OiByb3ctcmV2ZXJzZTtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1ldmVubHk7XG4gIHBhZGRpbmc6IDRweDtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICB0cmFuc2l0aW9uOiBhbGwgMXMgZWFzZTtcbiAgei1pbmRleDogOTtcbn1cblxuLmNhcmRTY2FuQXV0b1N3aXRjaE1vYmlsZSB7XG4gIHRvcDogMTBweDtcbn1cblxuLmNhcmRTY2FuQXV0b1N3aXRjaE1vYmlsZUxhbmRzY2FwZSB7XG4gIHRvcDogMTZweDtcbn1cblxuLmNhcmRTY2FuU3dpdGNoT2ZmIHtcbiAgYmFja2dyb3VuZDogdmFyKC0tY2FyZHNjYW4tYXV0by1zd2l0Y2gtaW5hY3RpdmUtY29sb3IpO1xuICBmbGV4LWZsb3c6IHJvdztcbn0iXX0= */";
var styles$6 = {"cardScanAutoSwitch":"scanSwitch-module_cardScanAutoSwitch__6ONVZ","cardScanAutoSwitchMobile":"scanSwitch-module_cardScanAutoSwitchMobile__Bo8Za","cardScanAutoSwitchMobileLandscape":"scanSwitch-module_cardScanAutoSwitchMobileLandscape__GYVhq","cardScanSwitchOff":"scanSwitch-module_cardScanSwitchOff__x9Hne"};
styleInject(css_248z$7);

var ScanSwitch = function (_a) {
    var isMobile = _a.isMobile;
    var _b = useGlobalContext(), isMobileOnLandscape = _b.isMobileOnLandscape, stateMachineState = _b.stateMachineState, stateMachineSend = _b.stateMachineSend;
    return (jsxs("div", __assign$2({ "data-cy": "cardScanAutoSwitch", className: "".concat(styles$6.cardScanAutoSwitch, " ").concat(stateMachineState.context.autoScan ? "" : styles$6.cardScanSwitchOff, " ").concat(isMobile
            ? isMobileOnLandscape
                ? styles$6.cardScanAutoSwitchMobileLandscape
                : styles$6.cardScanAutoSwitchMobile
            : ""), onClick: function () { return stateMachineSend("TOGGLE"); } }, { children: [jsx("img", { src: img$2 }), stateMachineState.context.autoScan ? "Auto" : "Off"] })));
};
ScanSwitch.propTypes = {
    isMobile: PropTypes.bool,
};

var css_248z$6 = ".scanFrame-module_cardscanHelperText__BSvel{background:var(--cardscan-message-background-color);border-radius:6px;color:var(--cardscan-message-text-color);font-size:var(--cardscan-message-font-size);font-weight:400;line-height:1.5;padding:6px;text-align:center;text-transform:none;transition:all 1.5s ease;white-space:pre-line;width:fit-content}@media (min-width:680px){.scanFrame-module_cardscanHelperText__BSvel{font-size:35px;font-weight:600}}.scanFrame-module_cardscanRetryButton__4iwA9{background:#6fcf97;border:none;border-radius:13px;box-shadow:0 2px 4px rgba(0,0,0,.25);color:#dfdedf;cursor:pointer;font-family:Roboto,sans-serif;font-size:14px;font-weight:600;letter-spacing:2px;line-height:22px;outline:none;padding:6px 14px;text-align:center;text-transform:uppercase;transition:all .3s ease 0s}.scanFrame-module_cardscanRetryButton__4iwA9:active,.scanFrame-module_cardscanRetryButton__4iwA9:focus{outline:none;transform:translate(2px,2px)}.scanFrame-module_corner__S6aVE{border-color:var(--cardscan-progress-bar-color);border-radius:5px;border-style:solid;content:\" \";height:62px;position:absolute;transition:border-color .5s ease,width .75s linear,height .75s linear;width:62px}.scanFrame-module_corner__S6aVE.scanFrame-module_cardscanCornerOff__G373s{border-color:#e3eaf4}.scanFrame-module_corner1__ouwk5{border-width:5px 0 0 5px;left:-2px;top:-2px;width:var(--cardscan-corner-width)}.scanFrame-module_corner2__LR0Sj{border-width:5px 5px 0 0;height:var(--cardscan-corner-height);right:-2px;top:-2px}.scanFrame-module_corner3__SSofi{border-width:0 5px 5px 0;bottom:-2px;right:-2px;width:var(--cardscan-corner-width)}.scanFrame-module_corner4__-rkSZ{border-width:0 0 5px 5px;bottom:-2px;height:var(--cardscan-corner-height);left:-2px}.scanFrame-module_cardGuide__41-fv{aspect-ratio:5/3;border:1px solid rgba(31,45,61,.08);box-shadow:0 0 8px 0 rgba(0,0,0,.55);left:50%;max-width:calc(var(--cardscan-video-width) - 20px);position:relative;position:fixed;top:50%;transform:translate(-50%,-50%);width:calc(100% - 20px);z-index:2}@supports not (aspect-ratio:5/3){.scanFrame-module_cardGuide__41-fv:before{content:\"\";float:left;padding-top:56.25%}.scanFrame-module_cardGuide__41-fv:after{clear:both;content:\"\";display:block}}@media (min-width:641px){.scanFrame-module_cardGuide__41-fv{width:calc(100% - 200px)}}@media (min-width:1025px){.scanFrame-module_cardGuide__41-fv{height:calc(var(--cardscan-video-background-height) - 140px);width:unset}}.scanFrame-module_cardGuide__41-fv .scanFrame-module_processStatus__Z-dLU,.scanFrame-module_cardGuide__41-fv .scanFrame-module_spinnerWrapper__rxkNG{display:block}.scanFrame-module_cardGuide__41-fv .scanFrame-module_processStatus__Z-dLU,.scanFrame-module_cardGuide__41-fv .scanFrame-module_spinnerWrapper__rxkNG{align-items:center;display:flex;flex-direction:column;justify-content:center;position:absolute;top:50%;transform:translateY(-50%);width:100%}.scanFrame-module_cardGuide__41-fv .scanFrame-module_processStatus__Z-dLU img{max-width:9%}.scanFrame-module_cardGuideLandscape__FZ9pd{height:calc(100% - 40px)}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var scanFrameStyles = {"cardscanHelperText":"scanFrame-module_cardscanHelperText__BSvel","cardscanRetryButton":"scanFrame-module_cardscanRetryButton__4iwA9","corner":"scanFrame-module_corner__S6aVE","cardscanCornerOff":"scanFrame-module_cardscanCornerOff__G373s","corner1":"scanFrame-module_corner1__ouwk5","corner2":"scanFrame-module_corner2__LR0Sj","corner3":"scanFrame-module_corner3__SSofi","corner4":"scanFrame-module_corner4__-rkSZ","cardGuide":"scanFrame-module_cardGuide__41-fv","spinnerWrapper":"scanFrame-module_spinnerWrapper__rxkNG","processStatus":"scanFrame-module_processStatus__Z-dLU","cardGuideLandscape":"scanFrame-module_cardGuideLandscape__FZ9pd"};
styleInject(css_248z$6);

var css_248z$5 = ".webToMobileModal-module_scanErrorModal__lMrJJ{align-items:center;background-color:#f9fbfd;border-radius:16px;box-shadow:0 8px 36px 0 rgba(0,0,0,.161);display:flex;flex-direction:column;height:500px;left:50%;padding:20px;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%);width:550px;z-index:999999}.webToMobileModal-module_scanErrorModal__lMrJJ>*{margin-bottom:16px}.webToMobileModal-module_scanErrorTitle__xn1rc{color:#000;font-size:24px;font-weight:700;text-align:center}.webToMobileModal-module_scanErrorDescription__M7bCV{color:rgba(21,25,32,.5);font-size:18px;font-weight:400;text-align:center}.webToMobileModal-module_scanErrorButton__OT-QR{border:none;border-radius:8px;font-size:14px;font-weight:600;height:42px;min-width:230px}.webToMobileModal-module_scanErrorButtonContainer__DImXw{display:flex;justify-content:space-around;width:100%}.webToMobileModal-module_scanErrorButtonSecondary__ObyA-{background:#fff;border:1px solid #566789;color:rgba(21,25,32,.5)}.webToMobileModal-module_scanErrorButtonPrimary__hqs2M{background-color:#2f80ed;color:#fff}.webToMobileModal-module_processStatus__zcTGi,.webToMobileModal-module_spinnerWrapper__lbMCo{display:block}.webToMobileModal-module_spinnerWrapper__lbMCo{display:flex;height:256px}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$5 = {"scanErrorModal":"webToMobileModal-module_scanErrorModal__lMrJJ","scanErrorTitle":"webToMobileModal-module_scanErrorTitle__xn1rc","scanErrorDescription":"webToMobileModal-module_scanErrorDescription__M7bCV","scanErrorButton":"webToMobileModal-module_scanErrorButton__OT-QR","scanErrorButtonContainer":"webToMobileModal-module_scanErrorButtonContainer__DImXw","scanErrorButtonSecondary":"webToMobileModal-module_scanErrorButtonSecondary__ObyA-","scanErrorButtonPrimary":"webToMobileModal-module_scanErrorButtonPrimary__hqs2M","spinnerWrapper":"webToMobileModal-module_spinnerWrapper__lbMCo","processStatus":"webToMobileModal-module_processStatus__zcTGi"};
styleInject(css_248z$5);

var lib = {};

var mode$1 = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};

var mode = mode$1;

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

var _8BitByte = QR8bitByte;

var ErrorCorrectLevel = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};

// ErrorCorrectLevel
var ECL = ErrorCorrectLevel;

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
};

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
};

var RSBlock$1 = QRRSBlock;

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

var BitBuffer$1 = QRBitBuffer;

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

var math$2 = QRMath;

var math$1 = math$2;

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math$1.gexp(math$1.glog(this.get(i) ) + math$1.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math$1.glog(this.get(0) ) - math$1.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math$1.gexp(math$1.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

var Polynomial$2 = QRPolynomial;

var Mode = mode$1;
var Polynomial$1 = Polynomial$2;
var math = math$2;

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial$1([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial$1([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

var util$1 = QRUtil;

var BitByte = _8BitByte;
var RSBlock = RSBlock$1;
var BitBuffer = BitBuffer$1;
var util = util$1;
var Polynomial = Polynomial$2;

function QRCode$1(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode$1.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode$1.PAD0 = 0xEC;
QRCode$1.PAD1 = 0x11;

QRCode$1.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD1, 8);
	}

	return QRCode$1.createBytes(buffer, rsBlocks);
};

QRCode$1.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

var QRCode_1 = QRCode$1;

var QRCodeSvg$1 = {};

Object.defineProperty(QRCodeSvg$1, "__esModule", {
  value: true
});

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes$1 = propTypes$2.exports;

var _propTypes2$1 = _interopRequireDefault$1(_propTypes$1);

var _react$1 = React__default$1;

var _react2$1 = _interopRequireDefault$1(_react$1);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes$1 = {
  bgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  bgD: _propTypes2$1.default.string.isRequired,
  fgColor: _propTypes2$1.default.oneOfType([_propTypes2$1.default.object, _propTypes2$1.default.string]).isRequired,
  fgD: _propTypes2$1.default.string.isRequired,
  size: _propTypes2$1.default.number.isRequired,
  title: _propTypes2$1.default.string,
  viewBoxSize: _propTypes2$1.default.number.isRequired,
  xmlns: _propTypes2$1.default.string
};

var defaultProps$1 = {
  title: undefined,
  xmlns: "http://www.w3.org/2000/svg"
};

var QRCodeSvg = (0, _react$1.forwardRef)(function (_ref, ref) {
  var bgColor = _ref.bgColor,
      bgD = _ref.bgD,
      fgD = _ref.fgD,
      fgColor = _ref.fgColor,
      size = _ref.size,
      title = _ref.title,
      viewBoxSize = _ref.viewBoxSize,
      props = _objectWithoutProperties$1(_ref, ["bgColor", "bgD", "fgD", "fgColor", "size", "title", "viewBoxSize"]);

  return _react2$1.default.createElement(
    "svg",
    _extends$1({}, props, { height: size, ref: ref, viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize, width: size }),
    title ? _react2$1.default.createElement(
      "title",
      null,
      title
    ) : null,
    _react2$1.default.createElement("path", { d: bgD, fill: bgColor }),
    _react2$1.default.createElement("path", { d: fgD, fill: fgColor })
  );
});

QRCodeSvg.displayName = "QRCodeSvg";
QRCodeSvg.propTypes = propTypes$1;
QRCodeSvg.defaultProps = defaultProps$1;

QRCodeSvg$1.default = QRCodeSvg;

Object.defineProperty(lib, "__esModule", {
  value: true
});
lib.QRCode = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _QRCode = QRCode_1;

var _QRCode2 = _interopRequireDefault(_QRCode);

var _ErrorCorrectLevel = ErrorCorrectLevel;

var _ErrorCorrectLevel2 = _interopRequireDefault(_ErrorCorrectLevel);

var _propTypes = propTypes$2.exports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = React__default$1;

var _react2 = _interopRequireDefault(_react);

var _QRCodeSvg = QRCodeSvg$1;

var _QRCodeSvg2 = _interopRequireDefault(_QRCodeSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.


var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.string,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};

var defaultProps = {
  bgColor: "#FFFFFF",
  fgColor: "#000000",
  level: "L",
  size: 256
};

var QRCode = (0, _react.forwardRef)(function (_ref, ref) {
  var bgColor = _ref.bgColor,
      fgColor = _ref.fgColor,
      level = _ref.level,
      size = _ref.size,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["bgColor", "fgColor", "level", "size", "value"]);

  // Use type === -1 to automatically pick the best type.
  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  qrcode.addData(value);
  qrcode.make();
  var cells = qrcode.modules;
  return _react2.default.createElement(_QRCodeSvg2.default, _extends({}, props, {
    bgColor: bgColor,
    bgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    fgColor: fgColor,
    fgD: cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
      }).join(" ");
    }).join(" "),
    ref: ref,
    size: size,
    viewBoxSize: cells.length
  }));
});

lib.QRCode = QRCode;
QRCode.displayName = "QRCode";
QRCode.propTypes = propTypes;
QRCode.defaultProps = defaultProps;

var _default = lib.default = QRCode;

var WebToMobileModal = function (_a) {
    var enableModel = _a.enableModel, cardScanApi = _a.cardScanApi, webToMobileHandoffConfig = _a.webToMobileHandoffConfig, spinnerOptions = _a.spinnerOptions;
    var _b = useState(""), webToMobileLink = _b[0], setWebToMobileLink = _b[1];
    useEffect(function () {
        var _a;
        if (enableModel &&
            cardScanApi.current.sessionToken &&
            webToMobileHandoffConfig) {
            (_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.generateMagicLink().then(function (res) {
                setWebToMobileLink("".concat(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.urlBase, "/?token=").concat(res.data.token, "&companyName=").concat(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.companyName));
            }).catch(function (error) {
                console.log(error);
                //_handleError(error, stateMachineSend, onError);
            });
        }
    }, []);
    if (!enableModel) {
        return jsx("div", {});
    }
    return (jsxs("div", __assign$2({ className: styles$5.scanErrorModal }, { children: [jsx("h2", __assign$2({ className: styles$5.scanErrorTitle }, { children: "Scanning Failed" })), jsxs("p", { children: ["Please scan this QR Code to continue scanning on your mobile phone.", jsx("br", {}), "Return here once successful to continue."] }), jsx("div", __assign$2({ style: { height: "auto", margin: "20px auto", width: "400" } }, { children: webToMobileLink ? (jsx(_default, { style: { height: "auto", maxWidth: "100%", width: "100%" }, value: webToMobileLink, viewBox: "0 0 256 256" })) : (jsx("div", __assign$2({ className: styles$5.spinnerWrapper }, { children: jsx(dist, __assign$2({}, spinnerOptions)) }))) })), jsx("div", __assign$2({ className: styles$5.scanErrorButtonContainer }, { children: jsx("button", __assign$2({ className: "".concat(styles$5.scanErrorButton, " ").concat(styles$5.scanErrorButtonPrimary), onClick: function () { return window.location.reload(); } }, { children: "Try Again" })) }))] })));
};

var ScanFrame = function (_a) {
    var successIndicator = _a.successIndicator, handleRetryButton = _a.handleRetryButton, frameDivRef = _a.frameDivRef, spinnerOptions = _a.spinnerOptions, errorIndicator = _a.errorIndicator, webToMobileHandoffConfig = _a.webToMobileHandoffConfig, cardScanApi = _a.cardScanApi;
    var _b = useGlobalContext(), stateMachineState = _b.stateMachineState, showCurtain = _b.showCurtain, isMobile = _b.isMobile, isMobileOnLandscape = _b.isMobileOnLandscape;
    var _c = useState(false), flipped = _c[0], setFlipped = _c[1];
    var _d = useSpring({
        opacity: flipped ? 1 : 0,
        transform: "perspective(300px) translateY(-100%) translateX(-50px) rotateY(".concat(flipped ? 180 : 0, "deg)"),
        config: config.molasses,
    }), transform = _d.transform, opacity = _d.opacity;
    useEffect(function () {
        var id = setInterval(function () {
            setFlipped(function (flipped) { return !flipped; });
        }, 2000);
        return function () {
            clearInterval(id);
        };
    }, []);
    var shouldShowProgress = [
        "frontsideProcessing",
        "backsideProcessing",
        "autoCapture",
        "manualCapture",
        "backsidePending",
    ].some(stateMachineState.matches);
    var shouldShowRotateToScanBack = stateMachineState.matches("backsidePending") ||
        (stateMachineState.matches("backsideProcessing") &&
            !stateMachineState.context.processing);
    var isPending = ["cameraLoading", "autoCapture", "manualCapture"].some(stateMachineState.matches);
    var isProcessing = ["frontsideProcessing", "backsideProcessing"].some(stateMachineState.matches) && stateMachineState.context.processing;
    var isProcessingAuto = isProcessing;
    isProcessing &&
        !stateMachineState.context.autoScan &&
        stateMachineState.context.scannerRunning;
    var isErrorOrRetry = ["error", "cameraError", "retry"].some(stateMachineState.matches);
    var greyCorner = ["manualCapture", "backsidePending"].some(stateMachineState.matches) &&
        !stateMachineState.context.autoScan;
    return (jsx(Fragment, { children: jsxs("div", __assign$2({ style: isErrorOrRetry ? { minWidth: "400px" } : {}, className: "".concat(scanFrameStyles.cardGuide, " cardscan-card-guide active ").concat(stateMachineState.matches("manualCapture")
                ? "cardscan-card-guide-processing"
                : "", " ").concat(isMobileOnLandscape && "card-guide-landscape"), ref: frameDivRef }, { children: [!showCurtain && !stateMachineState.context.processing && (jsx(ScanSwitch, {})), !stateMachineState.matches("completed") && (jsx("div", { className: "\n          ".concat(shouldShowProgress ? scanFrameStyles.corner : "", " \n          ").concat(scanFrameStyles.corner1, " \n          ").concat(greyCorner ? scanFrameStyles.cardscanCornerOff : "", "\n          ").concat(shouldShowProgress ? "cardscan-corner-active" : "") })), !stateMachineState.matches("completed") && (jsx("div", { className: "\n          ".concat(shouldShowProgress ? scanFrameStyles.corner : "", " \n          ").concat(scanFrameStyles.corner2, "\n          ").concat(greyCorner ? scanFrameStyles.cardscanCornerOff : "", "\n          ").concat(shouldShowProgress ? "cardscan-corner-active" : "") })), !stateMachineState.matches("completed") && (jsx("div", { className: "\n          ".concat(shouldShowProgress ? scanFrameStyles.corner : "", " \n          ").concat(scanFrameStyles.corner3, "\n          ").concat(greyCorner ? scanFrameStyles.cardscanCornerOff : "", "\n          ").concat(shouldShowProgress ? "cardscan-corner-active" : "") })), !stateMachineState.matches("completed") && (jsx("div", { className: "".concat(shouldShowProgress ? scanFrameStyles.corner : "", " \n          ").concat(scanFrameStyles.corner4, "\n          ").concat(greyCorner ? scanFrameStyles.cardscanCornerOff : "", "\n          ").concat(shouldShowProgress ? "cardscan-corner-active" : "") })), stateMachineState.matches("completed") && (jsxs("div", __assign$2({ className: scanFrameStyles.processStatus }, { children: [successIndicator != null ? (successIndicator) : (jsx("img", { src: img$6, alt: "" })), jsx("p", __assign$2({ "data-cy": "cardscanHelperText", className: scanFrameStyles.cardscanHelperText }, { children: stateMachineState.context.headerTitle }))] }))), isErrorOrRetry && (!(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) || isMobile) && (jsxs("div", __assign$2({ className: scanFrameStyles.processStatus }, { children: [errorIndicator != null ? (errorIndicator) : (jsx("img", { src: img$5, alt: "" })), jsx("p", __assign$2({ "data-cy": "cardscanHelperText", className: scanFrameStyles.cardscanHelperText }, { children: stateMachineState.context.headerTitle })), stateMachineState.matches("retry") && (jsx("div", __assign$2({ className: scanFrameStyles.cardscanRetryButton, onClick: handleRetryButton }, { children: "Retry Scan" })))] }))), isErrorOrRetry && !isMobile && (webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) && (jsx(WebToMobileModal, { enableModel: true, cardScanApi: cardScanApi, webToMobileHandoffConfig: webToMobileHandoffConfig, spinnerOptions: spinnerOptions })), shouldShowRotateToScanBack && (jsxs("div", __assign$2({ className: scanFrameStyles.processStatus, style: { top: "70%" } }, { children: [jsxs("div", __assign$2({ style: { position: "relative" } }, { children: [jsx(animated.img, { src: img$3, style: {
                                        position: "absolute",
                                        width: "100px",
                                        maxWidth: "100px",
                                        opacity: opacity.to(function (o) { return 1 - o; }),
                                        transform: transform,
                                        willChange: "transform, opacity",
                                        transformOrigin: "center",
                                    } }), jsx(animated.img, { src: img$4, style: {
                                        position: "absolute",
                                        width: "100px",
                                        maxWidth: "100px",
                                        willChange: "transform, opacity",
                                        opacity: opacity,
                                        transform: transform,
                                        transformOrigin: "center",
                                    } })] })), jsx("p", __assign$2({ "data-cy": "cardscanHelperText", className: scanFrameStyles.cardscanHelperText }, { children: stateMachineState.context.headerTitle }))] }))), (isProcessingAuto || isPending) && (jsx("div", __assign$2({ className: scanFrameStyles.processStatus }, { children: jsx("p", __assign$2({ "data-cy": "cardscanHelperText", className: scanFrameStyles.cardscanHelperText }, { children: stateMachineState.context.headerTitle })) })))] })) }));
};

var css_248z$4 = ".scanVideoViewer-module_videoBackground__9LiTo{background-color:#708090;max-width:65vw;width:var(--cardscan-video-width);z-index:2}.scanVideoViewer-module_videoBackground__9LiTo.scanVideoViewer-module_heightFrame__q1B2p{height:unset;max-height:var(--cardscan-video-height);max-width:var(--cardscan-video-width);width:var(--cardscan-app-width)}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjYW5WaWRlb1ZpZXdlci5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSwrQ0FDRSx3QkFBMkIsQ0FFM0IsY0FBZSxDQURmLGlDQUFrQyxDQUVsQyxTQUNGLENBQ0EseUZBQ0UsWUFBYSxDQUNiLHVDQUF3QyxDQUN4QyxxQ0FBc0MsQ0FDdEMsK0JBQ0YiLCJmaWxlIjoic2NhblZpZGVvVmlld2VyLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnZpZGVvQmFja2dyb3VuZCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHNsYXRlZ3JleTtcbiAgd2lkdGg6IHZhcigtLWNhcmRzY2FuLXZpZGVvLXdpZHRoKTtcbiAgbWF4LXdpZHRoOiA2NXZ3O1xuICB6LWluZGV4OiAyO1xufVxuLnZpZGVvQmFja2dyb3VuZC5oZWlnaHRGcmFtZSB7XG4gIGhlaWdodDogdW5zZXQ7XG4gIG1heC1oZWlnaHQ6IHZhcigtLWNhcmRzY2FuLXZpZGVvLWhlaWdodCk7XG4gIG1heC13aWR0aDogdmFyKC0tY2FyZHNjYW4tdmlkZW8td2lkdGgpO1xuICB3aWR0aDogdmFyKC0tY2FyZHNjYW4tYXBwLXdpZHRoKTtcbn0iXX0= */";
var styles$4 = {"videoBackground":"scanVideoViewer-module_videoBackground__9LiTo","heightFrame":"scanVideoViewer-module_heightFrame__q1B2p"};
styleInject(css_248z$4);

var ScanVideoViewer = function (_a) {
    var videoRef = _a.videoRef, setShowErrorModal = _a.setShowErrorModal, stateMachineSend = _a.stateMachineSend, setScanDebugState = _a.setScanDebugState, onError = _a.onError, setVideoMetadata = _a.setVideoMetadata, isMobile = _a.isMobile;
    var getVideo = useCallback(function (videoBg) {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.error("Video Error - mediaDevices or getUserMedia undefined");
            return;
        }
        var webCamPromise = navigator.mediaDevices
            .getUserMedia({
            audio: false,
            video: {
                width: 1920,
                facingMode: "environment",
            },
        })
            .then(function (stream) {
            setShowErrorModal(false);
            videoBg.srcObject = stream;
            var videoPromise = videoBg.play();
            if (videoPromise === undefined) {
                console.error("Video Error - videoPromise undefined");
                return;
            }
            videoPromise
                .then(function () { return console.debug("CardScan: Video Started"); })
                .catch(function (error) {
                var err = generateError(error.message, "VideoError", 675);
                console.error("Video Error: ", err);
                if (onError) {
                    onError(err);
                }
                stateMachineSend("ERROR");
            });
            var videoTrack = stream.getVideoTracks().pop();
            var settings = (videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.getSettings()) || {};
            setVideoMetadata({ videoTrack: settings });
            //only works on chrome powered
            navigator.mediaDevices.enumerateDevices().then(function (devices) {
                var device = devices
                    .filter(function (device) { return device["kind"] === "videoinput"; })
                    .pop();
                // getCapabilities won't likely be supported by TS
                // https://github.com/microsoft/TypeScript/issues/45660
                if (device && device.getCapabilities != undefined) {
                    var caps = device.getCapabilities();
                    setVideoMetadata({
                        videoTrack: settings,
                        cameraCapabilities: caps,
                    });
                }
            });
            // //1024x768 or less if video is smaller. If canvas is over 1024 we have GPU memory issues.
            // const captureCanvas = captureCanvasRef.current;
            // if (captureCanvas && settings.width && settings.height) {
            //   captureCanvas.width = Math.min(settings.width, 1024);
            //   captureCanvas.height = Math.min(settings.height, 768);
            // }
            return new Promise(function (resolve) {
                videoBg.onloadedmetadata = function () {
                    resolve(stream);
                    // send("CAMERA_LOADED", { videoLoaded: true });
                    stateMachineSend("CAMERA_LOADED");
                    setScanDebugState("loading");
                    //setScannerRunning(true);
                };
            });
        });
        webCamPromise
            .then(function () {
            stateMachineSend("CAMERA_LOADED");
            setScanDebugState("loading");
            //once video is loaded start the detection & capture loop
            //setScannerRunning(true);
        })
            .catch(function (error) {
            //leave it to the caller to treat the error
        });
        return webCamPromise;
    }, [
        onError,
        stateMachineSend,
        setScanDebugState,
        setShowErrorModal,
        setVideoMetadata,
    ]);
    useEffect(function () {
        var _a;
        var videoBg = videoRef.current;
        var videoPromise;
        if (videoBg) {
            (_a = getVideo(videoBg)) === null || _a === void 0 ? void 0 : _a.then(function (media) {
                videoPromise = media;
            }).catch(function (error) {
                var err = generateError(error.message, "VideoError", 676);
                console.error("Video Error: ", err);
                if (onError) {
                    onError(err);
                }
                //Only show error modal when error is a permissions error.
                if (error.name === "NotAllowedError") {
                    setShowErrorModal(true);
                    stateMachineSend("CAMERAERROR");
                }
                else if (error.name === "NotFoundError") {
                    setShowErrorModal(true);
                    stateMachineSend("CAMERAERROR");
                }
                else {
                    setShowErrorModal(false);
                    stateMachineSend("ERROR");
                }
            });
        }
        return function () {
            if (videoPromise) {
                videoPromise.getTracks().forEach(function (track) {
                    videoPromise.removeTrack(track);
                });
            }
        };
    }, [videoRef, getVideo, onError]);
    return (jsx("video", { ref: videoRef, style: isMobile ? { maxHeight: "100%", maxWidth: "100%" } : {}, className: styles$4.videoBackground, id: "frame", muted: true, playsInline: true, autoPlay: true }));
};

var img$1 = "data:image/png;base64,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";

var css_248z$3 = ".closeButton-module_closeBtn__XDcux{cursor:pointer;height:28px;position:fixed;right:10px;top:10px;width:28px;z-index:3}@media (min-width:680px){.closeButton-module_closeBtn__XDcux{height:38px;width:38px}}.closeButton-module_closeBtnLandscape__aztsu{top:16px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNsb3NlQnV0dG9uLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG9DQUlFLGNBQWUsQ0FFZixXQUFZLENBTFosY0FBZSxDQUVmLFVBQVcsQ0FEWCxRQUFTLENBS1QsVUFBVyxDQUZYLFNBR0YsQ0FDQSx5QkFDRSxvQ0FFRSxXQUFZLENBRFosVUFFRixDQUNGLENBRUEsNkNBQ0UsUUFDRiIsImZpbGUiOiJjbG9zZUJ1dHRvbi5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jbG9zZUJ0biB7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAxMHB4O1xuICByaWdodDogMTBweDtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICB6LWluZGV4OiAzO1xuICBoZWlnaHQ6IDI4cHg7XG4gIHdpZHRoOiAyOHB4O1xufVxuQG1lZGlhIChtaW4td2lkdGg6IDY4MHB4KSB7XG4gIC5jbG9zZUJ0biB7XG4gICAgd2lkdGg6IDM4cHg7XG4gICAgaGVpZ2h0OiAzOHB4O1xuICB9XG59XG5cbi5jbG9zZUJ0bkxhbmRzY2FwZSB7XG4gIHRvcDogMTZweDtcbn0iXX0= */";
var styles$3 = {"closeBtn":"closeButton-module_closeBtn__XDcux","closeBtnLandscape":"closeButton-module_closeBtnLandscape__aztsu"};
styleInject(css_248z$3);

var CloseButton = function (_a) {
    var onCloseBtn = _a.onCloseBtn, closeButton = _a.closeButton;
    var isMobileOnLandscape = useGlobalContext().isMobileOnLandscape;
    return closeButton != null ? (jsx("div", __assign$2({ "data-cy": "closeBtn", onClick: onCloseBtn, className: " ".concat(styles$3.closeBtn, " ").concat(isMobileOnLandscape && styles$3.closeBtnLandscape) }, { children: closeButton }))) : (jsx("span", __assign$2({ "data-cy": "closeBtn", onClick: onCloseBtn, className: " ".concat(styles$3.closeBtn, " ").concat(isMobileOnLandscape && styles$3.closeBtnLandscape) }, { children: jsx("img", { src: img$1, alt: "", style: { height: "100%" } }) })));
};
CloseButton.propTypes = {
    onCloseBtn: PropTypes.func.isRequired,
    closeButton: PropTypes.bool,
};

var img = "data:image/png;base64,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";

var css_248z$2 = ".cardCapture-module_bottomCurtain__psmrF{background:rgba(29,29,29,.7);bottom:0;height:150px;position:fixed;width:100%;z-index:8}.cardCapture-module_bottomCurtainLandscape__jTj1A{background:rgba(29,29,29,.7);bottom:0;height:16px;position:fixed;width:100%;z-index:8}.cardCapture-module_topCurtain__caSuL{background:rgba(29,29,29,.7);height:150px;position:fixed;top:0;width:100%;z-index:8}.cardCapture-module_topCurtainLandscape__US-NS{height:16px}.cardCapture-module_cameraBtn__bH3O4{cursor:pointer;left:50%;position:absolute;transform:translate(-50%,-12px);width:55px;z-index:3}.cardCapture-module_cameraBtn__bH3O4.cardCapture-module_heightFrame__azykv{bottom:40px;transform:translate(-50%)}.cardCapture-module_cameraBtn__bH3O4:active{transform:translate(-49%,-11px)}.cardCapture-module_cameraBtn__bH3O4:active.cardCapture-module_heightFrame__azykv{transform:translate(-49%,1px)}.cardCapture-module_cardscanLogo__CxQei{box-sizing:border-box;left:4px;max-width:135px;position:absolute;top:0;transform:translateY(-100%);z-index:300}.cardCapture-module_cardscanLogoLandscape__pAGr7{-webkit-filter:invert(100%);filter:invert(100%);max-width:90px}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$2 = {"bottomCurtain":"cardCapture-module_bottomCurtain__psmrF","bottomCurtainLandscape":"cardCapture-module_bottomCurtainLandscape__jTj1A","topCurtain":"cardCapture-module_topCurtain__caSuL","topCurtainLandscape":"cardCapture-module_topCurtainLandscape__US-NS","cameraBtn":"cardCapture-module_cameraBtn__bH3O4","heightFrame":"cardCapture-module_heightFrame__azykv","cardscanLogo":"cardCapture-module_cardscanLogo__CxQei","cardscanLogoLandscape":"cardCapture-module_cardscanLogoLandscape__pAGr7"};
styleInject(css_248z$2);

var CardCapture = function (_a) {
    var children = _a.children;
    var _b = useGlobalContext(), showCurtain = _b.showCurtain, onCloseBtn = _b.onCloseBtn, closeButton = _b.closeButton, isMobileOnLandscape = _b.isMobileOnLandscape, stateMachineState = _b.stateMachineState, stateMachineSend = _b.stateMachineSend;
    ["cameraLoading", "autoCapture", "manualCapture"].some(stateMachineState.matches);
    return (jsxs(Fragment, { children: [!showCurtain && (jsx(CloseButton, { onCloseBtn: onCloseBtn, closeButton: closeButton })), jsxs("div", __assign$2({ className: "".concat(styles$2.topCurtain, " ").concat(isMobileOnLandscape && styles$2.topCurtainLandscape), style: {
                    display: showCurtain ? "block" : "none",
                } }, { children: [showCurtain && (jsx(CloseButton, { onCloseBtn: onCloseBtn, closeButton: closeButton })), showCurtain && !stateMachineState.context.processing && (jsx(ScanSwitch, { isMobile: showCurtain }))] })), children, jsxs("div", __assign$2({ className: isMobileOnLandscape
                    ? styles$2.bottomCurtainLandscape
                    : styles$2.bottomCurtain, style: {
                    display: showCurtain ? "block" : "none",
                } }, { children: [jsx("img", { "data-cy": "cardscanLogo", src: CardScanLogoURL, className: "".concat(styles$2.cardscanLogo, " ").concat(isMobileOnLandscape && styles$2.cardscanLogoLandscape) }), !stateMachineState.context.autoScan &&
                        !stateMachineState.context.processing && (jsx("img", { "data-cy": "cameraBtn", src: img, className: styles$2.cameraBtn, id: "camera-btn", onClick: function () { return stateMachineSend("MANUAL_BUTTON_CLICK"); } }))] }))] }));
};

var ScanCanvas = function (_a) {
    var detectionCanvasRef = _a.detectionCanvasRef, captureCanvasRef = _a.captureCanvasRef; _a.videoRefBg; _a.frameDivRef; _a.frameDivDimensions; var videoHeight = _a.videoHeight, videoWidth = _a.videoWidth;
    return (jsxs(Fragment, { children: [jsx("canvas", { className: "detectionCanvas", width: DetectorWrapper.get().IMG_SIZE, height: DetectorWrapper.get().IMG_SIZE, ref: detectionCanvasRef, style: { display: "none" } }), jsx("canvas", { className: "captureCanvas", width: videoWidth, height: videoHeight, ref: captureCanvasRef, style: { display: "none" } })] }));
};

var useCustomWidget = function (autoSwitchActiveColor, autoSwitchInactiveColor, progressBarColor, widgetBackgroundColor, messageFontSize, messageTextColor, messageBackgroundColor) {
    useEffect(function () {
        if (messageFontSize) {
            document.documentElement.style.setProperty("--cardscan-message-font-size", messageFontSize);
        }
        if (messageTextColor) {
            document.documentElement.style.setProperty("--cardscan-message-text-color", messageTextColor);
        }
        if (messageBackgroundColor) {
            document.documentElement.style.setProperty("--cardscan-message-background-color", messageBackgroundColor);
        }
        if (widgetBackgroundColor) {
            document.documentElement.style.setProperty("--cardscan-widget-background-color", widgetBackgroundColor);
        }
        if (progressBarColor) {
            document.documentElement.style.setProperty("--cardscan-progress-bar-color", progressBarColor);
        }
        if (autoSwitchActiveColor) {
            document.documentElement.style.setProperty("--cardscan-auto-switch-active-color", autoSwitchActiveColor);
        }
        if (autoSwitchInactiveColor) {
            document.documentElement.style.setProperty("--cardscan-auto-switch-inactive-color", autoSwitchInactiveColor);
        }
    }, [
        messageFontSize,
        messageTextColor,
        messageBackgroundColor,
        widgetBackgroundColor,
        progressBarColor,
        autoSwitchActiveColor,
        autoSwitchInactiveColor,
    ]);
};

var useLayoutHeight = function (videoRefBg, isVideoLoading, videoLayoutHeight) {
    useEffect(function () {
        if (isVideoLoading)
            return;
        document.documentElement.style.setProperty("--cardscan-video-background-height", videoLayoutHeight ? "".concat(videoLayoutHeight, "px") : "0");
        window.addEventListener("resize", function () {
            document.documentElement.style.setProperty("--cardscan-video-background-height", videoLayoutHeight ? "".concat(videoLayoutHeight, "px") : "0");
        });
    }, [videoRefBg, isVideoLoading, videoLayoutHeight]);
};

var useBufferSize = function (bufferSize) {
    useEffect(function () {
        document.documentElement.style.setProperty("--cardscan-buffer-max-size", bufferSize.toString());
    }, [bufferSize]);
    //XXX NLS what is this?
    var bufferInfo = useState(4);
    return bufferInfo;
};

var useVideoSizes = function (videoRefBg, setShowCurtain, stateMachineState) {
    var _a, _b;
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (stateMachineState.matches("cameraLoading"))
            return;
        document.documentElement.style.setProperty("--cardscan-video-width", ((_a = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _a === void 0 ? void 0 : _a.videoWidth)
            ? "".concat((_b = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _b === void 0 ? void 0 : _b.videoWidth.toString(), "px")
            : "0");
        document.documentElement.style.setProperty("--cardscan-video-height", ((_c = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _c === void 0 ? void 0 : _c.videoHeight)
            ? "".concat((_d = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _d === void 0 ? void 0 : _d.videoHeight.toString(), "px")
            : "0");
        if ((((_e = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _e === void 0 ? void 0 : _e.videoWidth) &&
            ((_f = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _f === void 0 ? void 0 : _f.videoWidth) > 2 * window.innerWidth) ||
            isMobile_1) {
            setShowCurtain(true);
            var appHeight = function () {
                var doc = document.documentElement;
                doc.style.setProperty("--cardscan-app-height", "".concat(window.innerHeight, "px"));
                doc.style.setProperty("--cardscan-app-width", "".concat(window.innerWidth, "px"));
            };
            window.addEventListener("resize", appHeight);
            appHeight();
            var videoFrame = document.getElementById("frame");
            videoFrame === null || videoFrame === void 0 ? void 0 : videoFrame.classList.add("heightFrame");
            var cameraButton = document.getElementById("camera-btn");
            cameraButton === null || cameraButton === void 0 ? void 0 : cameraButton.classList.add("heightFrame");
        }
    }, [
        (_a = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _a === void 0 ? void 0 : _a.videoWidth,
        (_b = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _b === void 0 ? void 0 : _b.videoHeight,
        setShowCurtain,
        videoRefBg,
        stateMachineState,
    ]);
};

var useRect = function () {
    var ref = useRef(null);
    var _a = useState(null), rect = _a[0], setRect = _a[1];
    var set = function () {
        return setRect(ref && ref.current ? ref.current.getBoundingClientRect() : null);
    };
    useEffect(function () {
        set();
        window.addEventListener("resize", set);
        return function () { return window.removeEventListener("resize", set); };
    }, []);
    return [rect, ref];
};

var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

function useInterval(callback, delay) {
    var savedCallback = useRef(callback);
    // Remember the latest callback if it changes.
    useIsomorphicLayoutEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(function () {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        var id = setInterval(function () { return savedCallback.current(); }, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
}

var withSelector = {exports: {}};

var withSelector_production_min = {};

var shim = {exports: {}};

var useSyncExternalStoreShim_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=React__default$1;function h$1(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h$1,l=e.useState,m=e.useEffect,n$1=e.useLayoutEffect,p$1=e.useDebugValue;function q$1(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n$1(function(){c.value=d;c.getSnapshot=b;r$1(c)&&g({inst:c});},[a,d,b]);m(function(){r$1(c)&&g({inst:c});return a(function(){r$1(c)&&g({inst:c});})},[a]);p$1(d);return d}
function r$1(a){var b=a.getSnapshot;a=a.value;try{var d=b();return !k(a,d)}catch(f){return !0}}function t$1(a,b){return b()}var u$1="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t$1:q$1;useSyncExternalStoreShim_production_min.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u$1;

var useSyncExternalStoreShim_development = {};

/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ===
    'function'
) {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
}
          var React = React__default$1;

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      printWarning('error', format, args);
    }
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    } // eslint-disable-next-line react-internal/safe-string-coercion


    var argsWithFormat = args.map(function (item) {
      return String(item);
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

var objectIs = typeof Object.is === 'function' ? Object.is : is;

// dispatch for CommonJS interop named imports.

var useState = React.useState,
    useEffect = React.useEffect,
    useLayoutEffect = React.useLayoutEffect,
    useDebugValue = React.useDebugValue;
var didWarnOld18Alpha = false;
var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.

function useSyncExternalStore(subscribe, getSnapshot, // Note: The shim does not use getServerSnapshot, because pre-18 versions of
// React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
  {
    if (!didWarnOld18Alpha) {
      if (React.startTransition !== undefined) {
        didWarnOld18Alpha = true;

        error('You are using an outdated, pre-release alpha of React 18 that ' + 'does not support useSyncExternalStore. The ' + 'use-sync-external-store shim will not work correctly. Upgrade ' + 'to a newer pre-release.');
      }
    }
  } // Read the current snapshot from the store on every render. Again, this
  // breaks the rules of React, and only works here because of specific
  // implementation details, most importantly that updates are
  // always synchronous.


  var value = getSnapshot();

  {
    if (!didWarnUncachedGetSnapshot) {
      var cachedValue = getSnapshot();

      if (!objectIs(value, cachedValue)) {
        error('The result of getSnapshot should be cached to avoid an infinite loop');

        didWarnUncachedGetSnapshot = true;
      }
    }
  } // Because updates are synchronous, we don't queue them. Instead we force a
  // re-render whenever the subscribed state changes by updating an some
  // arbitrary useState hook. Then, during render, we call getSnapshot to read
  // the current value.
  //
  // Because we don't actually use the state returned by the useState hook, we
  // can save a bit of memory by storing other stuff in that slot.
  //
  // To implement the early bailout, we need to track some things on a mutable
  // object. Usually, we would put that in a useRef hook, but we can stash it in
  // our useState hook instead.
  //
  // To force a re-render, we call forceUpdate({inst}). That works because the
  // new object always fails an equality check.


  var _useState = useState({
    inst: {
      value: value,
      getSnapshot: getSnapshot
    }
  }),
      inst = _useState[0].inst,
      forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
  // in the layout phase so we can access it during the tearing check that
  // happens on subscribe.


  useLayoutEffect(function () {
    inst.value = value;
    inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
    // commit phase if there was an interleaved mutation. In concurrent mode
    // this can happen all the time, but even in synchronous mode, an earlier
    // effect may have mutated the store.

    if (checkIfSnapshotChanged(inst)) {
      // Force a re-render.
      forceUpdate({
        inst: inst
      });
    }
  }, [subscribe, value, getSnapshot]);
  useEffect(function () {
    // Check for changes right before subscribing. Subsequent changes will be
    // detected in the subscription handler.
    if (checkIfSnapshotChanged(inst)) {
      // Force a re-render.
      forceUpdate({
        inst: inst
      });
    }

    var handleStoreChange = function () {
      // TODO: Because there is no cross-renderer API for batching updates, it's
      // up to the consumer of this library to wrap their subscription event
      // with unstable_batchedUpdates. Should we try to detect when this isn't
      // the case and print a warning in development?
      // The store changed. Check if the snapshot changed since the last time we
      // read from the store.
      if (checkIfSnapshotChanged(inst)) {
        // Force a re-render.
        forceUpdate({
          inst: inst
        });
      }
    }; // Subscribe to the store and return a clean-up function.


    return subscribe(handleStoreChange);
  }, [subscribe]);
  useDebugValue(value);
  return value;
}

function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  var prevValue = inst.value;

  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(prevValue, nextValue);
  } catch (error) {
    return true;
  }
}

function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
  // Note: The shim does not use getServerSnapshot, because pre-18 versions of
  // React do not expose a way to check if we're hydrating. So users of the shim
  // will need to track that themselves and return the correct value
  // from `getSnapshot`.
  return getSnapshot();
}

var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');

var isServerEnvironment = !canUseDOM;

var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
var useSyncExternalStore$2 = React.useSyncExternalStore !== undefined ? React.useSyncExternalStore : shim;

useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ===
    'function'
) {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
}
        
  })();
}

if (process.env.NODE_ENV === 'production') {
  shim.exports = useSyncExternalStoreShim_production_min;
} else {
  shim.exports = useSyncExternalStoreShim_development;
}

/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=React__default$1,n=shim.exports;function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
withSelector_production_min.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f;}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return [function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d;},[d]);w(d);return d};

var withSelector_development = {};

/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ===
    'function'
) {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
}
          var React = React__default$1;
var shim$1 = shim.exports;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

var objectIs = typeof Object.is === 'function' ? Object.is : is;

var useSyncExternalStore = shim$1.useSyncExternalStore;

// for CommonJS interop.

var useRef = React.useRef,
    useEffect = React.useEffect,
    useMemo = React.useMemo,
    useDebugValue = React.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.

function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
  // Use this to track the rendered snapshot.
  var instRef = useRef(null);
  var inst;

  if (instRef.current === null) {
    inst = {
      hasValue: false,
      value: null
    };
    instRef.current = inst;
  } else {
    inst = instRef.current;
  }

  var _useMemo = useMemo(function () {
    // Track the memoized state using closure variables that are local to this
    // memoized instance of a getSnapshot function. Intentionally not using a
    // useRef hook, because that state would be shared across all concurrent
    // copies of the hook/component.
    var hasMemo = false;
    var memoizedSnapshot;
    var memoizedSelection;

    var memoizedSelector = function (nextSnapshot) {
      if (!hasMemo) {
        // The first time the hook is called, there is no memoized result.
        hasMemo = true;
        memoizedSnapshot = nextSnapshot;

        var _nextSelection = selector(nextSnapshot);

        if (isEqual !== undefined) {
          // Even if the selector has changed, the currently rendered selection
          // may be equal to the new selection. We should attempt to reuse the
          // current value if possible, to preserve downstream memoizations.
          if (inst.hasValue) {
            var currentSelection = inst.value;

            if (isEqual(currentSelection, _nextSelection)) {
              memoizedSelection = currentSelection;
              return currentSelection;
            }
          }
        }

        memoizedSelection = _nextSelection;
        return _nextSelection;
      } // We may be able to reuse the previous invocation's result.


      // We may be able to reuse the previous invocation's result.
      var prevSnapshot = memoizedSnapshot;
      var prevSelection = memoizedSelection;

      if (objectIs(prevSnapshot, nextSnapshot)) {
        // The snapshot is the same as last time. Reuse the previous selection.
        return prevSelection;
      } // The snapshot has changed, so we need to compute a new selection.


      // The snapshot has changed, so we need to compute a new selection.
      var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
      // has changed. If it hasn't, return the previous selection. That signals
      // to React that the selections are conceptually equal, and we can bail
      // out of rendering.

      // If a custom isEqual function is provided, use that to check if the data
      // has changed. If it hasn't, return the previous selection. That signals
      // to React that the selections are conceptually equal, and we can bail
      // out of rendering.
      if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) {
        return prevSelection;
      }

      memoizedSnapshot = nextSnapshot;
      memoizedSelection = nextSelection;
      return nextSelection;
    }; // Assigning this to a constant so that Flow knows it can't change.


    // Assigning this to a constant so that Flow knows it can't change.
    var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;

    var getSnapshotWithSelector = function () {
      return memoizedSelector(getSnapshot());
    };

    var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function () {
      return memoizedSelector(maybeGetServerSnapshot());
    };
    return [getSnapshotWithSelector, getServerSnapshotWithSelector];
  }, [getSnapshot, getServerSnapshot, selector, isEqual]),
      getSelection = _useMemo[0],
      getServerSelection = _useMemo[1];

  var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
  useEffect(function () {
    inst.hasValue = true;
    inst.value = value;
  }, [value]);
  useDebugValue(value);
  return value;
}

withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector;
          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
if (
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ===
    'function'
) {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
}
        
  })();
}

if (process.env.NODE_ENV === 'production') {
  withSelector.exports = withSelector_production_min;
} else {
  withSelector.exports = withSelector_development;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$2(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var ActionTypes;

(function (ActionTypes) {
  ActionTypes["Start"] = "xstate.start";
  ActionTypes["Stop"] = "xstate.stop";
  ActionTypes["Raise"] = "xstate.raise";
  ActionTypes["Send"] = "xstate.send";
  ActionTypes["Cancel"] = "xstate.cancel";
  ActionTypes["NullEvent"] = "";
  ActionTypes["Assign"] = "xstate.assign";
  ActionTypes["After"] = "xstate.after";
  ActionTypes["DoneState"] = "done.state";
  ActionTypes["DoneInvoke"] = "done.invoke";
  ActionTypes["Log"] = "xstate.log";
  ActionTypes["Init"] = "xstate.init";
  ActionTypes["Invoke"] = "xstate.invoke";
  ActionTypes["ErrorExecution"] = "error.execution";
  ActionTypes["ErrorCommunication"] = "error.communication";
  ActionTypes["ErrorPlatform"] = "error.platform";
  ActionTypes["ErrorCustom"] = "xstate.error";
  ActionTypes["Update"] = "xstate.update";
  ActionTypes["Pure"] = "xstate.pure";
  ActionTypes["Choose"] = "xstate.choose";
})(ActionTypes || (ActionTypes = {}));

var SpecialTargets;

(function (SpecialTargets) {
  SpecialTargets["Parent"] = "#_parent";
  SpecialTargets["Internal"] = "#_internal";
})(SpecialTargets || (SpecialTargets = {}));

var start$1 = ActionTypes.Start;
var stop$1 = ActionTypes.Stop;
var raise$1 = ActionTypes.Raise;
var send$1 = ActionTypes.Send;
var cancel$1 = ActionTypes.Cancel;
var nullEvent = ActionTypes.NullEvent;
var assign$2 = ActionTypes.Assign;
ActionTypes.After;
ActionTypes.DoneState;
var log = ActionTypes.Log;
var init = ActionTypes.Init;
var invoke = ActionTypes.Invoke;
ActionTypes.ErrorExecution;
var errorPlatform = ActionTypes.ErrorPlatform;
var error$1 = ActionTypes.ErrorCustom;
var update = ActionTypes.Update;
var choose = ActionTypes.Choose;
var pure = ActionTypes.Pure;

var STATE_DELIMITER = '.';
var EMPTY_ACTIVITY_MAP = {};
var DEFAULT_GUARD_TYPE = 'xstate.guard';
var TARGETLESS_KEY = '';

var IS_PRODUCTION = process.env.NODE_ENV === 'production';

var _a;
function matchesState(parentStateId, childStateId, delimiter) {
  if (delimiter === void 0) {
    delimiter = STATE_DELIMITER;
  }

  var parentStateValue = toStateValue(parentStateId, delimiter);
  var childStateValue = toStateValue(childStateId, delimiter);

  if (isString(childStateValue)) {
    if (isString(parentStateValue)) {
      return childStateValue === parentStateValue;
    } // Parent more specific than child


    return false;
  }

  if (isString(parentStateValue)) {
    return parentStateValue in childStateValue;
  }

  return Object.keys(parentStateValue).every(function (key) {
    if (!(key in childStateValue)) {
      return false;
    }

    return matchesState(parentStateValue[key], childStateValue[key]);
  });
}
function getEventType(event) {
  try {
    return isString(event) || typeof event === 'number' ? "".concat(event) : event.type;
  } catch (e) {
    throw new Error('Events must be strings or objects with a string event.type property.');
  }
}
function toStatePath(stateId, delimiter) {
  try {
    if (isArray(stateId)) {
      return stateId;
    }

    return stateId.toString().split(delimiter);
  } catch (e) {
    throw new Error("'".concat(stateId, "' is not a valid state path."));
  }
}
function isStateLike(state) {
  return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
function toStateValue(stateValue, delimiter) {
  if (isStateLike(stateValue)) {
    return stateValue.value;
  }

  if (isArray(stateValue)) {
    return pathToStateValue(stateValue);
  }

  if (typeof stateValue !== 'string') {
    return stateValue;
  }

  var statePath = toStatePath(stateValue, delimiter);
  return pathToStateValue(statePath);
}
function pathToStateValue(statePath) {
  if (statePath.length === 1) {
    return statePath[0];
  }

  var value = {};
  var marker = value;

  for (var i = 0; i < statePath.length - 1; i++) {
    if (i === statePath.length - 2) {
      marker[statePath[i]] = statePath[i + 1];
    } else {
      marker[statePath[i]] = {};
      marker = marker[statePath[i]];
    }
  }

  return value;
}
function mapValues(collection, iteratee) {
  var result = {};
  var collectionKeys = Object.keys(collection);

  for (var i = 0; i < collectionKeys.length; i++) {
    var key = collectionKeys[i];
    result[key] = iteratee(collection[key], key, collection, i);
  }

  return result;
}
function mapFilterValues(collection, iteratee, predicate) {
  var e_1, _a;

  var result = {};

  try {
    for (var _b = __values(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var item = collection[key];

      if (!predicate(item)) {
        continue;
      }

      result[key] = iteratee(item, key, collection);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */

var path = function (props) {
  return function (object) {
    var e_2, _a;

    var result = object;

    try {
      for (var props_1 = __values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
        var prop = props_1_1.value;
        result = result[prop];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return result;
  };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */

function nestedPath(props, accessorProp) {
  return function (object) {
    var e_3, _a;

    var result = object;

    try {
      for (var props_2 = __values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
        var prop = props_2_1.value;
        result = result[accessorProp][prop];
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return result;
  };
}
function toStatePaths(stateValue) {
  if (!stateValue) {
    return [[]];
  }

  if (isString(stateValue)) {
    return [[stateValue]];
  }

  var result = flatten(Object.keys(stateValue).map(function (key) {
    var subStateValue = stateValue[key];

    if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) {
      return [[key]];
    }

    return toStatePaths(stateValue[key]).map(function (subPath) {
      return [key].concat(subPath);
    });
  }));
  return result;
}
function flatten(array) {
  var _a;

  return (_a = []).concat.apply(_a, __spreadArray([], __read$2(array), false));
}
function toArrayStrict(value) {
  if (isArray(value)) {
    return value;
  }

  return [value];
}
function toArray(value) {
  if (value === undefined) {
    return [];
  }

  return toArrayStrict(value);
}
function mapContext(mapper, context, _event) {
  var e_5, _a;

  if (isFunction(mapper)) {
    return mapper(context, _event.data);
  }

  var result = {};

  try {
    for (var _b = __values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var subMapper = mapper[key];

      if (isFunction(subMapper)) {
        result[key] = subMapper(context, _event.data);
      } else {
        result[key] = subMapper;
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_5) throw e_5.error;
    }
  }

  return result;
}
function isBuiltInEvent(eventType) {
  return /^(done|error)\./.test(eventType);
}
function isPromiseLike(value) {
  if (value instanceof Promise) {
    return true;
  } // Check if shape matches the Promise/A+ specification for a "thenable".


  if (value !== null && (isFunction(value) || typeof value === 'object') && isFunction(value.then)) {
    return true;
  }

  return false;
}
function isBehavior(value) {
  return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
}
function partition(items, predicate) {
  var e_6, _a;

  var _b = __read$2([[], []], 2),
      truthy = _b[0],
      falsy = _b[1];

  try {
    for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;

      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
    } finally {
      if (e_6) throw e_6.error;
    }
  }

  return [truthy, falsy];
}
function updateHistoryStates(hist, stateValue) {
  return mapValues(hist.states, function (subHist, key) {
    if (!subHist) {
      return undefined;
    }

    var subStateValue = (isString(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);

    if (!subStateValue) {
      return undefined;
    }

    return {
      current: subStateValue,
      states: updateHistoryStates(subHist, subStateValue)
    };
  });
}
function updateHistoryValue(hist, stateValue) {
  return {
    current: stateValue,
    states: updateHistoryStates(hist, stateValue)
  };
}
function updateContext(context, _event, assignActions, state) {
  if (!IS_PRODUCTION) {
    warn(!!context, 'Attempting to update undefined context');
  }

  var updatedContext = context ? assignActions.reduce(function (acc, assignAction) {
    var e_7, _a;

    var assignment = assignAction.assignment;
    var meta = {
      state: state,
      action: assignAction,
      _event: _event
    };
    var partialUpdate = {};

    if (isFunction(assignment)) {
      partialUpdate = assignment(acc, _event.data, meta);
    } else {
      try {
        for (var _b = __values(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          var propAssignment = assignment[key];
          partialUpdate[key] = isFunction(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
    }

    return Object.assign({}, acc, partialUpdate);
  }, context) : context;
  return updatedContext;
} // tslint:disable-next-line:no-empty

var warn = function () {};

if (!IS_PRODUCTION) {
  warn = function (condition, message) {
    var error = condition instanceof Error ? condition : undefined;

    if (!error && condition) {
      return;
    }

    if (console !== undefined) {
      var args = ["Warning: ".concat(message)];

      if (error) {
        args.push(error);
      } // tslint:disable-next-line:no-console


      console.warn.apply(console, args);
    }
  };
}
function isArray(value) {
  return Array.isArray(value);
} // tslint:disable-next-line:ban-types

function isFunction(value) {
  return typeof value === 'function';
}
function isString(value) {
  return typeof value === 'string';
}
function toGuard(condition, guardMap) {
  if (!condition) {
    return undefined;
  }

  if (isString(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition,
      predicate: guardMap ? guardMap[condition] : undefined
    };
  }

  if (isFunction(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition.name,
      predicate: condition
    };
  }

  return condition;
}
function isObservable(value) {
  try {
    return 'subscribe' in value && isFunction(value.subscribe);
  } catch (e) {
    return false;
  }
}
var symbolObservable = /*#__PURE__*/function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages

(_a = {}, _a[symbolObservable] = function () {
  return this;
}, _a[Symbol.observable] = function () {
  return this;
}, _a);
function isMachine(value) {
  return !!value && '__xstatenode' in value;
}
function isActor$1(value) {
  return !!value && typeof value.send === 'function';
}
function toEventObject(event, payload // id?: TEvent['type']
) {
  if (isString(event) || typeof event === 'number') {
    return __assign$1({
      type: event
    }, payload);
  }

  return event;
}
function toSCXMLEvent(event, scxmlEvent) {
  if (!isString(event) && '$$type' in event && event.$$type === 'scxml') {
    return event;
  }

  var eventObject = toEventObject(event);
  return __assign$1({
    name: eventObject.type,
    data: eventObject,
    $$type: 'scxml',
    type: 'external'
  }, scxmlEvent);
}
function toTransitionConfigArray(event, configLike) {
  var transitions = toArrayStrict(configLike).map(function (transitionLike) {
    if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || isMachine(transitionLike)) {
      return {
        target: transitionLike,
        event: event
      };
    }

    return __assign$1(__assign$1({}, transitionLike), {
      event: event
    });
  });
  return transitions;
}
function normalizeTarget(target) {
  if (target === undefined || target === TARGETLESS_KEY) {
    return undefined;
  }

  return toArray(target);
}
function reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
  if (!IS_PRODUCTION) {
    var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';

    if (originalError === currentError) {
      // tslint:disable-next-line:no-console
      console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
    } else {
      var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console

      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
    }
  }
}
function evaluateGuard(machine, guard, context, _event, state) {
  var guards = machine.options.guards;
  var guardMeta = {
    state: state,
    cond: guard,
    _event: _event
  }; // TODO: do not hardcode!

  if (guard.type === DEFAULT_GUARD_TYPE) {
    return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
  }

  var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];

  if (!condFn) {
    throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
  }

  return condFn(context, _event.data, guardMeta);
}
function toInvokeSource$1(src) {
  if (typeof src === 'string') {
    return {
      type: src
    };
  }

  return src;
}
function toObserver(nextHandler, errorHandler, completionHandler) {
  var noop = function () {};

  var isObserver = typeof nextHandler === 'object';
  var self = isObserver ? nextHandler : null;
  return {
    next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
    error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
    complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
  };
}
function createInvokeId(stateNodeId, index) {
  return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function isRaisableAction(action) {
  return (action.type === raise$1 || action.type === send$1 && action.to === SpecialTargets.Internal) && typeof action.delay !== 'number';
}

var initEvent = /*#__PURE__*/toSCXMLEvent({
  type: init
});
function getActionFunction(actionType, actionFunctionMap) {
  return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function toActionObject(action, actionFunctionMap) {
  var actionObject;

  if (isString(action) || typeof action === 'number') {
    var exec = getActionFunction(action, actionFunctionMap);

    if (isFunction(exec)) {
      actionObject = {
        type: action,
        exec: exec
      };
    } else if (exec) {
      actionObject = exec;
    } else {
      actionObject = {
        type: action,
        exec: undefined
      };
    }
  } else if (isFunction(action)) {
    actionObject = {
      // Convert action to string if unnamed
      type: action.name || action.toString(),
      exec: action
    };
  } else {
    var exec = getActionFunction(action.type, actionFunctionMap);

    if (isFunction(exec)) {
      actionObject = __assign$1(__assign$1({}, action), {
        exec: exec
      });
    } else if (exec) {
      var actionType = exec.type || action.type;
      actionObject = __assign$1(__assign$1(__assign$1({}, exec), action), {
        type: actionType
      });
    } else {
      actionObject = action;
    }
  }

  return actionObject;
}
var toActionObjects = function (action, actionFunctionMap) {
  if (!action) {
    return [];
  }

  var actions = isArray(action) ? action : [action];
  return actions.map(function (subAction) {
    return toActionObject(subAction, actionFunctionMap);
  });
};
function toActivityDefinition(action) {
  var actionObject = toActionObject(action);
  return __assign$1(__assign$1({
    id: isString(action) ? action : actionObject.id
  }, actionObject), {
    type: actionObject.type
  });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */

function raise(event, options) {
  return {
    type: raise$1,
    event: typeof event === 'function' ? event : toEventObject(event),
    delay: options ? options.delay : undefined,
    id: options === null || options === void 0 ? void 0 : options.id
  };
}
function resolveRaise(action, ctx, _event, delaysMap) {
  var meta = {
    _event: _event
  };
  var resolvedEvent = toSCXMLEvent(isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;

  if (isString(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }

  return __assign$1(__assign$1({}, action), {
    type: raise$1,
    _event: resolvedEvent,
    delay: resolvedDelay
  });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */

function send(event, options) {
  return {
    to: options ? options.to : undefined,
    type: send$1,
    event: isFunction(event) ? event : toEventObject(event),
    delay: options ? options.delay : undefined,
    // TODO: don't auto-generate IDs here like that
    // there is too big chance of the ID collision
    id: options && options.id !== undefined ? options.id : isFunction(event) ? event.name : getEventType(event)
  };
}
function resolveSend(action, ctx, _event, delaysMap) {
  var meta = {
    _event: _event
  }; // TODO: helper function for resolving Expr

  var resolvedEvent = toSCXMLEvent(isFunction(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;

  if (isString(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = isFunction(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }

  var resolvedTarget = isFunction(action.to) ? action.to(ctx, _event.data, meta) : action.to;
  return __assign$1(__assign$1({}, action), {
    to: resolvedTarget,
    _event: resolvedEvent,
    event: resolvedEvent.data,
    delay: resolvedDelay
  });
}
var resolveLog = function (action, ctx, _event) {
  return __assign$1(__assign$1({}, action), {
    value: isString(action.expr) ? action.expr : action.expr(ctx, _event.data, {
      _event: _event
    })
  });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */

var cancel = function (sendId) {
  return {
    type: cancel$1,
    sendId: sendId
  };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */

function start(activity) {
  var activityDef = toActivityDefinition(activity);
  return {
    type: ActionTypes.Start,
    activity: activityDef,
    exec: undefined
  };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */

function stop(actorRef) {
  var activity = isFunction(actorRef) ? actorRef : toActivityDefinition(actorRef);
  return {
    type: ActionTypes.Stop,
    activity: activity,
    exec: undefined
  };
}
function resolveStop(action, context, _event) {
  var actorRefOrString = isFunction(action.activity) ? action.activity(context, _event.data) : action.activity;
  var resolvedActorRef = typeof actorRefOrString === 'string' ? {
    id: actorRefOrString
  } : actorRefOrString;
  var actionObject = {
    type: ActionTypes.Stop,
    activity: resolvedActorRef
  };
  return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */

var assign$1 = function (assignment) {
  return {
    type: assign$2,
    assignment: assignment
  };
};
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */

function after(delayRef, id) {
  var idSuffix = id ? "#".concat(id) : '';
  return "".concat(ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */

function done(id, data) {
  var type = "".concat(ActionTypes.DoneState, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */

function doneInvoke(id, data) {
  var type = "".concat(ActionTypes.DoneInvoke, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}
function error(id, data) {
  var type = "".concat(ActionTypes.ErrorPlatform, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}

var pluckAssigns = function (actionBlocks) {
  var e_1, _a;

  var assignActions = [];

  try {
    for (var actionBlocks_1 = __values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
      var block = actionBlocks_1_1.value;
      var i = 0;

      while (i < block.actions.length) {
        if (block.actions[i].type === assign$2) {
          assignActions.push(block.actions[i]);
          block.actions.splice(i, 1);
          continue;
        }

        i++;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return assignActions;
};

function resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
  if (preserveActionOrder === void 0) {
    preserveActionOrder = false;
  }

  var assignActions = preserveActionOrder ? [] : pluckAssigns(actionBlocks);
  var updatedContext = assignActions.length ? updateContext(currentContext, _event, assignActions, currentState) : currentContext;
  var preservedContexts = preserveActionOrder ? [currentContext] : undefined;
  var deferredToBlockEnd = [];

  function handleAction(blockType, actionObject) {
    var _a;

    switch (actionObject.type) {
      case raise$1:
        {
          var raisedAction = resolveRaise(actionObject, updatedContext, _event, machine.options.delays);

          if (predictableExec && typeof raisedAction.delay === 'number') {
            predictableExec(raisedAction, updatedContext, _event);
          }

          return raisedAction;
        }

      case send$1:
        var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init

        if (!IS_PRODUCTION) {
          var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here

          warn(!isString(configuredDelay) || typeof sendAction.delay === 'number', // tslint:disable-next-line:max-line-length
          "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
        }

        if (predictableExec && sendAction.to !== SpecialTargets.Internal) {
          if (blockType === 'entry') {
            deferredToBlockEnd.push(sendAction);
          } else {
            predictableExec(sendAction, updatedContext, _event);
          }
        }

        return sendAction;

      case log:
        {
          var resolved = resolveLog(actionObject, updatedContext, _event);
          predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, updatedContext, _event);
          return resolved;
        }

      case choose:
        {
          var chooseAction = actionObject;
          var matchedActions = (_a = chooseAction.conds.find(function (condition) {
            var guard = toGuard(condition.cond, machine.options.guards);
            return !guard || evaluateGuard(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
          })) === null || _a === void 0 ? void 0 : _a.actions;

          if (!matchedActions) {
            return [];
          }

          var _b = __read$2(resolveActions(machine, currentState, updatedContext, _event, [{
            type: blockType,
            actions: toActionObjects(toArray(matchedActions), machine.options.actions)
          }], predictableExec, preserveActionOrder), 2),
              resolvedActionsFromChoose = _b[0],
              resolvedContextFromChoose = _b[1];

          updatedContext = resolvedContextFromChoose;
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          return resolvedActionsFromChoose;
        }

      case pure:
        {
          var matchedActions = actionObject.get(updatedContext, _event.data);

          if (!matchedActions) {
            return [];
          }

          var _c = __read$2(resolveActions(machine, currentState, updatedContext, _event, [{
            type: blockType,
            actions: toActionObjects(toArray(matchedActions), machine.options.actions)
          }], predictableExec, preserveActionOrder), 2),
              resolvedActionsFromPure = _c[0],
              resolvedContext = _c[1];

          updatedContext = resolvedContext;
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          return resolvedActionsFromPure;
        }

      case stop$1:
        {
          var resolved = resolveStop(actionObject, updatedContext, _event);
          predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, currentContext, _event);
          return resolved;
        }

      case assign$2:
        {
          updatedContext = updateContext(updatedContext, _event, [actionObject], !predictableExec ? currentState : undefined);
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          break;
        }

      default:
        var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
        var exec_1 = resolvedActionObject.exec;

        if (predictableExec) {
          predictableExec(resolvedActionObject, updatedContext, _event);
        } else if (exec_1 && preservedContexts) {
          var contextIndex_1 = preservedContexts.length - 1;

          var wrapped = __assign$1(__assign$1({}, resolvedActionObject), {
            exec: function (_ctx) {
              var args = [];

              for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
              }

              exec_1.apply(void 0, __spreadArray([preservedContexts[contextIndex_1]], __read$2(args), false));
            }
          });

          resolvedActionObject = wrapped;
        }

        return resolvedActionObject;
    }
  }

  function processBlock(block) {
    var e_2, _a;

    var resolvedActions = [];

    try {
      for (var _b = __values(block.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        var resolved = handleAction(block.type, action);

        if (resolved) {
          resolvedActions = resolvedActions.concat(resolved);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    deferredToBlockEnd.forEach(function (action) {
      predictableExec(action, updatedContext, _event);
    });
    deferredToBlockEnd.length = 0;
    return resolvedActions;
  }

  var resolvedActions = flatten(actionBlocks.map(processBlock));
  return [resolvedActions, updatedContext];
}

/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */
var provide = function (service, fn) {
  var result = fn(service);
  return result;
};

function createNullActor(id) {
  var _a;

  return _a = {
    id: id,
    send: function () {
      return void 0;
    },
    subscribe: function () {
      return {
        unsubscribe: function () {
          return void 0;
        }
      };
    },
    getSnapshot: function () {
      return undefined;
    },
    toJSON: function () {
      return {
        id: id
      };
    }
  }, _a[symbolObservable] = function () {
    return this;
  }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */

function createInvocableActor(invokeDefinition, machine, context, _event) {
  var _a;

  var invokeSrc = toInvokeSource$1(invokeDefinition.src);
  var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
  var resolvedData = invokeDefinition.data ? mapContext(invokeDefinition.data, context, _event) : undefined;
  var tempActor = serviceCreator ? createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id); // @ts-ignore

  tempActor.meta = invokeDefinition;
  return tempActor;
}
function createDeferredActor(entity, id, data) {
  var tempActor = createNullActor(id); // @ts-ignore

  tempActor.deferred = true;

  if (isMachine(entity)) {
    // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
    var initialState_1 = tempActor.state = provide(undefined, function () {
      return (data ? entity.withContext(data) : entity).initialState;
    });

    tempActor.getSnapshot = function () {
      return initialState_1;
    };
  }

  return tempActor;
}
function isActor(item) {
  try {
    return typeof item.send === 'function';
  } catch (e) {
    return false;
  }
}
function isSpawnedActor(item) {
  return isActor(item) && 'id' in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now

function toActorRef(actorRefLike) {
  var _a;

  return __assign$1((_a = {
    subscribe: function () {
      return {
        unsubscribe: function () {
          return void 0;
        }
      };
    },
    id: 'anonymous',
    getSnapshot: function () {
      return undefined;
    }
  }, _a[symbolObservable] = function () {
    return this;
  }, _a), actorRefLike);
}

var isLeafNode = function (stateNode) {
  return stateNode.type === 'atomic' || stateNode.type === 'final';
};
function getAllChildren(stateNode) {
  return Object.keys(stateNode.states).map(function (key) {
    return stateNode.states[key];
  });
}
function getChildren(stateNode) {
  return getAllChildren(stateNode).filter(function (sn) {
    return sn.type !== 'history';
  });
}
function getAllStateNodes(stateNode) {
  var stateNodes = [stateNode];

  if (isLeafNode(stateNode)) {
    return stateNodes;
  }

  return stateNodes.concat(flatten(getChildren(stateNode).map(getAllStateNodes)));
}
function getConfiguration(prevStateNodes, stateNodes) {
  var e_1, _a, e_2, _b, e_3, _c, e_4, _d;

  var prevConfiguration = new Set(prevStateNodes);
  var prevAdjList = getAdjList(prevConfiguration);
  var configuration = new Set(stateNodes);

  try {
    // add all ancestors
    for (var configuration_1 = __values(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()) {
      var s = configuration_1_1.value;
      var m = s.parent;

      while (m && !configuration.has(m)) {
        configuration.add(m);
        m = m.parent;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  var adjList = getAdjList(configuration);

  try {
    // add descendants
    for (var configuration_2 = __values(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()) {
      var s = configuration_2_1.value; // if previously active, add existing child nodes

      if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
        if (prevAdjList.get(s)) {
          prevAdjList.get(s).forEach(function (sn) {
            return configuration.add(sn);
          });
        } else {
          s.initialStateNodes.forEach(function (sn) {
            return configuration.add(sn);
          });
        }
      } else {
        if (s.type === 'parallel') {
          try {
            for (var _e = (e_3 = void 0, __values(getChildren(s))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var child = _f.value;

              if (!configuration.has(child)) {
                configuration.add(child);

                if (prevAdjList.get(child)) {
                  prevAdjList.get(child).forEach(function (sn) {
                    return configuration.add(sn);
                  });
                } else {
                  child.initialStateNodes.forEach(function (sn) {
                    return configuration.add(sn);
                  });
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        }
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  try {
    // add all ancestors
    for (var configuration_3 = __values(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()) {
      var s = configuration_3_1.value;
      var m = s.parent;

      while (m && !configuration.has(m)) {
        configuration.add(m);
        m = m.parent;
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
    } finally {
      if (e_4) throw e_4.error;
    }
  }

  return configuration;
}

function getValueFromAdj(baseNode, adjList) {
  var childStateNodes = adjList.get(baseNode);

  if (!childStateNodes) {
    return {}; // todo: fix?
  }

  if (baseNode.type === 'compound') {
    var childStateNode = childStateNodes[0];

    if (childStateNode) {
      if (isLeafNode(childStateNode)) {
        return childStateNode.key;
      }
    } else {
      return {};
    }
  }

  var stateValue = {};
  childStateNodes.forEach(function (csn) {
    stateValue[csn.key] = getValueFromAdj(csn, adjList);
  });
  return stateValue;
}

function getAdjList(configuration) {
  var e_5, _a;

  var adjList = new Map();

  try {
    for (var configuration_4 = __values(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()) {
      var s = configuration_4_1.value;

      if (!adjList.has(s)) {
        adjList.set(s, []);
      }

      if (s.parent) {
        if (!adjList.has(s.parent)) {
          adjList.set(s.parent, []);
        }

        adjList.get(s.parent).push(s);
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
    } finally {
      if (e_5) throw e_5.error;
    }
  }

  return adjList;
}
function getValue(rootNode, configuration) {
  var config = getConfiguration([rootNode], configuration);
  return getValueFromAdj(rootNode, getAdjList(config));
}
function has(iterable, item) {
  if (Array.isArray(iterable)) {
    return iterable.some(function (member) {
      return member === item;
    });
  }

  if (iterable instanceof Set) {
    return iterable.has(item);
  }

  return false; // TODO: fix
}
function nextEvents(configuration) {
  return __spreadArray([], __read$2(new Set(flatten(__spreadArray([], __read$2(configuration.map(function (sn) {
    return sn.ownEvents;
  })), false)))), false);
}
function isInFinalState(configuration, stateNode) {
  if (stateNode.type === 'compound') {
    return getChildren(stateNode).some(function (s) {
      return s.type === 'final' && has(configuration, s);
    });
  }

  if (stateNode.type === 'parallel') {
    return getChildren(stateNode).every(function (sn) {
      return isInFinalState(configuration, sn);
    });
  }

  return false;
}
function getMeta(configuration) {
  if (configuration === void 0) {
    configuration = [];
  }

  return configuration.reduce(function (acc, stateNode) {
    if (stateNode.meta !== undefined) {
      acc[stateNode.id] = stateNode.meta;
    }

    return acc;
  }, {});
}
function getTagsFromConfiguration(configuration) {
  return new Set(flatten(configuration.map(function (sn) {
    return sn.tags;
  })));
}

function stateValuesEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a === undefined || b === undefined) {
    return false;
  }

  if (isString(a) || isString(b)) {
    return a === b;
  }

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  return aKeys.length === bKeys.length && aKeys.every(function (key) {
    return stateValuesEqual(a[key], b[key]);
  });
}
function isStateConfig(state) {
  if (typeof state !== 'object' || state === null) {
    return false;
  }

  return 'value' in state && '_event' in state;
}
function bindActionToState(action, state) {
  var exec = action.exec;

  var boundAction = __assign$1(__assign$1({}, action), {
    exec: exec !== undefined ? function () {
      return exec(state.context, state.event, {
        action: action,
        state: state,
        _event: state._event
      });
    } : undefined
  });

  return boundAction;
}

var State =
/*#__PURE__*/

/** @class */
function () {
  /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */
  function State(config) {
    var _this = this;

    var _a;

    this.actions = [];
    this.activities = EMPTY_ACTIVITY_MAP;
    this.meta = {};
    this.events = [];
    this.value = config.value;
    this.context = config.context;
    this._event = config._event;
    this._sessionid = config._sessionid;
    this.event = this._event.data;
    this.historyValue = config.historyValue;
    this.history = config.history;
    this.actions = config.actions || [];
    this.activities = config.activities || EMPTY_ACTIVITY_MAP;
    this.meta = getMeta(config.configuration);
    this.events = config.events || [];
    this.matches = this.matches.bind(this);
    this.toStrings = this.toStrings.bind(this);
    this.configuration = config.configuration;
    this.transitions = config.transitions;
    this.children = config.children;
    this.done = !!config.done;
    this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
    this.machine = config.machine;
    Object.defineProperty(this, 'nextEvents', {
      get: function () {
        return nextEvents(_this.configuration);
      }
    });
  }
  /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */


  State.from = function (stateValue, context) {
    if (stateValue instanceof State) {
      if (stateValue.context !== context) {
        return new State({
          value: stateValue.value,
          context: context,
          _event: stateValue._event,
          _sessionid: null,
          historyValue: stateValue.historyValue,
          history: stateValue.history,
          actions: [],
          activities: stateValue.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        });
      }

      return stateValue;
    }

    var _event = initEvent;
    return new State({
      value: stateValue,
      context: context,
      _event: _event,
      _sessionid: null,
      historyValue: undefined,
      history: undefined,
      actions: [],
      activities: undefined,
      meta: undefined,
      events: [],
      configuration: [],
      transitions: [],
      children: {}
    });
  };
  /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */


  State.create = function (config) {
    return new State(config);
  };
  /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */


  State.inert = function (stateValue, context) {
    if (stateValue instanceof State) {
      if (!stateValue.actions.length) {
        return stateValue;
      }

      var _event = initEvent;
      return new State({
        value: stateValue.value,
        context: context,
        _event: _event,
        _sessionid: null,
        historyValue: stateValue.historyValue,
        history: stateValue.history,
        activities: stateValue.activities,
        configuration: stateValue.configuration,
        transitions: [],
        children: {}
      });
    }

    return State.from(stateValue, context);
  };
  /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */


  State.prototype.toStrings = function (stateValue, delimiter) {
    var _this = this;

    if (stateValue === void 0) {
      stateValue = this.value;
    }

    if (delimiter === void 0) {
      delimiter = '.';
    }

    if (isString(stateValue)) {
      return [stateValue];
    }

    var valueKeys = Object.keys(stateValue);
    return valueKeys.concat.apply(valueKeys, __spreadArray([], __read$2(valueKeys.map(function (key) {
      return _this.toStrings(stateValue[key], delimiter).map(function (s) {
        return key + delimiter + s;
      });
    })), false));
  };

  State.prototype.toJSON = function () {
    var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = __rest$1(_a, ["configuration", "transitions", "tags", "machine"]);

    return __assign$1(__assign$1({}, jsonValues), {
      tags: Array.from(tags)
    });
  };

  State.prototype.matches = function (parentStateValue) {
    return matchesState(parentStateValue, this.value);
  };
  /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */


  State.prototype.hasTag = function (tag) {
    return this.tags.has(tag);
  };
  /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */


  State.prototype.can = function (event) {
    var _a;

    if (IS_PRODUCTION) {
      warn(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
    }

    var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
    return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
    transitionData.transitions.some(function (t) {
      return t.target !== undefined || t.actions.length;
    });
  };

  return State;
}();

var defaultOptions = {
  deferEvents: false
};

var Scheduler =
/*#__PURE__*/

/** @class */
function () {
  function Scheduler(options) {
    this.processingEvent = false;
    this.queue = [];
    this.initialized = false;
    this.options = __assign$1(__assign$1({}, defaultOptions), options);
  }

  Scheduler.prototype.initialize = function (callback) {
    this.initialized = true;

    if (callback) {
      if (!this.options.deferEvents) {
        this.schedule(callback);
        return;
      }

      this.process(callback);
    }

    this.flushEvents();
  };

  Scheduler.prototype.schedule = function (task) {
    if (!this.initialized || this.processingEvent) {
      this.queue.push(task);
      return;
    }

    if (this.queue.length !== 0) {
      throw new Error('Event queue should be empty when it is not processing events');
    }

    this.process(task);
    this.flushEvents();
  };

  Scheduler.prototype.clear = function () {
    this.queue = [];
  };

  Scheduler.prototype.flushEvents = function () {
    var nextCallback = this.queue.shift();

    while (nextCallback) {
      this.process(nextCallback);
      nextCallback = this.queue.shift();
    }
  };

  Scheduler.prototype.process = function (callback) {
    this.processingEvent = true;

    try {
      callback();
    } catch (e) {
      // there is no use to keep the future events
      // as the situation is not anymore the same
      this.clear();
      throw e;
    } finally {
      this.processingEvent = false;
    }
  };

  return Scheduler;
}();

var children = /*#__PURE__*/new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function () {
    return "x:".concat(sessionIdIndex++);
  },
  register: function (id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function (id) {
    return children.get(id);
  },
  free: function (id) {
    children.delete(id);
  }
};

function getGlobal() {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }

  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof global !== 'undefined') {
    return global;
  }

  if (!IS_PRODUCTION) {
    console.warn('XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues');
  }
}

function getDevTools() {
  var global = getGlobal();

  if (global && '__xstate__' in global) {
    return global.__xstate__;
  }

  return undefined;
}

function registerService(service) {
  if (!getGlobal()) {
    return;
  }

  var devTools = getDevTools();

  if (devTools) {
    devTools.register(service);
  }
}

function spawnBehavior(behavior, options) {
  if (options === void 0) {
    options = {};
  }

  var state = behavior.initialState;
  var observers = new Set();
  var mailbox = [];
  var flushing = false;

  var flush = function () {
    if (flushing) {
      return;
    }

    flushing = true;

    while (mailbox.length > 0) {
      var event_1 = mailbox.shift();
      state = behavior.transition(state, event_1, actorCtx);
      observers.forEach(function (observer) {
        return observer.next(state);
      });
    }

    flushing = false;
  };

  var actor = toActorRef({
    id: options.id,
    send: function (event) {
      mailbox.push(event);
      flush();
    },
    getSnapshot: function () {
      return state;
    },
    subscribe: function (next, handleError, complete) {
      var observer = toObserver(next, handleError, complete);
      observers.add(observer);
      observer.next(state);
      return {
        unsubscribe: function () {
          observers.delete(observer);
        }
      };
    }
  });
  var actorCtx = {
    parent: options.parent,
    self: actor,
    id: options.id || 'anonymous',
    observers: observers
  };
  state = behavior.start ? behavior.start(actorCtx) : state;
  return actor;
}

var DEFAULT_SPAWN_OPTIONS = {
  sync: false,
  autoForward: false
};
var InterpreterStatus;

(function (InterpreterStatus) {
  InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
  InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
  InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})(InterpreterStatus || (InterpreterStatus = {}));

var Interpreter =
/*#__PURE__*/

/** @class */
function () {
  /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */
  function Interpreter(machine, options) {
    if (options === void 0) {
      options = Interpreter.defaultOptions;
    }

    var _this = this;

    this.machine = machine;
    this.delayedEventsMap = {};
    this.listeners = new Set();
    this.contextListeners = new Set();
    this.stopListeners = new Set();
    this.doneListeners = new Set();
    this.eventListeners = new Set();
    this.sendListeners = new Set();
    /**
     * Whether the service is started.
     */

    this.initialized = false;
    this.status = InterpreterStatus.NotStarted;
    this.children = new Map();
    this.forwardTo = new Set();
    this._outgoingQueue = [];
    /**
     * Alias for Interpreter.prototype.start
     */

    this.init = this.start;
    /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */

    this.send = function (event, payload) {
      if (isArray(event)) {
        _this.batch(event);

        return _this.state;
      }

      var _event = toSCXMLEvent(toEventObject(event, payload));

      if (_this.status === InterpreterStatus.Stopped) {
        // do nothing
        if (!IS_PRODUCTION) {
          warn(false, "Event \"".concat(_event.name, "\" was sent to stopped service \"").concat(_this.machine.id, "\". This service has already reached its final state, and will not transition.\nEvent: ").concat(JSON.stringify(_event.data)));
        }

        return _this.state;
      }

      if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) {
        throw new Error("Event \"".concat(_event.name, "\" was sent to uninitialized service \"").concat(_this.machine.id // tslint:disable-next-line:max-line-length
        , "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ").concat(JSON.stringify(_event.data)));
      }

      _this.scheduler.schedule(function () {
        // Forward copy of event to child actors
        _this.forward(_event);

        var nextState = _this._nextState(_event);

        _this.update(nextState, _event);
      });

      return _this._state; // TODO: deprecate (should return void)
      // tslint:disable-next-line:semicolon
    };

    this.sendTo = function (event, to, immediate) {
      var isParent = _this.parent && (to === SpecialTargets.Parent || _this.parent.id === to);
      var target = isParent ? _this.parent : isString(to) ? to === SpecialTargets.Internal ? _this : _this.children.get(to) || registry.get(to) : isActor$1(to) ? to : undefined;

      if (!target) {
        if (!isParent) {
          throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
        } // tslint:disable-next-line:no-console


        if (!IS_PRODUCTION) {
          warn(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event.type));
        }

        return;
      }

      if ('machine' in target) {
        // perhaps those events should be rejected in the parent
        // but atm it doesn't have easy access to all of the information that is required to do it reliably
        if (_this.status !== InterpreterStatus.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
        _this.state.done) {
          // Send SCXML events to machines
          var scxmlEvent = __assign$1(__assign$1({}, event), {
            name: event.name === error$1 ? "".concat(error(_this.id)) : event.name,
            origin: _this.sessionId
          });

          if (!immediate && _this.machine.config.predictableActionArguments) {
            _this._outgoingQueue.push([target, scxmlEvent]);
          } else {
            target.send(scxmlEvent);
          }
        }
      } else {
        // Send normal events to other targets
        if (!immediate && _this.machine.config.predictableActionArguments) {
          _this._outgoingQueue.push([target, event.data]);
        } else {
          target.send(event.data);
        }
      }
    };

    this._exec = function (action, context, _event, actionFunctionMap) {
      if (actionFunctionMap === void 0) {
        actionFunctionMap = _this.machine.options.actions;
      }

      var actionOrExec = action.exec || getActionFunction(action.type, actionFunctionMap);
      var exec = isFunction(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;

      if (exec) {
        try {
          return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
            action: action,
            state: _this.state,
            _event: _event
          } : {
            action: action,
            _event: _event
          });
        } catch (err) {
          if (_this.parent) {
            _this.parent.send({
              type: 'xstate.error',
              data: err
            });
          }

          throw err;
        }
      }

      switch (action.type) {
        case raise$1:
          {
            // if raise action reached the interpreter then it's a delayed one
            var sendAction_1 = action;

            _this.defer(sendAction_1);

            break;
          }

        case send$1:
          var sendAction = action;

          if (typeof sendAction.delay === 'number') {
            _this.defer(sendAction);

            return;
          } else {
            if (sendAction.to) {
              _this.sendTo(sendAction._event, sendAction.to, _event === initEvent);
            } else {
              _this.send(sendAction._event);
            }
          }

          break;

        case cancel$1:
          _this.cancel(action.sendId);

          break;

        case start$1:
          {
            if (_this.status !== InterpreterStatus.Running) {
              return;
            }

            var activity = action.activity; // If the activity will be stopped right after it's started
            // (such as in transient states)
            // don't bother starting the activity.

            if ( // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
            !_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) {
              break;
            } // Invoked services


            if (activity.type === ActionTypes.Invoke) {
              var invokeSource = toInvokeSource$1(activity.src);
              var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
              var id = activity.id,
                  data = activity.data;

              if (!IS_PRODUCTION) {
                warn(!('forward' in activity), // tslint:disable-next-line:max-line-length
                "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
              }

              var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;

              if (!serviceCreator) {
                // tslint:disable-next-line:no-console
                if (!IS_PRODUCTION) {
                  warn(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                }

                return;
              }

              var resolvedData = data ? mapContext(data, context, _event) : undefined;

              if (typeof serviceCreator === 'string') {
                // TODO: warn
                return;
              }

              var source = isFunction(serviceCreator) ? serviceCreator(context, _event.data, {
                data: resolvedData,
                src: invokeSource,
                meta: activity.meta
              }) : serviceCreator;

              if (!source) {
                // TODO: warn?
                return;
              }

              var options = void 0;

              if (isMachine(source)) {
                source = resolvedData ? source.withContext(resolvedData) : source;
                options = {
                  autoForward: autoForward
                };
              }

              _this.spawn(source, id, options);
            } else {
              _this.spawnActivity(activity);
            }

            break;
          }

        case stop$1:
          {
            _this.stopChild(action.activity.id);

            break;
          }

        case log:
          var _a = action,
              label = _a.label,
              value = _a.value;

          if (label) {
            _this.logger(label, value);
          } else {
            _this.logger(value);
          }

          break;

        default:
          if (!IS_PRODUCTION) {
            warn(false, "No implementation found for action type '".concat(action.type, "'"));
          }

          break;
      }
    };

    var resolvedOptions = __assign$1(__assign$1({}, Interpreter.defaultOptions), options);

    var clock = resolvedOptions.clock,
        logger = resolvedOptions.logger,
        parent = resolvedOptions.parent,
        id = resolvedOptions.id;
    var resolvedId = id !== undefined ? id : machine.id;
    this.id = resolvedId;
    this.logger = logger;
    this.clock = clock;
    this.parent = parent;
    this.options = resolvedOptions;
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
    this.sessionId = registry.bookId();
  }

  Object.defineProperty(Interpreter.prototype, "initialState", {
    get: function () {
      var _this = this;

      if (this._initialState) {
        return this._initialState;
      }

      return provide(this, function () {
        _this._initialState = _this.machine.initialState;
        return _this._initialState;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Interpreter.prototype, "state", {
    /**
     * @deprecated Use `.getSnapshot()` instead.
     */
    get: function () {
      if (!IS_PRODUCTION) {
        warn(this.status !== InterpreterStatus.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
      }

      return this._state;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */

  Interpreter.prototype.execute = function (state, actionsConfig) {
    var e_1, _a;

    try {
      for (var _b = __values(state.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        this.exec(action, state, actionsConfig);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };

  Interpreter.prototype.update = function (state, _event) {
    var e_2, _a, e_3, _b, e_4, _c, e_5, _d;

    var _this = this; // Attach session ID to state


    state._sessionid = this.sessionId; // Update state

    this._state = state; // Execute actions

    if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
    // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
    _event === initEvent) && this.options.execute) {
      this.execute(this.state);
    } else {
      var item = void 0;

      while (item = this._outgoingQueue.shift()) {
        item[0].send(item[1]);
      }
    } // Update children


    this.children.forEach(function (child) {
      _this.state.children[child.id] = child;
    }); // Dev tools

    if (this.devTools) {
      this.devTools.send(_event.data, state);
    } // Execute listeners


    if (state.event) {
      try {
        for (var _e = __values(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()) {
          var listener = _f.value;
          listener(state.event);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }

    try {
      for (var _g = __values(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()) {
        var listener = _h.value;
        listener(state, state.event);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    try {
      for (var _j = __values(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()) {
        var contextListener = _k.value;
        contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    if (this.state.done) {
      // get final child state node
      var finalChildStateNode = state.configuration.find(function (sn) {
        return sn.type === 'final' && sn.parent === _this.machine;
      });
      var doneData = finalChildStateNode && finalChildStateNode.doneData ? mapContext(finalChildStateNode.doneData, state.context, _event) : undefined;
      this._doneEvent = doneInvoke(this.id, doneData);

      try {
        for (var _l = __values(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()) {
          var listener = _m.value;
          listener(this._doneEvent);
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
        } finally {
          if (e_5) throw e_5.error;
        }
      }

      this._stop();

      this._stopChildren();

      registry.free(this.sessionId);
    }
  };
  /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */


  Interpreter.prototype.onTransition = function (listener) {
    this.listeners.add(listener); // Send current state to listener

    if (this.status === InterpreterStatus.Running) {
      listener(this.state, this.state.event);
    }

    return this;
  };

  Interpreter.prototype.subscribe = function (nextListenerOrObserver, _, // TODO: error listener
  completeListener) {
    var _this = this;

    var observer = toObserver(nextListenerOrObserver, _, completeListener);
    this.listeners.add(observer.next); // Send current state to listener

    if (this.status !== InterpreterStatus.NotStarted) {
      observer.next(this.state);
    }

    var completeOnce = function () {
      _this.doneListeners.delete(completeOnce);

      _this.stopListeners.delete(completeOnce);

      observer.complete();
    };

    if (this.status === InterpreterStatus.Stopped) {
      observer.complete();
    } else {
      this.onDone(completeOnce);
      this.onStop(completeOnce);
    }

    return {
      unsubscribe: function () {
        _this.listeners.delete(observer.next);

        _this.doneListeners.delete(completeOnce);

        _this.stopListeners.delete(completeOnce);
      }
    };
  };
  /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */


  Interpreter.prototype.onEvent = function (listener) {
    this.eventListeners.add(listener);
    return this;
  };
  /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */


  Interpreter.prototype.onSend = function (listener) {
    this.sendListeners.add(listener);
    return this;
  };
  /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */


  Interpreter.prototype.onChange = function (listener) {
    this.contextListeners.add(listener);
    return this;
  };
  /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */


  Interpreter.prototype.onStop = function (listener) {
    this.stopListeners.add(listener);
    return this;
  };
  /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */


  Interpreter.prototype.onDone = function (listener) {
    if (this.status === InterpreterStatus.Stopped && this._doneEvent) {
      listener(this._doneEvent);
    } else {
      this.doneListeners.add(listener);
    }

    return this;
  };
  /**
   * Removes a listener.
   * @param listener The listener to remove
   */


  Interpreter.prototype.off = function (listener) {
    this.listeners.delete(listener);
    this.eventListeners.delete(listener);
    this.sendListeners.delete(listener);
    this.stopListeners.delete(listener);
    this.doneListeners.delete(listener);
    this.contextListeners.delete(listener);
    return this;
  };
  /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */


  Interpreter.prototype.start = function (initialState) {
    var _this = this;

    if (this.status === InterpreterStatus.Running) {
      // Do not restart the service if it is already started
      return this;
    } // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
    // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
    // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
    // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)


    this.machine._init();

    registry.register(this.sessionId, this);
    this.initialized = true;
    this.status = InterpreterStatus.Running;
    var resolvedState = initialState === undefined ? this.initialState : provide(this, function () {
      return isStateConfig(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState(State.from(initialState, _this.machine.context));
    });

    if (this.options.devTools) {
      this.attachDev();
    }

    this.scheduler.initialize(function () {
      _this.update(resolvedState, initEvent);
    });
    return this;
  };

  Interpreter.prototype._stopChildren = function () {
    // TODO: think about converting those to actions
    this.children.forEach(function (child) {
      if (isFunction(child.stop)) {
        child.stop();
      }
    });
    this.children.clear();
  };

  Interpreter.prototype._stop = function () {
    var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;

    try {
      for (var _f = __values(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()) {
        var listener = _g.value;
        this.listeners.delete(listener);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    try {
      for (var _h = __values(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()) {
        var listener = _j.value; // call listener, then remove

        listener();
        this.stopListeners.delete(listener);
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
      } finally {
        if (e_7) throw e_7.error;
      }
    }

    try {
      for (var _k = __values(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()) {
        var listener = _l.value;
        this.contextListeners.delete(listener);
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
      } finally {
        if (e_8) throw e_8.error;
      }
    }

    try {
      for (var _m = __values(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()) {
        var listener = _o.value;
        this.doneListeners.delete(listener);
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
      } finally {
        if (e_9) throw e_9.error;
      }
    }

    if (!this.initialized) {
      // Interpreter already stopped; do nothing
      return this;
    }

    this.initialized = false;
    this.status = InterpreterStatus.Stopped;
    this._initialState = undefined;

    try {
      // we are going to stop within the current sync frame
      // so we can safely just cancel this here as nothing async should be fired anyway
      for (var _p = __values(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()) {
        var key = _q.value;
        this.clock.clearTimeout(this.delayedEventsMap[key]);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
      } finally {
        if (e_10) throw e_10.error;
      }
    } // clear everything that might be enqueued


    this.scheduler.clear();
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
  };
  /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */


  Interpreter.prototype.stop = function () {
    // TODO: add warning for stopping non-root interpreters
    var _this = this; // grab the current scheduler as it will be replaced in _stop


    var scheduler = this.scheduler;

    this._stop(); // let what is currently processed to be finished


    scheduler.schedule(function () {
      // it feels weird to handle this here but we need to handle this even slightly "out of band"
      var _event = toSCXMLEvent({
        type: 'xstate.stop'
      });

      var nextState = provide(_this, function () {
        var exitActions = flatten(__spreadArray([], __read$2(_this.state.configuration), false).sort(function (a, b) {
          return b.order - a.order;
        }).map(function (stateNode) {
          return toActionObjects(stateNode.onExit, _this.machine.options.actions);
        }));

        var _a = __read$2(resolveActions(_this.machine, _this.state, _this.state.context, _event, [{
          type: 'exit',
          actions: exitActions
        }], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2),
            resolvedActions = _a[0],
            updatedContext = _a[1];

        var newState = new State({
          value: _this.state.value,
          context: updatedContext,
          _event: _event,
          _sessionid: _this.sessionId,
          historyValue: undefined,
          history: _this.state,
          actions: resolvedActions.filter(function (action) {
            return !isRaisableAction(action);
          }),
          activities: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {},
          done: _this.state.done,
          tags: _this.state.tags,
          machine: _this.machine
        });
        newState.changed = true;
        return newState;
      });

      _this.update(nextState, _event);

      _this._stopChildren();

      registry.free(_this.sessionId);
    });
    return this;
  };

  Interpreter.prototype.batch = function (events) {
    var _this = this;

    if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents) {
      // tslint:disable-next-line:no-console
      if (!IS_PRODUCTION) {
        warn(false, "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\" and are deferred. Make sure .start() is called for this service.\nEvent: ").concat(JSON.stringify(event)));
      }
    } else if (this.status !== InterpreterStatus.Running) {
      throw new Error( // tslint:disable-next-line:max-line-length
      "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options."));
    }

    if (!events.length) {
      return;
    }

    var exec = !!this.machine.config.predictableActionArguments && this._exec;
    this.scheduler.schedule(function () {
      var e_11, _a;

      var nextState = _this.state;
      var batchChanged = false;
      var batchedActions = [];

      var _loop_1 = function (event_1) {
        var _event = toSCXMLEvent(event_1);

        _this.forward(_event);

        nextState = provide(_this, function () {
          return _this.machine.transition(nextState, _event, undefined, exec || undefined);
        });
        batchedActions.push.apply(batchedActions, __spreadArray([], __read$2(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function (a) {
          return bindActionToState(a, nextState);
        })), false));
        batchChanged = batchChanged || !!nextState.changed;
      };

      try {
        for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
          var event_1 = events_1_1.value;

          _loop_1(event_1);
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
        } finally {
          if (e_11) throw e_11.error;
        }
      }

      nextState.changed = batchChanged;
      nextState.actions = batchedActions;

      _this.update(nextState, toSCXMLEvent(events[events.length - 1]));
    });
  };
  /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */


  Interpreter.prototype.sender = function (event) {
    return this.send.bind(this, event);
  };

  Interpreter.prototype._nextState = function (event, exec) {
    var _this = this;

    if (exec === void 0) {
      exec = !!this.machine.config.predictableActionArguments && this._exec;
    }

    var _event = toSCXMLEvent(event);

    if (_event.name.indexOf(errorPlatform) === 0 && !this.state.nextEvents.some(function (nextEvent) {
      return nextEvent.indexOf(errorPlatform) === 0;
    })) {
      throw _event.data.data;
    }

    var nextState = provide(this, function () {
      return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
    });
    return nextState;
  };
  /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */


  Interpreter.prototype.nextState = function (event) {
    return this._nextState(event, false);
  };

  Interpreter.prototype.forward = function (event) {
    var e_12, _a;

    try {
      for (var _b = __values(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        var child = this.children.get(id);

        if (!child) {
          throw new Error("Unable to forward event '".concat(event, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
        }

        child.send(event);
      }
    } catch (e_12_1) {
      e_12 = {
        error: e_12_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_12) throw e_12.error;
      }
    }
  };

  Interpreter.prototype.defer = function (sendAction) {
    var _this = this;

    var timerId = this.clock.setTimeout(function () {
      if ('to' in sendAction && sendAction.to) {
        _this.sendTo(sendAction._event, sendAction.to, true);
      } else {
        _this.send(sendAction._event);
      }
    }, sendAction.delay);

    if (sendAction.id) {
      this.delayedEventsMap[sendAction.id] = timerId;
    }
  };

  Interpreter.prototype.cancel = function (sendId) {
    this.clock.clearTimeout(this.delayedEventsMap[sendId]);
    delete this.delayedEventsMap[sendId];
  };

  Interpreter.prototype.exec = function (action, state, actionFunctionMap) {
    if (actionFunctionMap === void 0) {
      actionFunctionMap = this.machine.options.actions;
    }

    this._exec(action, state.context, state._event, actionFunctionMap);
  };

  Interpreter.prototype.removeChild = function (childId) {
    var _a;

    this.children.delete(childId);
    this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
    // such as when a child is added then removed while initializing the state

    (_a = this.state) === null || _a === void 0 ? true : delete _a.children[childId];
  };

  Interpreter.prototype.stopChild = function (childId) {
    var child = this.children.get(childId);

    if (!child) {
      return;
    }

    this.removeChild(childId);

    if (isFunction(child.stop)) {
      child.stop();
    }
  };

  Interpreter.prototype.spawn = function (entity, name, options) {
    if (this.status !== InterpreterStatus.Running) {
      return createDeferredActor(entity, name);
    }

    if (isPromiseLike(entity)) {
      return this.spawnPromise(Promise.resolve(entity), name);
    } else if (isFunction(entity)) {
      return this.spawnCallback(entity, name);
    } else if (isSpawnedActor(entity)) {
      return this.spawnActor(entity, name);
    } else if (isObservable(entity)) {
      return this.spawnObservable(entity, name);
    } else if (isMachine(entity)) {
      return this.spawnMachine(entity, __assign$1(__assign$1({}, options), {
        id: name
      }));
    } else if (isBehavior(entity)) {
      return this.spawnBehavior(entity, name);
    } else {
      throw new Error("Unable to spawn entity \"".concat(name, "\" of type \"").concat(typeof entity, "\"."));
    }
  };

  Interpreter.prototype.spawnMachine = function (machine, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    var childService = new Interpreter(machine, __assign$1(__assign$1({}, this.options), {
      parent: this,
      id: options.id || machine.id
    }));

    var resolvedOptions = __assign$1(__assign$1({}, DEFAULT_SPAWN_OPTIONS), options);

    if (resolvedOptions.sync) {
      childService.onTransition(function (state) {
        _this.send(update, {
          state: state,
          id: childService.id
        });
      });
    }

    var actor = childService;
    this.children.set(childService.id, actor);

    if (resolvedOptions.autoForward) {
      this.forwardTo.add(childService.id);
    }

    childService.onDone(function (doneEvent) {
      _this.removeChild(childService.id);

      _this.send(toSCXMLEvent(doneEvent, {
        origin: childService.id
      }));
    }).start();
    return actor;
  };

  Interpreter.prototype.spawnBehavior = function (behavior, id) {
    var actorRef = spawnBehavior(behavior, {
      id: id,
      parent: this
    });
    this.children.set(id, actorRef);
    return actorRef;
  };

  Interpreter.prototype.spawnPromise = function (promise, id) {
    var _a;

    var _this = this;

    var canceled = false;
    var resolvedData;
    promise.then(function (response) {
      if (!canceled) {
        resolvedData = response;

        _this.removeChild(id);

        _this.send(toSCXMLEvent(doneInvoke(id, response), {
          origin: id
        }));
      }
    }, function (errorData) {
      if (!canceled) {
        _this.removeChild(id);

        var errorEvent = error(id, errorData);

        try {
          // Send "error.platform.id" to this (parent).
          _this.send(toSCXMLEvent(errorEvent, {
            origin: id
          }));
        } catch (error) {
          reportUnhandledExceptionOnInvocation(errorData, error, id);

          if (_this.devTools) {
            _this.devTools.send(errorEvent, _this.state);
          }

          if (_this.machine.strict) {
            // it would be better to always stop the state machine if unhandled
            // exception/promise rejection happens but because we don't want to
            // break existing code so enforce it on strict mode only especially so
            // because documentation says that onError is optional
            _this.stop();
          }
        }
      }
    });
    var actor = (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function (next, handleError, complete) {
        var observer = toObserver(next, handleError, complete);
        var unsubscribed = false;
        promise.then(function (response) {
          if (unsubscribed) {
            return;
          }

          observer.next(response);

          if (unsubscribed) {
            return;
          }

          observer.complete();
        }, function (err) {
          if (unsubscribed) {
            return;
          }

          observer.error(err);
        });
        return {
          unsubscribe: function () {
            return unsubscribed = true;
          }
        };
      },
      stop: function () {
        canceled = true;
      },
      toJSON: function () {
        return {
          id: id
        };
      },
      getSnapshot: function () {
        return resolvedData;
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnCallback = function (callback, id) {
    var _a;

    var _this = this;

    var canceled = false;
    var receivers = new Set();
    var listeners = new Set();
    var emitted;

    var receive = function (e) {
      emitted = e;
      listeners.forEach(function (listener) {
        return listener(e);
      });

      if (canceled) {
        return;
      }

      _this.send(toSCXMLEvent(e, {
        origin: id
      }));
    };

    var callbackStop;

    try {
      callbackStop = callback(receive, function (newListener) {
        receivers.add(newListener);
      });
    } catch (err) {
      this.send(error(id, err));
    }

    if (isPromiseLike(callbackStop)) {
      // it turned out to be an async function, can't reliably check this before calling `callback`
      // because transpiled async functions are not recognizable
      return this.spawnPromise(callbackStop, id);
    }

    var actor = (_a = {
      id: id,
      send: function (event) {
        return receivers.forEach(function (receiver) {
          return receiver(event);
        });
      },
      subscribe: function (next) {
        var observer = toObserver(next);
        listeners.add(observer.next);
        return {
          unsubscribe: function () {
            listeners.delete(observer.next);
          }
        };
      },
      stop: function () {
        canceled = true;

        if (isFunction(callbackStop)) {
          callbackStop();
        }
      },
      toJSON: function () {
        return {
          id: id
        };
      },
      getSnapshot: function () {
        return emitted;
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnObservable = function (source, id) {
    var _a;

    var _this = this;

    var emitted;
    var subscription = source.subscribe(function (value) {
      emitted = value;

      _this.send(toSCXMLEvent(value, {
        origin: id
      }));
    }, function (err) {
      _this.removeChild(id);

      _this.send(toSCXMLEvent(error(id, err), {
        origin: id
      }));
    }, function () {
      _this.removeChild(id);

      _this.send(toSCXMLEvent(doneInvoke(id), {
        origin: id
      }));
    });
    var actor = (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function (next, handleError, complete) {
        return source.subscribe(next, handleError, complete);
      },
      stop: function () {
        return subscription.unsubscribe();
      },
      getSnapshot: function () {
        return emitted;
      },
      toJSON: function () {
        return {
          id: id
        };
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnActor = function (actor, name) {
    this.children.set(name, actor);
    return actor;
  };

  Interpreter.prototype.spawnActivity = function (activity) {
    var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;

    if (!implementation) {
      if (!IS_PRODUCTION) {
        warn(false, "No implementation found for activity '".concat(activity.type, "'"));
      } // tslint:disable-next-line:no-console


      return;
    } // Start implementation


    var dispose = implementation(this.state.context, activity);
    this.spawnEffect(activity.id, dispose);
  };

  Interpreter.prototype.spawnEffect = function (id, dispose) {
    var _a;

    this.children.set(id, (_a = {
      id: id,
      send: function () {
        return void 0;
      },
      subscribe: function () {
        return {
          unsubscribe: function () {
            return void 0;
          }
        };
      },
      stop: dispose || undefined,
      getSnapshot: function () {
        return undefined;
      },
      toJSON: function () {
        return {
          id: id
        };
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a));
  };

  Interpreter.prototype.attachDev = function () {
    var global = getGlobal();

    if (this.options.devTools && global) {
      if (global.__REDUX_DEVTOOLS_EXTENSION__) {
        var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
        this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect(__assign$1(__assign$1({
          name: this.id,
          autoPause: true,
          stateSanitizer: function (state) {
            return {
              value: state.value,
              context: state.context,
              actions: state.actions
            };
          }
        }, devToolsOptions), {
          features: __assign$1({
            jump: false,
            skip: false
          }, devToolsOptions ? devToolsOptions.features : undefined)
        }), this.machine);
        this.devTools.init(this.state);
      } // add XState-specific dev tooling hook


      registerService(this);
    }
  };

  Interpreter.prototype.toJSON = function () {
    return {
      id: this.id
    };
  };

  Interpreter.prototype[symbolObservable] = function () {
    return this;
  };

  Interpreter.prototype.getSnapshot = function () {
    if (this.status === InterpreterStatus.NotStarted) {
      return this.initialState;
    }

    return this._state;
  };
  /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */


  Interpreter.defaultOptions = {
    execute: true,
    deferEvents: true,
    clock: {
      setTimeout: function (fn, ms) {
        return setTimeout(fn, ms);
      },
      clearTimeout: function (id) {
        return clearTimeout(id);
      }
    },
    logger: /*#__PURE__*/console.log.bind(console),
    devTools: false
  };
  Interpreter.interpret = interpret;
  return Interpreter;
}();
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */

function interpret(machine, options) {
  var interpreter = new Interpreter(machine, options);
  return interpreter;
}

function toInvokeSource(src) {
  if (typeof src === 'string') {
    var simpleSrc = {
      type: src
    };

    simpleSrc.toString = function () {
      return src;
    }; // v4 compat - TODO: remove in v5


    return simpleSrc;
  }

  return src;
}
function toInvokeDefinition(invokeConfig) {
  return __assign$1(__assign$1({
    type: invoke
  }, invokeConfig), {
    toJSON: function () {
      invokeConfig.onDone;
          invokeConfig.onError;
          var invokeDef = __rest$1(invokeConfig, ["onDone", "onError"]);

      return __assign$1(__assign$1({}, invokeDef), {
        type: invoke,
        src: toInvokeSource(invokeConfig.src)
      });
    }
  });
}

var NULL_EVENT = '';
var STATE_IDENTIFIER = '#';
var WILDCARD = '*';
var EMPTY_OBJECT = {};

var isStateId = function (str) {
  return str[0] === STATE_IDENTIFIER;
};

var createDefaultOptions = function () {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};

var validateArrayifiedTransitions = function (stateNode, event, transitions) {
  var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function (transition) {
    return !('cond' in transition) && !('in' in transition) && (isString(transition.target) || isMachine(transition.target));
  });
  var eventText = event === NULL_EVENT ? 'the transient event' : "event '".concat(event, "'");
  warn(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};

var StateNode =
/*#__PURE__*/

/** @class */
function () {
  function StateNode(
  /**
   * The raw config used to create the machine.
   */
  config, options,
  /**
   * The initial extended state
   */
  _context, // TODO: this is unsafe, but we're removing it in v5 anyway
  _stateInfo) {
    if (_context === void 0) {
      _context = 'context' in config ? config.context : undefined;
    }

    var _this = this;

    var _a;

    this.config = config;
    this._context = _context;
    /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */

    this.order = -1;
    this.__xstatenode = true;
    this.__cache = {
      events: undefined,
      relativeValue: new Map(),
      initialStateValue: undefined,
      initialState: undefined,
      on: undefined,
      transitions: undefined,
      candidates: {},
      delayedTransitions: undefined
    };
    this.idMap = {};
    this.tags = [];
    this.options = Object.assign(createDefaultOptions(), options);
    this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
    this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || '(machine)';
    this.machine = this.parent ? this.parent.machine : this;
    this.path = this.parent ? this.parent.path.concat(this.key) : [];
    this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : STATE_DELIMITER);
    this.id = this.config.id || __spreadArray([this.machine.key], __read$2(this.path), false).join(this.delimiter);
    this.version = this.parent ? this.parent.version : this.config.version;
    this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
    this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
    this.description = this.config.description;

    if (!IS_PRODUCTION) {
      warn(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. ".concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
    }

    this.initial = this.config.initial;
    this.states = this.config.states ? mapValues(this.config.states, function (stateConfig, key) {
      var _a;

      var stateNode = new StateNode(stateConfig, {}, undefined, {
        parent: _this,
        key: key
      });
      Object.assign(_this.idMap, __assign$1((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
      return stateNode;
    }) : EMPTY_OBJECT; // Document order

    var order = 0;

    function dfs(stateNode) {
      var e_1, _a;

      stateNode.order = order++;

      try {
        for (var _b = __values(getAllChildren(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          dfs(child);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }

    dfs(this); // History config

    this.history = this.config.history === true ? 'shallow' : this.config.history || false;
    this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function (_a) {
      var event = _a.event;
      return event === NULL_EVENT;
    }) : NULL_EVENT in this.config.on);
    this.strict = !!this.config.strict; // TODO: deprecate (entry)

    this.onEntry = toArray(this.config.entry || this.config.onEntry).map(function (action) {
      return toActionObject(action);
    }); // TODO: deprecate (exit)

    this.onExit = toArray(this.config.exit || this.config.onExit).map(function (action) {
      return toActionObject(action);
    });
    this.meta = this.config.meta;
    this.doneData = this.type === 'final' ? this.config.data : undefined;
    this.invoke = toArray(this.config.invoke).map(function (invokeConfig, i) {
      var _a, _b;

      if (isMachine(invokeConfig)) {
        var invokeId = createInvokeId(_this.id, i);
        _this.machine.options.services = __assign$1((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
        return toInvokeDefinition({
          src: invokeId,
          id: invokeId
        });
      } else if (isString(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
        return toInvokeDefinition(__assign$1(__assign$1({}, invokeConfig), {
          id: invokeId,
          src: invokeConfig.src
        }));
      } else if (isMachine(invokeConfig.src) || isFunction(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
        _this.machine.options.services = __assign$1((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
        return toInvokeDefinition(__assign$1(__assign$1({
          id: invokeId
        }, invokeConfig), {
          src: invokeId
        }));
      } else {
        var invokeSource = invokeConfig.src;
        return toInvokeDefinition(__assign$1(__assign$1({
          id: createInvokeId(_this.id, i)
        }, invokeConfig), {
          src: invokeSource
        }));
      }
    });
    this.activities = toArray(this.config.activities).concat(this.invoke).map(function (activity) {
      return toActivityDefinition(activity);
    });
    this.transition = this.transition.bind(this);
    this.tags = toArray(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
  }

  StateNode.prototype._init = function () {
    if (this.__cache.transitions) {
      return;
    }

    getAllStateNodes(this).forEach(function (stateNode) {
      return stateNode.on;
    });
  };
  /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */


  StateNode.prototype.withConfig = function (options, context) {
    var _a = this.options,
        actions = _a.actions,
        activities = _a.activities,
        guards = _a.guards,
        services = _a.services,
        delays = _a.delays;
    return new StateNode(this.config, {
      actions: __assign$1(__assign$1({}, actions), options.actions),
      activities: __assign$1(__assign$1({}, activities), options.activities),
      guards: __assign$1(__assign$1({}, guards), options.guards),
      services: __assign$1(__assign$1({}, services), options.services),
      delays: __assign$1(__assign$1({}, delays), options.delays)
    }, context !== null && context !== void 0 ? context : this.context);
  };
  /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */


  StateNode.prototype.withContext = function (context) {
    return new StateNode(this.config, this.options, context);
  };

  Object.defineProperty(StateNode.prototype, "context", {
    get: function () {
      return isFunction(this._context) ? this._context() : this._context;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "definition", {
    /**
     * The well-structured state node definition.
     */
    get: function () {
      return {
        id: this.id,
        key: this.key,
        version: this.version,
        context: this.context,
        type: this.type,
        initial: this.initial,
        history: this.history,
        states: mapValues(this.states, function (state) {
          return state.definition;
        }),
        on: this.on,
        transitions: this.transitions,
        entry: this.onEntry,
        exit: this.onExit,
        activities: this.activities || [],
        meta: this.meta,
        order: this.order || -1,
        data: this.doneData,
        invoke: this.invoke,
        description: this.description,
        tags: this.tags
      };
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.toJSON = function () {
    return this.definition;
  };

  Object.defineProperty(StateNode.prototype, "on", {
    /**
     * The mapping of events to transitions.
     */
    get: function () {
      if (this.__cache.on) {
        return this.__cache.on;
      }

      var transitions = this.transitions;
      return this.__cache.on = transitions.reduce(function (map, transition) {
        map[transition.eventType] = map[transition.eventType] || [];
        map[transition.eventType].push(transition);
        return map;
      }, {});
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "after", {
    get: function () {
      return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "transitions", {
    /**
     * All the transitions that can be taken from this state node.
     */
    get: function () {
      return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.getCandidates = function (eventName) {
    if (this.__cache.candidates[eventName]) {
      return this.__cache.candidates[eventName];
    }

    var transient = eventName === NULL_EVENT;
    var candidates = this.transitions.filter(function (transition) {
      var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions

      return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
    });
    this.__cache.candidates[eventName] = candidates;
    return candidates;
  };
  /**
   * All delayed transitions from the config.
   */


  StateNode.prototype.getDelayedTransitions = function () {
    var _this = this;

    var afterConfig = this.config.after;

    if (!afterConfig) {
      return [];
    }

    var mutateEntryExit = function (delay, i) {
      var delayRef = isFunction(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
      var eventType = after(delayRef, _this.id);

      _this.onEntry.push(send(eventType, {
        delay: delay
      }));

      _this.onExit.push(cancel(eventType));

      return eventType;
    };

    var delayedTransitions = isArray(afterConfig) ? afterConfig.map(function (transition, i) {
      var eventType = mutateEntryExit(transition.delay, i);
      return __assign$1(__assign$1({}, transition), {
        event: eventType
      });
    }) : flatten(Object.keys(afterConfig).map(function (delay, i) {
      var configTransition = afterConfig[delay];
      var resolvedTransition = isString(configTransition) ? {
        target: configTransition
      } : configTransition;
      var resolvedDelay = !isNaN(+delay) ? +delay : delay;
      var eventType = mutateEntryExit(resolvedDelay, i);
      return toArray(resolvedTransition).map(function (transition) {
        return __assign$1(__assign$1({}, transition), {
          event: eventType,
          delay: resolvedDelay
        });
      });
    }));
    return delayedTransitions.map(function (delayedTransition) {
      var delay = delayedTransition.delay;
      return __assign$1(__assign$1({}, _this.formatTransition(delayedTransition)), {
        delay: delay
      });
    });
  };
  /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */


  StateNode.prototype.getStateNodes = function (state) {
    var _a;

    var _this = this;

    if (!state) {
      return [];
    }

    var stateValue = state instanceof State ? state.value : toStateValue(state, this.delimiter);

    if (isString(stateValue)) {
      var initialStateValue = this.getStateNode(stateValue).initial;
      return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [this, this.states[stateValue]];
    }

    var subStateKeys = Object.keys(stateValue);
    var subStateNodes = [this];
    subStateNodes.push.apply(subStateNodes, __spreadArray([], __read$2(flatten(subStateKeys.map(function (subStateKey) {
      return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
    }))), false));
    return subStateNodes;
  };
  /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */


  StateNode.prototype.handles = function (event) {
    var eventType = getEventType(event);
    return this.events.includes(eventType);
  };
  /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */


  StateNode.prototype.resolveState = function (state) {
    var stateFromConfig = state instanceof State ? state : State.create(state);
    var configuration = Array.from(getConfiguration([], this.getStateNodes(stateFromConfig.value)));
    return new State(__assign$1(__assign$1({}, stateFromConfig), {
      value: this.resolve(stateFromConfig.value),
      configuration: configuration,
      done: isInFinalState(configuration, this),
      tags: getTagsFromConfiguration(configuration),
      machine: this.machine
    }));
  };

  StateNode.prototype.transitionLeafNode = function (stateValue, state, _event) {
    var stateNode = this.getStateNode(stateValue);
    var next = stateNode.next(state, _event);

    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }

    return next;
  };

  StateNode.prototype.transitionCompoundNode = function (stateValue, state, _event) {
    var subStateKeys = Object.keys(stateValue);
    var stateNode = this.getStateNode(subStateKeys[0]);

    var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);

    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }

    return next;
  };

  StateNode.prototype.transitionParallelNode = function (stateValue, state, _event) {
    var e_2, _a;

    var transitionMap = {};

    try {
      for (var _b = __values(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var subStateKey = _c.value;
        var subStateValue = stateValue[subStateKey];

        if (!subStateValue) {
          continue;
        }

        var subStateNode = this.getStateNode(subStateKey);

        var next = subStateNode._transition(subStateValue, state, _event);

        if (next) {
          transitionMap[subStateKey] = next;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    var stateTransitions = Object.keys(transitionMap).map(function (key) {
      return transitionMap[key];
    });
    var enabledTransitions = flatten(stateTransitions.map(function (st) {
      return st.transitions;
    }));
    var willTransition = stateTransitions.some(function (st) {
      return st.transitions.length > 0;
    });

    if (!willTransition) {
      return this.next(state, _event);
    }

    var configuration = flatten(Object.keys(transitionMap).map(function (key) {
      return transitionMap[key].configuration;
    }));
    return {
      transitions: enabledTransitions,
      exitSet: flatten(stateTransitions.map(function (t) {
        return t.exitSet;
      })),
      configuration: configuration,
      source: state,
      actions: flatten(Object.keys(transitionMap).map(function (key) {
        return transitionMap[key].actions;
      }))
    };
  };

  StateNode.prototype._transition = function (stateValue, state, _event) {
    // leaf node
    if (isString(stateValue)) {
      return this.transitionLeafNode(stateValue, state, _event);
    } // hierarchical node


    if (Object.keys(stateValue).length === 1) {
      return this.transitionCompoundNode(stateValue, state, _event);
    } // orthogonal node


    return this.transitionParallelNode(stateValue, state, _event);
  };

  StateNode.prototype.getTransitionData = function (state, event) {
    return this._transition(state.value, state, toSCXMLEvent(event));
  };

  StateNode.prototype.next = function (state, _event) {
    var e_3, _a;

    var _this = this;

    var eventName = _event.name;
    var actions = [];
    var nextStateNodes = [];
    var selectedTransition;

    try {
      for (var _b = __values(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var candidate = _c.value;
        var cond = candidate.cond,
            stateIn = candidate.in;
        var resolvedContext = state.context;
        var isInState = stateIn ? isString(stateIn) && isStateId(stateIn) ? // Check if in state by ID
        state.matches(toStateValue(this.getStateNodeById(stateIn).path, this.delimiter)) : // Check if in state by relative grandparent
        matchesState(toStateValue(stateIn, this.delimiter), path(this.path.slice(0, -2))(state.value)) : true;
        var guardPassed = false;

        try {
          guardPassed = !cond || evaluateGuard(this.machine, cond, resolvedContext, _event, state);
        } catch (err) {
          throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
        }

        if (guardPassed && isInState) {
          if (candidate.target !== undefined) {
            nextStateNodes = candidate.target;
          }

          actions.push.apply(actions, __spreadArray([], __read$2(candidate.actions), false));
          selectedTransition = candidate;
          break;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    if (!selectedTransition) {
      return undefined;
    }

    if (!nextStateNodes.length) {
      return {
        transitions: [selectedTransition],
        exitSet: [],
        configuration: state.value ? [this] : [],
        source: state,
        actions: actions
      };
    }

    var allNextStateNodes = flatten(nextStateNodes.map(function (stateNode) {
      return _this.getRelativeStateNodes(stateNode, state.historyValue);
    }));
    var isInternal = !!selectedTransition.internal;
    return {
      transitions: [selectedTransition],
      exitSet: isInternal ? [] : flatten(nextStateNodes.map(function (targetNode) {
        return _this.getPotentiallyReenteringNodes(targetNode);
      })),
      configuration: allNextStateNodes,
      source: state,
      actions: actions
    };
  }; // even though the name of this function mentions reentry nodes
  // we are pushing its result into `exitSet`
  // that's because what we exit might be reentered (it's an invariant of reentrancy)


  StateNode.prototype.getPotentiallyReenteringNodes = function (targetNode) {
    if (this.order < targetNode.order) {
      return [this];
    }

    var nodes = [];
    var marker = this;
    var possibleAncestor = targetNode;

    while (marker && marker !== possibleAncestor) {
      nodes.push(marker);
      marker = marker.parent;
    }

    if (marker !== possibleAncestor) {
      // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
      // it's in a different part of the tree so no states will be reentered for such an external transition
      return [];
    }

    nodes.push(possibleAncestor);
    return nodes;
  };

  StateNode.prototype.getActions = function (resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
    var e_4, _a, e_5, _b;

    var _this = this;

    var prevConfig = prevState ? getConfiguration([], this.getStateNodes(prevState.value)) : [];
    var entrySet = new Set();

    try {
      for (var _c = __values(Array.from(resolvedConfig).sort(function (a, b) {
        return a.order - b.order;
      })), _d = _c.next(); !_d.done; _d = _c.next()) {
        var sn = _d.value;

        if (!has(prevConfig, sn) || has(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) {
          entrySet.add(sn);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    try {
      for (var prevConfig_1 = __values(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()) {
        var sn = prevConfig_1_1.value;

        if (!has(resolvedConfig, sn) || has(transition.exitSet, sn.parent)) {
          transition.exitSet.push(sn);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
      } finally {
        if (e_5) throw e_5.error;
      }
    }

    transition.exitSet.sort(function (a, b) {
      return b.order - a.order;
    });
    var entryStates = Array.from(entrySet).sort(function (a, b) {
      return a.order - b.order;
    });
    var exitStates = new Set(transition.exitSet);
    var doneEvents = flatten(entryStates.map(function (sn) {
      var events = [];

      if (sn.type !== 'final') {
        return events;
      }

      var parent = sn.parent;

      if (!parent.parent) {
        return events;
      }

      events.push(done(sn.id, sn.doneData), // TODO: deprecate - final states should not emit done events for their own state.
      done(parent.id, sn.doneData ? mapContext(sn.doneData, currentContext, _event) : undefined));
      var grandparent = parent.parent;

      if (grandparent.type === 'parallel') {
        if (getChildren(grandparent).every(function (parentNode) {
          return isInFinalState(transition.configuration, parentNode);
        })) {
          events.push(done(grandparent.id));
        }
      }

      return events;
    }));
    var entryActions = entryStates.map(function (stateNode) {
      var entryActions = stateNode.onEntry;
      var invokeActions = stateNode.activities.map(function (activity) {
        return start(activity);
      });
      return {
        type: 'entry',
        actions: toActionObjects(predictableExec ? __spreadArray(__spreadArray([], __read$2(entryActions), false), __read$2(invokeActions), false) : __spreadArray(__spreadArray([], __read$2(invokeActions), false), __read$2(entryActions), false), _this.machine.options.actions)
      };
    }).concat({
      type: 'state_done',
      actions: doneEvents.map(function (event) {
        return raise(event);
      })
    });
    var exitActions = Array.from(exitStates).map(function (stateNode) {
      return {
        type: 'exit',
        actions: toActionObjects(__spreadArray(__spreadArray([], __read$2(stateNode.onExit), false), __read$2(stateNode.activities.map(function (activity) {
          return stop(activity);
        })), false), _this.machine.options.actions)
      };
    });
    var actions = exitActions.concat({
      type: 'transition',
      actions: toActionObjects(transition.actions, this.machine.options.actions)
    }).concat(entryActions);

    if (isDone) {
      var stopActions = toActionObjects(flatten(__spreadArray([], __read$2(resolvedConfig), false).sort(function (a, b) {
        return b.order - a.order;
      }).map(function (stateNode) {
        return stateNode.onExit;
      })), this.machine.options.actions).filter(function (action) {
        return !isRaisableAction(action);
      });
      return actions.concat({
        type: 'stop',
        actions: stopActions
      });
    }

    return actions;
  };
  /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */


  StateNode.prototype.transition = function (state, event, context, exec) {
    if (state === void 0) {
      state = this.initialState;
    }

    var _event = toSCXMLEvent(event);

    var currentState;

    if (state instanceof State) {
      currentState = context === undefined ? state : this.resolveState(State.from(state, context));
    } else {
      var resolvedStateValue = isString(state) ? this.resolve(pathToStateValue(this.getResolvedPath(state))) : this.resolve(state);
      var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
      currentState = this.resolveState(State.from(resolvedStateValue, resolvedContext));
    }

    if (!IS_PRODUCTION && _event.name === WILDCARD) {
      throw new Error("An event cannot have the wildcard type ('".concat(WILDCARD, "')"));
    }

    if (this.strict) {
      if (!this.events.includes(_event.name) && !isBuiltInEvent(_event.name)) {
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
      }
    }

    var stateTransition = this._transition(currentState.value, currentState, _event) || {
      transitions: [],
      configuration: [],
      exitSet: [],
      source: currentState,
      actions: []
    };
    var prevConfig = getConfiguration([], this.getStateNodes(currentState.value));
    var resolvedConfig = stateTransition.configuration.length ? getConfiguration(prevConfig, stateTransition.configuration) : prevConfig;
    stateTransition.configuration = __spreadArray([], __read$2(resolvedConfig), false);
    return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
  };

  StateNode.prototype.resolveRaisedTransition = function (state, _event, originalEvent, predictableExec) {
    var _a;

    var currentActions = state.actions;
    state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
    // TODO: this should be the raised event! Delete in V5 (breaking)

    state._event = originalEvent;
    state.event = originalEvent.data;

    (_a = state.actions).unshift.apply(_a, __spreadArray([], __read$2(currentActions), false));

    return state;
  };

  StateNode.prototype.resolveTransition = function (stateTransition, currentState, context, predictableExec, _event) {
    var e_6, _a, e_7, _b;

    var _this = this;

    if (_event === void 0) {
      _event = initEvent;
    }

    var configuration = stateTransition.configuration; // Transition will "apply" if:
    // - this is the initial state (there is no current state)
    // - OR there are transitions

    var willTransition = !currentState || stateTransition.transitions.length > 0;
    var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
    var isDone = isInFinalState(resolvedConfiguration, this);
    var resolvedStateValue = willTransition ? getValue(this.machine, configuration) : undefined;
    var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
    var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
    var activities = currentState ? __assign$1({}, currentState.activities) : {};

    try {
      for (var actionBlocks_1 = __values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
        var block = actionBlocks_1_1.value;

        try {
          for (var _c = (e_7 = void 0, __values(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var action = _d.value;

            if (action.type === start$1) {
              activities[action.activity.id || action.activity.type] = action;
            } else if (action.type === stop$1) {
              activities[action.activity.id || action.activity.type] = false;
            }
          }
        } catch (e_7_1) {
          e_7 = {
            error: e_7_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
          } finally {
            if (e_7) throw e_7.error;
          }
        }
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    var _e = __read$2(resolveActions(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2),
        resolvedActions = _e[0],
        updatedContext = _e[1];

    var _f = __read$2(partition(resolvedActions, isRaisableAction), 2),
        raisedEvents = _f[0],
        nonRaisedActions = _f[1];

    var invokeActions = resolvedActions.filter(function (action) {
      var _a;

      return action.type === start$1 && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === invoke;
    });
    var children = invokeActions.reduce(function (acc, action) {
      acc[action.activity.id] = createInvocableActor(action.activity, _this.machine, updatedContext, _event);
      return acc;
    }, currentState ? __assign$1({}, currentState.children) : {});
    var nextState = new State({
      value: resolvedStateValue || currentState.value,
      context: updatedContext,
      _event: _event,
      // Persist _sessionid between states
      _sessionid: currentState ? currentState._sessionid : null,
      historyValue: resolvedStateValue ? historyValue ? updateHistoryValue(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
      history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
      actions: resolvedStateValue ? nonRaisedActions : [],
      activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
      events: [],
      configuration: resolvedConfiguration,
      transitions: stateTransition.transitions,
      children: children,
      done: isDone,
      tags: getTagsFromConfiguration(resolvedConfiguration),
      machine: this
    });
    var didUpdateContext = context !== updatedContext;
    nextState.changed = _event.name === update || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks

    var history = nextState.history;

    if (history) {
      delete history.history;
    } // There are transient transitions if the machine is not in a final state
    // and if some of the state nodes have transient ("always") transitions.


    var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function (stateNode) {
      return stateNode._transient;
    })); // If there are no enabled transitions, check if there are transient transitions.
    // If there are transient transitions, continue checking for more transitions
    // because an transient transition should be triggered even if there are no
    // enabled transitions.
    //
    // If we're already working on an transient transition then stop to prevent an infinite loop.
    //
    // Otherwise, if there are no enabled nor transient transitions, we are done.

    if (!willTransition && (!hasAlwaysTransitions || _event.name === NULL_EVENT)) {
      return nextState;
    }

    var maybeNextState = nextState;

    if (!isDone) {
      if (hasAlwaysTransitions) {
        maybeNextState = this.resolveRaisedTransition(maybeNextState, {
          type: nullEvent
        }, _event, predictableExec);
      }

      while (raisedEvents.length) {
        var raisedEvent = raisedEvents.shift();
        maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
      }
    } // Detect if state changed


    var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !stateValuesEqual(maybeNextState.value, history.value) : undefined);
    maybeNextState.changed = changed; // Preserve original history after raised events

    maybeNextState.history = history;
    return maybeNextState;
  };
  /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */


  StateNode.prototype.getStateNode = function (stateKey) {
    if (isStateId(stateKey)) {
      return this.machine.getStateNodeById(stateKey);
    }

    if (!this.states) {
      throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
    }

    var result = this.states[stateKey];

    if (!result) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }

    return result;
  };
  /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */


  StateNode.prototype.getStateNodeById = function (stateId) {
    var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;

    if (resolvedStateId === this.id) {
      return this;
    }

    var stateNode = this.machine.idMap[resolvedStateId];

    if (!stateNode) {
      throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
    }

    return stateNode;
  };
  /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */


  StateNode.prototype.getStateNodeByPath = function (statePath) {
    if (typeof statePath === 'string' && isStateId(statePath)) {
      try {
        return this.getStateNodeById(statePath.slice(1));
      } catch (e) {// try individual paths
        // throw e;
      }
    }

    var arrayStatePath = toStatePath(statePath, this.delimiter).slice();
    var currentStateNode = this;

    while (arrayStatePath.length) {
      var key = arrayStatePath.shift();

      if (!key.length) {
        break;
      }

      currentStateNode = currentStateNode.getStateNode(key);
    }

    return currentStateNode;
  };
  /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */


  StateNode.prototype.resolve = function (stateValue) {
    var _a;

    var _this = this;

    if (!stateValue) {
      return this.initialStateValue || EMPTY_OBJECT; // TODO: type-specific properties
    }

    switch (this.type) {
      case 'parallel':
        return mapValues(this.initialStateValue, function (subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
        });

      case 'compound':
        if (isString(stateValue)) {
          var subStateNode = this.getStateNode(stateValue);

          if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') {
            return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
          }

          return stateValue;
        }

        if (!Object.keys(stateValue).length) {
          return this.initialStateValue || {};
        }

        return mapValues(stateValue, function (subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
        });

      default:
        return stateValue || EMPTY_OBJECT;
    }
  };

  StateNode.prototype.getResolvedPath = function (stateIdentifier) {
    if (isStateId(stateIdentifier)) {
      var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];

      if (!stateNode) {
        throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
      }

      return stateNode.path;
    }

    return toStatePath(stateIdentifier, this.delimiter);
  };

  Object.defineProperty(StateNode.prototype, "initialStateValue", {
    get: function () {
      var _a;

      if (this.__cache.initialStateValue) {
        return this.__cache.initialStateValue;
      }

      var initialStateValue;

      if (this.type === 'parallel') {
        initialStateValue = mapFilterValues(this.states, function (state) {
          return state.initialStateValue || EMPTY_OBJECT;
        }, function (stateNode) {
          return !(stateNode.type === 'history');
        });
      } else if (this.initial !== undefined) {
        if (!this.states[this.initial]) {
          throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
        }

        initialStateValue = isLeafNode(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
      } else {
        // The finite state value of a machine without child states is just an empty object
        initialStateValue = {};
      }

      this.__cache.initialStateValue = initialStateValue;
      return this.__cache.initialStateValue;
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.getInitialState = function (stateValue, context) {
    this._init(); // TODO: this should be in the constructor (see note in constructor)


    var configuration = this.getStateNodes(stateValue);
    return this.resolveTransition({
      configuration: configuration,
      exitSet: [],
      transitions: [],
      source: undefined,
      actions: []
    }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
  };

  Object.defineProperty(StateNode.prototype, "initialState", {
    /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */
    get: function () {
      var initialStateValue = this.initialStateValue;

      if (!initialStateValue) {
        throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
      }

      return this.getInitialState(initialStateValue);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "target", {
    /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */
    get: function () {
      var target;

      if (this.type === 'history') {
        var historyConfig = this.config;

        if (isString(historyConfig.target)) {
          target = isStateId(historyConfig.target) ? pathToStateValue(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
        } else {
          target = historyConfig.target;
        }
      }

      return target;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */

  StateNode.prototype.getRelativeStateNodes = function (relativeStateId, historyValue, resolve) {
    if (resolve === void 0) {
      resolve = true;
    }

    return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [relativeStateId];
  };

  Object.defineProperty(StateNode.prototype, "initialStateNodes", {
    get: function () {
      var _this = this;

      if (isLeafNode(this)) {
        return [this];
      } // Case when state node is compound but no initial state is defined


      if (this.type === 'compound' && !this.initial) {
        if (!IS_PRODUCTION) {
          warn(false, "Compound state node '".concat(this.id, "' has no initial state."));
        }

        return [this];
      }

      var initialStateNodePaths = toStatePaths(this.initialStateValue);
      return flatten(initialStateNodePaths.map(function (initialPath) {
        return _this.getFromRelativePath(initialPath);
      }));
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */

  StateNode.prototype.getFromRelativePath = function (relativePath) {
    if (!relativePath.length) {
      return [this];
    }

    var _a = __read$2(relativePath),
        stateKey = _a[0],
        childStatePath = _a.slice(1);

    if (!this.states) {
      throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
    }

    var childStateNode = this.getStateNode(stateKey);

    if (childStateNode.type === 'history') {
      return childStateNode.resolveHistory();
    }

    if (!this.states[stateKey]) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }

    return this.states[stateKey].getFromRelativePath(childStatePath);
  };

  StateNode.prototype.historyValue = function (relativeStateValue) {
    if (!Object.keys(this.states).length) {
      return undefined;
    }

    return {
      current: relativeStateValue || this.initialStateValue,
      states: mapFilterValues(this.states, function (stateNode, key) {
        if (!relativeStateValue) {
          return stateNode.historyValue();
        }

        var subStateValue = isString(relativeStateValue) ? undefined : relativeStateValue[key];
        return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
      }, function (stateNode) {
        return !stateNode.history;
      })
    };
  };
  /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */


  StateNode.prototype.resolveHistory = function (historyValue) {
    var _this = this;

    if (this.type !== 'history') {
      return [this];
    }

    var parent = this.parent;

    if (!historyValue) {
      var historyTarget = this.target;
      return historyTarget ? flatten(toStatePaths(historyTarget).map(function (relativeChildPath) {
        return parent.getFromRelativePath(relativeChildPath);
      })) : parent.initialStateNodes;
    }

    var subHistoryValue = nestedPath(parent.path, 'states')(historyValue).current;

    if (isString(subHistoryValue)) {
      return [parent.getStateNode(subHistoryValue)];
    }

    return flatten(toStatePaths(subHistoryValue).map(function (subStatePath) {
      return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [parent.states[subStatePath[0]]];
    }));
  };

  Object.defineProperty(StateNode.prototype, "stateIds", {
    /**
     * All the state node IDs of this state node and its descendant state nodes.
     */
    get: function () {
      var _this = this;

      var childStateIds = flatten(Object.keys(this.states).map(function (stateKey) {
        return _this.states[stateKey].stateIds;
      }));
      return [this.id].concat(childStateIds);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "events", {
    /**
     * All the event types accepted by this state node and its descendants.
     */
    get: function () {
      var e_8, _a, e_9, _b;

      if (this.__cache.events) {
        return this.__cache.events;
      }

      var states = this.states;
      var events = new Set(this.ownEvents);

      if (states) {
        try {
          for (var _c = __values(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var stateId = _d.value;
            var state = states[stateId];

            if (state.states) {
              try {
                for (var _e = (e_9 = void 0, __values(state.events)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  var event_1 = _f.value;
                  events.add("".concat(event_1));
                }
              } catch (e_9_1) {
                e_9 = {
                  error: e_9_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally {
                  if (e_9) throw e_9.error;
                }
              }
            }
          }
        } catch (e_8_1) {
          e_8 = {
            error: e_8_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_8) throw e_8.error;
          }
        }
      }

      return this.__cache.events = Array.from(events);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "ownEvents", {
    /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */
    get: function () {
      var events = new Set(this.transitions.filter(function (transition) {
        return !(!transition.target && !transition.actions.length && transition.internal);
      }).map(function (transition) {
        return transition.eventType;
      }));
      return Array.from(events);
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.resolveTarget = function (_target) {
    var _this = this;

    if (_target === undefined) {
      // an undefined target signals that the state node should not transition from that state when receiving that event
      return undefined;
    }

    return _target.map(function (target) {
      if (!isString(target)) {
        return target;
      }

      var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
      // do not include machine key on target

      if (isInternalTarget && !_this.parent) {
        return _this.getStateNodeByPath(target.slice(1));
      }

      var resolvedTarget = isInternalTarget ? _this.key + target : target;

      if (_this.parent) {
        try {
          var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);

          return targetStateNode;
        } catch (err) {
          throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
        }
      } else {
        return _this.getStateNodeByPath(resolvedTarget);
      }
    });
  };

  StateNode.prototype.formatTransition = function (transitionConfig) {
    var _this = this;

    var normalizedTarget = normalizeTarget(transitionConfig.target);
    var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function (_target) {
      return isString(_target) && _target[0] === _this.delimiter;
    }) : true;
    var guards = this.machine.options.guards;
    var target = this.resolveTarget(normalizedTarget);

    var transition = __assign$1(__assign$1({}, transitionConfig), {
      actions: toActionObjects(toArray(transitionConfig.actions)),
      cond: toGuard(transitionConfig.cond, guards),
      target: target,
      source: this,
      internal: internal,
      eventType: transitionConfig.event,
      toJSON: function () {
        return __assign$1(__assign$1({}, transition), {
          target: transition.target ? transition.target.map(function (t) {
            return "#".concat(t.id);
          }) : undefined,
          source: "#".concat(_this.id)
        });
      }
    });

    return transition;
  };

  StateNode.prototype.formatTransitions = function () {
    var e_10, _a;

    var _this = this;

    var onConfig;

    if (!this.config.on) {
      onConfig = [];
    } else if (Array.isArray(this.config.on)) {
      onConfig = this.config.on;
    } else {
      var _b = this.config.on,
          _c = WILDCARD,
          _d = _b[_c],
          wildcardConfigs = _d === void 0 ? [] : _d,
          strictTransitionConfigs_1 = __rest$1(_b, [typeof _c === "symbol" ? _c : _c + ""]);

      onConfig = flatten(Object.keys(strictTransitionConfigs_1).map(function (key) {
        if (!IS_PRODUCTION && key === NULL_EVENT) {
          warn(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + "Please check the `on` configuration for \"#".concat(_this.id, "\"."));
        }

        var transitionConfigArray = toTransitionConfigArray(key, strictTransitionConfigs_1[key]);

        if (!IS_PRODUCTION) {
          validateArrayifiedTransitions(_this, key, transitionConfigArray);
        }

        return transitionConfigArray;
      }).concat(toTransitionConfigArray(WILDCARD, wildcardConfigs)));
    }

    var eventlessConfig = this.config.always ? toTransitionConfigArray('', this.config.always) : [];
    var doneConfig = this.config.onDone ? toTransitionConfigArray(String(done(this.id)), this.config.onDone) : [];

    if (!IS_PRODUCTION) {
      warn(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"".concat(this.id, "\"."));
    }

    var invokeConfig = flatten(this.invoke.map(function (invokeDef) {
      var settleTransitions = [];

      if (invokeDef.onDone) {
        settleTransitions.push.apply(settleTransitions, __spreadArray([], __read$2(toTransitionConfigArray(String(doneInvoke(invokeDef.id)), invokeDef.onDone)), false));
      }

      if (invokeDef.onError) {
        settleTransitions.push.apply(settleTransitions, __spreadArray([], __read$2(toTransitionConfigArray(String(error(invokeDef.id)), invokeDef.onError)), false));
      }

      return settleTransitions;
    }));
    var delayedTransitions = this.after;
    var formattedTransitions = flatten(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read$2(doneConfig), false), __read$2(invokeConfig), false), __read$2(onConfig), false), __read$2(eventlessConfig), false).map(function (transitionConfig) {
      return toArray(transitionConfig).map(function (transition) {
        return _this.formatTransition(transition);
      });
    }));

    try {
      for (var delayedTransitions_1 = __values(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()) {
        var delayedTransition = delayedTransitions_1_1.value;
        formattedTransitions.push(delayedTransition);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
      } finally {
        if (e_10) throw e_10.error;
      }
    }

    return formattedTransitions;
  };

  return StateNode;
}();

var warned = false;
function createMachine(config, options) {
  if (!IS_PRODUCTION && !('predictableActionArguments' in config) && !warned) {
    warned = true;
    console.warn('It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html');
  }

  return new StateNode(config, options);
}

var assign = assign$1;

var index =  useLayoutEffect ;

function useConstant(fn) {
    var ref = React$1.useRef();
    if (!ref.current) {
        ref.current = { v: fn() };
    }
    return ref.current.v;
}

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$1 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function useIdleInterpreter(getMachine, options) {
    var machine = useConstant(function () {
        return typeof getMachine === 'function' ? getMachine() : getMachine;
    });
    if (process.env.NODE_ENV !== 'production' &&
        typeof getMachine !== 'function') {
        var _a = __read$1(useState(machine), 1), initialMachine = _a[0];
        if (getMachine !== initialMachine) {
            console.warn('Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\n' +
                'Please make sure that you pass the same Machine as argument each time.');
        }
    }
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays; options.state; var interpreterOptions = __rest(options, ["context", "guards", "actions", "activities", "services", "delays", "state"]);
    var service = useConstant(function () {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function () { return (__assign(__assign({}, machine.context), context)); });
        return interpret(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    index(function () {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [actions, guards, activities, services, delays]);
    return service;
}

(undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
(undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function isInterpreterStateEqual(service, prevState, nextState) {
    if (service.status === InterpreterStatus.NotStarted) {
        return true;
    }
    // Only change the current state if:
    // - the incoming state is the "live" initial state (since it might have new actors)
    // - OR the incoming state actually changed.
    //
    // The "live" initial state will have .changed === undefined.
    var initialStateChanged = nextState.changed === undefined &&
        (Object.keys(nextState.children).length > 0 ||
            typeof prevState.changed === 'boolean');
    return !(nextState.changed || initialStateChanged);
}

var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function identity(a) {
    return a;
}
function useMachine(getMachine) {
    var _a = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        _a[_i - 1] = arguments[_i];
    }
    var _b = __read(_a, 1), _c = _b[0], options = _c === void 0 ? {} : _c;
    // using `useIdleInterpreter` allows us to subscribe to the service *before* we start it
    // so we don't miss any notifications
    var service = useIdleInterpreter(getMachine, options);
    var getSnapshot = useCallback(function () {
        if (service.status === InterpreterStatus.NotStarted) {
            return (options.state
                ? State.create(options.state)
                : service.machine.initialState);
        }
        return service.getSnapshot();
    }, [service]);
    var isEqual = useCallback(function (prevState, nextState) {
        return isInterpreterStateEqual(service, prevState, nextState);
    }, [service]);
    var subscribe = useCallback(function (handleStoreChange) {
        var unsubscribe = service.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [service]);
    var storeSnapshot = withSelector.exports.useSyncExternalStoreWithSelector(subscribe, getSnapshot, getSnapshot, identity, isEqual);
    useEffect(function () {
        var rehydratedState = options.state;
        service.start(rehydratedState ? State.create(rehydratedState) : undefined);
        return function () {
            service.stop();
            service.status = InterpreterStatus.NotStarted;
        };
    }, []);
    return [storeSnapshot, service.send, service];
}

var scanViewStateMachine = createMachine({
    id: "scanStatus",
    initial: "cameraLoading",
    context: {
        card_id: "",
        scan_id: "",
        autoScan: true,
        scannerRunning: false,
        backSideSupport: false,
        headerTitle: "Hold Card in Frame\nIt Will Scan Automatically",
        messageState: {},
        toggledAutoManual: false,
        processing: false,
        httpCode: 0,
        httpMessage: "",
    },
    states: {
        cameraLoading: {
            on: {
                CAMERA_LOADED: {
                    target: "autoCapture",
                    actions: [
                        assign({
                            scannerRunning: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                ERROR: {
                    target: "error",
                    actions: [
                        assign({
                            scannerRunning: true,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                        "updateHeaderTitle",
                    ],
                },
                CAMERAERROR: {
                    target: "cameraError",
                    actions: [
                        assign({
                            scannerRunning: true,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
        },
        autoCapture: {
            on: {
                "card.frontside_processing": {
                    target: "frontsideProcessing",
                    actions: [
                        assign({
                            card_id: function (context, event) { return event.card_id; },
                            scan_id: function (context, event) { return event.scan_id; },
                            backSideSupport: function (context, event) {
                                return event.backSideSupport ? event.backSideSupport : false;
                            },
                            processing: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                TOGGLE: {
                    target: "manualCapture",
                    actions: [
                        assign({
                            autoScan: false,
                            scannerRunning: false,
                            toggledAutoManual: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                ERROR: {
                    target: "error",
                    actions: [
                        assign({
                            scannerRunning: true,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
        },
        manualCapture: {
            on: {
                "card.frontside_processing": {
                    target: "frontsideProcessing",
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                MANUAL_BUTTON_CLICK: {
                    target: "frontsideProcessing",
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                TOGGLE: {
                    target: "autoCapture",
                    actions: [
                        assign({
                            autoScan: true,
                            scannerRunning: true,
                            toggledAutoManual: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                ERROR: {
                    target: "error",
                    actions: [
                        assign({
                            scannerRunning: true,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
        },
        frontsideProcessing: {
            on: {
                //when frontside only
                "card.completed": [
                    {
                        target: "completed",
                        actions: [
                            assign({
                                scannerRunning: false,
                            }),
                            "updateHeaderTitle",
                        ],
                    },
                ],
                //when backside supported
                "card.backside_processing": [
                    {
                        target: "backsidePending",
                        actions: [
                            assign({
                                scannerRunning: false,
                                processing: false,
                            }),
                            "updateHeaderTitle",
                        ],
                    },
                ],
                "card.frontside_failed": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                ERROR: {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
        },
        backsidePending: {
            on: {
                ERROR: {
                    target: "error",
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: false,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "card.backside_failed": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                TOGGLE: [
                    {
                        //when toggled from manual to auto scan, transition immediately
                        target: "backsideProcessing",
                        cond: function (ctx) { return !ctx.autoScan; },
                        actions: [
                            assign({
                                scannerRunning: true,
                                processing: true,
                                autoScan: true,
                                toggledAutoManual: true,
                            }),
                            "updateHeaderTitle",
                        ],
                    },
                    {
                        //when toggled from auto to manual scan, disable runner and await manual button click
                        cond: function (ctx) { return ctx.autoScan; },
                        actions: [
                            assign({
                                scannerRunning: false,
                                processing: false,
                                autoScan: false,
                                toggledAutoManual: true,
                            }),
                            "updateHeaderTitle",
                        ],
                    },
                ],
                MANUAL_BUTTON_CLICK: {
                    target: "backsideProcessing",
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
            after: {
                // after 5 seconds, transition to backsideProcessing
                5000: {
                    target: "backsideProcessing",
                    cond: function (ctx) { return ctx.autoScan; },
                    actions: [
                        assign({
                            autoScan: true,
                            scannerRunning: true,
                        }),
                    ],
                },
            },
        },
        backsideProcessing: {
            on: {
                MANUAL_BUTTON_CLICK: {
                    actions: [
                        assign({
                            scannerRunning: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "scan.processing": {
                    actions: [
                        assign({
                            scannerRunning: true,
                            processing: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "card.completed": {
                    target: "completed",
                    actions: [
                        assign({
                            scannerRunning: false, //replaces on cleanUp
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "card.backside_failed": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                "card.error": {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
                ERROR: {
                    target: "retry",
                    actions: [
                        assign({
                            scannerRunning: false,
                            httpCode: function (context, event) { return event.httpCode; },
                            httpMessage: function (context, event) { return event.httpMessage; },
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
        },
        retry: {
            on: {
                retry_scan: {
                    target: "autoCapture",
                    actions: [
                        assign({
                            scannerRunning: true,
                            autoScan: true,
                            processing: false,
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
        },
        completed: {
            type: "final",
        },
        error: {
            //type: "final",
            on: {
                "card.completed": {
                    target: "completed",
                    actions: [
                        assign({
                            scannerRunning: false,
                            processing: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
        },
        cameraError: {
            //type: "final",
            on: {
                "card.completed": {
                    target: "completed",
                    actions: [
                        assign({
                            scannerRunning: false,
                            processing: true,
                        }),
                        "updateHeaderTitle",
                    ],
                },
            },
        },
    },
}, {
    actions: {
        log: function (context, event, meta) {
            console.log("backSideSupport: " + context.backSideSupport);
        },
        updateHeaderTitle: function (context, event, meta) {
            context.headerTitle = getHeaderTitle(String(meta.state.value), context.messageState, context.autoScan);
        },
    },
});

var _handleError = function (error, stateMachineSend, onError, stateMachineState) {
    console.error(error);
    if (error.isAxiosError === true && error.response) {
        stateMachineSend("ERROR", {
            httpCode: error.response.status,
            httpMessage: error.message,
        });
        var err = generateError(error.message, "ResponseError", error.response.status);
        if (onError) {
            onError(err);
        }
        console.debug(err);
    }
    else if (error.isAxiosError === true && error.request) {
        stateMachineSend("ERROR", {
            httpCode: error.request.status,
            httpMessage: error.message,
        });
        var err = generateError(error.message, "RequestError", error.request.status);
        if (onError) {
            onError(err);
        }
        console.debug(err);
    }
    else if (error.isCardScanError == true) {
        var err = error;
        //avoid calling onError on 403 here
        //because it is already handled in AxiosError
        //so we don't get onError being called twice
        //when websocket fails on 403
        if (stateMachineState.context.httpCode == 403) {
            err = generateError(stateMachineState.context.httpMessage, "RequestError", stateMachineState.context.httpCode);
            stateMachineSend("ERROR", {
                httpCode: stateMachineState.context.httpCode,
                httpMessage: stateMachineState.context.httpMessage,
            });
        }
        else {
            stateMachineSend("ERROR");
            if (onError) {
                onError(err);
            }
        }
    }
    else {
        var err = generateError(error.message, "UnknownError", 606);
        if (onError) {
            onError(err);
        }
        //don't change UI Status as we don't know if this error is fatal or not.
    }
};

var generateImageFromCanvas = function (videoRefBg, frameDivRef, captureCanvasRef, debug) {
    var _a = calculateGuides(videoRefBg, frameDivRef, debug), guideX = _a[0], guideY = _a[1], guideWidth = _a[2], guideHeight = _a[3];
    var captureCanvas = captureCanvasRef.current;
    var video = videoRefBg.current;
    if (!captureCanvas || !video) {
        return;
    }
    //resize image to canvas sizes
    var ctx = captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.getContext("2d", { alpha: false });
    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, guideX, guideY, guideWidth, guideHeight, 0, 0, captureCanvas.width, captureCanvas.height);
    //The captureCanvas drawImage use a large amount of GPU memory and isn't getting properly garbage collected inside of the loop.
    //To fix this we convert the captured image to a jpeg string, which is stored in RAM.
    //We then clear the canvas context to clear up GPU memory when possible.
    var jpegUrl = captureCanvas.toDataURL("image/jpeg", 0.85);
    ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, captureCanvas.width, captureCanvas.height);
    return jpegUrl;
};
var generateImageMetadata = function (capture, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, debug) {
    var video = videoRefBg.current;
    var captureCanvas = captureCanvasRef.current;
    var _a = calculateGuides(videoRefBg, frameDivRef, debug), guideX = _a[0], guideY = _a[1], guideWidth = _a[2], guideHeight = _a[3];
    var metadata = { captureType: capture };
    metadata["guides"] = {
        x: guideX,
        y: guideY,
        width: guideWidth,
        height: guideHeight,
    };
    metadata["captureCanvas"] = {
        width: captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.width,
        height: captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.height,
    };
    metadata["videoBackground"] = {
        width: video === null || video === void 0 ? void 0 : video.videoWidth,
        height: video === null || video === void 0 ? void 0 : video.videoHeight,
    };
    metadata["windowInner"] = {
        width: window.innerWidth,
        height: window.innerHeight,
    };
    if (capture == "automatic" /* CaptureType.automatic */) {
        metadata["mlThreshold"] = threshold;
        metadata["laplacianThreshold"] = laplacianThreshold;
    }
    metadata["package_name"] = "insurance-cardscan-react";
    metadata["package_version"] = cardScanPackageVersion;
    metadata = Object.assign({}, metadata, videoMetadata);
    return metadata;
};

//Main scan processing handler for scans -- called every ~250ms when active.
//Handles: auto & manual scan
//---------------------------------------
// Hot Path
//---------------------------------------
var scanHandler = function (videoRefBg, frameDivRef, captureCanvasRef, detectionCanvasRef, debugCanvasLatestRef, setLatestScore, setLatestLaplacian, setBestScore, setModelState, setScanDebugState, setScanProgress, scanCaptureBuffer, threshold, laplacianThreshold, onError, scanProgress, softMaxUploads, bufferSize, videoMetadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, debug) {
    var _a;
    var video = videoRefBg.current;
    if (!video || stateMachineState.matches("cameraLoading")) {
        console.log("scanHandler -- no video found");
        return;
    }
    var detectionCanvas = detectionCanvasRef.current;
    var captureCanvas = captureCanvasRef.current;
    var _b = calculateGuides(videoRefBg, frameDivRef, debug), guideX = _b[0], guideY = _b[1], guideWidth = _b[2], guideHeight = _b[3];
    if (debug) {
        console.debug("Canvas: ".concat(captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.width, ", ").concat(captureCanvas === null || captureCanvas === void 0 ? void 0 : captureCanvas.height));
        console.debug("Video: ".concat(video.videoWidth, ", ").concat(video.videoHeight));
    }
    if (!(detectionCanvas && captureCanvas)) {
        console.error("CardScan: no canvas found - critical failure");
        return;
    }
    //resize image to canvas sizes
    (_a = detectionCanvas
        .getContext("2d")) === null || _a === void 0 ? void 0 : _a.drawImage(video, guideX, guideY, guideWidth, guideHeight, 0, 0, detectionCanvas.width, detectionCanvas.height);
    var jpegUrl;
    //work around for iOS GPU memory issue.
    //TODO: check we still need this and remove if not. might have been fixed by useInterval
    if (!isIOS_1) {
        jpegUrl = generateImageFromCanvas(videoRefBg, frameDivRef, captureCanvasRef, debug);
    }
    detectCard(videoRefBg, frameDivRef, captureCanvasRef, detectionCanvas, debugCanvasLatestRef, setLatestScore, setLatestLaplacian, setBestScore, setModelState, setScanDebugState, threshold, laplacianThreshold, onError, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoMetadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, jpegUrl, debug);
};
var detectCard = function (videoRefBg, frameDivRef, captureCanvasRef, detectionCanvas, debugCanvasLatestRef, setLatestScore, setLatestLaplacian, setBestScore, setModelState, setScanDebugState, threshold, laplacianThreshold, onError, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoMetadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, jpegUrl, debug) {
    DetectorWrapper
        .get()
        .predict_image(detectionCanvas)
        .then(function (ret) {
        if (ret === null) {
            console.debug("cardDetector race condition -- early exit");
            return;
        }
        if (debug) {
            setModelState(DetectorWrapper.get().modelState);
            setScanDebugState("active");
        }
        if (ret["modelClass"] === "card" &&
            ["autoCapture", "frontsideProcessing", "backsideProcessing"].some(stateMachineState.matches)) {
            var score = Number(ret["modelProbability"]);
            var laplacian = Number(ret["laplaceVariance"]);
            if (debug) {
                setLatestScore(score);
                setLatestLaplacian(laplacian);
                renderDebugCanvas(videoRefBg, frameDivRef, debugCanvasLatestRef, debug);
            }
            // Add quality images to the buffer...
            if (score > threshold && laplacian > laplacianThreshold) {
                if (debug) {
                    setBestScore(score);
                    renderDebugCanvas(videoRefBg, frameDivRef, debugCanvasLatestRef, debug);
                }
                //TODO: see if this is still an issue.
                if (jpegUrl === undefined) {
                    //lazy jpeg capture to workaround iOS GPU memory issue
                    //downside is that we capture the submitted image ~10-15ms after detection but should be Ok
                    var jpeg = generateImageFromCanvas(videoRefBg, frameDivRef, captureCanvasRef, debug);
                    addImageToBuffer(jpeg, score, laplacian, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, cardScanApi, cardIdRef, stateMachineState, onError, debug);
                }
                else {
                    addImageToBuffer(jpegUrl, score, laplacian, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, cardScanApi, cardIdRef, stateMachineState, onError, debug);
                }
            }
        }
    })
        .catch(function (error) {
        _handleError(error, stateMachineSend, onError);
    });
};
var addImageToBuffer = function (jpegUrl, score, laplacian, scanCaptureBuffer, scanProgress, setScanProgress, softMaxUploads, bufferSize, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, cardScanApi, cardIdRef, stateMachineState, onError, debug) {
    var file = dataURLtoFile(jpegUrl, "card.jpeg");
    scanCaptureBuffer.current.push({ file: file, score: score, laplacian: laplacian });
    var cardGuide = document.getElementsByClassName(scanFrameStyles.cardGuide)[0];
    //TODO: update progress UI -- a little slow to update, we could use the scanCapture buffer.
    if (debug) {
        console.log("CardScan: add image to buffer: ", scanProgress, new Date().toISOString());
    }
    setScanProgress(function (p) {
        if (p >= (softMaxUploads * bufferSize) / 2) {
            return p + 0.5;
        }
        else {
            return p + 1;
        }
    });
    var numScans = Math.min(Math.ceil(scanProgress), softMaxUploads * bufferSize);
    var cornerWidth = 62 +
        ((cardGuide.clientWidth - 124) / (softMaxUploads * bufferSize - 1)) *
            numScans;
    var cornerHeight = 62 +
        ((cardGuide.clientHeight - 124) / (softMaxUploads * bufferSize - 1)) *
            numScans;
    document.documentElement.style.setProperty("--cardscan-corner-height", "".concat(cornerHeight, "px"));
    document.documentElement.style.setProperty("--cardscan-corner-width", "".concat(cornerWidth, "px"));
    document.documentElement.style.setProperty("--cardscan-buffer-size", numScans.toString());
    if (scanCaptureBuffer.current.length === bufferSize) {
        //pull best / least blurry image from buffer
        var lapScores = scanCaptureBuffer.current.map(function (i) {
            return Number(i.laplacian);
        });
        var maxScore = Math.max.apply(null, lapScores);
        var index = lapScores.indexOf(maxScore);
        if (debug) {
            console.debug("Current Buffer: ", scanCaptureBuffer.current);
        }
        var bestImage = scanCaptureBuffer.current[index].file;
        if (debug) {
            console.debug("Upload Picked: ", bestImage);
        }
        //Note: metadata might have changed between capture and upload.
        var metadata = generateImageMetadata("automatic" /* CaptureType.automatic */, videoRefBg, frameDivRef, captureCanvasRef, threshold, laplacianThreshold, videoMetadata, debug);
        var scores = scanCaptureBuffer.current.map(function (i) { return ({
            score: i.score,
            laplacian: i.laplacian,
        }); });
        metadata["capture_score"] = { scores: scores, max_lapScore: maxScore };
        uploadFile(bestImage, "automatic" /* CaptureType.automatic */, metadata, cardScanApi, cardIdRef, stateMachineState, debug, onError, function () {
            if (debug) {
                console.debug("CardScan: upload complete: ", new Date().toISOString());
            }
        });
        //start capture buffer here so that we start the upload timer right away
        scanCaptureBuffer.current = [];
    }
};
var uploadFile = function (file, captureType, metadata, cardScanApi, cardIdRef, stateMachineState, debug, stateMachineSend, onError, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.uploadScanImage(file, cardIdRef.current, captureType, ["backsideProcessing", "backsidePending"].some(stateMachineState.matches)
            ? "back"
            : "front", metadata).then(function () {
            if (cb) {
                cb();
            }
            if (debug) {
                console.debug("Upload Success");
            }
        }).catch(function (error) {
            _handleError(error, stateMachineSend, onError);
        });
        return [2 /*return*/];
    });
}); };
//---------------------------------------
// Debug Menu
//---------------------------------------
//debug data to be passed in with every scan
var renderDebugCanvas = function (videoRefBg, frameDivRef, debugCanvasRef, debug) {
    var videoBg = videoRefBg.current;
    if (debug && debugCanvasRef && videoBg) {
        var _a = calculateGuides(videoRefBg, frameDivRef, debug), guideX = _a[0], guideY = _a[1], guideWidth = _a[2], guideHeight = _a[3];
        var dCanvas = debugCanvasRef.current;
        if (dCanvas) {
            var destCtx = dCanvas.getContext("2d", { alpha: false });
            destCtx === null || destCtx === void 0 ? void 0 : destCtx.drawImage(videoBg, guideX, guideY, guideWidth, guideHeight, 0, 0, dCanvas.width, dCanvas.height);
        }
    }
};

var resetCorners = function () {
    //reset corners before flipping
    document.documentElement.style.setProperty("--cardscan-corner-width", "62px");
    document.documentElement.style.setProperty("--cardscan-corner-height", "62px");
};

//---------------------------------------
// Exit and Cleanup
//---------------------------------------
var cleanUp = function (scanCaptureBuffer, setScanProgress, videoRefBg, cardScanApi) {
    //kill timer
    //setScannerRunning(false); on completed state
    var _a;
    //empty both detection buffer and clear progress UI
    scanCaptureBuffer.current = [];
    setScanProgress(0);
    //disable camera on exit
    if (videoRefBg && videoRefBg.current) {
        var videoBackground = videoRefBg.current;
        var stream = videoBackground.srcObject;
        if (stream) {
            var tracks = stream.getTracks();
            tracks.forEach(function (track) { return track.stop(); });
            videoBackground.srcObject = null;
        }
    }
    DetectorWrapper.cleanUp();
    if (cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) {
        (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket.close();
        cardScanApi.current = null;
    }
    resetCorners();
};

//---------------------------------------
// Websocket message handling
//---------------------------------------
var webSocketHandler = function (cardScanApi, cardIdRef, onError, debug, stateMachineState, stateMachineSend, backSideSupport) {
    var _a;
    if ((_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket) {
        cardScanApi.current.socket.onopen = function () {
            var _a;
            if (debug) {
                console.debug("CardScan: Socket Successfully Opened");
            }
            //register current card on socket creation -- check card_id length to avoid race condition.
            if (cardIdRef.current && cardIdRef.current.length > 0) {
                var payload = JSON.stringify({
                    card_id: cardIdRef.current,
                    action: "register",
                    source: "onopen",
                });
                (_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket.send(payload);
            }
        };
        cardScanApi.current.socket.onclose = function (event) {
            console.debug("CardScan: websocket closed", event);
            if (event.code == 1005 && event.wasClean) {
                console.debug("CardScan: websocket closed cleanly");
            }
            else if (event.code == 1000) {
                console.debug("CardScan: websocket closed cleanly");
            }
            else {
                var error = generateError("The connection was closed abnormally", "WSError", event.code);
                _handleError(error, stateMachineSend, onError, stateMachineState);
            }
        };
        cardScanApi.current.socket.onerror = function (event) {
            var error;
            if (stateMachineState.context.httpCode == 403) {
                error = generateError(stateMachineState.context.httpMessage, "WSError", 403);
            }
            else {
                error = generateError("Unknown error from websocket", "WSError", 642);
            }
            _handleError(error, stateMachineSend, onError, stateMachineState);
        };
        cardScanApi.current.socket.onmessage = function (event) {
            //early exit for keepalive
            if (event.data == "pong") {
                return;
            }
            var _type = "";
            try {
                var type = JSON.parse(event.data).type;
                _type = type;
            }
            catch (error) {
                console.log("CardScan: Unable to parse event received from websocket");
                console.debug(event);
            }
            if (_type == "card") {
                var _a = JSON.parse(event.data), state = _a.state, details = _a.details, error = _a.error, card_id = _a.card_id;
                var cardState = state;
                console.debug("Card Event Received: cardId: ".concat(card_id, " card_state:").concat(cardState, " - ui_status:").concat(stateMachineState.value, " - ").concat(new Date().toISOString()));
                if (debug && details) {
                    console.debug("CardScan: socket event received with", details);
                }
                stateMachineSend("card.".concat(cardState), { card_id: card_id, backSideSupport: backSideSupport });
            }
            else if (_type == "scan") {
                var _b = JSON.parse(event.data), state = _b.state, error = _b.error, scan_id = _b.scan_id, card_id = _b.card_id;
                var scanState = state;
                // If we receive a skipped card error,
                // and we are in an error state or cameraError state
                // and the card is in completed state
                // we need to transition to completed state
                // This is a workaround for when we use web-to-mobile handoff
                // and the user completes the scan on mobile
                // the desktop widget will receive the completed message
                if (error &&
                    error.error === "SkippedCard" &&
                    error.message ===
                        "Skipping scan for card received in completed state" &&
                    ["error", "cameraError"].some(stateMachineState.matches)) {
                    stateMachineSend("card.completed");
                }
                console.debug("Scan Event Received: scanId: ".concat(scan_id, " scan_state:").concat(scanState, " cardId: ").concat(card_id, " - ui_status:").concat(stateMachineState.value, " - ").concat(new Date().toISOString()));
                stateMachineSend("scan.".concat(scanState), { card_id: card_id, scan_id: scan_id });
            }
            else {
                console.log("CardScan: Unknown event received from websocket");
                console.debug(event);
            }
        };
    }
    else {
        var error = generateError("No websocket found - critical failure", "WSError", 640);
        _handleError(error, stateMachineSend, onError, stateMachineState);
    }
};

var css_248z$1 = ".scanview-module_cardscanMain__JjW3i{align-items:center;background-color:var(--cardscan-widget-background-color);box-sizing:border-box;display:flex;font-family:HK Grotesk Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;font-size:17px;height:-webkit-fill-available;height:var(--cardscan-app-height);justify-content:center;line-height:1.5;max-height:100%;max-width:100%;overflow:hidden;position:relative;width:var(--cardscan-app-width)}.scanview-module_cardscanVideoContainer__PK-Ea{position:relative}.scanview-module_cameraBtn__87nOC{cursor:pointer;left:50%;position:absolute;transform:translate(-50%,-12px);width:55px;z-index:3}.scanview-module_cameraBtn__87nOC.scanview-module_heightFrame__k92qj{bottom:40px;transform:translate(-50%)}.scanview-module_cameraBtn__87nOC:active{transform:translate(-49%,-11px)}.scanview-module_cameraBtn__87nOC:active.scanview-module_heightFrame__k92qj{transform:translate(-49%,1px)}.scanview-module_cardscanLogo__T3S98{box-sizing:border-box;left:4px;max-width:135px;position:absolute;top:0;transform:translateY(-100%);z-index:300}.scanview-module_cardscanLogoLandscape__LkARY{-webkit-filter:invert(100%);filter:invert(100%);max-width:90px}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$1 = {"cardscanMain":"scanview-module_cardscanMain__JjW3i","cardscanVideoContainer":"scanview-module_cardscanVideoContainer__PK-Ea","cameraBtn":"scanview-module_cameraBtn__87nOC","heightFrame":"scanview-module_heightFrame__k92qj","cardscanLogo":"scanview-module_cardscanLogo__T3S98","cardscanLogoLandscape":"scanview-module_cardscanLogoLandscape__LkARY"};
styleInject(css_248z$1);

var CardScanView = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var debug = _a.debug, live = _a.live, sessionToken = _a.sessionToken, onSuccess = _a.onSuccess, onCancel = _a.onCancel, onError = _a.onError, onRetry = _a.onRetry; _a.shouldRetry; var backsideSupport = _a.backsideSupport, requiredFields = _a.requiredFields, optionalFields = _a.optionalFields, eligibility = _a.eligibility, _h = _a.messages, messages = _h === void 0 ? {} : _h, closeButton = _a.closeButton, successIndicator = _a.successIndicator, errorIndicator = _a.errorIndicator, indicatorOptions = _a.indicatorOptions, enableCameraPermissionModal = _a.enableCameraPermissionModal, autoSwitchActiveColor = _a.autoSwitchActiveColor, autoSwitchInactiveColor = _a.autoSwitchInactiveColor, progressBarColor = _a.progressBarColor, widgetBackgroundColor = _a.widgetBackgroundColor, messageFontSize = _a.messageFontSize, messageTextColor = _a.messageTextColor, messageBackgroundColor = _a.messageBackgroundColor, webToMobileHandoffConfig = _a.webToMobileHandoffConfig;
    //video, detection and image capture canvas
    var videoRefBg = useRef(null);
    var detectionCanvasRef = useRef(null);
    var captureCanvasRef = useRef(null);
    var _j = useRect(), frameDivRefRect = _j[0], frameDivRef = _j[1];
    var isLandscape = useMobileOrientation_1().isLandscape;
    var isMobileOnLandscape = isLandscape && isMobile_1;
    var cardScanApi = useRef(null);
    //TODO: remove this and move to state machine?
    var cardIdRef = useRef("");
    if (sessionToken && !cardScanApi.current) {
        cardScanApi.current = new CardScanApi({
            sessionToken: sessionToken,
            live: live || false,
        });
    }
    // Update user UI
    var _k = useState(false), showCurtain = _k[0], setShowCurtain = _k[1];
    var _l = useState(false), showErrorModal = _l[0], setShowErrorModal = _l[1];
    var messageState = useState(__assign$2(__assign$2({}, defaultMessages), messages))[0];
    var spinnerOptions = useState(__assign$2(__assign$2({}, defaultIndicatorOptions), indicatorOptions))[0];
    var _m = useMachine(scanViewStateMachine, {
        context: {
            messageState: messageState,
        },
    }), stateMachineState = _m[0], stateMachineSend = _m[1], stateMachineService = _m[2];
    // Buffer for storing scan_id of sent images.
    var _o = useState(0.0), scanProgress = _o[0], setScanProgress = _o[1];
    // Also set server side for max successful scans.
    var softMaxUploads = 12;
    // Card detection parameters & metadata
    var _p = useState(0.9), threshold = _p[0], setThreshold = _p[1];
    var _q = useState(0.01), laplacianThreshold = _q[0], setLaplacianThreshold = _q[1];
    var defaultScanFrequency = 250;
    var _r = useState(defaultScanFrequency), scanFreqency = _r[0], setScanFreqency = _r[1];
    // state to save timestamp of last WS ping
    var pingFrequency = 6500;
    var _s = useState(new Date()), lastPing = _s[0], setLastPing = _s[1];
    var _t = useState({}), videoMetadata = _t[0], setVideoMetadata = _t[1];
    // Short lived buffer for storing scan images before upload
    var _u = useBufferSize(4), bufferSize = _u[0], setBufferSize = _u[1];
    var scanCaptureBuffer = useRef([]);
    //debug options
    var _v = useState(0.0), latestScore = _v[0], setLatestScore = _v[1];
    var _w = useState(0.0), latestLaplacian = _w[0], setLatestLaplacian = _w[1];
    var _x = useState(0.0), bestScore = _x[0], setBestScore = _x[1];
    var debugCanvasBestRef = useRef(null);
    var debugCanvasLatestRef = useRef(null);
    var _y = useState(""), modelState = _y[0], setModelState = _y[1];
    var _z = useState(""), scanDebugState = _z[0], setScanDebugState = _z[1];
    useVideoSizes(videoRefBg, setShowCurtain, stateMachineState);
    var videoWidth = ((_b = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _b === void 0 ? void 0 : _b.videoWidth)
        ? (_c = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _c === void 0 ? void 0 : _c.videoWidth
        : 500;
    var videoHeight = ((_d = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _d === void 0 ? void 0 : _d.videoHeight)
        ? (_e = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _e === void 0 ? void 0 : _e.videoHeight
        : 500;
    var totalPixels = videoWidth * videoHeight;
    if (totalPixels <= 786432) {
        //1024*768 -> 90%
        videoHeight = 0.9 * videoHeight;
        videoWidth = 0.9 * videoWidth;
    }
    else {
        // > 1024*768 -> 50%
        videoHeight = 0.5 * videoHeight;
        videoWidth = 0.5 * videoWidth;
    }
    var videoLayoutHeight = ((_g = (_f = videoRefBg === null || videoRefBg === void 0 ? void 0 : videoRefBg.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect()) === null || _g === void 0 ? void 0 : _g.height) || 0;
    videoLayoutHeight =
        videoLayoutHeight > videoHeight ? videoHeight : videoLayoutHeight;
    useLayoutHeight(videoRefBg, stateMachineState.matches("cameraLoading"), videoLayoutHeight);
    useCustomWidget(autoSwitchActiveColor, autoSwitchInactiveColor, progressBarColor, widgetBackgroundColor, messageFontSize, messageTextColor, messageBackgroundColor);
    //This is the main scanning loop and is enabled once the video has loaded.
    //Toggable with setScannerRunning & loop duration is set via scanFrequency.
    useInterval(function () {
        scanHandler(videoRefBg, frameDivRef, captureCanvasRef, detectionCanvasRef, debugCanvasLatestRef, setLatestScore, setLatestLaplacian, setBestScore, setModelState, setScanDebugState, setScanProgress, scanCaptureBuffer, threshold, laplacianThreshold, onError, scanProgress, softMaxUploads, bufferSize, videoMetadata, cardScanApi, cardIdRef, stateMachineState, stateMachineSend, debug);
        wsPing(); //this should be moved to a separate interval
    }, stateMachineState.context.scannerRunning ? scanFreqency : null);
    useEffect(function () {
        webSocketHandler(cardScanApi, cardIdRef, onError, debug, stateMachineState, stateMachineSend, backsideSupport);
    }, [cardScanApi, stateMachineState, stateMachineSend, stateMachineService]);
    //TODO: find a way to reset states more clearly
    useEffect(function () {
        var subscription = stateMachineService.subscribe(function (state) {
            var _a;
            if (state.matches("completed")) {
                (_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.getCard(cardIdRef.current).then(function (res) {
                    var card = new Card(res.data);
                    onSuccess(card);
                });
                cleanUp(scanCaptureBuffer, setScanProgress, videoRefBg, cardScanApi);
            }
            //reset before moving to backside
            if (state.matches("backsidePending")) {
                scanCaptureBuffer.current = [];
                setScanProgress(0);
                resetCorners();
            }
            // on toggle
            if (state.context.toggledAutoManual &&
                ["autoCapture", "manualCapture"].some(state.matches)) {
                scanCaptureBuffer.current = [];
                setScanProgress(0);
                document.documentElement.style.setProperty("--cardscan-buffer-size", "0");
                setScanFreqency(defaultScanFrequency);
            }
        });
        return subscription.unsubscribe;
    }, [stateMachineService]);
    useEffect(function () {
        var _a;
        //de-dupe this or make it lazy.
        //creating and saving card_id.
        (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.createCard(backsideSupport, requiredFields, optionalFields, eligibility).then(function (response) {
            var _a, _b;
            cardIdRef.current = response.data.card_id;
            console.debug("Setting Card ID", cardIdRef.current);
            //register socket on card creation
            if (((_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket) &&
                ((_b = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _b === void 0 ? void 0 : _b.socket.readyState) == 1) {
                // 1 is open
                var payload = JSON.stringify({
                    card_id: response.data.card_id,
                    action: "register",
                    source: "startup",
                });
                cardScanApi.current.socket.send(payload);
            }
        }).catch(function (error) {
            _handleError(error, stateMachineSend, onError);
        });
    }, [cardScanApi, stateMachineSend]);
    useEffect(function () {
        //TODO: move this - make into a cleanup state?
        window.onpopstate = function () {
            cleanUp(scanCaptureBuffer, setScanProgress, videoRefBg, cardScanApi);
        };
        if (debug) {
            setModelState(DetectorWrapper.get().modelState);
            DetectorWrapper.get().debug = true;
        }
    }, [debug]);
    //TODO: move this into cardScanApi w/ own timer and toggle on/off?
    var wsPing = function () {
        var _a;
        var now = new Date();
        var ms = lastPing.getTime();
        if (["completed", "error"].some(stateMachineState.matches)) {
            return;
        }
        if (now.getTime() - ms < pingFrequency) {
            return;
        }
        if (((_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket) &&
            cardScanApi.current.socket.readyState == 1) {
            cardScanApi.current.socket.send("ping");
            setLastPing(now);
        }
    };
    //---------------------------------------
    // UI Interaction handlers
    //---------------------------------------
    //TODO: most of this could be reduced to state machine (but need to add retry state -> autocapture)
    var handleRetryButton = function () {
        //sanity check we're in retry mode.
        var _a;
        //empty both detection buffer and clear progress UI
        scanCaptureBuffer.current = [];
        setScanProgress(0);
        document.documentElement.style.setProperty("--cardscan-buffer-size", "0");
        var video = videoRefBg.current;
        if (video === null || video === void 0 ? void 0 : video.paused) {
            video === null || video === void 0 ? void 0 : video.play();
        }
        //reset state.
        stateMachineSend("retry_scan");
        setScanFreqency(defaultScanFrequency);
        cardIdRef.current = "";
        if (onRetry) {
            onRetry();
        }
        //de-dupe this
        (_a = cardScanApi.current) === null || _a === void 0 ? void 0 : _a.createCard(backsideSupport, requiredFields, optionalFields, eligibility).then(function (response) {
            var _a;
            cardIdRef.current = response.data.card_id;
            //register socket on card creation
            if ((_a = cardScanApi === null || cardScanApi === void 0 ? void 0 : cardScanApi.current) === null || _a === void 0 ? void 0 : _a.socket) {
                var payload = JSON.stringify({
                    card_id: response.data.card_id,
                    action: "register",
                    source: "retry",
                });
                cardScanApi.current.socket.send(payload);
            }
            //needs to implement another state coming to "retry"
            stateMachineSend("retry_scan");
        }).catch(function (error) {
            _handleError(error, stateMachineSend, onError);
        });
    };
    var onCloseBtn = function () {
        if (onCancel) {
            onCancel();
        }
    };
    //---------------------------------------
    // Rendering
    //---------------------------------------
    return (jsxs(MyGlobalContext.Provider, __assign$2({ value: {
            debug: debug,
            modelState: modelState,
            scanDebugState: scanDebugState,
            threshold: threshold,
            setThreshold: setThreshold,
            laplacianThreshold: laplacianThreshold,
            setLaplacianThreshold: setLaplacianThreshold,
            scanFreqency: scanFreqency,
            setScanFreqency: setScanFreqency,
            bufferSize: bufferSize,
            setBufferSize: setBufferSize,
            bufferRef: scanCaptureBuffer,
            debugCanvasBestRef: debugCanvasBestRef,
            bestScore: bestScore,
            debugCanvasLatestRef: debugCanvasLatestRef,
            latestScore: latestScore,
            latestLaplacian: latestLaplacian,
            showCurtain: showCurtain,
            onCloseBtn: onCloseBtn,
            closeButton: closeButton,
            isMobile: isMobile_1,
            isMobileOnLandscape: isMobileOnLandscape,
            stateMachineState: stateMachineState,
            stateMachineSend: stateMachineSend,
            stateMachineService: stateMachineService,
        } }, { children: [jsx(CameraPermissionModal, { enableModel: showErrorModal &&
                    enableCameraPermissionModal &&
                    (!(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) || isMobile_1) }), jsx(WebToMobileModal, { enableModel: showErrorModal &&
                    !isMobile_1 &&
                    !enableCameraPermissionModal &&
                    (webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) !== undefined
                    ? webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled
                    : false, cardScanApi: cardScanApi, webToMobileHandoffConfig: webToMobileHandoffConfig, spinnerOptions: spinnerOptions }), jsxs("div", __assign$2({ className: styles$1.cardscanMain }, { children: [jsx(DebugMenu, {}), jsx(CardCapture, { children: jsxs("div", __assign$2({ className: styles$1.cardscanVideoContainer }, { children: [jsx(ScanVideoViewer, { videoRef: videoRefBg, setShowErrorModal: setShowErrorModal, stateMachineSend: stateMachineSend, setScanDebugState: setScanDebugState, onError: onError, captureCanvasRef: captureCanvasRef, setVideoMetadata: setVideoMetadata, isMobile: isMobile_1 }), stateMachineState.matches("cameraLoading") ? (jsx("div", __assign$2({ className: "spinner-wrapper" }, { children: jsx(dist, __assign$2({}, spinnerOptions)) }))) : (jsx(ScanFrame, { successIndicator: successIndicator, errorIndicator: errorIndicator, handleRetryButton: handleRetryButton, frameDivRef: frameDivRef, spinnerOptions: spinnerOptions, webToMobileHandoffConfig: webToMobileHandoffConfig, cardScanApi: cardScanApi })), !showCurtain && !stateMachineState.matches("cameraLoading") && (jsxs(Fragment, { children: [!showErrorModal && !(webToMobileHandoffConfig === null || webToMobileHandoffConfig === void 0 ? void 0 : webToMobileHandoffConfig.enabled) && (jsx("img", { "data-cy": "cardscanLogo", src: CardScanLogoURL, className: styles$1.cardscanLogo, style: {
                                                bottom: 0,
                                                top: "unset",
                                                transform: "translate(-5px, -4px)",
                                            } })), !stateMachineState.context.autoScan &&
                                            !stateMachineState.context.processing && (jsx("img", { "data-cy": "cameraBtn", src: img, className: styles$1.cameraBtn, onClick: function () { return stateMachineSend("MANUAL_BUTTON_CLICK"); }, style: { bottom: 0 } }))] }))] })) })] })), jsx(ScanCanvas, { captureCanvasRef: captureCanvasRef, detectionCanvasRef: detectionCanvasRef, frameDivDimensions: frameDivRefRect, frameDivRef: frameDivRef, videoRefBg: videoRefBg, videoHeight: videoHeight, videoWidth: videoWidth })] })));
};

var css_248z = ".scanErrorWrapper-module_scanErrorBar__Vz8hg{background:#ffe0e0;border:1px solid #a33a3a;color:#ba3939;margin:10px;padding:10px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjYW5FcnJvcldyYXBwZXIubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNkNBSUUsa0JBQW1CLENBQ25CLHdCQUF5QixDQUZ6QixhQUFjLENBRGQsV0FBWSxDQURaLFlBS0YiLCJmaWxlIjoic2NhbkVycm9yV3JhcHBlci5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zY2FuRXJyb3JCYXIge1xuICBwYWRkaW5nOiAxMHB4O1xuICBtYXJnaW46IDEwcHg7XG4gIGNvbG9yOiAjYmEzOTM5O1xuICBiYWNrZ3JvdW5kOiAjZmZlMGUwO1xuICBib3JkZXI6IDFweCBzb2xpZCAjYTMzYTNhO1xufSJdfQ== */";
var styles = {"scanErrorBar":"scanErrorWrapper-module_scanErrorBar__Vz8hg"};
styleInject(css_248z);

// Check if there is a valid token
var ScanErrorWrapper = function (_a) {
    var sessionToken = _a.sessionToken, children = _a.children;
    return !sessionToken || sessionToken.length == 0 ? (jsx("div", __assign$2({ "data-cy": "scanErrorBar", className: styles.scanErrorBar }, { children: "A Session Token is needed to continue." }))) : (jsx("div", { children: children }));
};

var App = function (_a) {
    var _b = _a.debug, debug = _b === void 0 ? false : _b, _c = _a.live, live = _c === void 0 ? false : _c, sessionToken = _a.sessionToken, onSuccess = _a.onSuccess, onCancel = _a.onCancel, onError = _a.onError, messages = _a.messages, _d = _a.backsideSupport, backsideSupport = _d === void 0 ? false : _d, eligibility = _a.eligibility, _e = _a.indicatorOptions, indicatorOptions = _e === void 0 ? {} : _e, _f = _a.enableCameraPermissionModal, enableCameraPermissionModal = _f === void 0 ? true : _f, closeButton = _a.closeButton, successIndicator = _a.successIndicator, errorIndicator = _a.errorIndicator, autoSwitchActiveColor = _a.autoSwitchActiveColor, autoSwitchInactiveColor = _a.autoSwitchInactiveColor, progressBarColor = _a.progressBarColor, widgetBackgroundColor = _a.widgetBackgroundColor, messageFontSize = _a.messageFontSize, messageTextColor = _a.messageTextColor, messageBackgroundColor = _a.messageBackgroundColor, _g = _a.webToMobileHandoffConfig, webToMobileHandoffConfig = _g === void 0 ? {
        enabled: false,
        urlBase: live
            ? "https://capture.cardscan.ai"
            : "https://sandbox-capture.cardscan.ai",
        companyName: "CardScanHealth",
    } : _g;
    return (jsx(ScanErrorWrapper, __assign$2({ sessionToken: sessionToken }, { children: jsx(CardScanView, { live: live, debug: debug, sessionToken: sessionToken, onSuccess: onSuccess, onCancel: onCancel, onError: onError, messages: messages, backsideSupport: backsideSupport, eligibility: eligibility, indicatorOptions: indicatorOptions, enableCameraPermissionModal: enableCameraPermissionModal, closeButton: closeButton, successIndicator: successIndicator, errorIndicator: errorIndicator, autoSwitchActiveColor: autoSwitchActiveColor, autoSwitchInactiveColor: autoSwitchInactiveColor, progressBarColor: progressBarColor, widgetBackgroundColor: widgetBackgroundColor, messageFontSize: messageFontSize, messageTextColor: messageTextColor, messageBackgroundColor: messageBackgroundColor, webToMobileHandoffConfig: webToMobileHandoffConfig }) })));
};
App.propTypes = {
    debug: PropTypes.bool,
    live: PropTypes.bool,
    sessionToken: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    onError: PropTypes.func,
    enableCameraPermissionModal: PropTypes.bool,
    backsideSupport: PropTypes.bool,
    webToMobileHandoffConfig: PropTypes.shape({}),
};
App.defaultProps = {
    enableCameraPermissionModal: true,
    webToMobileHandoffConfig: {
        enabled: false,
        urlBase: "capture.cardscan.ai",
        companyName: "CardScanHealth",
    },
};

export { CardScanApi, CardScanModel, App as CardScanView, CardState };
//# sourceMappingURL=index.es.js.map
